var cb = Object.defineProperty;
var db = (e, r, t) => r in e ? cb(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var ae = (e, r, t) => db(e, typeof r != "symbol" ? r + "" : r, t);
import { jsx as x, jsxs as ee, Fragment as Wu } from "react/jsx-runtime";
import * as U from "react";
import P, { memo as Yr, forwardRef as at, useState as ke, useRef as ye, useEffect as He, useCallback as re, useLayoutEffect as Go, useMemo as We, createContext as Yo, useContext as za, Component as yt, Fragment as Gi, useId as Bu, useReducer as Sp, Children as fb, isValidElement as pb, cloneElement as Vu, useImperativeHandle as Ip, createRef as kn, createElement as hb } from "react";
import { Button as At, IconButton as jn, FormControl as ta, FormLabel as ra, InputGroup as na, InputLeftElement as Dp, Text as mt, Input as Ho, Textarea as gb, InputRightAddon as mb, FormHelperText as aa, createIcon as Ss, Tooltip as vb, Flex as Rt, Tag as bb, TagLabel as yb, Box as Ze, Icon as Wn, InputRightElement as _p, Menu as Pa, MenuButton as Aa, MenuList as Ra, MenuItem as Oa, useToast as wb, Progress as Cb, Alert as xb, AlertIcon as Sb, SimpleGrid as kp, RadioGroup as Ib, Stack as Db, Radio as _b, Heading as kb, Modal as Ep, ModalOverlay as Mp, ModalContent as Pp, ModalHeader as Eb, ModalCloseButton as Ap, ModalBody as Rp, ModalFooter as Mb, useMediaQuery as Pb, Tbody as Ab, Tr as dl, Td as si, Skeleton as So, Checkbox as td, Table as Rb, Thead as Ob, Th as rd, chakra as nd, useDisclosure as Tb, Image as Fb, keyframes as Op, Tab as Nb, ChakraProvider as Lb } from "@chakra-ui/react";
import { colors as j, rounded as Is, field as sr, inputWidth as oa, fontWeight as ia, fontSize as je, requiredAsteriskColor as fn, formColors as zt, inputHeight as ar, zummaTheme as Wb } from "./theme.js";
import { inputContainerHeight as xF, inputPadding as SF, padding as IF, specialBoxStyles as DF } from "./theme.js";
import { jsx as he, css as Tp, keyframes as Fp, ThemeContext as Bb } from "@emotion/react";
import * as Vb from "react-dom";
import Gb, { createPortal as Yb } from "react-dom";
import ad from "@emotion/styled";
const Er = {
  size: "sm",
  gap: 2,
  fontSize: {
    base: "0.875rem"
  },
  fontWeight: 600,
  px: {
    base: 3,
    md: 4
  },
  py: {
    base: 2
  }
}, Yi = Yr(
  at(({ variant: e = "default", ...r }, t) => {
    const n = {
      bg: "rgba(0, 0, 0, 0.04)",
      borderColor: j.text[4],
      color: j.text[2],
      _hover: {
        bg: "rgba(0, 0, 0, 0.08)",
        color: j.text[1]
      },
      _active: {
        bg: "rgba(0, 0, 0, 0.12)"
      }
    }, a = e === "tertiary" ? {
      bg: j.tertiary[3],
      borderColor: j.tertiary[1],
      color: j.text[1],
      _hover: {
        bg: j.tertiary[3],
        color: j.tertiary[1]
      },
      _active: {
        bg: "transparent"
      }
    } : {}, o = e === "dotted" ? {
      borderStyle: "dashed",
      bg: "transparent",
      borderColor: j.text[4],
      color: j.text[2],
      _hover: {
        borderColor: j.text[1]
      },
      _active: {
        bg: "transparent"
      }
    } : {}, i = e === "approve" ? {
      bg: "#48BB78",
      borderColor: "#38A169",
      color: "white",
      _hover: {
        bg: "#38A169",
        color: "white"
      },
      _active: {
        bg: "#2F855A"
      }
    } : {}, s = e === "deny" ? {
      bg: "#F56565",
      borderColor: "#E53E3E",
      color: "white",
      _hover: {
        bg: "#E53E3E",
        color: "white"
      },
      _active: {
        bg: "#C53030"
      }
    } : {}, l = e === "primary" ? {
      bg: j.primary[2],
      borderColor: j.primary[1],
      color: j.text[1],
      _hover: {
        bg: j.primary[3],
        opacity: 0.9
      },
      _active: {
        bg: j.primary[1],
        opacity: 0.8
      }
    } : {}, u = e === "apply" ? {
      bg: j.apply[2],
      borderColor: j.apply[2],
      color: "white",
      _hover: {
        bg: j.apply[1],
        opacity: 0.9
      },
      _active: {
        bg: j.apply[2],
        opacity: 0.8
      }
    } : {}, c = e === "default" ? n : {};
    return /* @__PURE__ */ x(
      At,
      {
        ref: t,
        minWidth: { base: 160 },
        size: Er.size,
        fontSize: Er.fontSize,
        fontWeight: Er.fontWeight,
        px: Er.px,
        py: Er.py,
        gap: Er.gap,
        border: 1.5,
        rounded: "4px",
        transition: "transform 0.1s",
        _focusVisible: { ring: 0.4 },
        ...n,
        ...c,
        ...a,
        ...o,
        ...i,
        ...s,
        ...l,
        ...u,
        ...r
      }
    );
  })
);
Yi.displayName = "Button";
const Hb = Yr(
  at(({ variant: e = "default", ...r }, t) => {
    const n = {
      bg: "rgba(0, 0, 0, 0.04)",
      borderColor: j.text[4],
      color: j.text[2],
      _hover: {
        bg: "rgba(0, 0, 0, 0.08)",
        color: j.text[1]
      },
      _active: {
        bg: "rgba(0, 0, 0, 0.12)"
      }
    }, a = e === "tertiary" ? {
      bg: j.tertiary[2],
      borderColor: j.tertiary[1],
      color: j.text[1],
      _hover: {
        bg: j.tertiary[3],
        opacity: 0.9
      },
      _active: {
        bg: j.tertiary[1],
        opacity: 0.8
      }
    } : {}, o = e === "primary" ? {
      bg: j.primary[2],
      borderColor: j.primary[1],
      color: j.text[1],
      _hover: {
        bg: j.primary[3],
        opacity: 0.9
      },
      _active: {
        bg: j.primary[1],
        opacity: 0.8
      }
    } : {}, i = e === "deny" ? {
      bg: "#F56565",
      borderColor: "#E53E3E",
      color: "white",
      _hover: {
        bg: "#E53E3E",
        color: "white"
      },
      _active: {
        bg: "#C53030"
      }
    } : {}, s = e === "apply" ? {
      bg: j.apply[2],
      borderColor: j.apply[2],
      color: "white",
      _hover: {
        bg: j.apply[1],
        opacity: 0.9
      },
      _active: {
        bg: j.apply[2],
        opacity: 0.8
      }
    } : {};
    return /* @__PURE__ */ x(
      jn,
      {
        ref: t,
        maxWidth: { sm: "fit-content" },
        size: Er.size,
        fontSize: Er.fontSize,
        fontWeight: Er.fontWeight,
        py: Er.py,
        border: 1.5,
        rounded: Is.button,
        transition: "transform 0.1s",
        _focusVisible: { ring: 0.4 },
        ...n,
        ...a,
        ...o,
        ...i,
        ...s,
        ...r
      }
    );
  })
);
Hb.displayName = "IconButton";
var Np = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, od = P.createContext && /* @__PURE__ */ P.createContext(Np), zb = ["attr", "size", "title"];
function $b(e, r) {
  if (e == null) return {};
  var t, n, a = Xb(e, r);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (n = 0; n < o.length; n++) t = o[n], r.indexOf(t) === -1 && {}.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
  }
  return a;
}
function Xb(e, r) {
  if (e == null) return {};
  var t = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (r.indexOf(n) !== -1) continue;
    t[n] = e[n];
  }
  return t;
}
function Hi() {
  return Hi = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t) ({}).hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Hi.apply(null, arguments);
}
function id(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function zi(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? id(Object(t), !0).forEach(function(n) {
      jb(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : id(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function jb(e, r, t) {
  return (r = Zb(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Zb(e) {
  var r = Ub(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function Ub(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function Lp(e) {
  return e && e.map((r, t) => /* @__PURE__ */ P.createElement(r.tag, zi({
    key: t
  }, r.attr), Lp(r.child)));
}
function pr(e) {
  return (r) => /* @__PURE__ */ P.createElement(Jb, Hi({
    attr: zi({}, e.attr)
  }, r), Lp(e.child));
}
function Jb(e) {
  var r = (t) => {
    var n = e.attr, a = e.size, o = e.title, i = $b(e, zb), s = a || t.size || "1em", l;
    return t.className && (l = t.className), e.className && (l = (l ? l + " " : "") + e.className), /* @__PURE__ */ P.createElement("svg", Hi({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, t.attr, n, i, {
      className: l,
      style: zi(zi({
        color: e.color || t.color
      }, t.style), e.style),
      height: s,
      width: s,
      xmlns: "http://www.w3.org/2000/svg"
    }), o && /* @__PURE__ */ P.createElement("title", null, o), e.children);
  };
  return od !== void 0 ? /* @__PURE__ */ P.createElement(od.Consumer, null, (t) => r(t)) : r(Np);
}
function Wp(e) {
  return pr({ attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z" }, child: [] }] })(e);
}
function Bp(e) {
  return pr({ attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z" }, child: [] }] })(e);
}
function Qb(e) {
  return pr({ attr: { viewBox: "0 0 576 512" }, child: [{ tag: "path", attr: { d: "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z" }, child: [] }] })(e);
}
function Vp(e) {
  return pr({ attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z" }, child: [] }] })(e);
}
const iF = ({ placeholder: e, size: r = "md", addClass: t, type: n = "text", name: a, helperText: o, label: i, id: s, leftChildren: l, rightChildren: u, isDisabled: c, onChange: d, isInvalid: p = !1, value: f, onFocus: h, onBlur: g, limit: m, isReadOnly: v, isRequired: y, onKeyDownCapture: w, trimOnChange: I, ariaDescribedBy: b }) => {
  const [D, S] = ke(!1), _ = n === "currency", k = _ ? "number" : n, R = (W) => {
    m && W.target.value.length > m || (I && (W.target.value = W.target.value.trim()), d && d(W));
  };
  return /* @__PURE__ */ ee(
    ta,
    {
      width: oa,
      minH: sr.inputContainerHeight,
      id: s,
      isDisabled: c,
      isInvalid: p,
      children: [
        /* @__PURE__ */ ee(
          ra,
          {
            opacity: 0.5,
            fontSize: je.label,
            fontWeight: ia.label,
            padding: sr.labelPadding,
            children: [
              i,
              " ",
              y ? /* @__PURE__ */ x("span", { style: { color: fn }, children: "*" }) : ""
            ]
          }
        ),
        /* @__PURE__ */ ee(
          na,
          {
            maxH: "100%",
            padding: 0,
            children: [
              (l || _) && /* @__PURE__ */ x(
                Dp,
                {
                  maxH: "100%",
                  pointerEvents: "none",
                  padding: 0,
                  children: l || /* @__PURE__ */ x(
                    mt,
                    {
                      maxH: "100%",
                      padding: 0,
                      color: j.neutralDark,
                      fontSize: je.input,
                      fontWeight: "normal",
                      children: "$"
                    }
                  )
                }
              ),
              ["text", "number", "password", "currency"].includes(n) ? /* @__PURE__ */ x(
                Ho,
                {
                  onKeyDownCapture: w,
                  height: ar,
                  isReadOnly: v,
                  isInvalid: p,
                  id: s,
                  value: f ?? "",
                  size: r,
                  name: a,
                  errorBorderColor: zt.error.border,
                  focusBorderColor: zt.default.focus.border,
                  className: t,
                  placeholder: e,
                  type: n === "password" ? D ? "text" : "password" : k,
                  isDisabled: c,
                  onChange: R,
                  onFocus: h,
                  onBlur: g,
                  "aria-describedby": b,
                  _focus: {
                    borderColor: "none"
                  }
                }
              ) : /* @__PURE__ */ x(
                gb,
                {
                  onKeyDownCapture: w,
                  height: ar,
                  isReadOnly: v,
                  isInvalid: p,
                  id: s,
                  value: f ?? "",
                  name: a,
                  resize: "none",
                  errorBorderColor: zt.error.border,
                  focusBorderColor: zt.default.focus.border,
                  className: t,
                  placeholder: e,
                  isDisabled: c,
                  onChange: R,
                  onFocus: h,
                  onBlur: g,
                  _focus: {
                    borderColor: "none"
                  }
                }
              ),
              n === "password" && /* @__PURE__ */ x(
                mb,
                {
                  backgroundColor: D ? zt.default.hover.backgroundColor : j.gray88,
                  onClick: () => S(!D),
                  p: "0",
                  height: ar,
                  children: /* @__PURE__ */ x(
                    At,
                    {
                      borderRightRadius: "sm",
                      borderTopLeftRadius: "none",
                      borderBottomLeftRadius: "none",
                      variant: "solid",
                      height: ar,
                      minHeight: ar,
                      _hover: {
                        backgroundColor: D ? zt.default.hover.backgroundColor : j.gray88
                      },
                      backgroundColor: D ? zt.default.hover.backgroundColor : j.gray88,
                      onClick: () => S(!D),
                      children: /* @__PURE__ */ x(Qb, {})
                    }
                  )
                }
              ),
              u
            ]
          }
        ),
        /* @__PURE__ */ x(aa, { height: 2, children: o })
      ]
    }
  );
}, sF = ({ placeholder: e = "0.00", size: r = "md", addClass: t, name: n, helperText: a, label: o, id: i, isDisabled: s, onChange: l, isInvalid: u = !1, value: c, onFocus: d, onBlur: p, isReadOnly: f, isRequired: h, currency: g = "$", decimals: m = 2, min: v, max: y, allowNegative: w = !1, ariaDescribedBy: I }) => {
  const [b, D] = ke(""), [S, _] = ke(!1), k = ye(null), R = (A) => {
    if (A === null || isNaN(A)) return "";
    const G = A.toFixed(m).split(".");
    return G[0] = G[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","), G.join(".");
  }, W = (A) => {
    if (!A) return null;
    const N = A.replace(/[^\d.-]/g, "").replace(/(?!^)-/g, "").replace(/\./g, (Q, L, O) => O.indexOf(".") === L ? "." : "");
    if (!N || N === "-" || N === ".") return null;
    const G = parseFloat(N);
    return isNaN(G) || !w && G < 0 ? null : v !== void 0 && G < v ? v : y !== void 0 && G > y ? y : G;
  };
  He(() => {
    const A = typeof c == "string" ? W(c) : c ?? null;
    S || D(A !== null ? R(A) : "");
  }, [c, S, m]);
  const B = (A) => {
    const N = A.target.value;
    D(N);
    const G = W(N);
    l && l(G);
  }, V = (A) => {
    _(!0);
    const N = W(b);
    N !== null && D(N.toString()), d && d(A);
  }, F = (A) => {
    _(!1);
    const N = W(b);
    D(N !== null ? R(N) : ""), p && p(A);
  }, H = (A) => {
    var G;
    if (!["Backspace", "Delete", "Tab", "Escape", "Enter", "ArrowLeft", "ArrowRight", "Home", "End"].includes(A.key)) {
      if (A.key === "." && m > 0) {
        b.includes(".") && A.preventDefault();
        return;
      }
      if (A.key === "-" && w) {
        (b.includes("-") || (((G = k.current) == null ? void 0 : G.selectionStart) ?? 0) > 0) && A.preventDefault();
        return;
      }
      (A.ctrlKey || A.metaKey) && ["a", "c", "v", "x", "z"].includes(A.key.toLowerCase()) || /^\d$/.test(A.key) || A.preventDefault();
    }
  };
  return /* @__PURE__ */ ee(
    ta,
    {
      width: oa,
      minH: sr.inputContainerHeight,
      id: i,
      isDisabled: s,
      isInvalid: u,
      children: [
        /* @__PURE__ */ ee(
          ra,
          {
            opacity: 0.5,
            fontSize: je.label,
            fontWeight: ia.label,
            padding: sr.labelPadding,
            children: [
              o,
              " ",
              h ? /* @__PURE__ */ x("span", { style: { color: fn }, children: "*" }) : ""
            ]
          }
        ),
        /* @__PURE__ */ ee(
          na,
          {
            maxH: "100%",
            padding: 0,
            children: [
              /* @__PURE__ */ x(
                Dp,
                {
                  maxH: "100%",
                  pointerEvents: "none",
                  padding: 0,
                  children: /* @__PURE__ */ x(
                    mt,
                    {
                      maxH: "100%",
                      padding: 0,
                      color: j.neutralDark,
                      fontSize: je.input,
                      fontWeight: "normal",
                      children: g
                    }
                  )
                }
              ),
              /* @__PURE__ */ x(
                Ho,
                {
                  ref: k,
                  height: ar,
                  isReadOnly: f,
                  isInvalid: u,
                  id: i,
                  value: b,
                  size: r,
                  name: n,
                  errorBorderColor: zt.error.border,
                  focusBorderColor: zt.default.focus.border,
                  className: t,
                  placeholder: e,
                  type: "text",
                  inputMode: "decimal",
                  isDisabled: s,
                  onChange: B,
                  onFocus: V,
                  onBlur: F,
                  onKeyDown: H,
                  "aria-describedby": I,
                  _focus: {
                    borderColor: "none"
                  }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ x(aa, { height: 2, children: a })
      ]
    }
  );
};
function Zn(e) {
  "@babel/helpers - typeof";
  return Zn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Zn(e);
}
function qb(e, r) {
  if (Zn(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r);
    if (Zn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function Gp(e) {
  var r = qb(e, "string");
  return Zn(r) == "symbol" ? r : r + "";
}
function Ca(e, r, t) {
  return (r = Gp(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function sd(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function ce(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? sd(Object(t), !0).forEach(function(n) {
      Ca(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : sd(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function Kb(e) {
  if (Array.isArray(e)) return e;
}
function e0(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n, a, o, i, s = [], l = !0, u = !1;
    try {
      if (o = (t = t.call(e)).next, r === 0) {
        if (Object(t) !== t) return;
        l = !1;
      } else for (; !(l = (n = o.call(t)).done) && (s.push(n.value), s.length !== r); l = !0) ;
    } catch (c) {
      u = !0, a = c;
    } finally {
      try {
        if (!l && t.return != null && (i = t.return(), Object(i) !== i)) return;
      } finally {
        if (u) throw a;
      }
    }
    return s;
  }
}
function Ql(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = Array(r); t < r; t++) n[t] = e[t];
  return n;
}
function Yp(e, r) {
  if (e) {
    if (typeof e == "string") return Ql(e, r);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? Ql(e, r) : void 0;
  }
}
function t0() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wt(e, r) {
  return Kb(e) || e0(e, r) || Yp(e, r) || t0();
}
function r0(e, r) {
  if (e == null) return {};
  var t = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (r.indexOf(n) !== -1) continue;
    t[n] = e[n];
  }
  return t;
}
function Cr(e, r) {
  if (e == null) return {};
  var t, n, a = r0(e, r);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (n = 0; n < o.length; n++) t = o[n], r.indexOf(t) === -1 && {}.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
  }
  return a;
}
var n0 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function Ds(e) {
  var r = e.defaultInputValue, t = r === void 0 ? "" : r, n = e.defaultMenuIsOpen, a = n === void 0 ? !1 : n, o = e.defaultValue, i = o === void 0 ? null : o, s = e.inputValue, l = e.menuIsOpen, u = e.onChange, c = e.onInputChange, d = e.onMenuClose, p = e.onMenuOpen, f = e.value, h = Cr(e, n0), g = ke(s !== void 0 ? s : t), m = wt(g, 2), v = m[0], y = m[1], w = ke(l !== void 0 ? l : a), I = wt(w, 2), b = I[0], D = I[1], S = ke(f !== void 0 ? f : i), _ = wt(S, 2), k = _[0], R = _[1], W = re(function(G, Q) {
    typeof u == "function" && u(G, Q), R(G);
  }, [u]), B = re(function(G, Q) {
    var L;
    typeof c == "function" && (L = c(G, Q)), y(L !== void 0 ? L : G);
  }, [c]), V = re(function() {
    typeof p == "function" && p(), D(!0);
  }, [p]), F = re(function() {
    typeof d == "function" && d(), D(!1);
  }, [d]), H = s !== void 0 ? s : v, A = l !== void 0 ? l : b, N = f !== void 0 ? f : k;
  return ce(ce({}, h), {}, {
    inputValue: H,
    menuIsOpen: A,
    onChange: W,
    onInputChange: B,
    onMenuClose: F,
    onMenuOpen: V,
    value: N
  });
}
function pe() {
  return pe = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t) ({}).hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, pe.apply(null, arguments);
}
function a0(e, r) {
  if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
}
function ld(e, r) {
  for (var t = 0; t < r.length; t++) {
    var n = r[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Gp(n.key), n);
  }
}
function o0(e, r, t) {
  return r && ld(e.prototype, r), t && ld(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ql(e, r) {
  return ql = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
    return t.__proto__ = n, t;
  }, ql(e, r);
}
function i0(e, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), r && ql(e, r);
}
function $i(e) {
  return $i = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, $i(e);
}
function Hp() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Hp = function() {
    return !!e;
  })();
}
function s0(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function l0(e, r) {
  if (r && (Zn(r) == "object" || typeof r == "function")) return r;
  if (r !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return s0(e);
}
function u0(e) {
  var r = Hp();
  return function() {
    var t, n = $i(e);
    if (r) {
      var a = $i(this).constructor;
      t = Reflect.construct(n, arguments, a);
    } else t = n.apply(this, arguments);
    return l0(this, t);
  };
}
function c0(e) {
  if (Array.isArray(e)) return Ql(e);
}
function d0(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function f0() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ia(e) {
  return c0(e) || d0(e) || Yp(e) || f0();
}
function p0(e, r) {
  return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(r)
    }
  }));
}
const Ta = Math.min, Yn = Math.max, Xi = Math.round, li = Math.floor, Fr = (e) => ({
  x: e,
  y: e
}), h0 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, g0 = {
  start: "end",
  end: "start"
};
function m0(e, r, t) {
  return Yn(e, Ta(r, t));
}
function _s(e, r) {
  return typeof e == "function" ? e(r) : e;
}
function Fa(e) {
  return e.split("-")[0];
}
function zo(e) {
  return e.split("-")[1];
}
function v0(e) {
  return e === "x" ? "y" : "x";
}
function Gu(e) {
  return e === "y" ? "height" : "width";
}
const b0 = /* @__PURE__ */ new Set(["top", "bottom"]);
function Bn(e) {
  return b0.has(Fa(e)) ? "y" : "x";
}
function Yu(e) {
  return v0(Bn(e));
}
function y0(e, r, t) {
  t === void 0 && (t = !1);
  const n = zo(e), a = Yu(e), o = Gu(a);
  let i = a === "x" ? n === (t ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return r.reference[o] > r.floating[o] && (i = ji(i)), [i, ji(i)];
}
function w0(e) {
  const r = ji(e);
  return [Kl(e), r, Kl(r)];
}
function Kl(e) {
  return e.replace(/start|end/g, (r) => g0[r]);
}
const ud = ["left", "right"], cd = ["right", "left"], C0 = ["top", "bottom"], x0 = ["bottom", "top"];
function S0(e, r, t) {
  switch (e) {
    case "top":
    case "bottom":
      return t ? r ? cd : ud : r ? ud : cd;
    case "left":
    case "right":
      return r ? C0 : x0;
    default:
      return [];
  }
}
function I0(e, r, t, n) {
  const a = zo(e);
  let o = S0(Fa(e), t === "start", n);
  return a && (o = o.map((i) => i + "-" + a), r && (o = o.concat(o.map(Kl)))), o;
}
function ji(e) {
  return e.replace(/left|right|bottom|top/g, (r) => h0[r]);
}
function D0(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function zp(e) {
  return typeof e != "number" ? D0(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Zi(e) {
  const {
    x: r,
    y: t,
    width: n,
    height: a
  } = e;
  return {
    width: n,
    height: a,
    top: t,
    left: r,
    right: r + n,
    bottom: t + a,
    x: r,
    y: t
  };
}
function dd(e, r, t) {
  let {
    reference: n,
    floating: a
  } = e;
  const o = Bn(r), i = Yu(r), s = Gu(i), l = Fa(r), u = o === "y", c = n.x + n.width / 2 - a.width / 2, d = n.y + n.height / 2 - a.height / 2, p = n[s] / 2 - a[s] / 2;
  let f;
  switch (l) {
    case "top":
      f = {
        x: c,
        y: n.y - a.height
      };
      break;
    case "bottom":
      f = {
        x: c,
        y: n.y + n.height
      };
      break;
    case "right":
      f = {
        x: n.x + n.width,
        y: d
      };
      break;
    case "left":
      f = {
        x: n.x - a.width,
        y: d
      };
      break;
    default:
      f = {
        x: n.x,
        y: n.y
      };
  }
  switch (zo(r)) {
    case "start":
      f[i] -= p * (t && u ? -1 : 1);
      break;
    case "end":
      f[i] += p * (t && u ? -1 : 1);
      break;
  }
  return f;
}
const _0 = async (e, r, t) => {
  const {
    placement: n = "bottom",
    strategy: a = "absolute",
    middleware: o = [],
    platform: i
  } = t, s = o.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(r));
  let u = await i.getElementRects({
    reference: e,
    floating: r,
    strategy: a
  }), {
    x: c,
    y: d
  } = dd(u, n, l), p = n, f = {}, h = 0;
  for (let g = 0; g < s.length; g++) {
    const {
      name: m,
      fn: v
    } = s[g], {
      x: y,
      y: w,
      data: I,
      reset: b
    } = await v({
      x: c,
      y: d,
      initialPlacement: n,
      placement: p,
      strategy: a,
      middlewareData: f,
      rects: u,
      platform: i,
      elements: {
        reference: e,
        floating: r
      }
    });
    c = y ?? c, d = w ?? d, f = {
      ...f,
      [m]: {
        ...f[m],
        ...I
      }
    }, b && h <= 50 && (h++, typeof b == "object" && (b.placement && (p = b.placement), b.rects && (u = b.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: r,
      strategy: a
    }) : b.rects), {
      x: c,
      y: d
    } = dd(u, p, l)), g = -1);
  }
  return {
    x: c,
    y: d,
    placement: p,
    strategy: a,
    middlewareData: f
  };
};
async function k0(e, r) {
  var t;
  r === void 0 && (r = {});
  const {
    x: n,
    y: a,
    platform: o,
    rects: i,
    elements: s,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: d = "floating",
    altBoundary: p = !1,
    padding: f = 0
  } = _s(r, e), h = zp(f), m = s[p ? d === "floating" ? "reference" : "floating" : d], v = Zi(await o.getClippingRect({
    element: (t = await (o.isElement == null ? void 0 : o.isElement(m))) == null || t ? m : m.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: l
  })), y = d === "floating" ? {
    x: n,
    y: a,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, w = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), I = await (o.isElement == null ? void 0 : o.isElement(w)) ? await (o.getScale == null ? void 0 : o.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = Zi(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: y,
    offsetParent: w,
    strategy: l
  }) : y);
  return {
    top: (v.top - b.top + h.top) / I.y,
    bottom: (b.bottom - v.bottom + h.bottom) / I.y,
    left: (v.left - b.left + h.left) / I.x,
    right: (b.right - v.right + h.right) / I.x
  };
}
const E0 = (e) => ({
  name: "arrow",
  options: e,
  async fn(r) {
    const {
      x: t,
      y: n,
      placement: a,
      rects: o,
      platform: i,
      elements: s,
      middlewareData: l
    } = r, {
      element: u,
      padding: c = 0
    } = _s(e, r) || {};
    if (u == null)
      return {};
    const d = zp(c), p = {
      x: t,
      y: n
    }, f = Yu(a), h = Gu(f), g = await i.getDimensions(u), m = f === "y", v = m ? "top" : "left", y = m ? "bottom" : "right", w = m ? "clientHeight" : "clientWidth", I = o.reference[h] + o.reference[f] - p[f] - o.floating[h], b = p[f] - o.reference[f], D = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(u));
    let S = D ? D[w] : 0;
    (!S || !await (i.isElement == null ? void 0 : i.isElement(D))) && (S = s.floating[w] || o.floating[h]);
    const _ = I / 2 - b / 2, k = S / 2 - g[h] / 2 - 1, R = Ta(d[v], k), W = Ta(d[y], k), B = R, V = S - g[h] - W, F = S / 2 - g[h] / 2 + _, H = m0(B, F, V), A = !l.arrow && zo(a) != null && F !== H && o.reference[h] / 2 - (F < B ? R : W) - g[h] / 2 < 0, N = A ? F < B ? F - B : F - V : 0;
    return {
      [f]: p[f] + N,
      data: {
        [f]: H,
        centerOffset: F - H - N,
        ...A && {
          alignmentOffset: N
        }
      },
      reset: A
    };
  }
}), M0 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(r) {
      var t, n;
      const {
        placement: a,
        middlewareData: o,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: u
      } = r, {
        mainAxis: c = !0,
        crossAxis: d = !0,
        fallbackPlacements: p,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: g = !0,
        ...m
      } = _s(e, r);
      if ((t = o.arrow) != null && t.alignmentOffset)
        return {};
      const v = Fa(a), y = Bn(s), w = Fa(s) === s, I = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), b = p || (w || !g ? [ji(s)] : w0(s)), D = h !== "none";
      !p && D && b.push(...I0(s, g, h, I));
      const S = [s, ...b], _ = await k0(r, m), k = [];
      let R = ((n = o.flip) == null ? void 0 : n.overflows) || [];
      if (c && k.push(_[v]), d) {
        const F = y0(a, i, I);
        k.push(_[F[0]], _[F[1]]);
      }
      if (R = [...R, {
        placement: a,
        overflows: k
      }], !k.every((F) => F <= 0)) {
        var W, B;
        const F = (((W = o.flip) == null ? void 0 : W.index) || 0) + 1, H = S[F];
        if (H && (!(d === "alignment" ? y !== Bn(H) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        R.every((G) => Bn(G.placement) === y ? G.overflows[0] > 0 : !0)))
          return {
            data: {
              index: F,
              overflows: R
            },
            reset: {
              placement: H
            }
          };
        let A = (B = R.filter((N) => N.overflows[0] <= 0).sort((N, G) => N.overflows[1] - G.overflows[1])[0]) == null ? void 0 : B.placement;
        if (!A)
          switch (f) {
            case "bestFit": {
              var V;
              const N = (V = R.filter((G) => {
                if (D) {
                  const Q = Bn(G.placement);
                  return Q === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Q === "y";
                }
                return !0;
              }).map((G) => [G.placement, G.overflows.filter((Q) => Q > 0).reduce((Q, L) => Q + L, 0)]).sort((G, Q) => G[1] - Q[1])[0]) == null ? void 0 : V[0];
              N && (A = N);
              break;
            }
            case "initialPlacement":
              A = s;
              break;
          }
        if (a !== A)
          return {
            reset: {
              placement: A
            }
          };
      }
      return {};
    }
  };
}, P0 = /* @__PURE__ */ new Set(["left", "top"]);
async function A0(e, r) {
  const {
    placement: t,
    platform: n,
    elements: a
  } = e, o = await (n.isRTL == null ? void 0 : n.isRTL(a.floating)), i = Fa(t), s = zo(t), l = Bn(t) === "y", u = P0.has(i) ? -1 : 1, c = o && l ? -1 : 1, d = _s(r, e);
  let {
    mainAxis: p,
    crossAxis: f,
    alignmentAxis: h
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof h == "number" && (f = s === "end" ? h * -1 : h), l ? {
    x: f * c,
    y: p * u
  } : {
    x: p * u,
    y: f * c
  };
}
const R0 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(r) {
      var t, n;
      const {
        x: a,
        y: o,
        placement: i,
        middlewareData: s
      } = r, l = await A0(r, e);
      return i === ((t = s.offset) == null ? void 0 : t.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: a + l.x,
        y: o + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
};
function ks() {
  return typeof window < "u";
}
function $a(e) {
  return $p(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Zt(e) {
  var r;
  return (e == null || (r = e.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function Hr(e) {
  var r;
  return (r = ($p(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : r.documentElement;
}
function $p(e) {
  return ks() ? e instanceof Node || e instanceof Zt(e).Node : !1;
}
function kt(e) {
  return ks() ? e instanceof Element || e instanceof Zt(e).Element : !1;
}
function Br(e) {
  return ks() ? e instanceof HTMLElement || e instanceof Zt(e).HTMLElement : !1;
}
function fd(e) {
  return !ks() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Zt(e).ShadowRoot;
}
const O0 = /* @__PURE__ */ new Set(["inline", "contents"]);
function $o(e) {
  const {
    overflow: r,
    overflowX: t,
    overflowY: n,
    display: a
  } = lr(e);
  return /auto|scroll|overlay|hidden|clip/.test(r + n + t) && !O0.has(a);
}
const T0 = /* @__PURE__ */ new Set(["table", "td", "th"]);
function F0(e) {
  return T0.has($a(e));
}
const N0 = [":popover-open", ":modal"];
function Es(e) {
  return N0.some((r) => {
    try {
      return e.matches(r);
    } catch {
      return !1;
    }
  });
}
const L0 = ["transform", "translate", "scale", "rotate", "perspective"], W0 = ["transform", "translate", "scale", "rotate", "perspective", "filter"], B0 = ["paint", "layout", "strict", "content"];
function Hu(e) {
  const r = zu(), t = kt(e) ? lr(e) : e;
  return L0.some((n) => t[n] ? t[n] !== "none" : !1) || (t.containerType ? t.containerType !== "normal" : !1) || !r && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !r && (t.filter ? t.filter !== "none" : !1) || W0.some((n) => (t.willChange || "").includes(n)) || B0.some((n) => (t.contain || "").includes(n));
}
function V0(e) {
  let r = En(e);
  for (; Br(r) && !Na(r); ) {
    if (Hu(r))
      return r;
    if (Es(r))
      return null;
    r = En(r);
  }
  return null;
}
function zu() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const G0 = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Na(e) {
  return G0.has($a(e));
}
function lr(e) {
  return Zt(e).getComputedStyle(e);
}
function Ms(e) {
  return kt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function En(e) {
  if ($a(e) === "html")
    return e;
  const r = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    fd(e) && e.host || // Fallback.
    Hr(e)
  );
  return fd(r) ? r.host : r;
}
function Xp(e) {
  const r = En(e);
  return Na(r) ? e.ownerDocument ? e.ownerDocument.body : e.body : Br(r) && $o(r) ? r : Xp(r);
}
function Po(e, r, t) {
  var n;
  r === void 0 && (r = []), t === void 0 && (t = !0);
  const a = Xp(e), o = a === ((n = e.ownerDocument) == null ? void 0 : n.body), i = Zt(a);
  if (o) {
    const s = eu(i);
    return r.concat(i, i.visualViewport || [], $o(a) ? a : [], s && t ? Po(s) : []);
  }
  return r.concat(a, Po(a, [], t));
}
function eu(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function jp(e) {
  const r = lr(e);
  let t = parseFloat(r.width) || 0, n = parseFloat(r.height) || 0;
  const a = Br(e), o = a ? e.offsetWidth : t, i = a ? e.offsetHeight : n, s = Xi(t) !== o || Xi(n) !== i;
  return s && (t = o, n = i), {
    width: t,
    height: n,
    $: s
  };
}
function $u(e) {
  return kt(e) ? e : e.contextElement;
}
function Da(e) {
  const r = $u(e);
  if (!Br(r))
    return Fr(1);
  const t = r.getBoundingClientRect(), {
    width: n,
    height: a,
    $: o
  } = jp(r);
  let i = (o ? Xi(t.width) : t.width) / n, s = (o ? Xi(t.height) : t.height) / a;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const Y0 = /* @__PURE__ */ Fr(0);
function Zp(e) {
  const r = Zt(e);
  return !zu() || !r.visualViewport ? Y0 : {
    x: r.visualViewport.offsetLeft,
    y: r.visualViewport.offsetTop
  };
}
function H0(e, r, t) {
  return r === void 0 && (r = !1), !t || r && t !== Zt(e) ? !1 : r;
}
function Un(e, r, t, n) {
  r === void 0 && (r = !1), t === void 0 && (t = !1);
  const a = e.getBoundingClientRect(), o = $u(e);
  let i = Fr(1);
  r && (n ? kt(n) && (i = Da(n)) : i = Da(e));
  const s = H0(o, t, n) ? Zp(o) : Fr(0);
  let l = (a.left + s.x) / i.x, u = (a.top + s.y) / i.y, c = a.width / i.x, d = a.height / i.y;
  if (o) {
    const p = Zt(o), f = n && kt(n) ? Zt(n) : n;
    let h = p, g = eu(h);
    for (; g && n && f !== h; ) {
      const m = Da(g), v = g.getBoundingClientRect(), y = lr(g), w = v.left + (g.clientLeft + parseFloat(y.paddingLeft)) * m.x, I = v.top + (g.clientTop + parseFloat(y.paddingTop)) * m.y;
      l *= m.x, u *= m.y, c *= m.x, d *= m.y, l += w, u += I, h = Zt(g), g = eu(h);
    }
  }
  return Zi({
    width: c,
    height: d,
    x: l,
    y: u
  });
}
function Ps(e, r) {
  const t = Ms(e).scrollLeft;
  return r ? r.left + t : Un(Hr(e)).left + t;
}
function Up(e, r) {
  const t = e.getBoundingClientRect(), n = t.left + r.scrollLeft - Ps(e, t), a = t.top + r.scrollTop;
  return {
    x: n,
    y: a
  };
}
function z0(e) {
  let {
    elements: r,
    rect: t,
    offsetParent: n,
    strategy: a
  } = e;
  const o = a === "fixed", i = Hr(n), s = r ? Es(r.floating) : !1;
  if (n === i || s && o)
    return t;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Fr(1);
  const c = Fr(0), d = Br(n);
  if ((d || !d && !o) && (($a(n) !== "body" || $o(i)) && (l = Ms(n)), Br(n))) {
    const f = Un(n);
    u = Da(n), c.x = f.x + n.clientLeft, c.y = f.y + n.clientTop;
  }
  const p = i && !d && !o ? Up(i, l) : Fr(0);
  return {
    width: t.width * u.x,
    height: t.height * u.y,
    x: t.x * u.x - l.scrollLeft * u.x + c.x + p.x,
    y: t.y * u.y - l.scrollTop * u.y + c.y + p.y
  };
}
function $0(e) {
  return Array.from(e.getClientRects());
}
function X0(e) {
  const r = Hr(e), t = Ms(e), n = e.ownerDocument.body, a = Yn(r.scrollWidth, r.clientWidth, n.scrollWidth, n.clientWidth), o = Yn(r.scrollHeight, r.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -t.scrollLeft + Ps(e);
  const s = -t.scrollTop;
  return lr(n).direction === "rtl" && (i += Yn(r.clientWidth, n.clientWidth) - a), {
    width: a,
    height: o,
    x: i,
    y: s
  };
}
const pd = 25;
function j0(e, r) {
  const t = Zt(e), n = Hr(e), a = t.visualViewport;
  let o = n.clientWidth, i = n.clientHeight, s = 0, l = 0;
  if (a) {
    o = a.width, i = a.height;
    const c = zu();
    (!c || c && r === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  const u = Ps(n);
  if (u <= 0) {
    const c = n.ownerDocument, d = c.body, p = getComputedStyle(d), f = c.compatMode === "CSS1Compat" && parseFloat(p.marginLeft) + parseFloat(p.marginRight) || 0, h = Math.abs(n.clientWidth - d.clientWidth - f);
    h <= pd && (o -= h);
  } else u <= pd && (o += u);
  return {
    width: o,
    height: i,
    x: s,
    y: l
  };
}
const Z0 = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function U0(e, r) {
  const t = Un(e, !0, r === "fixed"), n = t.top + e.clientTop, a = t.left + e.clientLeft, o = Br(e) ? Da(e) : Fr(1), i = e.clientWidth * o.x, s = e.clientHeight * o.y, l = a * o.x, u = n * o.y;
  return {
    width: i,
    height: s,
    x: l,
    y: u
  };
}
function hd(e, r, t) {
  let n;
  if (r === "viewport")
    n = j0(e, t);
  else if (r === "document")
    n = X0(Hr(e));
  else if (kt(r))
    n = U0(r, t);
  else {
    const a = Zp(e);
    n = {
      x: r.x - a.x,
      y: r.y - a.y,
      width: r.width,
      height: r.height
    };
  }
  return Zi(n);
}
function Jp(e, r) {
  const t = En(e);
  return t === r || !kt(t) || Na(t) ? !1 : lr(t).position === "fixed" || Jp(t, r);
}
function J0(e, r) {
  const t = r.get(e);
  if (t)
    return t;
  let n = Po(e, [], !1).filter((s) => kt(s) && $a(s) !== "body"), a = null;
  const o = lr(e).position === "fixed";
  let i = o ? En(e) : e;
  for (; kt(i) && !Na(i); ) {
    const s = lr(i), l = Hu(i);
    !l && s.position === "fixed" && (a = null), (o ? !l && !a : !l && s.position === "static" && !!a && Z0.has(a.position) || $o(i) && !l && Jp(e, i)) ? n = n.filter((c) => c !== i) : a = s, i = En(i);
  }
  return r.set(e, n), n;
}
function Q0(e) {
  let {
    element: r,
    boundary: t,
    rootBoundary: n,
    strategy: a
  } = e;
  const i = [...t === "clippingAncestors" ? Es(r) ? [] : J0(r, this._c) : [].concat(t), n], s = i[0], l = i.reduce((u, c) => {
    const d = hd(r, c, a);
    return u.top = Yn(d.top, u.top), u.right = Ta(d.right, u.right), u.bottom = Ta(d.bottom, u.bottom), u.left = Yn(d.left, u.left), u;
  }, hd(r, s, a));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function q0(e) {
  const {
    width: r,
    height: t
  } = jp(e);
  return {
    width: r,
    height: t
  };
}
function K0(e, r, t) {
  const n = Br(r), a = Hr(r), o = t === "fixed", i = Un(e, !0, o, r);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Fr(0);
  function u() {
    l.x = Ps(a);
  }
  if (n || !n && !o)
    if (($a(r) !== "body" || $o(a)) && (s = Ms(r)), n) {
      const f = Un(r, !0, o, r);
      l.x = f.x + r.clientLeft, l.y = f.y + r.clientTop;
    } else a && u();
  o && !n && a && u();
  const c = a && !n && !o ? Up(a, s) : Fr(0), d = i.left + s.scrollLeft - l.x - c.x, p = i.top + s.scrollTop - l.y - c.y;
  return {
    x: d,
    y: p,
    width: i.width,
    height: i.height
  };
}
function fl(e) {
  return lr(e).position === "static";
}
function gd(e, r) {
  if (!Br(e) || lr(e).position === "fixed")
    return null;
  if (r)
    return r(e);
  let t = e.offsetParent;
  return Hr(e) === t && (t = t.ownerDocument.body), t;
}
function Qp(e, r) {
  const t = Zt(e);
  if (Es(e))
    return t;
  if (!Br(e)) {
    let a = En(e);
    for (; a && !Na(a); ) {
      if (kt(a) && !fl(a))
        return a;
      a = En(a);
    }
    return t;
  }
  let n = gd(e, r);
  for (; n && F0(n) && fl(n); )
    n = gd(n, r);
  return n && Na(n) && fl(n) && !Hu(n) ? t : n || V0(e) || t;
}
const ey = async function(e) {
  const r = this.getOffsetParent || Qp, t = this.getDimensions, n = await t(e.floating);
  return {
    reference: K0(e.reference, await r(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function ty(e) {
  return lr(e).direction === "rtl";
}
const ry = {
  convertOffsetParentRelativeRectToViewportRelativeRect: z0,
  getDocumentElement: Hr,
  getClippingRect: Q0,
  getOffsetParent: Qp,
  getElementRects: ey,
  getClientRects: $0,
  getDimensions: q0,
  getScale: Da,
  isElement: kt,
  isRTL: ty
};
function qp(e, r) {
  return e.x === r.x && e.y === r.y && e.width === r.width && e.height === r.height;
}
function ny(e, r) {
  let t = null, n;
  const a = Hr(e);
  function o() {
    var s;
    clearTimeout(n), (s = t) == null || s.disconnect(), t = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), o();
    const u = e.getBoundingClientRect(), {
      left: c,
      top: d,
      width: p,
      height: f
    } = u;
    if (s || r(), !p || !f)
      return;
    const h = li(d), g = li(a.clientWidth - (c + p)), m = li(a.clientHeight - (d + f)), v = li(c), w = {
      rootMargin: -h + "px " + -g + "px " + -m + "px " + -v + "px",
      threshold: Yn(0, Ta(1, l)) || 1
    };
    let I = !0;
    function b(D) {
      const S = D[0].intersectionRatio;
      if (S !== l) {
        if (!I)
          return i();
        S ? i(!1, S) : n = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      S === 1 && !qp(u, e.getBoundingClientRect()) && i(), I = !1;
    }
    try {
      t = new IntersectionObserver(b, {
        ...w,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(b, w);
    }
    t.observe(e);
  }
  return i(!0), o;
}
function Kp(e, r, t, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: o = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, u = $u(e), c = a || o ? [...u ? Po(u) : [], ...Po(r)] : [];
  c.forEach((v) => {
    a && v.addEventListener("scroll", t, {
      passive: !0
    }), o && v.addEventListener("resize", t);
  });
  const d = u && s ? ny(u, t) : null;
  let p = -1, f = null;
  i && (f = new ResizeObserver((v) => {
    let [y] = v;
    y && y.target === u && f && (f.unobserve(r), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var w;
      (w = f) == null || w.observe(r);
    })), t();
  }), u && !l && f.observe(u), f.observe(r));
  let h, g = l ? Un(e) : null;
  l && m();
  function m() {
    const v = Un(e);
    g && !qp(g, v) && t(), g = v, h = requestAnimationFrame(m);
  }
  return t(), () => {
    var v;
    c.forEach((y) => {
      a && y.removeEventListener("scroll", t), o && y.removeEventListener("resize", t);
    }), d == null || d(), (v = f) == null || v.disconnect(), f = null, l && cancelAnimationFrame(h);
  };
}
const ay = R0, oy = M0, md = E0, iy = (e, r, t) => {
  const n = /* @__PURE__ */ new Map(), a = {
    platform: ry,
    ...t
  }, o = {
    ...a.platform,
    _c: n
  };
  return _0(e, r, {
    ...a,
    platform: o
  });
};
var tu = Go, sy = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], Ui = function() {
};
function ly(e, r) {
  return r ? r[0] === "-" ? e + r : e + "__" + r : e;
}
function uy(e, r) {
  for (var t = arguments.length, n = new Array(t > 2 ? t - 2 : 0), a = 2; a < t; a++)
    n[a - 2] = arguments[a];
  var o = [].concat(n);
  if (r && e)
    for (var i in r)
      r.hasOwnProperty(i) && r[i] && o.push("".concat(ly(e, i)));
  return o.filter(function(s) {
    return s;
  }).map(function(s) {
    return String(s).trim();
  }).join(" ");
}
var Ji = function(r) {
  return yy(r) ? r.filter(Boolean) : Zn(r) === "object" && r !== null ? [r] : [];
}, eh = function(r) {
  r.className, r.clearValue, r.cx, r.getStyles, r.getClassNames, r.getValue, r.hasValue, r.isMulti, r.isRtl, r.options, r.selectOption, r.selectProps, r.setValue, r.theme;
  var t = Cr(r, sy);
  return ce({}, t);
}, lt = function(r, t, n) {
  var a = r.cx, o = r.getStyles, i = r.getClassNames, s = r.className;
  return {
    css: o(t, r),
    className: a(n ?? {}, i(t, r), s)
  };
};
function cy(e, r, t) {
  if (t) {
    var n = t(e, r);
    if (typeof n == "string") return n;
  }
  return e;
}
function As(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function dy(e) {
  return As(e) ? window.innerHeight : e.clientHeight;
}
function th(e) {
  return As(e) ? window.pageYOffset : e.scrollTop;
}
function Qi(e, r) {
  if (As(e)) {
    window.scrollTo(0, r);
    return;
  }
  e.scrollTop = r;
}
function fy(e) {
  var r = getComputedStyle(e), t = r.position === "absolute", n = /(auto|scroll)/;
  if (r.position === "fixed") return document.documentElement;
  for (var a = e; a = a.parentElement; )
    if (r = getComputedStyle(a), !(t && r.position === "static") && n.test(r.overflow + r.overflowY + r.overflowX))
      return a;
  return document.documentElement;
}
function py(e, r, t, n) {
  return t * ((e = e / n - 1) * e * e + 1) + r;
}
function ui(e, r) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Ui, a = th(e), o = r - a, i = 10, s = 0;
  function l() {
    s += i;
    var u = py(s, a, o, t);
    Qi(e, u), s < t ? window.requestAnimationFrame(l) : n(e);
  }
  l();
}
function vd(e, r) {
  var t = e.getBoundingClientRect(), n = r.getBoundingClientRect(), a = r.offsetHeight / 3;
  n.bottom + a > t.bottom ? Qi(e, Math.min(r.offsetTop + r.clientHeight - e.offsetHeight + a, e.scrollHeight)) : n.top - a < t.top && Qi(e, Math.max(r.offsetTop - a, 0));
}
function hy(e) {
  var r = e.getBoundingClientRect();
  return {
    bottom: r.bottom,
    height: r.height,
    left: r.left,
    right: r.right,
    top: r.top,
    width: r.width
  };
}
function bd() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function gy() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var rh = !1, my = {
  get passive() {
    return rh = !0;
  }
}, ci = typeof window < "u" ? window : {};
ci.addEventListener && ci.removeEventListener && (ci.addEventListener("p", Ui, my), ci.removeEventListener("p", Ui, !1));
var vy = rh;
function by(e) {
  return e != null;
}
function yy(e) {
  return Array.isArray(e);
}
function yo(e, r, t) {
  return e ? r : t;
}
var wy = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  var o = Object.entries(r).filter(function(i) {
    var s = wt(i, 1), l = s[0];
    return !n.includes(l);
  });
  return o.reduce(function(i, s) {
    var l = wt(s, 2), u = l[0], c = l[1];
    return i[u] = c, i;
  }, {});
}, Cy = ["children", "innerProps"], xy = ["children", "innerProps"];
function Sy(e) {
  var r = e.maxHeight, t = e.menuEl, n = e.minHeight, a = e.placement, o = e.shouldScroll, i = e.isFixedPosition, s = e.controlHeight, l = fy(t), u = {
    placement: "bottom",
    maxHeight: r
  };
  if (!t || !t.offsetParent) return u;
  var c = l.getBoundingClientRect(), d = c.height, p = t.getBoundingClientRect(), f = p.bottom, h = p.height, g = p.top, m = t.offsetParent.getBoundingClientRect(), v = m.top, y = i ? window.innerHeight : dy(l), w = th(l), I = parseInt(getComputedStyle(t).marginBottom, 10), b = parseInt(getComputedStyle(t).marginTop, 10), D = v - b, S = y - g, _ = D + w, k = d - w - g, R = f - y + w + I, W = w + g - b, B = 160;
  switch (a) {
    case "auto":
    case "bottom":
      if (S >= h)
        return {
          placement: "bottom",
          maxHeight: r
        };
      if (k >= h && !i)
        return o && ui(l, R, B), {
          placement: "bottom",
          maxHeight: r
        };
      if (!i && k >= n || i && S >= n) {
        o && ui(l, R, B);
        var V = i ? S - I : k - I;
        return {
          placement: "bottom",
          maxHeight: V
        };
      }
      if (a === "auto" || i) {
        var F = r, H = i ? D : _;
        return H >= n && (F = Math.min(H - I - s, r)), {
          placement: "top",
          maxHeight: F
        };
      }
      if (a === "bottom")
        return o && Qi(l, R), {
          placement: "bottom",
          maxHeight: r
        };
      break;
    case "top":
      if (D >= h)
        return {
          placement: "top",
          maxHeight: r
        };
      if (_ >= h && !i)
        return o && ui(l, W, B), {
          placement: "top",
          maxHeight: r
        };
      if (!i && _ >= n || i && D >= n) {
        var A = r;
        return (!i && _ >= n || i && D >= n) && (A = i ? D - b : _ - b), o && ui(l, W, B), {
          placement: "top",
          maxHeight: A
        };
      }
      return {
        placement: "bottom",
        maxHeight: r
      };
    default:
      throw new Error('Invalid placement provided "'.concat(a, '".'));
  }
  return u;
}
function Iy(e) {
  var r = {
    bottom: "top",
    top: "bottom"
  };
  return e ? r[e] : "bottom";
}
var nh = function(r) {
  return r === "auto" ? "bottom" : r;
}, Dy = function(r, t) {
  var n, a = r.placement, o = r.theme, i = o.borderRadius, s = o.spacing, l = o.colors;
  return ce((n = {
    label: "menu"
  }, Ca(n, Iy(a), "100%"), Ca(n, "position", "absolute"), Ca(n, "width", "100%"), Ca(n, "zIndex", 1), n), t ? {} : {
    backgroundColor: l.neutral0,
    borderRadius: i,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: s.menuGutter,
    marginTop: s.menuGutter
  });
}, ah = /* @__PURE__ */ Yo(null), _y = function(r) {
  var t = r.children, n = r.minMenuHeight, a = r.maxMenuHeight, o = r.menuPlacement, i = r.menuPosition, s = r.menuShouldScrollIntoView, l = r.theme, u = za(ah) || {}, c = u.setPortalPlacement, d = ye(null), p = ke(a), f = wt(p, 2), h = f[0], g = f[1], m = ke(null), v = wt(m, 2), y = v[0], w = v[1], I = l.spacing.controlHeight;
  return tu(function() {
    var b = d.current;
    if (b) {
      var D = i === "fixed", S = s && !D, _ = Sy({
        maxHeight: a,
        menuEl: b,
        minHeight: n,
        placement: o,
        shouldScroll: S,
        isFixedPosition: D,
        controlHeight: I
      });
      g(_.maxHeight), w(_.placement), c == null || c(_.placement);
    }
  }, [a, o, i, s, n, c, I]), t({
    ref: d,
    placerProps: ce(ce({}, r), {}, {
      placement: y || nh(o),
      maxHeight: h
    })
  });
}, ky = function(r) {
  var t = r.children, n = r.innerRef, a = r.innerProps;
  return he("div", pe({}, lt(r, "menu", {
    menu: !0
  }), {
    ref: n
  }, a), t);
}, Ey = ky, My = function(r, t) {
  var n = r.maxHeight, a = r.theme.spacing.baseUnit;
  return ce({
    maxHeight: n,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, t ? {} : {
    paddingBottom: a,
    paddingTop: a
  });
}, Py = function(r) {
  var t = r.children, n = r.innerProps, a = r.innerRef, o = r.isMulti;
  return he("div", pe({}, lt(r, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": o
  }), {
    ref: a
  }, n), t);
}, oh = function(r, t) {
  var n = r.theme, a = n.spacing.baseUnit, o = n.colors;
  return ce({
    textAlign: "center"
  }, t ? {} : {
    color: o.neutral40,
    padding: "".concat(a * 2, "px ").concat(a * 3, "px")
  });
}, Ay = oh, Ry = oh, Oy = function(r) {
  var t = r.children, n = t === void 0 ? "No options" : t, a = r.innerProps, o = Cr(r, Cy);
  return he("div", pe({}, lt(ce(ce({}, o), {}, {
    children: n,
    innerProps: a
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), a), n);
}, Ty = function(r) {
  var t = r.children, n = t === void 0 ? "Loading..." : t, a = r.innerProps, o = Cr(r, xy);
  return he("div", pe({}, lt(ce(ce({}, o), {}, {
    children: n,
    innerProps: a
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), a), n);
}, Fy = function(r) {
  var t = r.rect, n = r.offset, a = r.position;
  return {
    left: t.left,
    position: a,
    top: n,
    width: t.width,
    zIndex: 1
  };
}, Ny = function(r) {
  var t = r.appendTo, n = r.children, a = r.controlElement, o = r.innerProps, i = r.menuPlacement, s = r.menuPosition, l = ye(null), u = ye(null), c = ke(nh(i)), d = wt(c, 2), p = d[0], f = d[1], h = We(function() {
    return {
      setPortalPlacement: f
    };
  }, []), g = ke(null), m = wt(g, 2), v = m[0], y = m[1], w = re(function() {
    if (a) {
      var S = hy(a), _ = s === "fixed" ? 0 : window.pageYOffset, k = S[p] + _;
      (k !== (v == null ? void 0 : v.offset) || S.left !== (v == null ? void 0 : v.rect.left) || S.width !== (v == null ? void 0 : v.rect.width)) && y({
        offset: k,
        rect: S
      });
    }
  }, [a, s, p, v == null ? void 0 : v.offset, v == null ? void 0 : v.rect.left, v == null ? void 0 : v.rect.width]);
  tu(function() {
    w();
  }, [w]);
  var I = re(function() {
    typeof u.current == "function" && (u.current(), u.current = null), a && l.current && (u.current = Kp(a, l.current, w, {
      elementResize: "ResizeObserver" in window
    }));
  }, [a, w]);
  tu(function() {
    I();
  }, [I]);
  var b = re(function(S) {
    l.current = S, I();
  }, [I]);
  if (!t && s !== "fixed" || !v) return null;
  var D = he("div", pe({
    ref: b
  }, lt(ce(ce({}, r), {}, {
    offset: v.offset,
    position: s,
    rect: v.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), o), n);
  return he(ah.Provider, {
    value: h
  }, t ? /* @__PURE__ */ Yb(D, t) : D);
}, Ly = function(r) {
  var t = r.isDisabled, n = r.isRtl;
  return {
    label: "container",
    direction: n ? "rtl" : void 0,
    pointerEvents: t ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, Wy = function(r) {
  var t = r.children, n = r.innerProps, a = r.isDisabled, o = r.isRtl;
  return he("div", pe({}, lt(r, "container", {
    "--is-disabled": a,
    "--is-rtl": o
  }), n), t);
}, By = function(r, t) {
  var n = r.theme.spacing, a = r.isMulti, o = r.hasValue, i = r.selectProps.controlShouldRenderValue;
  return ce({
    alignItems: "center",
    display: a && o && i ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, t ? {} : {
    padding: "".concat(n.baseUnit / 2, "px ").concat(n.baseUnit * 2, "px")
  });
}, Vy = function(r) {
  var t = r.children, n = r.innerProps, a = r.isMulti, o = r.hasValue;
  return he("div", pe({}, lt(r, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": a,
    "value-container--has-value": o
  }), n), t);
}, Gy = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, Yy = function(r) {
  var t = r.children, n = r.innerProps;
  return he("div", pe({}, lt(r, "indicatorsContainer", {
    indicators: !0
  }), n), t);
}, yd, Hy = ["size"], zy = ["innerProps", "isRtl", "size"];
function $y() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Xy = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: $y
}, ih = function(r) {
  var t = r.size, n = Cr(r, Hy);
  return he("svg", pe({
    height: t,
    width: t,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: Xy
  }, n));
}, Xu = function(r) {
  return he(ih, pe({
    size: 20
  }, r), he("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, sh = function(r) {
  return he(ih, pe({
    size: 20
  }, r), he("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, lh = function(r, t) {
  var n = r.isFocused, a = r.theme, o = a.spacing.baseUnit, i = a.colors;
  return ce({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, t ? {} : {
    color: n ? i.neutral60 : i.neutral20,
    padding: o * 2,
    ":hover": {
      color: n ? i.neutral80 : i.neutral40
    }
  });
}, jy = lh, Zy = function(r) {
  var t = r.children, n = r.innerProps;
  return he("div", pe({}, lt(r, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), n), t || he(sh, null));
}, Uy = lh, Jy = function(r) {
  var t = r.children, n = r.innerProps;
  return he("div", pe({}, lt(r, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), n), t || he(Xu, null));
}, Qy = function(r, t) {
  var n = r.isDisabled, a = r.theme, o = a.spacing.baseUnit, i = a.colors;
  return ce({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, t ? {} : {
    backgroundColor: n ? i.neutral10 : i.neutral20,
    marginBottom: o * 2,
    marginTop: o * 2
  });
}, qy = function(r) {
  var t = r.innerProps;
  return he("span", pe({}, t, lt(r, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, Ky = Fp(yd || (yd = p0([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), ew = function(r, t) {
  var n = r.isFocused, a = r.size, o = r.theme, i = o.colors, s = o.spacing.baseUnit;
  return ce({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: a,
    lineHeight: 1,
    marginRight: a,
    textAlign: "center",
    verticalAlign: "middle"
  }, t ? {} : {
    color: n ? i.neutral60 : i.neutral20,
    padding: s * 2
  });
}, pl = function(r) {
  var t = r.delay, n = r.offset;
  return he("span", {
    css: /* @__PURE__ */ Tp({
      animation: "".concat(Ky, " 1s ease-in-out ").concat(t, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: n ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, tw = function(r) {
  var t = r.innerProps, n = r.isRtl, a = r.size, o = a === void 0 ? 4 : a, i = Cr(r, zy);
  return he("div", pe({}, lt(ce(ce({}, i), {}, {
    innerProps: t,
    isRtl: n,
    size: o
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), t), he(pl, {
    delay: 0,
    offset: n
  }), he(pl, {
    delay: 160,
    offset: !0
  }), he(pl, {
    delay: 320,
    offset: !n
  }));
}, rw = function(r, t) {
  var n = r.isDisabled, a = r.isFocused, o = r.theme, i = o.colors, s = o.borderRadius, l = o.spacing;
  return ce({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: l.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, t ? {} : {
    backgroundColor: n ? i.neutral5 : i.neutral0,
    borderColor: n ? i.neutral10 : a ? i.primary : i.neutral20,
    borderRadius: s,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: a ? "0 0 0 1px ".concat(i.primary) : void 0,
    "&:hover": {
      borderColor: a ? i.primary : i.neutral30
    }
  });
}, nw = function(r) {
  var t = r.children, n = r.isDisabled, a = r.isFocused, o = r.innerRef, i = r.innerProps, s = r.menuIsOpen;
  return he("div", pe({
    ref: o
  }, lt(r, "control", {
    control: !0,
    "control--is-disabled": n,
    "control--is-focused": a,
    "control--menu-is-open": s
  }), i, {
    "aria-disabled": n || void 0
  }), t);
}, aw = nw, ow = ["data"], iw = function(r, t) {
  var n = r.theme.spacing;
  return t ? {} : {
    paddingBottom: n.baseUnit * 2,
    paddingTop: n.baseUnit * 2
  };
}, sw = function(r) {
  var t = r.children, n = r.cx, a = r.getStyles, o = r.getClassNames, i = r.Heading, s = r.headingProps, l = r.innerProps, u = r.label, c = r.theme, d = r.selectProps;
  return he("div", pe({}, lt(r, "group", {
    group: !0
  }), l), he(i, pe({}, s, {
    selectProps: d,
    theme: c,
    getStyles: a,
    getClassNames: o,
    cx: n
  }), u), he("div", null, t));
}, lw = function(r, t) {
  var n = r.theme, a = n.colors, o = n.spacing;
  return ce({
    label: "group",
    cursor: "default",
    display: "block"
  }, t ? {} : {
    color: a.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: o.baseUnit * 3,
    paddingRight: o.baseUnit * 3,
    textTransform: "uppercase"
  });
}, uw = function(r) {
  var t = eh(r);
  t.data;
  var n = Cr(t, ow);
  return he("div", pe({}, lt(r, "groupHeading", {
    "group-heading": !0
  }), n));
}, cw = sw, dw = ["innerRef", "isDisabled", "isHidden", "inputClassName"], fw = function(r, t) {
  var n = r.isDisabled, a = r.value, o = r.theme, i = o.spacing, s = o.colors;
  return ce(ce({
    visibility: n ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: a ? "translateZ(0)" : ""
  }, pw), t ? {} : {
    margin: i.baseUnit / 2,
    paddingBottom: i.baseUnit / 2,
    paddingTop: i.baseUnit / 2,
    color: s.neutral80
  });
}, uh = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, pw = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": ce({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, uh)
}, hw = function(r) {
  return ce({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: r ? 0 : 1,
    width: "100%"
  }, uh);
}, gw = function(r) {
  var t = r.cx, n = r.value, a = eh(r), o = a.innerRef, i = a.isDisabled, s = a.isHidden, l = a.inputClassName, u = Cr(a, dw);
  return he("div", pe({}, lt(r, "input", {
    "input-container": !0
  }), {
    "data-value": n || ""
  }), he("input", pe({
    className: t({
      input: !0
    }, l),
    ref: o,
    style: hw(s),
    disabled: i
  }, u)));
}, mw = gw, vw = function(r, t) {
  var n = r.theme, a = n.spacing, o = n.borderRadius, i = n.colors;
  return ce({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, t ? {} : {
    backgroundColor: i.neutral10,
    borderRadius: o / 2,
    margin: a.baseUnit / 2
  });
}, bw = function(r, t) {
  var n = r.theme, a = n.borderRadius, o = n.colors, i = r.cropWithEllipsis;
  return ce({
    overflow: "hidden",
    textOverflow: i || i === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, t ? {} : {
    borderRadius: a / 2,
    color: o.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, yw = function(r, t) {
  var n = r.theme, a = n.spacing, o = n.borderRadius, i = n.colors, s = r.isFocused;
  return ce({
    alignItems: "center",
    display: "flex"
  }, t ? {} : {
    borderRadius: o / 2,
    backgroundColor: s ? i.dangerLight : void 0,
    paddingLeft: a.baseUnit,
    paddingRight: a.baseUnit,
    ":hover": {
      backgroundColor: i.dangerLight,
      color: i.danger
    }
  });
}, ch = function(r) {
  var t = r.children, n = r.innerProps;
  return he("div", n, t);
}, ww = ch, Cw = ch;
function xw(e) {
  var r = e.children, t = e.innerProps;
  return he("div", pe({
    role: "button"
  }, t), r || he(Xu, {
    size: 14
  }));
}
var Sw = function(r) {
  var t = r.children, n = r.components, a = r.data, o = r.innerProps, i = r.isDisabled, s = r.removeProps, l = r.selectProps, u = n.Container, c = n.Label, d = n.Remove;
  return he(u, {
    data: a,
    innerProps: ce(ce({}, lt(r, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": i
    })), o),
    selectProps: l
  }, he(c, {
    data: a,
    innerProps: ce({}, lt(r, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: l
  }, t), he(d, {
    data: a,
    innerProps: ce(ce({}, lt(r, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(t || "option")
    }, s),
    selectProps: l
  }));
}, Iw = Sw, Dw = function(r, t) {
  var n = r.isDisabled, a = r.isFocused, o = r.isSelected, i = r.theme, s = i.spacing, l = i.colors;
  return ce({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, t ? {} : {
    backgroundColor: o ? l.primary : a ? l.primary25 : "transparent",
    color: n ? l.neutral20 : o ? l.neutral0 : "inherit",
    padding: "".concat(s.baseUnit * 2, "px ").concat(s.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: n ? void 0 : o ? l.primary : l.primary50
    }
  });
}, _w = function(r) {
  var t = r.children, n = r.isDisabled, a = r.isFocused, o = r.isSelected, i = r.innerRef, s = r.innerProps;
  return he("div", pe({}, lt(r, "option", {
    option: !0,
    "option--is-disabled": n,
    "option--is-focused": a,
    "option--is-selected": o
  }), {
    ref: i,
    "aria-disabled": n
  }, s), t);
}, kw = _w, Ew = function(r, t) {
  var n = r.theme, a = n.spacing, o = n.colors;
  return ce({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, t ? {} : {
    color: o.neutral50,
    marginLeft: a.baseUnit / 2,
    marginRight: a.baseUnit / 2
  });
}, Mw = function(r) {
  var t = r.children, n = r.innerProps;
  return he("div", pe({}, lt(r, "placeholder", {
    placeholder: !0
  }), n), t);
}, Pw = Mw, Aw = function(r, t) {
  var n = r.isDisabled, a = r.theme, o = a.spacing, i = a.colors;
  return ce({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, t ? {} : {
    color: n ? i.neutral40 : i.neutral80,
    marginLeft: o.baseUnit / 2,
    marginRight: o.baseUnit / 2
  });
}, Rw = function(r) {
  var t = r.children, n = r.isDisabled, a = r.innerProps;
  return he("div", pe({}, lt(r, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": n
  }), a), t);
}, Ow = Rw, Tw = {
  ClearIndicator: Jy,
  Control: aw,
  DropdownIndicator: Zy,
  DownChevron: sh,
  CrossIcon: Xu,
  Group: cw,
  GroupHeading: uw,
  IndicatorsContainer: Yy,
  IndicatorSeparator: qy,
  Input: mw,
  LoadingIndicator: tw,
  Menu: Ey,
  MenuList: Py,
  MenuPortal: Ny,
  LoadingMessage: Ty,
  NoOptionsMessage: Oy,
  MultiValue: Iw,
  MultiValueContainer: ww,
  MultiValueLabel: Cw,
  MultiValueRemove: xw,
  Option: kw,
  Placeholder: Pw,
  SelectContainer: Wy,
  SingleValue: Ow,
  ValueContainer: Vy
}, Fw = function(r) {
  return ce(ce({}, Tw), r.components);
}, wd = Number.isNaN || function(r) {
  return typeof r == "number" && r !== r;
};
function Nw(e, r) {
  return !!(e === r || wd(e) && wd(r));
}
function Lw(e, r) {
  if (e.length !== r.length)
    return !1;
  for (var t = 0; t < e.length; t++)
    if (!Nw(e[t], r[t]))
      return !1;
  return !0;
}
function Ww(e, r) {
  r === void 0 && (r = Lw);
  var t = null;
  function n() {
    for (var a = [], o = 0; o < arguments.length; o++)
      a[o] = arguments[o];
    if (t && t.lastThis === this && r(a, t.lastArgs))
      return t.lastResult;
    var i = e.apply(this, a);
    return t = {
      lastResult: i,
      lastArgs: a,
      lastThis: this
    }, i;
  }
  return n.clear = function() {
    t = null;
  }, n;
}
function Bw() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Vw = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: Bw
}, Gw = function(r) {
  return he("span", pe({
    css: Vw
  }, r));
}, Cd = Gw, Yw = {
  guidance: function(r) {
    var t = r.isSearchable, n = r.isMulti, a = r.tabSelectsValue, o = r.context, i = r.isInitialFocus;
    switch (o) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(a ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return i ? "".concat(r["aria-label"] || "Select", " is focused ").concat(t ? ",type to refine list" : "", ", press Down to open the menu, ").concat(n ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(r) {
    var t = r.action, n = r.label, a = n === void 0 ? "" : n, o = r.labels, i = r.isDisabled;
    switch (t) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(a, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(o.length > 1 ? "s" : "", " ").concat(o.join(","), ", selected.");
      case "select-option":
        return i ? "option ".concat(a, " is disabled. Select another option.") : "option ".concat(a, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(r) {
    var t = r.context, n = r.focused, a = r.options, o = r.label, i = o === void 0 ? "" : o, s = r.selectValue, l = r.isDisabled, u = r.isSelected, c = r.isAppleDevice, d = function(g, m) {
      return g && g.length ? "".concat(g.indexOf(m) + 1, " of ").concat(g.length) : "";
    };
    if (t === "value" && s)
      return "value ".concat(i, " focused, ").concat(d(s, n), ".");
    if (t === "menu" && c) {
      var p = l ? " disabled" : "", f = "".concat(u ? " selected" : "").concat(p);
      return "".concat(i).concat(f, ", ").concat(d(a, n), ".");
    }
    return "";
  },
  onFilter: function(r) {
    var t = r.inputValue, n = r.resultsMessage;
    return "".concat(n).concat(t ? " for search term " + t : "", ".");
  }
}, Hw = function(r) {
  var t = r.ariaSelection, n = r.focusedOption, a = r.focusedValue, o = r.focusableOptions, i = r.isFocused, s = r.selectValue, l = r.selectProps, u = r.id, c = r.isAppleDevice, d = l.ariaLiveMessages, p = l.getOptionLabel, f = l.inputValue, h = l.isMulti, g = l.isOptionDisabled, m = l.isSearchable, v = l.menuIsOpen, y = l.options, w = l.screenReaderStatus, I = l.tabSelectsValue, b = l.isLoading, D = l["aria-label"], S = l["aria-live"], _ = We(function() {
    return ce(ce({}, Yw), d || {});
  }, [d]), k = We(function() {
    var H = "";
    if (t && _.onChange) {
      var A = t.option, N = t.options, G = t.removedValue, Q = t.removedValues, L = t.value, O = function(se) {
        return Array.isArray(se) ? null : se;
      }, $ = G || A || O(L), Y = $ ? p($) : "", X = N || Q || void 0, ne = X ? X.map(p) : [], K = ce({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: $ && g($, s),
        label: Y,
        labels: ne
      }, t);
      H = _.onChange(K);
    }
    return H;
  }, [t, _, g, s, p]), R = We(function() {
    var H = "", A = n || a, N = !!(n && s && s.includes(n));
    if (A && _.onFocus) {
      var G = {
        focused: A,
        label: p(A),
        isDisabled: g(A, s),
        isSelected: N,
        options: o,
        context: A === n ? "menu" : "value",
        selectValue: s,
        isAppleDevice: c
      };
      H = _.onFocus(G);
    }
    return H;
  }, [n, a, p, g, _, o, s, c]), W = We(function() {
    var H = "";
    if (v && y.length && !b && _.onFilter) {
      var A = w({
        count: o.length
      });
      H = _.onFilter({
        inputValue: f,
        resultsMessage: A
      });
    }
    return H;
  }, [o, f, v, _, y, w, b]), B = (t == null ? void 0 : t.action) === "initial-input-focus", V = We(function() {
    var H = "";
    if (_.guidance) {
      var A = a ? "value" : v ? "menu" : "input";
      H = _.guidance({
        "aria-label": D,
        context: A,
        isDisabled: n && g(n, s),
        isMulti: h,
        isSearchable: m,
        tabSelectsValue: I,
        isInitialFocus: B
      });
    }
    return H;
  }, [D, n, a, h, g, m, v, _, s, I, B]), F = he(Gi, null, he("span", {
    id: "aria-selection"
  }, k), he("span", {
    id: "aria-focused"
  }, R), he("span", {
    id: "aria-results"
  }, W), he("span", {
    id: "aria-guidance"
  }, V));
  return he(Gi, null, he(Cd, {
    id: u
  }, B && F), he(Cd, {
    "aria-live": S,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, i && !B && F));
}, zw = Hw, ru = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], $w = new RegExp("[" + ru.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), dh = {};
for (var hl = 0; hl < ru.length; hl++)
  for (var gl = ru[hl], ml = 0; ml < gl.letters.length; ml++)
    dh[gl.letters[ml]] = gl.base;
var fh = function(r) {
  return r.replace($w, function(t) {
    return dh[t];
  });
}, Xw = Ww(fh), xd = function(r) {
  return r.replace(/^\s+|\s+$/g, "");
}, jw = function(r) {
  return "".concat(r.label, " ").concat(r.value);
}, Zw = function(r) {
  return function(t, n) {
    if (t.data.__isNew__) return !0;
    var a = ce({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: jw,
      trim: !0,
      matchFrom: "any"
    }, r), o = a.ignoreCase, i = a.ignoreAccents, s = a.stringify, l = a.trim, u = a.matchFrom, c = l ? xd(n) : n, d = l ? xd(s(t)) : s(t);
    return o && (c = c.toLowerCase(), d = d.toLowerCase()), i && (c = Xw(c), d = fh(d)), u === "start" ? d.substr(0, c.length) === c : d.indexOf(c) > -1;
  };
}, Uw = ["innerRef"];
function Jw(e) {
  var r = e.innerRef, t = Cr(e, Uw), n = wy(t, "onExited", "in", "enter", "exit", "appear");
  return he("input", pe({
    ref: r
  }, n, {
    css: /* @__PURE__ */ Tp({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var Qw = function(r) {
  r.cancelable && r.preventDefault(), r.stopPropagation();
};
function qw(e) {
  var r = e.isEnabled, t = e.onBottomArrive, n = e.onBottomLeave, a = e.onTopArrive, o = e.onTopLeave, i = ye(!1), s = ye(!1), l = ye(0), u = ye(null), c = re(function(m, v) {
    if (u.current !== null) {
      var y = u.current, w = y.scrollTop, I = y.scrollHeight, b = y.clientHeight, D = u.current, S = v > 0, _ = I - b - w, k = !1;
      _ > v && i.current && (n && n(m), i.current = !1), S && s.current && (o && o(m), s.current = !1), S && v > _ ? (t && !i.current && t(m), D.scrollTop = I, k = !0, i.current = !0) : !S && -v > w && (a && !s.current && a(m), D.scrollTop = 0, k = !0, s.current = !0), k && Qw(m);
    }
  }, [t, n, a, o]), d = re(function(m) {
    c(m, m.deltaY);
  }, [c]), p = re(function(m) {
    l.current = m.changedTouches[0].clientY;
  }, []), f = re(function(m) {
    var v = l.current - m.changedTouches[0].clientY;
    c(m, v);
  }, [c]), h = re(function(m) {
    if (m) {
      var v = vy ? {
        passive: !1
      } : !1;
      m.addEventListener("wheel", d, v), m.addEventListener("touchstart", p, v), m.addEventListener("touchmove", f, v);
    }
  }, [f, p, d]), g = re(function(m) {
    m && (m.removeEventListener("wheel", d, !1), m.removeEventListener("touchstart", p, !1), m.removeEventListener("touchmove", f, !1));
  }, [f, p, d]);
  return He(function() {
    if (r) {
      var m = u.current;
      return h(m), function() {
        g(m);
      };
    }
  }, [r, h, g]), function(m) {
    u.current = m;
  };
}
var Sd = ["boxSizing", "height", "overflow", "paddingRight", "position"], Id = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function Dd(e) {
  e.preventDefault();
}
function _d(e) {
  e.stopPropagation();
}
function kd() {
  var e = this.scrollTop, r = this.scrollHeight, t = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : t === r && (this.scrollTop = e - 1);
}
function Ed() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var Md = !!(typeof window < "u" && window.document && window.document.createElement), io = 0, ma = {
  capture: !1,
  passive: !1
};
function Kw(e) {
  var r = e.isEnabled, t = e.accountForScrollbars, n = t === void 0 ? !0 : t, a = ye({}), o = ye(null), i = re(function(l) {
    if (Md) {
      var u = document.body, c = u && u.style;
      if (n && Sd.forEach(function(h) {
        var g = c && c[h];
        a.current[h] = g;
      }), n && io < 1) {
        var d = parseInt(a.current.paddingRight, 10) || 0, p = document.body ? document.body.clientWidth : 0, f = window.innerWidth - p + d || 0;
        Object.keys(Id).forEach(function(h) {
          var g = Id[h];
          c && (c[h] = g);
        }), c && (c.paddingRight = "".concat(f, "px"));
      }
      u && Ed() && (u.addEventListener("touchmove", Dd, ma), l && (l.addEventListener("touchstart", kd, ma), l.addEventListener("touchmove", _d, ma))), io += 1;
    }
  }, [n]), s = re(function(l) {
    if (Md) {
      var u = document.body, c = u && u.style;
      io = Math.max(io - 1, 0), n && io < 1 && Sd.forEach(function(d) {
        var p = a.current[d];
        c && (c[d] = p);
      }), u && Ed() && (u.removeEventListener("touchmove", Dd, ma), l && (l.removeEventListener("touchstart", kd, ma), l.removeEventListener("touchmove", _d, ma)));
    }
  }, [n]);
  return He(function() {
    if (r) {
      var l = o.current;
      return i(l), function() {
        s(l);
      };
    }
  }, [r, i, s]), function(l) {
    o.current = l;
  };
}
function eC() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var tC = function(r) {
  var t = r.target;
  return t.ownerDocument.activeElement && t.ownerDocument.activeElement.blur();
}, rC = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: eC
};
function nC(e) {
  var r = e.children, t = e.lockEnabled, n = e.captureEnabled, a = n === void 0 ? !0 : n, o = e.onBottomArrive, i = e.onBottomLeave, s = e.onTopArrive, l = e.onTopLeave, u = qw({
    isEnabled: a,
    onBottomArrive: o,
    onBottomLeave: i,
    onTopArrive: s,
    onTopLeave: l
  }), c = Kw({
    isEnabled: t
  }), d = function(f) {
    u(f), c(f);
  };
  return he(Gi, null, t && he("div", {
    onClick: tC,
    css: rC
  }), r(d));
}
function aC() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var oC = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: aC
}, iC = function(r) {
  var t = r.name, n = r.onFocus;
  return he("input", {
    required: !0,
    name: t,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: n,
    css: oC,
    value: "",
    onChange: function() {
    }
  });
}, sC = iC;
function ju(e) {
  var r;
  return typeof window < "u" && window.navigator != null ? e.test(((r = window.navigator.userAgentData) === null || r === void 0 ? void 0 : r.platform) || window.navigator.platform) : !1;
}
function lC() {
  return ju(/^iPhone/i);
}
function ph() {
  return ju(/^Mac/i);
}
function uC() {
  return ju(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  ph() && navigator.maxTouchPoints > 1;
}
function cC() {
  return lC() || uC();
}
function dC() {
  return ph() || cC();
}
var fC = function(r) {
  return r.label;
}, hh = function(r) {
  return r.label;
}, gh = function(r) {
  return r.value;
}, pC = function(r) {
  return !!r.isDisabled;
}, hC = {
  clearIndicator: Uy,
  container: Ly,
  control: rw,
  dropdownIndicator: jy,
  group: iw,
  groupHeading: lw,
  indicatorsContainer: Gy,
  indicatorSeparator: Qy,
  input: fw,
  loadingIndicator: ew,
  loadingMessage: Ry,
  menu: Dy,
  menuList: My,
  menuPortal: Fy,
  multiValue: vw,
  multiValueLabel: bw,
  multiValueRemove: yw,
  noOptionsMessage: Ay,
  option: Dw,
  placeholder: Ew,
  singleValue: Aw,
  valueContainer: By
}, gC = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, mC = 4, mh = 4, vC = 38, bC = mh * 2, yC = {
  baseUnit: mh,
  controlHeight: vC,
  menuGutter: bC
}, vl = {
  borderRadius: mC,
  colors: gC,
  spacing: yC
}, wC = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: bd(),
  captureMenuScroll: !bd(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: Zw(),
  formatGroupLabel: fC,
  getOptionLabel: hh,
  getOptionValue: gh,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: pC,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !gy(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(r) {
    var t = r.count;
    return "".concat(t, " result").concat(t !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function Pd(e, r, t, n) {
  var a = yh(e, r, t), o = wh(e, r, t), i = bh(e, r), s = qi(e, r);
  return {
    type: "option",
    data: r,
    isDisabled: a,
    isSelected: o,
    label: i,
    value: s,
    index: n
  };
}
function ki(e, r) {
  return e.options.map(function(t, n) {
    if ("options" in t) {
      var a = t.options.map(function(i, s) {
        return Pd(e, i, r, s);
      }).filter(function(i) {
        return Rd(e, i);
      });
      return a.length > 0 ? {
        type: "group",
        data: t,
        options: a,
        index: n
      } : void 0;
    }
    var o = Pd(e, t, r, n);
    return Rd(e, o) ? o : void 0;
  }).filter(by);
}
function vh(e) {
  return e.reduce(function(r, t) {
    return t.type === "group" ? r.push.apply(r, Ia(t.options.map(function(n) {
      return n.data;
    }))) : r.push(t.data), r;
  }, []);
}
function Ad(e, r) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, Ia(n.options.map(function(a) {
      return {
        data: a.data,
        id: "".concat(r, "-").concat(n.index, "-").concat(a.index)
      };
    }))) : t.push({
      data: n.data,
      id: "".concat(r, "-").concat(n.index)
    }), t;
  }, []);
}
function CC(e, r) {
  return vh(ki(e, r));
}
function Rd(e, r) {
  var t = e.inputValue, n = t === void 0 ? "" : t, a = r.data, o = r.isSelected, i = r.label, s = r.value;
  return (!xh(e) || !o) && Ch(e, {
    label: i,
    value: s,
    data: a
  }, n);
}
function xC(e, r) {
  var t = e.focusedValue, n = e.selectValue, a = n.indexOf(t);
  if (a > -1) {
    var o = r.indexOf(t);
    if (o > -1)
      return t;
    if (a < r.length)
      return r[a];
  }
  return null;
}
function SC(e, r) {
  var t = e.focusedOption;
  return t && r.indexOf(t) > -1 ? t : r[0];
}
var bl = function(r, t) {
  var n, a = (n = r.find(function(o) {
    return o.data === t;
  })) === null || n === void 0 ? void 0 : n.id;
  return a || null;
}, bh = function(r, t) {
  return r.getOptionLabel(t);
}, qi = function(r, t) {
  return r.getOptionValue(t);
};
function yh(e, r, t) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(r, t) : !1;
}
function wh(e, r, t) {
  if (t.indexOf(r) > -1) return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(r, t);
  var n = qi(e, r);
  return t.some(function(a) {
    return qi(e, a) === n;
  });
}
function Ch(e, r, t) {
  return e.filterOption ? e.filterOption(r, t) : !0;
}
var xh = function(r) {
  var t = r.hideSelectedOptions, n = r.isMulti;
  return t === void 0 ? n : t;
}, IC = 1, Xo = /* @__PURE__ */ function(e) {
  i0(t, e);
  var r = u0(t);
  function t(n) {
    var a;
    if (a0(this, t), a = r.call(this, n), a.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, a.blockOptionHover = !1, a.isComposing = !1, a.commonProps = void 0, a.initialTouchX = 0, a.initialTouchY = 0, a.openAfterFocus = !1, a.scrollToFocusedOptionOnUpdate = !1, a.userIsDragging = void 0, a.isAppleDevice = dC(), a.controlRef = null, a.getControlRef = function(l) {
      a.controlRef = l;
    }, a.focusedOptionRef = null, a.getFocusedOptionRef = function(l) {
      a.focusedOptionRef = l;
    }, a.menuListRef = null, a.getMenuListRef = function(l) {
      a.menuListRef = l;
    }, a.inputRef = null, a.getInputRef = function(l) {
      a.inputRef = l;
    }, a.focus = a.focusInput, a.blur = a.blurInput, a.onChange = function(l, u) {
      var c = a.props, d = c.onChange, p = c.name;
      u.name = p, a.ariaOnChange(l, u), d(l, u);
    }, a.setValue = function(l, u, c) {
      var d = a.props, p = d.closeMenuOnSelect, f = d.isMulti, h = d.inputValue;
      a.onInputChange("", {
        action: "set-value",
        prevInputValue: h
      }), p && (a.setState({
        inputIsHiddenAfterUpdate: !f
      }), a.onMenuClose()), a.setState({
        clearFocusValueOnUpdate: !0
      }), a.onChange(l, {
        action: u,
        option: c
      });
    }, a.selectOption = function(l) {
      var u = a.props, c = u.blurInputOnSelect, d = u.isMulti, p = u.name, f = a.state.selectValue, h = d && a.isOptionSelected(l, f), g = a.isOptionDisabled(l, f);
      if (h) {
        var m = a.getOptionValue(l);
        a.setValue(f.filter(function(v) {
          return a.getOptionValue(v) !== m;
        }), "deselect-option", l);
      } else if (!g)
        d ? a.setValue([].concat(Ia(f), [l]), "select-option", l) : a.setValue(l, "select-option");
      else {
        a.ariaOnChange(l, {
          action: "select-option",
          option: l,
          name: p
        });
        return;
      }
      c && a.blurInput();
    }, a.removeValue = function(l) {
      var u = a.props.isMulti, c = a.state.selectValue, d = a.getOptionValue(l), p = c.filter(function(h) {
        return a.getOptionValue(h) !== d;
      }), f = yo(u, p, p[0] || null);
      a.onChange(f, {
        action: "remove-value",
        removedValue: l
      }), a.focusInput();
    }, a.clearValue = function() {
      var l = a.state.selectValue;
      a.onChange(yo(a.props.isMulti, [], null), {
        action: "clear",
        removedValues: l
      });
    }, a.popValue = function() {
      var l = a.props.isMulti, u = a.state.selectValue, c = u[u.length - 1], d = u.slice(0, u.length - 1), p = yo(l, d, d[0] || null);
      a.onChange(p, {
        action: "pop-value",
        removedValue: c
      });
    }, a.getFocusedOptionId = function(l) {
      return bl(a.state.focusableOptionsWithIds, l);
    }, a.getFocusableOptionsWithIds = function() {
      return Ad(ki(a.props, a.state.selectValue), a.getElementId("option"));
    }, a.getValue = function() {
      return a.state.selectValue;
    }, a.cx = function() {
      for (var l = arguments.length, u = new Array(l), c = 0; c < l; c++)
        u[c] = arguments[c];
      return uy.apply(void 0, [a.props.classNamePrefix].concat(u));
    }, a.getOptionLabel = function(l) {
      return bh(a.props, l);
    }, a.getOptionValue = function(l) {
      return qi(a.props, l);
    }, a.getStyles = function(l, u) {
      var c = a.props.unstyled, d = hC[l](u, c);
      d.boxSizing = "border-box";
      var p = a.props.styles[l];
      return p ? p(d, u) : d;
    }, a.getClassNames = function(l, u) {
      var c, d;
      return (c = (d = a.props.classNames)[l]) === null || c === void 0 ? void 0 : c.call(d, u);
    }, a.getElementId = function(l) {
      return "".concat(a.state.instancePrefix, "-").concat(l);
    }, a.getComponents = function() {
      return Fw(a.props);
    }, a.buildCategorizedOptions = function() {
      return ki(a.props, a.state.selectValue);
    }, a.getCategorizedOptions = function() {
      return a.props.menuIsOpen ? a.buildCategorizedOptions() : [];
    }, a.buildFocusableOptions = function() {
      return vh(a.buildCategorizedOptions());
    }, a.getFocusableOptions = function() {
      return a.props.menuIsOpen ? a.buildFocusableOptions() : [];
    }, a.ariaOnChange = function(l, u) {
      a.setState({
        ariaSelection: ce({
          value: l
        }, u)
      });
    }, a.onMenuMouseDown = function(l) {
      l.button === 0 && (l.stopPropagation(), l.preventDefault(), a.focusInput());
    }, a.onMenuMouseMove = function(l) {
      a.blockOptionHover = !1;
    }, a.onControlMouseDown = function(l) {
      if (!l.defaultPrevented) {
        var u = a.props.openMenuOnClick;
        a.state.isFocused ? a.props.menuIsOpen ? l.target.tagName !== "INPUT" && l.target.tagName !== "TEXTAREA" && a.onMenuClose() : u && a.openMenu("first") : (u && (a.openAfterFocus = !0), a.focusInput()), l.target.tagName !== "INPUT" && l.target.tagName !== "TEXTAREA" && l.preventDefault();
      }
    }, a.onDropdownIndicatorMouseDown = function(l) {
      if (!(l && l.type === "mousedown" && l.button !== 0) && !a.props.isDisabled) {
        var u = a.props, c = u.isMulti, d = u.menuIsOpen;
        a.focusInput(), d ? (a.setState({
          inputIsHiddenAfterUpdate: !c
        }), a.onMenuClose()) : a.openMenu("first"), l.preventDefault();
      }
    }, a.onClearIndicatorMouseDown = function(l) {
      l && l.type === "mousedown" && l.button !== 0 || (a.clearValue(), l.preventDefault(), a.openAfterFocus = !1, l.type === "touchend" ? a.focusInput() : setTimeout(function() {
        return a.focusInput();
      }));
    }, a.onScroll = function(l) {
      typeof a.props.closeMenuOnScroll == "boolean" ? l.target instanceof HTMLElement && As(l.target) && a.props.onMenuClose() : typeof a.props.closeMenuOnScroll == "function" && a.props.closeMenuOnScroll(l) && a.props.onMenuClose();
    }, a.onCompositionStart = function() {
      a.isComposing = !0;
    }, a.onCompositionEnd = function() {
      a.isComposing = !1;
    }, a.onTouchStart = function(l) {
      var u = l.touches, c = u && u.item(0);
      c && (a.initialTouchX = c.clientX, a.initialTouchY = c.clientY, a.userIsDragging = !1);
    }, a.onTouchMove = function(l) {
      var u = l.touches, c = u && u.item(0);
      if (c) {
        var d = Math.abs(c.clientX - a.initialTouchX), p = Math.abs(c.clientY - a.initialTouchY), f = 5;
        a.userIsDragging = d > f || p > f;
      }
    }, a.onTouchEnd = function(l) {
      a.userIsDragging || (a.controlRef && !a.controlRef.contains(l.target) && a.menuListRef && !a.menuListRef.contains(l.target) && a.blurInput(), a.initialTouchX = 0, a.initialTouchY = 0);
    }, a.onControlTouchEnd = function(l) {
      a.userIsDragging || a.onControlMouseDown(l);
    }, a.onClearIndicatorTouchEnd = function(l) {
      a.userIsDragging || a.onClearIndicatorMouseDown(l);
    }, a.onDropdownIndicatorTouchEnd = function(l) {
      a.userIsDragging || a.onDropdownIndicatorMouseDown(l);
    }, a.handleInputChange = function(l) {
      var u = a.props.inputValue, c = l.currentTarget.value;
      a.setState({
        inputIsHiddenAfterUpdate: !1
      }), a.onInputChange(c, {
        action: "input-change",
        prevInputValue: u
      }), a.props.menuIsOpen || a.onMenuOpen();
    }, a.onInputFocus = function(l) {
      a.props.onFocus && a.props.onFocus(l), a.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (a.openAfterFocus || a.props.openMenuOnFocus) && a.openMenu("first"), a.openAfterFocus = !1;
    }, a.onInputBlur = function(l) {
      var u = a.props.inputValue;
      if (a.menuListRef && a.menuListRef.contains(document.activeElement)) {
        a.inputRef.focus();
        return;
      }
      a.props.onBlur && a.props.onBlur(l), a.onInputChange("", {
        action: "input-blur",
        prevInputValue: u
      }), a.onMenuClose(), a.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, a.onOptionHover = function(l) {
      if (!(a.blockOptionHover || a.state.focusedOption === l)) {
        var u = a.getFocusableOptions(), c = u.indexOf(l);
        a.setState({
          focusedOption: l,
          focusedOptionId: c > -1 ? a.getFocusedOptionId(l) : null
        });
      }
    }, a.shouldHideSelectedOptions = function() {
      return xh(a.props);
    }, a.onValueInputFocus = function(l) {
      l.preventDefault(), l.stopPropagation(), a.focus();
    }, a.onKeyDown = function(l) {
      var u = a.props, c = u.isMulti, d = u.backspaceRemovesValue, p = u.escapeClearsValue, f = u.inputValue, h = u.isClearable, g = u.isDisabled, m = u.menuIsOpen, v = u.onKeyDown, y = u.tabSelectsValue, w = u.openMenuOnFocus, I = a.state, b = I.focusedOption, D = I.focusedValue, S = I.selectValue;
      if (!g && !(typeof v == "function" && (v(l), l.defaultPrevented))) {
        switch (a.blockOptionHover = !0, l.key) {
          case "ArrowLeft":
            if (!c || f) return;
            a.focusValue("previous");
            break;
          case "ArrowRight":
            if (!c || f) return;
            a.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (f) return;
            if (D)
              a.removeValue(D);
            else {
              if (!d) return;
              c ? a.popValue() : h && a.clearValue();
            }
            break;
          case "Tab":
            if (a.isComposing || l.shiftKey || !m || !y || !b || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            w && a.isOptionSelected(b, S))
              return;
            a.selectOption(b);
            break;
          case "Enter":
            if (l.keyCode === 229)
              break;
            if (m) {
              if (!b || a.isComposing) return;
              a.selectOption(b);
              break;
            }
            return;
          case "Escape":
            m ? (a.setState({
              inputIsHiddenAfterUpdate: !1
            }), a.onInputChange("", {
              action: "menu-close",
              prevInputValue: f
            }), a.onMenuClose()) : h && p && a.clearValue();
            break;
          case " ":
            if (f)
              return;
            if (!m) {
              a.openMenu("first");
              break;
            }
            if (!b) return;
            a.selectOption(b);
            break;
          case "ArrowUp":
            m ? a.focusOption("up") : a.openMenu("last");
            break;
          case "ArrowDown":
            m ? a.focusOption("down") : a.openMenu("first");
            break;
          case "PageUp":
            if (!m) return;
            a.focusOption("pageup");
            break;
          case "PageDown":
            if (!m) return;
            a.focusOption("pagedown");
            break;
          case "Home":
            if (!m) return;
            a.focusOption("first");
            break;
          case "End":
            if (!m) return;
            a.focusOption("last");
            break;
          default:
            return;
        }
        l.preventDefault();
      }
    }, a.state.instancePrefix = "react-select-" + (a.props.instanceId || ++IC), a.state.selectValue = Ji(n.value), n.menuIsOpen && a.state.selectValue.length) {
      var o = a.getFocusableOptionsWithIds(), i = a.buildFocusableOptions(), s = i.indexOf(a.state.selectValue[0]);
      a.state.focusableOptionsWithIds = o, a.state.focusedOption = i[s], a.state.focusedOptionId = bl(o, i[s]);
    }
    return a;
  }
  return o0(t, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && vd(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var o = this.props, i = o.isDisabled, s = o.menuIsOpen, l = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (l && !i && a.isDisabled || // ensure focus is on the Input when the menu opens
      l && s && !a.menuIsOpen) && this.focusInput(), l && i && !a.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !l && !i && a.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (vd(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(a, o) {
      this.props.onInputChange(a, o);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(a) {
      var o = this, i = this.state, s = i.selectValue, l = i.isFocused, u = this.buildFocusableOptions(), c = a === "first" ? 0 : u.length - 1;
      if (!this.props.isMulti) {
        var d = u.indexOf(s[0]);
        d > -1 && (c = d);
      }
      this.scrollToFocusedOptionOnUpdate = !(l && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: u[c],
        focusedOptionId: this.getFocusedOptionId(u[c])
      }, function() {
        return o.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(a) {
      var o = this.state, i = o.selectValue, s = o.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var l = i.indexOf(s);
        s || (l = -1);
        var u = i.length - 1, c = -1;
        if (i.length) {
          switch (a) {
            case "previous":
              l === 0 ? c = 0 : l === -1 ? c = u : c = l - 1;
              break;
            case "next":
              l > -1 && l < u && (c = l + 1);
              break;
          }
          this.setState({
            inputIsHidden: c !== -1,
            focusedValue: i[c]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", o = this.props.pageSize, i = this.state.focusedOption, s = this.getFocusableOptions();
      if (s.length) {
        var l = 0, u = s.indexOf(i);
        i || (u = -1), a === "up" ? l = u > 0 ? u - 1 : s.length - 1 : a === "down" ? l = (u + 1) % s.length : a === "pageup" ? (l = u - o, l < 0 && (l = 0)) : a === "pagedown" ? (l = u + o, l > s.length - 1 && (l = s.length - 1)) : a === "last" && (l = s.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: s[l],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(s[l])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(vl) : ce(ce({}, vl), this.props.theme) : vl;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var a = this.clearValue, o = this.cx, i = this.getStyles, s = this.getClassNames, l = this.getValue, u = this.selectOption, c = this.setValue, d = this.props, p = d.isMulti, f = d.isRtl, h = d.options, g = this.hasValue();
      return {
        clearValue: a,
        cx: o,
        getStyles: i,
        getClassNames: s,
        getValue: l,
        hasValue: g,
        isMulti: p,
        isRtl: f,
        options: h,
        selectOption: u,
        selectProps: d,
        setValue: c,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var a = this.state.selectValue;
      return a.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var a = this.props, o = a.isClearable, i = a.isMulti;
      return o === void 0 ? i : o;
    }
  }, {
    key: "isOptionDisabled",
    value: function(a, o) {
      return yh(this.props, a, o);
    }
  }, {
    key: "isOptionSelected",
    value: function(a, o) {
      return wh(this.props, a, o);
    }
  }, {
    key: "filterOption",
    value: function(a, o) {
      return Ch(this.props, a, o);
    }
  }, {
    key: "formatOptionLabel",
    value: function(a, o) {
      if (typeof this.props.formatOptionLabel == "function") {
        var i = this.props.inputValue, s = this.state.selectValue;
        return this.props.formatOptionLabel(a, {
          context: o,
          inputValue: i,
          selectValue: s
        });
      } else
        return this.getOptionLabel(a);
    }
  }, {
    key: "formatGroupLabel",
    value: function(a) {
      return this.props.formatGroupLabel(a);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var a = this.props, o = a.isDisabled, i = a.isSearchable, s = a.inputId, l = a.inputValue, u = a.tabIndex, c = a.form, d = a.menuIsOpen, p = a.required, f = this.getComponents(), h = f.Input, g = this.state, m = g.inputIsHidden, v = g.ariaSelection, y = this.commonProps, w = s || this.getElementId("input"), I = ce(ce(ce({
          "aria-autocomplete": "list",
          "aria-expanded": d,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": p,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, d && {
          "aria-controls": this.getElementId("listbox")
        }), !i && {
          "aria-readonly": !0
        }), this.hasValue() ? (v == null ? void 0 : v.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return i ? /* @__PURE__ */ U.createElement(h, pe({}, y, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: w,
          innerRef: this.getInputRef,
          isDisabled: o,
          isHidden: m,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: u,
          form: c,
          type: "text",
          value: l
        }, I)) : /* @__PURE__ */ U.createElement(Jw, pe({
          id: w,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: Ui,
          onFocus: this.onInputFocus,
          disabled: o,
          tabIndex: u,
          inputMode: "none",
          form: c,
          value: ""
        }, I));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var a = this, o = this.getComponents(), i = o.MultiValue, s = o.MultiValueContainer, l = o.MultiValueLabel, u = o.MultiValueRemove, c = o.SingleValue, d = o.Placeholder, p = this.commonProps, f = this.props, h = f.controlShouldRenderValue, g = f.isDisabled, m = f.isMulti, v = f.inputValue, y = f.placeholder, w = this.state, I = w.selectValue, b = w.focusedValue, D = w.isFocused;
      if (!this.hasValue() || !h)
        return v ? null : /* @__PURE__ */ U.createElement(d, pe({}, p, {
          key: "placeholder",
          isDisabled: g,
          isFocused: D,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), y);
      if (m)
        return I.map(function(_, k) {
          var R = _ === b, W = "".concat(a.getOptionLabel(_), "-").concat(a.getOptionValue(_));
          return /* @__PURE__ */ U.createElement(i, pe({}, p, {
            components: {
              Container: s,
              Label: l,
              Remove: u
            },
            isFocused: R,
            isDisabled: g,
            key: W,
            index: k,
            removeProps: {
              onClick: function() {
                return a.removeValue(_);
              },
              onTouchEnd: function() {
                return a.removeValue(_);
              },
              onMouseDown: function(V) {
                V.preventDefault();
              }
            },
            data: _
          }), a.formatOptionLabel(_, "value"));
        });
      if (v)
        return null;
      var S = I[0];
      return /* @__PURE__ */ U.createElement(c, pe({}, p, {
        data: S,
        isDisabled: g
      }), this.formatOptionLabel(S, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var a = this.getComponents(), o = a.ClearIndicator, i = this.commonProps, s = this.props, l = s.isDisabled, u = s.isLoading, c = this.state.isFocused;
      if (!this.isClearable() || !o || l || !this.hasValue() || u)
        return null;
      var d = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ U.createElement(o, pe({}, i, {
        innerProps: d,
        isFocused: c
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var a = this.getComponents(), o = a.LoadingIndicator, i = this.commonProps, s = this.props, l = s.isDisabled, u = s.isLoading, c = this.state.isFocused;
      if (!o || !u) return null;
      var d = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ U.createElement(o, pe({}, i, {
        innerProps: d,
        isDisabled: l,
        isFocused: c
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var a = this.getComponents(), o = a.DropdownIndicator, i = a.IndicatorSeparator;
      if (!o || !i) return null;
      var s = this.commonProps, l = this.props.isDisabled, u = this.state.isFocused;
      return /* @__PURE__ */ U.createElement(i, pe({}, s, {
        isDisabled: l,
        isFocused: u
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var a = this.getComponents(), o = a.DropdownIndicator;
      if (!o) return null;
      var i = this.commonProps, s = this.props.isDisabled, l = this.state.isFocused, u = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ U.createElement(o, pe({}, i, {
        innerProps: u,
        isDisabled: s,
        isFocused: l
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var a = this, o = this.getComponents(), i = o.Group, s = o.GroupHeading, l = o.Menu, u = o.MenuList, c = o.MenuPortal, d = o.LoadingMessage, p = o.NoOptionsMessage, f = o.Option, h = this.commonProps, g = this.state.focusedOption, m = this.props, v = m.captureMenuScroll, y = m.inputValue, w = m.isLoading, I = m.loadingMessage, b = m.minMenuHeight, D = m.maxMenuHeight, S = m.menuIsOpen, _ = m.menuPlacement, k = m.menuPosition, R = m.menuPortalTarget, W = m.menuShouldBlockScroll, B = m.menuShouldScrollIntoView, V = m.noOptionsMessage, F = m.onMenuScrollToTop, H = m.onMenuScrollToBottom;
      if (!S) return null;
      var A = function(Y, X) {
        var ne = Y.type, K = Y.data, ue = Y.isDisabled, se = Y.isSelected, be = Y.label, ge = Y.value, Ae = g === K, Z = ue ? void 0 : function() {
          return a.onOptionHover(K);
        }, ot = ue ? void 0 : function() {
          return a.selectOption(K);
        }, It = "".concat(a.getElementId("option"), "-").concat(X), Et = {
          id: It,
          onClick: ot,
          onMouseMove: Z,
          onMouseOver: Z,
          tabIndex: -1,
          role: "option",
          "aria-selected": a.isAppleDevice ? void 0 : se
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ U.createElement(f, pe({}, h, {
          innerProps: Et,
          data: K,
          isDisabled: ue,
          isSelected: se,
          key: It,
          label: be,
          type: ne,
          value: ge,
          isFocused: Ae,
          innerRef: Ae ? a.getFocusedOptionRef : void 0
        }), a.formatOptionLabel(Y.data, "menu"));
      }, N;
      if (this.hasOptions())
        N = this.getCategorizedOptions().map(function($) {
          if ($.type === "group") {
            var Y = $.data, X = $.options, ne = $.index, K = "".concat(a.getElementId("group"), "-").concat(ne), ue = "".concat(K, "-heading");
            return /* @__PURE__ */ U.createElement(i, pe({}, h, {
              key: K,
              data: Y,
              options: X,
              Heading: s,
              headingProps: {
                id: ue,
                data: $.data
              },
              label: a.formatGroupLabel($.data)
            }), $.options.map(function(se) {
              return A(se, "".concat(ne, "-").concat(se.index));
            }));
          } else if ($.type === "option")
            return A($, "".concat($.index));
        });
      else if (w) {
        var G = I({
          inputValue: y
        });
        if (G === null) return null;
        N = /* @__PURE__ */ U.createElement(d, h, G);
      } else {
        var Q = V({
          inputValue: y
        });
        if (Q === null) return null;
        N = /* @__PURE__ */ U.createElement(p, h, Q);
      }
      var L = {
        minMenuHeight: b,
        maxMenuHeight: D,
        menuPlacement: _,
        menuPosition: k,
        menuShouldScrollIntoView: B
      }, O = /* @__PURE__ */ U.createElement(_y, pe({}, h, L), function($) {
        var Y = $.ref, X = $.placerProps, ne = X.placement, K = X.maxHeight;
        return /* @__PURE__ */ U.createElement(l, pe({}, h, L, {
          innerRef: Y,
          innerProps: {
            onMouseDown: a.onMenuMouseDown,
            onMouseMove: a.onMenuMouseMove
          },
          isLoading: w,
          placement: ne
        }), /* @__PURE__ */ U.createElement(nC, {
          captureEnabled: v,
          onTopArrive: F,
          onBottomArrive: H,
          lockEnabled: W
        }, function(ue) {
          return /* @__PURE__ */ U.createElement(u, pe({}, h, {
            innerRef: function(be) {
              a.getMenuListRef(be), ue(be);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": h.isMulti,
              id: a.getElementId("listbox")
            },
            isLoading: w,
            maxHeight: K,
            focusedOption: g
          }), N);
        }));
      });
      return R || k === "fixed" ? /* @__PURE__ */ U.createElement(c, pe({}, h, {
        appendTo: R,
        controlElement: this.controlRef,
        menuPlacement: _,
        menuPosition: k
      }), O) : O;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var a = this, o = this.props, i = o.delimiter, s = o.isDisabled, l = o.isMulti, u = o.name, c = o.required, d = this.state.selectValue;
      if (c && !this.hasValue() && !s)
        return /* @__PURE__ */ U.createElement(sC, {
          name: u,
          onFocus: this.onValueInputFocus
        });
      if (!(!u || s))
        if (l)
          if (i) {
            var p = d.map(function(g) {
              return a.getOptionValue(g);
            }).join(i);
            return /* @__PURE__ */ U.createElement("input", {
              name: u,
              type: "hidden",
              value: p
            });
          } else {
            var f = d.length > 0 ? d.map(function(g, m) {
              return /* @__PURE__ */ U.createElement("input", {
                key: "i-".concat(m),
                name: u,
                type: "hidden",
                value: a.getOptionValue(g)
              });
            }) : /* @__PURE__ */ U.createElement("input", {
              name: u,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ U.createElement("div", null, f);
          }
        else {
          var h = d[0] ? this.getOptionValue(d[0]) : "";
          return /* @__PURE__ */ U.createElement("input", {
            name: u,
            type: "hidden",
            value: h
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var a = this.commonProps, o = this.state, i = o.ariaSelection, s = o.focusedOption, l = o.focusedValue, u = o.isFocused, c = o.selectValue, d = this.getFocusableOptions();
      return /* @__PURE__ */ U.createElement(zw, pe({}, a, {
        id: this.getElementId("live-region"),
        ariaSelection: i,
        focusedOption: s,
        focusedValue: l,
        isFocused: u,
        selectValue: c,
        focusableOptions: d,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var a = this.getComponents(), o = a.Control, i = a.IndicatorsContainer, s = a.SelectContainer, l = a.ValueContainer, u = this.props, c = u.className, d = u.id, p = u.isDisabled, f = u.menuIsOpen, h = this.state.isFocused, g = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ U.createElement(s, pe({}, g, {
        className: c,
        innerProps: {
          id: d,
          onKeyDown: this.onKeyDown
        },
        isDisabled: p,
        isFocused: h
      }), this.renderLiveRegion(), /* @__PURE__ */ U.createElement(o, pe({}, g, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: p,
        isFocused: h,
        menuIsOpen: f
      }), /* @__PURE__ */ U.createElement(l, pe({}, g, {
        isDisabled: p
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ U.createElement(i, pe({}, g, {
        isDisabled: p
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(a, o) {
      var i = o.prevProps, s = o.clearFocusValueOnUpdate, l = o.inputIsHiddenAfterUpdate, u = o.ariaSelection, c = o.isFocused, d = o.prevWasFocused, p = o.instancePrefix, f = a.options, h = a.value, g = a.menuIsOpen, m = a.inputValue, v = a.isMulti, y = Ji(h), w = {};
      if (i && (h !== i.value || f !== i.options || g !== i.menuIsOpen || m !== i.inputValue)) {
        var I = g ? CC(a, y) : [], b = g ? Ad(ki(a, y), "".concat(p, "-option")) : [], D = s ? xC(o, y) : null, S = SC(o, I), _ = bl(b, S);
        w = {
          selectValue: y,
          focusedOption: S,
          focusedOptionId: _,
          focusableOptionsWithIds: b,
          focusedValue: D,
          clearFocusValueOnUpdate: !1
        };
      }
      var k = l != null && a !== i ? {
        inputIsHidden: l,
        inputIsHiddenAfterUpdate: void 0
      } : {}, R = u, W = c && d;
      return c && !W && (R = {
        value: yo(v, y, y[0] || null),
        options: y,
        action: "initial-input-focus"
      }, W = !d), (u == null ? void 0 : u.action) === "initial-input-focus" && (R = null), ce(ce(ce({}, w), k), {}, {
        prevProps: a,
        ariaSelection: R,
        prevWasFocused: W
      });
    }
  }]), t;
}(yt);
Xo.defaultProps = wC;
var DC = /* @__PURE__ */ at(function(e, r) {
  var t = Ds(e);
  return /* @__PURE__ */ U.createElement(Xo, pe({
    ref: r
  }, t));
}), _C = DC;
function kC(e, r) {
  return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${r}`;
}
function jo(e = {}) {
  const {
    name: r,
    strict: t = !0,
    hookName: n = "useContext",
    providerName: a = "Provider",
    errorMessage: o,
    defaultValue: i
  } = e, s = Yo(i);
  s.displayName = r;
  function l() {
    var u;
    const c = za(s);
    if (!c && t) {
      const d = new Error(
        o ?? kC(n, a)
      );
      throw d.name = "ContextError", (u = Error.captureStackTrace) == null || u.call(Error, d, l), d;
    }
    return c;
  }
  return [s.Provider, l, s];
}
function EC(e, r) {
  if (e != null) {
    if (typeof e == "function") {
      e(r);
      return;
    }
    try {
      e.current = r;
    } catch {
      throw new Error(`Cannot assign value '${r}' to ref '${e}'`);
    }
  }
}
function Ao(...e) {
  return (r) => {
    e.forEach((t) => {
      EC(t, r);
    });
  };
}
function Xa() {
  const e = za(
    Bb
  );
  if (!e)
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  return e;
}
var Sh = Yo({});
Sh.displayName = "ColorModeContext";
function Zu() {
  const e = za(Sh);
  if (e === void 0)
    throw new Error("useColorMode must be used within a ColorModeProvider");
  return e;
}
function Od(e, r) {
  const { colorMode: t } = Zu();
  return t === "dark" ? r : e;
}
var MC = globalThis != null && globalThis.document ? Go : He;
function PC() {
  const e = Zu(), r = Xa();
  return { ...e, theme: r };
}
var Jn = (...e) => e.filter(Boolean).join(" ");
function rn(e) {
  const r = typeof e;
  return e != null && (r === "object" || r === "function") && !Array.isArray(e);
}
function wn(e, ...r) {
  return AC(e) ? e(...r) : e;
}
var AC = (e) => typeof e == "function", vn = (e) => e ? "" : void 0, yl = (e) => e ? !0 : void 0;
function Td(...e) {
  return function(t) {
    e.some((n) => (n == null || n(t), t == null ? void 0 : t.defaultPrevented));
  };
}
var di = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Uu(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ki = { exports: {} };
Ki.exports;
(function(e, r) {
  var t = 200, n = "__lodash_hash_undefined__", a = 800, o = 16, i = 9007199254740991, s = "[object Arguments]", l = "[object Array]", u = "[object AsyncFunction]", c = "[object Boolean]", d = "[object Date]", p = "[object Error]", f = "[object Function]", h = "[object GeneratorFunction]", g = "[object Map]", m = "[object Number]", v = "[object Null]", y = "[object Object]", w = "[object Proxy]", I = "[object RegExp]", b = "[object Set]", D = "[object String]", S = "[object Undefined]", _ = "[object WeakMap]", k = "[object ArrayBuffer]", R = "[object DataView]", W = "[object Float32Array]", B = "[object Float64Array]", V = "[object Int8Array]", F = "[object Int16Array]", H = "[object Int32Array]", A = "[object Uint8Array]", N = "[object Uint8ClampedArray]", G = "[object Uint16Array]", Q = "[object Uint32Array]", L = /[\\^$.*+?()[\]{}|]/g, O = /^\[object .+?Constructor\]$/, $ = /^(?:0|[1-9]\d*)$/, Y = {};
  Y[W] = Y[B] = Y[V] = Y[F] = Y[H] = Y[A] = Y[N] = Y[G] = Y[Q] = !0, Y[s] = Y[l] = Y[k] = Y[c] = Y[R] = Y[d] = Y[p] = Y[f] = Y[g] = Y[m] = Y[y] = Y[I] = Y[b] = Y[D] = Y[_] = !1;
  var X = typeof di == "object" && di && di.Object === Object && di, ne = typeof self == "object" && self && self.Object === Object && self, K = X || ne || Function("return this")(), ue = r && !r.nodeType && r, se = ue && !0 && e && !e.nodeType && e, be = se && se.exports === ue, ge = be && X.process, Ae = function() {
    try {
      var C = se && se.require && se.require("util").types;
      return C || ge && ge.binding && ge.binding("util");
    } catch {
    }
  }(), Z = Ae && Ae.isTypedArray;
  function ot(C, M, T) {
    switch (T.length) {
      case 0:
        return C.call(M);
      case 1:
        return C.call(M, T[0]);
      case 2:
        return C.call(M, T[0], T[1]);
      case 3:
        return C.call(M, T[0], T[1], T[2]);
    }
    return C.apply(M, T);
  }
  function It(C, M) {
    for (var T = -1, le = Array(C); ++T < C; )
      le[T] = M(T);
    return le;
  }
  function Et(C) {
    return function(M) {
      return C(M);
    };
  }
  function Xr(C, M) {
    return C == null ? void 0 : C[M];
  }
  function Wt(C, M) {
    return function(T) {
      return C(M(T));
    };
  }
  var Bt = Array.prototype, Mt = Function.prototype, Re = Object.prototype, Kt = K["__core-js_shared__"], Vt = Mt.toString, Gt = Re.hasOwnProperty, q = function() {
    var C = /[^.]+$/.exec(Kt && Kt.keys && Kt.keys.IE_PROTO || "");
    return C ? "Symbol(src)_1." + C : "";
  }(), fe = Re.toString, Ue = Vt.call(Object), it = RegExp(
    "^" + Vt.call(Gt).replace(L, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), ct = be ? K.Buffer : void 0, gn = K.Symbol, jr = K.Uint8Array;
  ct && ct.allocUnsafe;
  var ca = Wt(Object.getPrototypeOf, Object), da = Object.create, to = Re.propertyIsEnumerable, fa = Bt.splice, mr = gn ? gn.toStringTag : void 0, mn = function() {
    try {
      var C = nl(Object, "defineProperty");
      return C({}, "", {}), C;
    } catch {
    }
  }(), ro = ct ? ct.isBuffer : void 0, pa = Math.max, el = Date.now, zc = nl(K, "Map"), no = nl(Object, "create"), cv = /* @__PURE__ */ function() {
    function C() {
    }
    return function(M) {
      if (!Tn(M))
        return {};
      if (da)
        return da(M);
      C.prototype = M;
      var T = new C();
      return C.prototype = void 0, T;
    };
  }();
  function On(C) {
    var M = -1, T = C == null ? 0 : C.length;
    for (this.clear(); ++M < T; ) {
      var le = C[M];
      this.set(le[0], le[1]);
    }
  }
  function dv() {
    this.__data__ = no ? no(null) : {}, this.size = 0;
  }
  function fv(C) {
    var M = this.has(C) && delete this.__data__[C];
    return this.size -= M ? 1 : 0, M;
  }
  function pv(C) {
    var M = this.__data__;
    if (no) {
      var T = M[C];
      return T === n ? void 0 : T;
    }
    return Gt.call(M, C) ? M[C] : void 0;
  }
  function hv(C) {
    var M = this.__data__;
    return no ? M[C] !== void 0 : Gt.call(M, C);
  }
  function gv(C, M) {
    var T = this.__data__;
    return this.size += this.has(C) ? 0 : 1, T[C] = no && M === void 0 ? n : M, this;
  }
  On.prototype.clear = dv, On.prototype.delete = fv, On.prototype.get = pv, On.prototype.has = hv, On.prototype.set = gv;
  function Zr(C) {
    var M = -1, T = C == null ? 0 : C.length;
    for (this.clear(); ++M < T; ) {
      var le = C[M];
      this.set(le[0], le[1]);
    }
  }
  function mv() {
    this.__data__ = [], this.size = 0;
  }
  function vv(C) {
    var M = this.__data__, T = ni(M, C);
    if (T < 0)
      return !1;
    var le = M.length - 1;
    return T == le ? M.pop() : fa.call(M, T, 1), --this.size, !0;
  }
  function bv(C) {
    var M = this.__data__, T = ni(M, C);
    return T < 0 ? void 0 : M[T][1];
  }
  function yv(C) {
    return ni(this.__data__, C) > -1;
  }
  function wv(C, M) {
    var T = this.__data__, le = ni(T, C);
    return le < 0 ? (++this.size, T.push([C, M])) : T[le][1] = M, this;
  }
  Zr.prototype.clear = mv, Zr.prototype.delete = vv, Zr.prototype.get = bv, Zr.prototype.has = yv, Zr.prototype.set = wv;
  function ha(C) {
    var M = -1, T = C == null ? 0 : C.length;
    for (this.clear(); ++M < T; ) {
      var le = C[M];
      this.set(le[0], le[1]);
    }
  }
  function Cv() {
    this.size = 0, this.__data__ = {
      hash: new On(),
      map: new (zc || Zr)(),
      string: new On()
    };
  }
  function xv(C) {
    var M = oi(this, C).delete(C);
    return this.size -= M ? 1 : 0, M;
  }
  function Sv(C) {
    return oi(this, C).get(C);
  }
  function Iv(C) {
    return oi(this, C).has(C);
  }
  function Dv(C, M) {
    var T = oi(this, C), le = T.size;
    return T.set(C, M), this.size += T.size == le ? 0 : 1, this;
  }
  ha.prototype.clear = Cv, ha.prototype.delete = xv, ha.prototype.get = Sv, ha.prototype.has = Iv, ha.prototype.set = Dv;
  function ga(C) {
    var M = this.__data__ = new Zr(C);
    this.size = M.size;
  }
  function _v() {
    this.__data__ = new Zr(), this.size = 0;
  }
  function kv(C) {
    var M = this.__data__, T = M.delete(C);
    return this.size = M.size, T;
  }
  function Ev(C) {
    return this.__data__.get(C);
  }
  function Mv(C) {
    return this.__data__.has(C);
  }
  function Pv(C, M) {
    var T = this.__data__;
    if (T instanceof Zr) {
      var le = T.__data__;
      if (!zc || le.length < t - 1)
        return le.push([C, M]), this.size = ++T.size, this;
      T = this.__data__ = new ha(le);
    }
    return T.set(C, M), this.size = T.size, this;
  }
  ga.prototype.clear = _v, ga.prototype.delete = kv, ga.prototype.get = Ev, ga.prototype.has = Mv, ga.prototype.set = Pv;
  function Av(C, M) {
    var T = il(C), le = !T && ol(C), De = !T && !le && Uc(C), $e = !T && !le && !De && Qc(C), Ke = T || le || De || $e, Oe = Ke ? It(C.length, String) : [], et = Oe.length;
    for (var vr in C)
      Ke && // Safari 9 has enumerable `arguments.length` in strict mode.
      (vr == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      De && (vr == "offset" || vr == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      $e && (vr == "buffer" || vr == "byteLength" || vr == "byteOffset") || // Skip index properties.
      jc(vr, et)) || Oe.push(vr);
    return Oe;
  }
  function tl(C, M, T) {
    (T !== void 0 && !ii(C[M], T) || T === void 0 && !(M in C)) && rl(C, M, T);
  }
  function Rv(C, M, T) {
    var le = C[M];
    (!(Gt.call(C, M) && ii(le, T)) || T === void 0 && !(M in C)) && rl(C, M, T);
  }
  function ni(C, M) {
    for (var T = C.length; T--; )
      if (ii(C[T][0], M))
        return T;
    return -1;
  }
  function rl(C, M, T) {
    M == "__proto__" && mn ? mn(C, M, {
      configurable: !0,
      enumerable: !0,
      value: T,
      writable: !0
    }) : C[M] = T;
  }
  var Ov = Xv();
  function ai(C) {
    return C == null ? C === void 0 ? S : v : mr && mr in Object(C) ? jv(C) : Kv(C);
  }
  function $c(C) {
    return ao(C) && ai(C) == s;
  }
  function Tv(C) {
    if (!Tn(C) || Qv(C))
      return !1;
    var M = ll(C) ? it : O;
    return M.test(nb(C));
  }
  function Fv(C) {
    return ao(C) && Jc(C.length) && !!Y[ai(C)];
  }
  function Nv(C) {
    if (!Tn(C))
      return qv(C);
    var M = Zc(C), T = [];
    for (var le in C)
      le == "constructor" && (M || !Gt.call(C, le)) || T.push(le);
    return T;
  }
  function Xc(C, M, T, le, De) {
    C !== M && Ov(M, function($e, Ke) {
      if (De || (De = new ga()), Tn($e))
        Lv(C, M, Ke, T, Xc, le, De);
      else {
        var Oe = le ? le(al(C, Ke), $e, Ke + "", C, M, De) : void 0;
        Oe === void 0 && (Oe = $e), tl(C, Ke, Oe);
      }
    }, qc);
  }
  function Lv(C, M, T, le, De, $e, Ke) {
    var Oe = al(C, T), et = al(M, T), vr = Ke.get(et);
    if (vr) {
      tl(C, T, vr);
      return;
    }
    var Yt = $e ? $e(Oe, et, T + "", C, M, Ke) : void 0, oo = Yt === void 0;
    if (oo) {
      var ul = il(et), cl = !ul && Uc(et), ed = !ul && !cl && Qc(et);
      Yt = et, ul || cl || ed ? il(Oe) ? Yt = Oe : ab(Oe) ? Yt = Hv(Oe) : cl ? (oo = !1, Yt = Vv(et)) : ed ? (oo = !1, Yt = Yv(et)) : Yt = [] : ob(et) || ol(et) ? (Yt = Oe, ol(Oe) ? Yt = ib(Oe) : (!Tn(Oe) || ll(Oe)) && (Yt = Zv(et))) : oo = !1;
    }
    oo && (Ke.set(et, Yt), De(Yt, et, le, $e, Ke), Ke.delete(et)), tl(C, T, Yt);
  }
  function Wv(C, M) {
    return tb(eb(C, M, Kc), C + "");
  }
  var Bv = mn ? function(C, M) {
    return mn(C, "toString", {
      configurable: !0,
      enumerable: !1,
      value: lb(M),
      writable: !0
    });
  } : Kc;
  function Vv(C, M) {
    return C.slice();
  }
  function Gv(C) {
    var M = new C.constructor(C.byteLength);
    return new jr(M).set(new jr(C)), M;
  }
  function Yv(C, M) {
    var T = Gv(C.buffer);
    return new C.constructor(T, C.byteOffset, C.length);
  }
  function Hv(C, M) {
    var T = -1, le = C.length;
    for (M || (M = Array(le)); ++T < le; )
      M[T] = C[T];
    return M;
  }
  function zv(C, M, T, le) {
    var De = !T;
    T || (T = {});
    for (var $e = -1, Ke = M.length; ++$e < Ke; ) {
      var Oe = M[$e], et = void 0;
      et === void 0 && (et = C[Oe]), De ? rl(T, Oe, et) : Rv(T, Oe, et);
    }
    return T;
  }
  function $v(C) {
    return Wv(function(M, T) {
      var le = -1, De = T.length, $e = De > 1 ? T[De - 1] : void 0, Ke = De > 2 ? T[2] : void 0;
      for ($e = C.length > 3 && typeof $e == "function" ? (De--, $e) : void 0, Ke && Uv(T[0], T[1], Ke) && ($e = De < 3 ? void 0 : $e, De = 1), M = Object(M); ++le < De; ) {
        var Oe = T[le];
        Oe && C(M, Oe, le, $e);
      }
      return M;
    });
  }
  function Xv(C) {
    return function(M, T, le) {
      for (var De = -1, $e = Object(M), Ke = le(M), Oe = Ke.length; Oe--; ) {
        var et = Ke[++De];
        if (T($e[et], et, $e) === !1)
          break;
      }
      return M;
    };
  }
  function oi(C, M) {
    var T = C.__data__;
    return Jv(M) ? T[typeof M == "string" ? "string" : "hash"] : T.map;
  }
  function nl(C, M) {
    var T = Xr(C, M);
    return Tv(T) ? T : void 0;
  }
  function jv(C) {
    var M = Gt.call(C, mr), T = C[mr];
    try {
      C[mr] = void 0;
      var le = !0;
    } catch {
    }
    var De = fe.call(C);
    return le && (M ? C[mr] = T : delete C[mr]), De;
  }
  function Zv(C) {
    return typeof C.constructor == "function" && !Zc(C) ? cv(ca(C)) : {};
  }
  function jc(C, M) {
    var T = typeof C;
    return M = M ?? i, !!M && (T == "number" || T != "symbol" && $.test(C)) && C > -1 && C % 1 == 0 && C < M;
  }
  function Uv(C, M, T) {
    if (!Tn(T))
      return !1;
    var le = typeof M;
    return (le == "number" ? sl(T) && jc(M, T.length) : le == "string" && M in T) ? ii(T[M], C) : !1;
  }
  function Jv(C) {
    var M = typeof C;
    return M == "string" || M == "number" || M == "symbol" || M == "boolean" ? C !== "__proto__" : C === null;
  }
  function Qv(C) {
    return !!q && q in C;
  }
  function Zc(C) {
    var M = C && C.constructor, T = typeof M == "function" && M.prototype || Re;
    return C === T;
  }
  function qv(C) {
    var M = [];
    if (C != null)
      for (var T in Object(C))
        M.push(T);
    return M;
  }
  function Kv(C) {
    return fe.call(C);
  }
  function eb(C, M, T) {
    return M = pa(M === void 0 ? C.length - 1 : M, 0), function() {
      for (var le = arguments, De = -1, $e = pa(le.length - M, 0), Ke = Array($e); ++De < $e; )
        Ke[De] = le[M + De];
      De = -1;
      for (var Oe = Array(M + 1); ++De < M; )
        Oe[De] = le[De];
      return Oe[M] = T(Ke), ot(C, this, Oe);
    };
  }
  function al(C, M) {
    if (!(M === "constructor" && typeof C[M] == "function") && M != "__proto__")
      return C[M];
  }
  var tb = rb(Bv);
  function rb(C) {
    var M = 0, T = 0;
    return function() {
      var le = el(), De = o - (le - T);
      if (T = le, De > 0) {
        if (++M >= a)
          return arguments[0];
      } else
        M = 0;
      return C.apply(void 0, arguments);
    };
  }
  function nb(C) {
    if (C != null) {
      try {
        return Vt.call(C);
      } catch {
      }
      try {
        return C + "";
      } catch {
      }
    }
    return "";
  }
  function ii(C, M) {
    return C === M || C !== C && M !== M;
  }
  var ol = $c(/* @__PURE__ */ function() {
    return arguments;
  }()) ? $c : function(C) {
    return ao(C) && Gt.call(C, "callee") && !to.call(C, "callee");
  }, il = Array.isArray;
  function sl(C) {
    return C != null && Jc(C.length) && !ll(C);
  }
  function ab(C) {
    return ao(C) && sl(C);
  }
  var Uc = ro || ub;
  function ll(C) {
    if (!Tn(C))
      return !1;
    var M = ai(C);
    return M == f || M == h || M == u || M == w;
  }
  function Jc(C) {
    return typeof C == "number" && C > -1 && C % 1 == 0 && C <= i;
  }
  function Tn(C) {
    var M = typeof C;
    return C != null && (M == "object" || M == "function");
  }
  function ao(C) {
    return C != null && typeof C == "object";
  }
  function ob(C) {
    if (!ao(C) || ai(C) != y)
      return !1;
    var M = ca(C);
    if (M === null)
      return !0;
    var T = Gt.call(M, "constructor") && M.constructor;
    return typeof T == "function" && T instanceof T && Vt.call(T) == Ue;
  }
  var Qc = Z ? Et(Z) : Fv;
  function ib(C) {
    return zv(C, qc(C));
  }
  function qc(C) {
    return sl(C) ? Av(C) : Nv(C);
  }
  var sb = $v(function(C, M, T, le) {
    Xc(C, M, T, le);
  });
  function lb(C) {
    return function() {
      return C;
    };
  }
  function Kc(C) {
    return C;
  }
  function ub() {
    return !1;
  }
  e.exports = sb;
})(Ki, Ki.exports);
var RC = Ki.exports;
const en = /* @__PURE__ */ Uu(RC);
var OC = (e) => /!(important)?$/.test(e), Fd = (e) => typeof e == "string" ? e.replace(/!(important)?$/, "").trim() : e, TC = (e, r) => (t) => {
  const n = String(r), a = OC(n), o = Fd(n), i = e ? `${e}.${o}` : o;
  let s = rn(t.__cssMap) && i in t.__cssMap ? t.__cssMap[i].varRef : r;
  return s = Fd(s), a ? `${s} !important` : s;
};
function Ju(e) {
  const { scale: r, transform: t, compose: n } = e;
  return (o, i) => {
    var s;
    const l = TC(r, o)(i);
    let u = (s = t == null ? void 0 : t(l, i)) != null ? s : l;
    return n && (u = n(u, i)), u;
  };
}
var fi = (...e) => (r) => e.reduce((t, n) => n(t), r);
function er(e, r) {
  return (t) => {
    const n = { property: t, scale: e };
    return n.transform = Ju({
      scale: e,
      transform: r
    }), n;
  };
}
var FC = ({ rtl: e, ltr: r }) => (t) => t.direction === "rtl" ? e : r;
function NC(e) {
  const { property: r, scale: t, transform: n } = e;
  return {
    scale: t,
    property: FC(r),
    transform: t ? Ju({
      scale: t,
      compose: n
    }) : n
  };
}
var Ih = [
  "rotate(var(--chakra-rotate, 0))",
  "scaleX(var(--chakra-scale-x, 1))",
  "scaleY(var(--chakra-scale-y, 1))",
  "skewX(var(--chakra-skew-x, 0))",
  "skewY(var(--chakra-skew-y, 0))"
];
function LC() {
  return [
    "translateX(var(--chakra-translate-x, 0))",
    "translateY(var(--chakra-translate-y, 0))",
    ...Ih
  ].join(" ");
}
function WC() {
  return [
    "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
    ...Ih
  ].join(" ");
}
var BC = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: [
    "var(--chakra-blur)",
    "var(--chakra-brightness)",
    "var(--chakra-contrast)",
    "var(--chakra-grayscale)",
    "var(--chakra-hue-rotate)",
    "var(--chakra-invert)",
    "var(--chakra-saturate)",
    "var(--chakra-sepia)",
    "var(--chakra-drop-shadow)"
  ].join(" ")
}, VC = {
  backdropFilter: [
    "var(--chakra-backdrop-blur)",
    "var(--chakra-backdrop-brightness)",
    "var(--chakra-backdrop-contrast)",
    "var(--chakra-backdrop-grayscale)",
    "var(--chakra-backdrop-hue-rotate)",
    "var(--chakra-backdrop-invert)",
    "var(--chakra-backdrop-opacity)",
    "var(--chakra-backdrop-saturate)",
    "var(--chakra-backdrop-sepia)"
  ].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function GC(e) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": e,
    boxShadow: [
      "var(--chakra-ring-offset-shadow)",
      "var(--chakra-ring-shadow)",
      "var(--chakra-shadow, 0 0 #0000)"
    ].join(", ")
  };
}
var YC = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, nu = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, HC = new Set(Object.values(nu)), au = /* @__PURE__ */ new Set([
  "none",
  "-moz-initial",
  "inherit",
  "initial",
  "revert",
  "unset"
]), zC = (e) => e.trim();
function $C(e, r) {
  if (e == null || au.has(e))
    return e;
  if (!(ou(e) || au.has(e)))
    return `url('${e}')`;
  const a = /(^[a-z-A-Z]+)\((.*)\)/g.exec(e), o = a == null ? void 0 : a[1], i = a == null ? void 0 : a[2];
  if (!o || !i)
    return e;
  const s = o.includes("-gradient") ? o : `${o}-gradient`, [l, ...u] = i.split(",").map(zC).filter(Boolean);
  if ((u == null ? void 0 : u.length) === 0)
    return e;
  const c = l in nu ? nu[l] : l;
  u.unshift(c);
  const d = u.map((p) => {
    if (HC.has(p))
      return p;
    const f = p.indexOf(" "), [h, g] = f !== -1 ? [p.substr(0, f), p.substr(f + 1)] : [p], m = ou(g) ? g : g && g.split(" "), v = `colors.${h}`, y = v in r.__cssMap ? r.__cssMap[v].varRef : h;
    return m ? [
      y,
      ...Array.isArray(m) ? m : [m]
    ].join(" ") : y;
  });
  return `${s}(${d.join(", ")})`;
}
var ou = (e) => typeof e == "string" && e.includes("(") && e.includes(")"), XC = (e, r) => $C(e, r ?? {});
function jC(e) {
  return /^var\(--.+\)$/.test(e);
}
var ZC = (e) => {
  const r = parseFloat(e.toString()), t = e.toString().replace(String(r), "");
  return { unitless: !t, value: r, unit: t };
}, Ir = (e) => (r) => `${e}(${r})`, Ie = {
  filter(e) {
    return e !== "auto" ? e : BC;
  },
  backdropFilter(e) {
    return e !== "auto" ? e : VC;
  },
  ring(e) {
    return GC(Ie.px(e));
  },
  bgClip(e) {
    return e === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: e };
  },
  transform(e) {
    return e === "auto" ? LC() : e === "auto-gpu" ? WC() : e;
  },
  vh(e) {
    return e === "$100vh" ? "var(--chakra-vh)" : e;
  },
  px(e) {
    if (e == null)
      return e;
    const { unitless: r } = ZC(e);
    return r || typeof e == "number" ? `${e}px` : e;
  },
  fraction(e) {
    return typeof e != "number" || e > 1 ? e : `${e * 100}%`;
  },
  float(e, r) {
    const t = { left: "right", right: "left" };
    return r.direction === "rtl" ? t[e] : e;
  },
  degree(e) {
    if (jC(e) || e == null)
      return e;
    const r = typeof e == "string" && !e.endsWith("deg");
    return typeof e == "number" || r ? `${e}deg` : e;
  },
  gradient: XC,
  blur: Ir("blur"),
  opacity: Ir("opacity"),
  brightness: Ir("brightness"),
  contrast: Ir("contrast"),
  dropShadow: Ir("drop-shadow"),
  grayscale: Ir("grayscale"),
  hueRotate: (e) => Ir("hue-rotate")(Ie.degree(e)),
  invert: Ir("invert"),
  saturate: Ir("saturate"),
  sepia: Ir("sepia"),
  bgImage(e) {
    return e == null || ou(e) || au.has(e) ? e : `url(${e})`;
  },
  outline(e) {
    const r = String(e) === "0" || String(e) === "none";
    return e !== null && r ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: e };
  },
  flexDirection(e) {
    var r;
    const { space: t, divide: n } = (r = YC[e]) != null ? r : {}, a = { flexDirection: e };
    return t && (a[t] = 1), n && (a[n] = 1), a;
  }
}, E = {
  borderWidths: er("borderWidths"),
  borderStyles: er("borderStyles"),
  colors: er("colors"),
  borders: er("borders"),
  gradients: er("gradients", Ie.gradient),
  radii: er("radii", Ie.px),
  space: er("space", fi(Ie.vh, Ie.px)),
  spaceT: er("space", fi(Ie.vh, Ie.px)),
  degreeT(e) {
    return { property: e, transform: Ie.degree };
  },
  prop(e, r, t) {
    return {
      property: e,
      scale: r,
      ...r && {
        transform: Ju({ scale: r, transform: t })
      }
    };
  },
  propT(e, r) {
    return { property: e, transform: r };
  },
  sizes: er("sizes", fi(Ie.vh, Ie.px)),
  sizesT: er("sizes", fi(Ie.vh, Ie.fraction)),
  shadows: er("shadows"),
  logical: NC,
  blur: er("blur", Ie.blur)
}, Ei = {
  background: E.colors("background"),
  backgroundColor: E.colors("backgroundColor"),
  backgroundImage: E.gradients("backgroundImage"),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: { transform: Ie.bgClip },
  bgSize: E.prop("backgroundSize"),
  bgPosition: E.prop("backgroundPosition"),
  bg: E.colors("background"),
  bgColor: E.colors("backgroundColor"),
  bgPos: E.prop("backgroundPosition"),
  bgRepeat: E.prop("backgroundRepeat"),
  bgAttachment: E.prop("backgroundAttachment"),
  bgGradient: E.gradients("backgroundImage"),
  bgClip: { transform: Ie.bgClip }
};
Object.assign(Ei, {
  bgImage: Ei.backgroundImage,
  bgImg: Ei.backgroundImage
});
var Te = {
  border: E.borders("border"),
  borderWidth: E.borderWidths("borderWidth"),
  borderStyle: E.borderStyles("borderStyle"),
  borderColor: E.colors("borderColor"),
  borderRadius: E.radii("borderRadius"),
  borderTop: E.borders("borderTop"),
  borderBlockStart: E.borders("borderBlockStart"),
  borderTopLeftRadius: E.radii("borderTopLeftRadius"),
  borderStartStartRadius: E.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: E.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: E.radii("borderTopRightRadius"),
  borderStartEndRadius: E.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: E.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: E.borders("borderRight"),
  borderInlineEnd: E.borders("borderInlineEnd"),
  borderBottom: E.borders("borderBottom"),
  borderBlockEnd: E.borders("borderBlockEnd"),
  borderBottomLeftRadius: E.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: E.radii("borderBottomRightRadius"),
  borderLeft: E.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: E.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: E.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: E.borders(["borderLeft", "borderRight"]),
  borderInline: E.borders("borderInline"),
  borderY: E.borders(["borderTop", "borderBottom"]),
  borderBlock: E.borders("borderBlock"),
  borderTopWidth: E.borderWidths("borderTopWidth"),
  borderBlockStartWidth: E.borderWidths("borderBlockStartWidth"),
  borderTopColor: E.colors("borderTopColor"),
  borderBlockStartColor: E.colors("borderBlockStartColor"),
  borderTopStyle: E.borderStyles("borderTopStyle"),
  borderBlockStartStyle: E.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: E.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: E.borderWidths("borderBlockEndWidth"),
  borderBottomColor: E.colors("borderBottomColor"),
  borderBlockEndColor: E.colors("borderBlockEndColor"),
  borderBottomStyle: E.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: E.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: E.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: E.borderWidths("borderInlineStartWidth"),
  borderLeftColor: E.colors("borderLeftColor"),
  borderInlineStartColor: E.colors("borderInlineStartColor"),
  borderLeftStyle: E.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: E.borderStyles("borderInlineStartStyle"),
  borderRightWidth: E.borderWidths("borderRightWidth"),
  borderInlineEndWidth: E.borderWidths("borderInlineEndWidth"),
  borderRightColor: E.colors("borderRightColor"),
  borderInlineEndColor: E.colors("borderInlineEndColor"),
  borderRightStyle: E.borderStyles("borderRightStyle"),
  borderInlineEndStyle: E.borderStyles("borderInlineEndStyle"),
  borderTopRadius: E.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: E.radii([
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ]),
  borderLeftRadius: E.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: E.radii([
    "borderTopRightRadius",
    "borderBottomRightRadius"
  ])
};
Object.assign(Te, {
  rounded: Te.borderRadius,
  roundedTop: Te.borderTopRadius,
  roundedTopLeft: Te.borderTopLeftRadius,
  roundedTopRight: Te.borderTopRightRadius,
  roundedTopStart: Te.borderStartStartRadius,
  roundedTopEnd: Te.borderStartEndRadius,
  roundedBottom: Te.borderBottomRadius,
  roundedBottomLeft: Te.borderBottomLeftRadius,
  roundedBottomRight: Te.borderBottomRightRadius,
  roundedBottomStart: Te.borderEndStartRadius,
  roundedBottomEnd: Te.borderEndEndRadius,
  roundedLeft: Te.borderLeftRadius,
  roundedRight: Te.borderRightRadius,
  roundedStart: Te.borderInlineStartRadius,
  roundedEnd: Te.borderInlineEndRadius,
  borderStart: Te.borderInlineStart,
  borderEnd: Te.borderInlineEnd,
  borderTopStartRadius: Te.borderStartStartRadius,
  borderTopEndRadius: Te.borderStartEndRadius,
  borderBottomStartRadius: Te.borderEndStartRadius,
  borderBottomEndRadius: Te.borderEndEndRadius,
  borderStartRadius: Te.borderInlineStartRadius,
  borderEndRadius: Te.borderInlineEndRadius,
  borderStartWidth: Te.borderInlineStartWidth,
  borderEndWidth: Te.borderInlineEndWidth,
  borderStartColor: Te.borderInlineStartColor,
  borderEndColor: Te.borderInlineEndColor,
  borderStartStyle: Te.borderInlineStartStyle,
  borderEndStyle: Te.borderInlineEndStyle
});
var UC = {
  color: E.colors("color"),
  textColor: E.colors("color"),
  fill: E.colors("fill"),
  stroke: E.colors("stroke")
}, iu = {
  boxShadow: E.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: E.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: E.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(iu, {
  shadow: iu.boxShadow
});
var JC = {
  filter: { transform: Ie.filter },
  blur: E.blur("--chakra-blur"),
  brightness: E.propT("--chakra-brightness", Ie.brightness),
  contrast: E.propT("--chakra-contrast", Ie.contrast),
  hueRotate: E.propT("--chakra-hue-rotate", Ie.hueRotate),
  invert: E.propT("--chakra-invert", Ie.invert),
  saturate: E.propT("--chakra-saturate", Ie.saturate),
  dropShadow: E.propT("--chakra-drop-shadow", Ie.dropShadow),
  backdropFilter: { transform: Ie.backdropFilter },
  backdropBlur: E.blur("--chakra-backdrop-blur"),
  backdropBrightness: E.propT(
    "--chakra-backdrop-brightness",
    Ie.brightness
  ),
  backdropContrast: E.propT("--chakra-backdrop-contrast", Ie.contrast),
  backdropHueRotate: E.propT(
    "--chakra-backdrop-hue-rotate",
    Ie.hueRotate
  ),
  backdropInvert: E.propT("--chakra-backdrop-invert", Ie.invert),
  backdropSaturate: E.propT("--chakra-backdrop-saturate", Ie.saturate)
}, es = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: { transform: Ie.flexDirection },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: E.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: E.space("gap"),
  rowGap: E.space("rowGap"),
  columnGap: E.space("columnGap")
};
Object.assign(es, {
  flexDir: es.flexDirection
});
var Dh = {
  gridGap: E.space("gridGap"),
  gridColumnGap: E.space("gridColumnGap"),
  gridRowGap: E.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}, QC = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: { transform: Ie.outline },
  outlineOffset: !0,
  outlineColor: E.colors("outlineColor")
}, tr = {
  width: E.sizesT("width"),
  inlineSize: E.sizesT("inlineSize"),
  height: E.sizes("height"),
  blockSize: E.sizes("blockSize"),
  boxSize: E.sizes(["width", "height"]),
  minWidth: E.sizes("minWidth"),
  minInlineSize: E.sizes("minInlineSize"),
  minHeight: E.sizes("minHeight"),
  minBlockSize: E.sizes("minBlockSize"),
  maxWidth: E.sizes("maxWidth"),
  maxInlineSize: E.sizes("maxInlineSize"),
  maxHeight: E.sizes("maxHeight"),
  maxBlockSize: E.sizes("maxBlockSize"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  aspectRatio: !0,
  hideFrom: {
    scale: "breakpoints",
    transform: (e, r) => {
      var t, n, a;
      return { [`@media screen and (min-width: ${(a = (n = (t = r.__breakpoints) == null ? void 0 : t.get(e)) == null ? void 0 : n.minW) != null ? a : e})`]: { display: "none" } };
    }
  },
  hideBelow: {
    scale: "breakpoints",
    transform: (e, r) => {
      var t, n, a;
      return { [`@media screen and (max-width: ${(a = (n = (t = r.__breakpoints) == null ? void 0 : t.get(e)) == null ? void 0 : n._minW) != null ? a : e})`]: { display: "none" } };
    }
  },
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: E.propT("float", Ie.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(tr, {
  w: tr.width,
  h: tr.height,
  minW: tr.minWidth,
  maxW: tr.maxWidth,
  minH: tr.minHeight,
  maxH: tr.maxHeight,
  overscroll: tr.overscrollBehavior,
  overscrollX: tr.overscrollBehaviorX,
  overscrollY: tr.overscrollBehaviorY
});
var qC = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: E.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: E.prop("listStyleImage")
};
function KC(e, r, t, n) {
  const a = typeof r == "string" ? r.split(".") : [r];
  for (n = 0; n < a.length && e; n += 1)
    e = e[a[n]];
  return e === void 0 ? t : e;
}
var e1 = (e) => {
  const r = /* @__PURE__ */ new WeakMap();
  return (n, a, o, i) => {
    if (typeof n > "u")
      return e(n, a, o);
    r.has(n) || r.set(n, /* @__PURE__ */ new Map());
    const s = r.get(n);
    if (s.has(a))
      return s.get(a);
    const l = e(n, a, o, i);
    return s.set(a, l), l;
  };
}, t1 = e1(KC), r1 = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, n1 = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, wl = (e, r, t) => {
  const n = {}, a = t1(e, r, {});
  for (const o in a)
    o in t && t[o] != null || (n[o] = a[o]);
  return n;
}, a1 = {
  srOnly: {
    transform(e) {
      return e === !0 ? r1 : e === "focusable" ? n1 : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: (e, r, t) => wl(r, `layerStyles.${e}`, t)
  },
  textStyle: {
    processResult: !0,
    transform: (e, r, t) => wl(r, `textStyles.${e}`, t)
  },
  apply: {
    processResult: !0,
    transform: (e, r, t) => wl(r, e, t)
  }
}, Io = {
  position: !0,
  pos: E.prop("position"),
  zIndex: E.prop("zIndex", "zIndices"),
  inset: E.spaceT("inset"),
  insetX: E.spaceT(["left", "right"]),
  insetInline: E.spaceT("insetInline"),
  insetY: E.spaceT(["top", "bottom"]),
  insetBlock: E.spaceT("insetBlock"),
  top: E.spaceT("top"),
  insetBlockStart: E.spaceT("insetBlockStart"),
  bottom: E.spaceT("bottom"),
  insetBlockEnd: E.spaceT("insetBlockEnd"),
  left: E.spaceT("left"),
  insetInlineStart: E.logical({
    scale: "space",
    property: { ltr: "left", rtl: "right" }
  }),
  right: E.spaceT("right"),
  insetInlineEnd: E.logical({
    scale: "space",
    property: { ltr: "right", rtl: "left" }
  })
};
Object.assign(Io, {
  insetStart: Io.insetInlineStart,
  insetEnd: Io.insetInlineEnd
});
var o1 = {
  ring: { transform: Ie.ring },
  ringColor: E.colors("--chakra-ring-color"),
  ringOffset: E.prop("--chakra-ring-offset-width"),
  ringOffsetColor: E.colors("--chakra-ring-offset-color"),
  ringInset: E.prop("--chakra-ring-inset")
}, Je = {
  margin: E.spaceT("margin"),
  marginTop: E.spaceT("marginTop"),
  marginBlockStart: E.spaceT("marginBlockStart"),
  marginRight: E.spaceT("marginRight"),
  marginInlineEnd: E.spaceT("marginInlineEnd"),
  marginBottom: E.spaceT("marginBottom"),
  marginBlockEnd: E.spaceT("marginBlockEnd"),
  marginLeft: E.spaceT("marginLeft"),
  marginInlineStart: E.spaceT("marginInlineStart"),
  marginX: E.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: E.spaceT("marginInline"),
  marginY: E.spaceT(["marginTop", "marginBottom"]),
  marginBlock: E.spaceT("marginBlock"),
  padding: E.space("padding"),
  paddingTop: E.space("paddingTop"),
  paddingBlockStart: E.space("paddingBlockStart"),
  paddingRight: E.space("paddingRight"),
  paddingBottom: E.space("paddingBottom"),
  paddingBlockEnd: E.space("paddingBlockEnd"),
  paddingLeft: E.space("paddingLeft"),
  paddingInlineStart: E.space("paddingInlineStart"),
  paddingInlineEnd: E.space("paddingInlineEnd"),
  paddingX: E.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: E.space("paddingInline"),
  paddingY: E.space(["paddingTop", "paddingBottom"]),
  paddingBlock: E.space("paddingBlock")
};
Object.assign(Je, {
  m: Je.margin,
  mt: Je.marginTop,
  mr: Je.marginRight,
  me: Je.marginInlineEnd,
  marginEnd: Je.marginInlineEnd,
  mb: Je.marginBottom,
  ml: Je.marginLeft,
  ms: Je.marginInlineStart,
  marginStart: Je.marginInlineStart,
  mx: Je.marginX,
  my: Je.marginY,
  p: Je.padding,
  pt: Je.paddingTop,
  py: Je.paddingY,
  px: Je.paddingX,
  pb: Je.paddingBottom,
  pl: Je.paddingLeft,
  ps: Je.paddingInlineStart,
  paddingStart: Je.paddingInlineStart,
  pr: Je.paddingRight,
  pe: Je.paddingInlineEnd,
  paddingEnd: Je.paddingInlineEnd
});
var i1 = {
  textDecorationColor: E.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: { property: "textDecoration" },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: E.shadows("textShadow")
}, s1 = {
  clipPath: !0,
  transform: E.propT("transform", Ie.transform),
  transformOrigin: !0,
  translateX: E.spaceT("--chakra-translate-x"),
  translateY: E.spaceT("--chakra-translate-y"),
  skewX: E.degreeT("--chakra-skew-x"),
  skewY: E.degreeT("--chakra-skew-y"),
  scaleX: E.prop("--chakra-scale-x"),
  scaleY: E.prop("--chakra-scale-y"),
  scale: E.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: E.degreeT("--chakra-rotate")
}, l1 = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: E.prop("transitionDuration", "transition.duration"),
  transitionProperty: E.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: E.prop(
    "transitionTimingFunction",
    "transition.easing"
  )
}, u1 = {
  fontFamily: E.prop("fontFamily", "fonts"),
  fontSize: E.prop("fontSize", "fontSizes", Ie.px),
  fontWeight: E.prop("fontWeight", "fontWeights"),
  lineHeight: E.prop("lineHeight", "lineHeights"),
  letterSpacing: E.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  textIndent: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  isTruncated: {
    transform(e) {
      if (e === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  },
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
}, c1 = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  // scroll margin
  scrollMargin: E.spaceT("scrollMargin"),
  scrollMarginTop: E.spaceT("scrollMarginTop"),
  scrollMarginBottom: E.spaceT("scrollMarginBottom"),
  scrollMarginLeft: E.spaceT("scrollMarginLeft"),
  scrollMarginRight: E.spaceT("scrollMarginRight"),
  scrollMarginX: E.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: E.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: E.spaceT("scrollPadding"),
  scrollPaddingTop: E.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: E.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: E.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: E.spaceT("scrollPaddingRight"),
  scrollPaddingX: E.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: E.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function _h(e) {
  return rn(e) && e.reference ? e.reference : String(e);
}
var Rs = (e, ...r) => r.map(_h).join(` ${e} `).replace(/calc/g, ""), Nd = (...e) => `calc(${Rs("+", ...e)})`, Ld = (...e) => `calc(${Rs("-", ...e)})`, su = (...e) => `calc(${Rs("*", ...e)})`, Wd = (...e) => `calc(${Rs("/", ...e)})`, Bd = (e) => {
  const r = _h(e);
  return r != null && !Number.isNaN(parseFloat(r)) ? String(r).startsWith("-") ? String(r).slice(1) : `-${r}` : su(r, -1);
}, so = Object.assign(
  (e) => ({
    add: (...r) => so(Nd(e, ...r)),
    subtract: (...r) => so(Ld(e, ...r)),
    multiply: (...r) => so(su(e, ...r)),
    divide: (...r) => so(Wd(e, ...r)),
    negate: () => so(Bd(e)),
    toString: () => e.toString()
  }),
  {
    add: Nd,
    subtract: Ld,
    multiply: su,
    divide: Wd,
    negate: Bd
  }
);
function d1(e) {
  const r = parseFloat(e.toString()), t = e.toString().replace(String(r), "");
  return { unitless: !t, value: r, unit: t };
}
function Vd(e) {
  if (e == null)
    return e;
  const { unitless: r } = d1(e);
  return r || typeof e == "number" ? `${e}px` : e;
}
function f1(e, r) {
  const t = ["@media screen"];
  return e && t.push("and", `(min-width: ${Vd(e)})`), r && t.push("and", `(max-width: ${Vd(r)})`), t.join(" ");
}
var St = {
  hover: (e, r) => `${e}:hover ${r}, ${e}[data-hover] ${r}`,
  focus: (e, r) => `${e}:focus ${r}, ${e}[data-focus] ${r}`,
  focusVisible: (e, r) => `${e}:focus-visible ${r}`,
  focusWithin: (e, r) => `${e}:focus-within ${r}`,
  active: (e, r) => `${e}:active ${r}, ${e}[data-active] ${r}`,
  disabled: (e, r) => `${e}:disabled ${r}, ${e}[data-disabled] ${r}`,
  invalid: (e, r) => `${e}:invalid ${r}, ${e}[data-invalid] ${r}`,
  checked: (e, r) => `${e}:checked ${r}, ${e}[data-checked] ${r}`,
  placeholderShown: (e, r) => `${e}:placeholder-shown ${r}`
}, bn = (e) => kh((r) => e(r, "&"), "[role=group]", "[data-group]", ".group"), Ur = (e) => kh((r) => e(r, "~ &"), "[data-peer]", ".peer"), kh = (e, ...r) => r.map(e).join(", "), Qu = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   * - `&[disabled]`
   */
  _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS selector `&::first-letter`
   *
   * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
   * @example
   * ```jsx
   * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
   * ```
   */
  _firstLetter: "&::first-letter",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: bn(St.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: Ur(St.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: bn(St.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: Ur(St.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: bn(St.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: Ur(St.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: bn(St.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: Ur(St.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: bn(St.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: Ur(St.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: bn(St.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: Ur(St.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: bn(St.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: Ur(St.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: bn(St.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: Ur(St.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: Ur(St.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
  /**
   * Styles for the CSS Selector `&[data-orientation=horizontal]`
   */
  _horizontal: "&[data-orientation=horizontal]",
  /**
   * Styles for the CSS Selector `&[data-orientation=vertical]`
   */
  _vertical: "&[data-orientation=vertical]"
}, p1 = Object.keys(
  Qu
);
function h1(e, r = []) {
  const t = Object.assign({}, e);
  for (const n of r)
    n in t && delete t[n];
  return t;
}
var qu = en(
  {},
  Ei,
  Te,
  UC,
  es,
  tr,
  JC,
  o1,
  QC,
  Dh,
  a1,
  Io,
  iu,
  Je,
  c1,
  u1,
  i1,
  s1,
  qC,
  l1
);
Object.assign({}, Je, tr, es, Dh, Io);
var g1 = [...Object.keys(qu), ...p1], m1 = { ...qu, ...Qu }, v1 = (e) => e in m1, b1 = (e) => (r) => {
  if (!r.__breakpoints)
    return e;
  const { isResponsive: t, toArrayValue: n, media: a } = r.__breakpoints, o = {};
  for (const i in e) {
    let s = wn(e[i], r);
    if (s == null)
      continue;
    if (s = rn(s) && t(s) ? n(s) : s, !Array.isArray(s)) {
      o[i] = s;
      continue;
    }
    const l = s.slice(0, a.length).length;
    for (let u = 0; u < l; u += 1) {
      const c = a == null ? void 0 : a[u];
      if (!c) {
        o[i] = s[u];
        continue;
      }
      o[c] = o[c] || {}, s[u] != null && (o[c][i] = s[u]);
    }
  }
  return o;
};
function y1(e) {
  const r = [];
  let t = "", n = !1;
  for (let a = 0; a < e.length; a++) {
    const o = e[a];
    o === "(" ? (n = !0, t += o) : o === ")" ? (n = !1, t += o) : o === "," && !n ? (r.push(t), t = "") : t += o;
  }
  return t = t.trim(), t && r.push(t), r;
}
function w1(e) {
  return /^var\(--.+\)$/.test(e);
}
var C1 = (e, r) => e.startsWith("--") && typeof r == "string" && !w1(r), x1 = (e, r) => {
  var t, n;
  if (r == null)
    return r;
  const a = (l) => {
    var u, c;
    return (c = (u = e.__cssMap) == null ? void 0 : u[l]) == null ? void 0 : c.varRef;
  }, o = (l) => {
    var u;
    return (u = a(l)) != null ? u : l;
  }, [i, s] = y1(r);
  return r = (n = (t = a(i)) != null ? t : o(s)) != null ? n : o(r), r;
};
function S1(e) {
  const { configs: r = {}, pseudos: t = {}, theme: n } = e, a = (o, i = !1) => {
    var s, l, u;
    const c = wn(o, n), d = b1(c)(n);
    let p = {};
    for (let f in d) {
      const h = d[f];
      let g = wn(h, n);
      f in t && (f = t[f]), C1(f, g) && (g = x1(n, g));
      let m = r[f];
      if (m === !0 && (m = { property: f }), rn(g)) {
        p[f] = (s = p[f]) != null ? s : {}, p[f] = en(
          {},
          p[f],
          a(g, !0)
        );
        continue;
      }
      let v = (u = (l = m == null ? void 0 : m.transform) == null ? void 0 : l.call(m, g, n, c)) != null ? u : g;
      v = m != null && m.processResult ? a(v, !0) : v;
      const y = wn(m == null ? void 0 : m.property, n);
      if (!i && (m != null && m.static)) {
        const w = wn(m.static, n);
        p = en({}, p, w);
      }
      if (y && Array.isArray(y)) {
        for (const w of y)
          p[w] = v;
        continue;
      }
      if (y) {
        y === "&" && rn(v) ? p = en({}, p, v) : p[y] = v;
        continue;
      }
      if (rn(v)) {
        p = en({}, p, v);
        continue;
      }
      p[f] = v;
    }
    return p;
  };
  return a;
}
var I1 = (e) => (r) => S1({
  theme: r,
  pseudos: Qu,
  configs: qu
})(e);
function D1(e, r) {
  if (Array.isArray(e))
    return e;
  if (rn(e))
    return r(e);
  if (e != null)
    return [e];
}
function _1(e, r) {
  for (let t = r + 1; t < e.length; t++)
    if (e[t] != null)
      return t;
  return -1;
}
function k1(e) {
  const r = e.__breakpoints;
  return function(n, a, o, i) {
    var s, l;
    if (!r)
      return;
    const u = {}, c = D1(o, r.toArrayValue);
    if (!c)
      return u;
    const d = c.length, p = d === 1, f = !!n.parts;
    for (let h = 0; h < d; h++) {
      const g = r.details[h], m = r.details[_1(c, h)], v = f1(g.minW, m == null ? void 0 : m._minW), y = wn((s = n[a]) == null ? void 0 : s[c[h]], i);
      if (y) {
        if (f) {
          (l = n.parts) == null || l.forEach((w) => {
            en(u, {
              [w]: p ? y[w] : { [v]: y[w] }
            });
          });
          continue;
        }
        if (!f) {
          p ? en(u, y) : u[v] = y;
          continue;
        }
        u[v] = y;
      }
    }
    return u;
  };
}
function E1(e) {
  return (r) => {
    var t;
    const { variant: n, size: a, theme: o } = r, i = k1(o);
    return en(
      {},
      wn((t = e.baseStyle) != null ? t : {}, r),
      i(e, "sizes", a, r),
      i(e, "variants", n, r)
    );
  };
}
function Os(e) {
  return h1(e, ["styleConfig", "size", "variant", "colorScheme"]);
}
function M1(e, r) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    r.includes(n) || (t[n] = e[n]);
  }), t;
}
function P1(e, r, t, n) {
  const a = typeof r == "string" ? r.split(".") : [r];
  for (n = 0; n < a.length && e; n += 1)
    e = e[a[n]];
  return e === void 0 ? t : e;
}
var A1 = (e) => {
  const r = /* @__PURE__ */ new WeakMap();
  return (n, a, o, i) => {
    if (typeof n > "u")
      return e(n, a, o);
    r.has(n) || r.set(n, /* @__PURE__ */ new Map());
    const s = r.get(n);
    if (s.has(a))
      return s.get(a);
    const l = e(n, a, o, i);
    return s.set(a, l), l;
  };
}, R1 = A1(P1);
function Eh(e, r) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    const a = e[n];
    r(a, n, e) && (t[n] = a);
  }), t;
}
var Mh = (e) => Eh(e, (r) => r != null);
function O1(e) {
  return typeof e == "function";
}
process.env.NODE_ENV;
process.env.NODE_ENV;
function T1(e, ...r) {
  return O1(e) ? e(...r) : e;
}
var F1 = typeof Element < "u", N1 = typeof Map == "function", L1 = typeof Set == "function", W1 = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Mi(e, r) {
  if (e === r) return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor) return !1;
    var t, n, a;
    if (Array.isArray(e)) {
      if (t = e.length, t != r.length) return !1;
      for (n = t; n-- !== 0; )
        if (!Mi(e[n], r[n])) return !1;
      return !0;
    }
    var o;
    if (N1 && e instanceof Map && r instanceof Map) {
      if (e.size !== r.size) return !1;
      for (o = e.entries(); !(n = o.next()).done; )
        if (!r.has(n.value[0])) return !1;
      for (o = e.entries(); !(n = o.next()).done; )
        if (!Mi(n.value[1], r.get(n.value[0]))) return !1;
      return !0;
    }
    if (L1 && e instanceof Set && r instanceof Set) {
      if (e.size !== r.size) return !1;
      for (o = e.entries(); !(n = o.next()).done; )
        if (!r.has(n.value[0])) return !1;
      return !0;
    }
    if (W1 && ArrayBuffer.isView(e) && ArrayBuffer.isView(r)) {
      if (t = e.length, t != r.length) return !1;
      for (n = t; n-- !== 0; )
        if (e[n] !== r[n]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof r.valueOf == "function") return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof r.toString == "function") return e.toString() === r.toString();
    if (a = Object.keys(e), t = a.length, t !== Object.keys(r).length) return !1;
    for (n = t; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, a[n])) return !1;
    if (F1 && e instanceof Element) return !1;
    for (n = t; n-- !== 0; )
      if (!((a[n] === "_owner" || a[n] === "__v" || a[n] === "__o") && e.$$typeof) && !Mi(e[a[n]], r[a[n]]))
        return !1;
    return !0;
  }
  return e !== e && r !== r;
}
var B1 = function(r, t) {
  try {
    return Mi(r, t);
  } catch (n) {
    if ((n.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw n;
  }
};
const V1 = /* @__PURE__ */ Uu(B1);
function Ph(e, r = {}) {
  var t;
  const { styleConfig: n, ...a } = r, { theme: o, colorMode: i } = PC(), s = e ? R1(o, `components.${e}`) : void 0, l = n || s, u = en(
    { theme: o, colorMode: i },
    (t = l == null ? void 0 : l.defaultProps) != null ? t : {},
    Mh(M1(a, ["children"]))
  ), c = ye({});
  if (l) {
    const p = E1(l)(u);
    V1(c.current, p) || (c.current = p);
  }
  return c.current;
}
function Ts(e, r = {}) {
  return Ph(e, r);
}
function Vr(e, r = {}) {
  return Ph(e, r);
}
var G1 = /* @__PURE__ */ new Set([
  ...g1,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]), Y1 = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function H1(e) {
  return Y1.has(e) || !G1.has(e);
}
function z1(e, ...r) {
  if (e == null)
    throw new TypeError("Cannot convert undefined or null to object");
  const t = { ...e };
  for (const n of r)
    if (n != null)
      for (const a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (a in t && delete t[a], t[a] = n[a]);
  return t;
}
var Gd, $1 = (Gd = ad.default) != null ? Gd : ad, X1 = ({ baseStyle: e }) => (r) => {
  const { theme: t, css: n, __css: a, sx: o, ...i } = r, s = Eh(i, (d, p) => v1(p)), l = T1(e, r), u = z1(
    {},
    a,
    l,
    Mh(s),
    o
  ), c = I1(u)(r.theme);
  return n ? [c, n] : c;
};
function Cl(e, r) {
  const { baseStyle: t, ...n } = r ?? {};
  n.shouldForwardProp || (n.shouldForwardProp = H1);
  const a = X1({ baseStyle: t }), o = $1(
    e,
    n
  )(a);
  return P.forwardRef(function(l, u) {
    const { colorMode: c, forced: d } = Zu();
    return P.createElement(o, {
      ref: u,
      "data-theme": d ? c : void 0,
      ...l
    });
  });
}
function j1() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(Cl, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply(r, t, n) {
      return Cl(...n);
    },
    /**
     * @example
     * <chakra.div />
     */
    get(r, t) {
      return e.has(t) || e.set(t, Cl(t)), e.get(t);
    }
  });
}
var ur = j1();
function sa(e) {
  return at(e);
}
var [Z1, U1] = jo({
  name: "FormControlStylesContext",
  errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
}), [J1, Ah] = jo({
  strict: !1,
  name: "FormControlContext"
});
function Q1(e) {
  const {
    id: r,
    isRequired: t,
    isInvalid: n,
    isDisabled: a,
    isReadOnly: o,
    ...i
  } = e, s = Bu(), l = r || `field-${s}`, u = `${l}-label`, c = `${l}-feedback`, d = `${l}-helptext`, [p, f] = ke(!1), [h, g] = ke(!1), [m, v] = ke(!1), y = re(
    (S = {}, _ = null) => ({
      id: d,
      ...S,
      /**
       * Notify the field context when the help text is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: Ao(_, (k) => {
        k && g(!0);
      })
    }),
    [d]
  ), w = re(
    (S = {}, _ = null) => ({
      ...S,
      ref: _,
      "data-focus": vn(m),
      "data-disabled": vn(a),
      "data-invalid": vn(n),
      "data-readonly": vn(o),
      id: S.id !== void 0 ? S.id : u,
      htmlFor: S.htmlFor !== void 0 ? S.htmlFor : l
    }),
    [l, a, m, n, o, u]
  ), I = re(
    (S = {}, _ = null) => ({
      id: c,
      ...S,
      /**
       * Notify the field context when the error message is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: Ao(_, (k) => {
        k && f(!0);
      }),
      "aria-live": "polite"
    }),
    [c]
  ), b = re(
    (S = {}, _ = null) => ({
      ...S,
      ...i,
      ref: _,
      role: "group",
      "data-focus": vn(m),
      "data-disabled": vn(a),
      "data-invalid": vn(n),
      "data-readonly": vn(o)
    }),
    [i, a, m, n, o]
  ), D = re(
    (S = {}, _ = null) => ({
      ...S,
      ref: _,
      role: "presentation",
      "aria-hidden": !0,
      children: S.children || "*"
    }),
    []
  );
  return {
    isRequired: !!t,
    isInvalid: !!n,
    isReadOnly: !!o,
    isDisabled: !!a,
    isFocused: !!m,
    onFocus: () => v(!0),
    onBlur: () => v(!1),
    hasFeedbackText: p,
    setHasFeedbackText: f,
    hasHelpText: h,
    setHasHelpText: g,
    id: l,
    labelId: u,
    feedbackId: c,
    helpTextId: d,
    htmlProps: i,
    getHelpTextProps: y,
    getErrorMessageProps: I,
    getRootProps: b,
    getLabelProps: w,
    getRequiredIndicatorProps: D
  };
}
var q1 = sa(
  function(r, t) {
    const n = Vr("Form", r), a = Os(r), {
      getRootProps: o,
      htmlProps: i,
      ...s
    } = Q1(a), l = Jn("chakra-form-control", r.className);
    return /* @__PURE__ */ x(J1, { value: s, children: /* @__PURE__ */ x(Z1, { value: n, children: /* @__PURE__ */ x(
      ur.div,
      {
        ...o({}, t),
        className: l,
        __css: n.container
      }
    ) }) });
  }
);
q1.displayName = "FormControl";
var K1 = sa(
  function(r, t) {
    const n = Ah(), a = U1(), o = Jn("chakra-form__helper-text", r.className);
    return /* @__PURE__ */ x(
      ur.div,
      {
        ...n == null ? void 0 : n.getHelpTextProps(r, t),
        __css: a.helperText,
        className: o
      }
    );
  }
);
K1.displayName = "FormHelperText";
var Yd = {
  path: /* @__PURE__ */ ee("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ x(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ x(
      "path",
      {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ x("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] }),
  viewBox: "0 0 24 24"
}, Fs = sa((e, r) => {
  const {
    as: t,
    viewBox: n,
    color: a = "currentColor",
    focusable: o = !1,
    children: i,
    className: s,
    __css: l,
    ...u
  } = e, c = Jn("chakra-icon", s), d = Ts("Icon", e), p = {
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: a,
    ...l,
    ...d
  }, f = {
    ref: r,
    focusable: o,
    className: c,
    __css: p
  }, h = n ?? Yd.viewBox;
  if (t && typeof t != "string")
    return /* @__PURE__ */ x(ur.svg, { as: t, ...f, ...u });
  const g = i ?? Yd.path;
  return /* @__PURE__ */ x(ur.svg, { verticalAlign: "middle", viewBox: h, ...f, ...u, children: g });
});
Fs.displayName = "Icon";
function ex(e) {
  const { isDisabled: r, isInvalid: t, isReadOnly: n, isRequired: a, ...o } = tx(e);
  return {
    ...o,
    disabled: r,
    readOnly: n,
    required: a,
    "aria-invalid": yl(t),
    "aria-required": yl(a),
    "aria-readonly": yl(n)
  };
}
function tx(e) {
  var r, t, n;
  const a = Ah(), {
    id: o,
    disabled: i,
    readOnly: s,
    required: l,
    isRequired: u,
    isInvalid: c,
    isReadOnly: d,
    isDisabled: p,
    onFocus: f,
    onBlur: h,
    ...g
  } = e, m = e["aria-describedby"] ? [e["aria-describedby"]] : [];
  return a != null && a.hasFeedbackText && (a != null && a.isInvalid) && m.push(a.feedbackId), a != null && a.hasHelpText && m.push(a.helpTextId), {
    ...g,
    "aria-describedby": m.join(" ") || void 0,
    id: o ?? (a == null ? void 0 : a.id),
    isDisabled: (r = i ?? p) != null ? r : a == null ? void 0 : a.isDisabled,
    isReadOnly: (t = s ?? d) != null ? t : a == null ? void 0 : a.isReadOnly,
    isRequired: (n = l ?? u) != null ? n : a == null ? void 0 : a.isRequired,
    isInvalid: c ?? (a == null ? void 0 : a.isInvalid),
    onFocus: Td(a == null ? void 0 : a.onFocus, f),
    onBlur: Td(a == null ? void 0 : a.onBlur, h)
  };
}
var Rh = Object.freeze([
  "base",
  "sm",
  "md",
  "lg",
  "xl",
  "2xl"
]);
function rx(e, r = Rh) {
  const t = {};
  return e.forEach((n, a) => {
    const o = r[a];
    n != null && (t[o] = n);
  }), t;
}
var bt = ur("div");
bt.displayName = "Box";
var Oh = sa(function(r, t) {
  const { size: n, centerContent: a = !0, ...o } = r;
  return /* @__PURE__ */ x(
    bt,
    {
      ref: t,
      boxSize: n,
      __css: {
        ...a ? { display: "flex", alignItems: "center", justifyContent: "center" } : {},
        flexShrink: 0,
        flexGrow: 0
      },
      ...o
    }
  );
});
Oh.displayName = "Square";
var nx = sa(function(r, t) {
  const { size: n, ...a } = r;
  return /* @__PURE__ */ x(Oh, { size: n, ref: t, borderRadius: "9999px", ...a });
});
nx.displayName = "Circle";
var Th = sa(function(r, t) {
  const {
    borderLeftWidth: n,
    borderBottomWidth: a,
    borderTopWidth: o,
    borderRightWidth: i,
    borderWidth: s,
    borderStyle: l,
    borderColor: u,
    ...c
  } = Ts("Divider", r), {
    className: d,
    orientation: p = "horizontal",
    __css: f,
    ...h
  } = Os(r), g = {
    vertical: {
      borderLeftWidth: n || i || s || "1px",
      height: "100%"
    },
    horizontal: {
      borderBottomWidth: a || o || s || "1px",
      width: "100%"
    }
  };
  return /* @__PURE__ */ x(
    ur.hr,
    {
      ref: t,
      "aria-orientation": p,
      ...h,
      __css: {
        ...c,
        border: "0",
        borderColor: u,
        borderStyle: l,
        ...g[p],
        ...f
      },
      className: Jn("chakra-divider", d)
    }
  );
});
Th.displayName = "Divider";
var Fh = Yo({
  getDocument() {
    return document;
  },
  getWindow() {
    return window;
  }
});
Fh.displayName = "EnvironmentContext";
function ax({ defer: e } = {}) {
  const [, r] = Sp((t) => t + 1, 0);
  return MC(() => {
    e && r();
  }, [e]), za(Fh);
}
function ox(e, r = {}) {
  const { ssr: t = !0, fallback: n } = r, { getWindow: a } = ax(), o = Array.isArray(e) ? e : [e];
  let i = Array.isArray(n) ? n : [n];
  i = i.filter((u) => u != null);
  const [s, l] = ke(() => o.map((u, c) => ({
    media: u,
    matches: t ? !!i[c] : a().matchMedia(u).matches
  })));
  return He(() => {
    const u = a();
    l(
      o.map((p) => ({
        media: p,
        matches: u.matchMedia(p).matches
      }))
    );
    const c = o.map((p) => u.matchMedia(p)), d = (p) => {
      l((f) => f.slice().map((h) => h.media === p.media ? { ...h, matches: p.matches } : h));
    };
    return c.forEach((p) => {
      typeof p.addListener == "function" ? p.addListener(d) : p.addEventListener("change", d);
    }), () => {
      c.forEach((p) => {
        typeof p.removeListener == "function" ? p.removeListener(d) : p.removeEventListener("change", d);
      });
    };
  }, [a]), s.map((u) => u.matches);
}
function ix(e, r, t = Rh) {
  let n = Object.keys(e).indexOf(r);
  if (n !== -1)
    return e[r];
  let a = t.indexOf(r);
  for (; a >= 0; ) {
    const o = t[a];
    if (e.hasOwnProperty(o)) {
      n = a;
      break;
    }
    a -= 1;
  }
  if (n !== -1) {
    const o = t[n];
    return e[o];
  }
}
function sx(e) {
  var r, t;
  const n = rn(e) ? e : { fallback: e ?? "base" }, o = Xa().__breakpoints.details.map(
    ({ minMaxQuery: u, breakpoint: c }) => ({
      breakpoint: c,
      query: u.replace("@media screen and ", "")
    })
  ), i = o.map((u) => u.breakpoint === n.fallback), l = ox(
    o.map((u) => u.query),
    { fallback: i, ssr: n.ssr }
  ).findIndex((u) => u == !0);
  return (t = (r = o[l]) == null ? void 0 : r.breakpoint) != null ? t : n.fallback;
}
function lx(e, r) {
  var t;
  const n = rn(r) ? r : { fallback: r ?? "base" }, a = sx(n), o = Xa();
  if (!a)
    return;
  const i = Array.from(((t = o.__breakpoints) == null ? void 0 : t.keys) || []), s = Array.isArray(e) ? Object.fromEntries(
    Object.entries(rx(e, i)).map(
      ([l, u]) => [l, u]
    )
  ) : e;
  return ix(s, a, i);
}
var ux = Fp({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
}), Nh = sa((e, r) => {
  const t = Ts("Spinner", e), {
    label: n = "Loading...",
    thickness: a = "2px",
    speed: o = "0.45s",
    emptyColor: i = "transparent",
    className: s,
    ...l
  } = Os(e), u = Jn("chakra-spinner", s), c = {
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: a,
    borderBottomColor: i,
    borderLeftColor: i,
    animation: `${ux} ${o} linear infinite`,
    ...t
  };
  return /* @__PURE__ */ x(
    ur.div,
    {
      ref: r,
      __css: c,
      className: u,
      ...l,
      children: n && /* @__PURE__ */ x(ur.span, { srOnly: !0, children: n })
    }
  );
});
Nh.displayName = "Spinner";
var cx = Object.defineProperty, dx = (e, r, t) => r in e ? cx(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, st = (e, r, t) => (dx(e, typeof r != "symbol" ? r + "" : r, t), t);
function Hd(e) {
  return e.sort((r, t) => {
    const n = r.compareDocumentPosition(t);
    if (n & Node.DOCUMENT_POSITION_FOLLOWING || n & Node.DOCUMENT_POSITION_CONTAINED_BY)
      return -1;
    if (n & Node.DOCUMENT_POSITION_PRECEDING || n & Node.DOCUMENT_POSITION_CONTAINS)
      return 1;
    if (n & Node.DOCUMENT_POSITION_DISCONNECTED || n & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC)
      throw Error("Cannot sort the given nodes.");
    return 0;
  });
}
var fx = (e) => typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
function zd(e, r, t) {
  let n = e + 1;
  return t && n >= r && (n = 0), n;
}
function $d(e, r, t) {
  let n = e - 1;
  return t && n < 0 && (n = r), n;
}
var lu = typeof window < "u" ? Go : He, ts = (e) => e, px = class {
  constructor() {
    st(this, "descendants", /* @__PURE__ */ new Map()), st(this, "register", (e) => {
      if (e != null)
        return fx(e) ? this.registerNode(e) : (r) => {
          this.registerNode(r, e);
        };
    }), st(this, "unregister", (e) => {
      this.descendants.delete(e);
      const r = Hd(Array.from(this.descendants.keys()));
      this.assignIndex(r);
    }), st(this, "destroy", () => {
      this.descendants.clear();
    }), st(this, "assignIndex", (e) => {
      this.descendants.forEach((r) => {
        const t = e.indexOf(r.node);
        r.index = t, r.node.dataset.index = r.index.toString();
      });
    }), st(this, "count", () => this.descendants.size), st(this, "enabledCount", () => this.enabledValues().length), st(this, "values", () => Array.from(this.descendants.values()).sort((r, t) => r.index - t.index)), st(this, "enabledValues", () => this.values().filter((e) => !e.disabled)), st(this, "item", (e) => {
      if (this.count() !== 0)
        return this.values()[e];
    }), st(this, "enabledItem", (e) => {
      if (this.enabledCount() !== 0)
        return this.enabledValues()[e];
    }), st(this, "first", () => this.item(0)), st(this, "firstEnabled", () => this.enabledItem(0)), st(this, "last", () => this.item(this.descendants.size - 1)), st(this, "lastEnabled", () => {
      const e = this.enabledValues().length - 1;
      return this.enabledItem(e);
    }), st(this, "indexOf", (e) => {
      var r, t;
      return e && (t = (r = this.descendants.get(e)) == null ? void 0 : r.index) != null ? t : -1;
    }), st(this, "enabledIndexOf", (e) => e == null ? -1 : this.enabledValues().findIndex((r) => r.node.isSameNode(e))), st(this, "next", (e, r = !0) => {
      const t = zd(e, this.count(), r);
      return this.item(t);
    }), st(this, "nextEnabled", (e, r = !0) => {
      const t = this.item(e);
      if (!t)
        return;
      const n = this.enabledIndexOf(t.node), a = zd(
        n,
        this.enabledCount(),
        r
      );
      return this.enabledItem(a);
    }), st(this, "prev", (e, r = !0) => {
      const t = $d(e, this.count() - 1, r);
      return this.item(t);
    }), st(this, "prevEnabled", (e, r = !0) => {
      const t = this.item(e);
      if (!t)
        return;
      const n = this.enabledIndexOf(t.node), a = $d(
        n,
        this.enabledCount() - 1,
        r
      );
      return this.enabledItem(a);
    }), st(this, "registerNode", (e, r) => {
      if (!e || this.descendants.has(e))
        return;
      const t = Array.from(this.descendants.keys()).concat(e), n = Hd(t);
      r != null && r.disabled && (r.disabled = !!r.disabled);
      const a = { node: e, index: -1, ...r };
      this.descendants.set(e, a), this.assignIndex(n);
    });
  }
};
function hx() {
  const e = ye(new px());
  return lu(() => () => e.current.destroy()), e.current;
}
var [gx, Lh] = jo({
  name: "DescendantsProvider",
  errorMessage: "useDescendantsContext must be used within DescendantsProvider"
});
function mx(e) {
  const r = Lh(), [t, n] = ke(-1), a = ye(null);
  lu(() => () => {
    a.current && r.unregister(a.current);
  }, []), lu(() => {
    if (!a.current)
      return;
    const i = Number(a.current.dataset.index);
    t != i && !Number.isNaN(i) && n(i);
  });
  const o = ts(e ? r.register(e) : r.register);
  return {
    descendants: r,
    index: t,
    enabledIndex: r.enabledIndexOf(a.current),
    register: Ao(o, a)
  };
}
function vx() {
  return [
    ts(gx),
    () => ts(Lh()),
    () => hx(),
    (a) => mx(a)
  ];
}
function Wh(e) {
  return e != null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
}
function Bh(e) {
  var r;
  if (!Wh(e))
    return !1;
  const t = (r = e.ownerDocument.defaultView) != null ? r : window;
  return e instanceof t.HTMLElement;
}
function bx(e) {
  var r, t;
  return (t = (r = Vh(e)) == null ? void 0 : r.defaultView) != null ? t : window;
}
function Vh(e) {
  return Wh(e) ? e.ownerDocument : document;
}
function yx(e) {
  return Vh(e).activeElement;
}
var Gh = (e) => e.hasAttribute("tabindex"), wx = (e) => Gh(e) && e.tabIndex === -1;
function Cx(e) {
  return !!e.getAttribute("disabled") || !!e.getAttribute("aria-disabled");
}
function Yh(e) {
  return e.parentElement && Yh(e.parentElement) ? !0 : e.hidden;
}
function xx(e) {
  const r = e.getAttribute("contenteditable");
  return r !== "false" && r != null;
}
function Sx(e) {
  if (!Bh(e) || Yh(e) || Cx(e))
    return !1;
  const { localName: r } = e;
  if (["input", "select", "textarea", "button"].indexOf(r) >= 0)
    return !0;
  const n = {
    a: () => e.hasAttribute("href"),
    audio: () => e.hasAttribute("controls"),
    video: () => e.hasAttribute("controls")
  };
  return r in n ? n[r]() : xx(e) ? !0 : Gh(e);
}
function Ix(e) {
  return e ? Bh(e) && Sx(e) && !wx(e) : !1;
}
function rs(e, r = []) {
  const t = ye(e);
  return He(() => {
    t.current = e;
  }), re((...n) => {
    var a;
    return (a = t.current) == null ? void 0 : a.call(t, ...n);
  }, r);
}
function Dx(e, r, t, n) {
  const a = rs(t);
  return He(() => {
    const o = typeof e == "function" ? e() : e ?? document;
    if (!(!t || !o))
      return o.addEventListener(r, a, n), () => {
        o.removeEventListener(r, a, n);
      };
  }, [r, e, n, a, t]), () => {
    const o = typeof e == "function" ? e() : e ?? document;
    o == null || o.removeEventListener(r, a, n);
  };
}
function Hh(e, r) {
  const t = ye(!1), n = ye(!1);
  He(() => {
    if (t.current && n.current)
      return e();
    n.current = !0;
  }, r), He(() => (t.current = !0, () => {
    t.current = !1;
  }), []);
}
function _x(e) {
  const r = e.current;
  if (!r)
    return !1;
  const t = yx(r);
  return !t || r.contains(t) ? !1 : !!Ix(t);
}
function kx(e, r) {
  const { visible: t, focusRef: n } = r, a = !t;
  Hh(() => {
    if (!a || _x(e))
      return;
    const o = (n == null ? void 0 : n.current) || e.current;
    let i;
    if (o)
      return i = requestAnimationFrame(() => {
        o.focus({ preventScroll: !0 });
      }), () => {
        cancelAnimationFrame(i);
      };
  }, [a, e, n]);
}
var lo = (e, r) => ({
  var: e,
  varRef: r ? `var(${e}, ${r})` : `var(${e})`
}), Xt = {
  arrowSize: lo("--popper-arrow-size", "8px"),
  arrowSizeHalf: lo("--popper-arrow-size-half"),
  arrowBg: lo("--popper-arrow-bg"),
  transformOrigin: lo("--popper-transform-origin"),
  arrowOffset: lo("--popper-arrow-offset")
};
function Ex(e) {
  if (e.includes("top"))
    return "1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("bottom"))
    return "-1px -1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("right"))
    return "-1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("left"))
    return "1px -1px 0px 0 var(--popper-arrow-shadow-color)";
}
var Mx = {
  top: "bottom center",
  "top-start": "bottom left",
  "top-end": "bottom right",
  bottom: "top center",
  "bottom-start": "top left",
  "bottom-end": "top right",
  left: "right center",
  "left-start": "right top",
  "left-end": "right bottom",
  right: "left center",
  "right-start": "left top",
  "right-end": "left bottom"
}, Px = (e) => Mx[e], Xd = {
  scroll: !0,
  resize: !0
};
function Ax(e) {
  let r;
  return typeof e == "object" ? r = {
    enabled: !0,
    options: { ...Xd, ...e }
  } : r = {
    enabled: e,
    options: Xd
  }, r;
}
var Rx = {
  name: "matchWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  },
  effect: ({ state: e }) => () => {
    const r = e.elements.reference;
    e.elements.popper.style.width = `${r.offsetWidth}px`;
  }
}, Ox = {
  name: "transformOrigin",
  enabled: !0,
  phase: "write",
  fn: ({ state: e }) => {
    jd(e);
  },
  effect: ({ state: e }) => () => {
    jd(e);
  }
}, jd = (e) => {
  e.elements.popper.style.setProperty(
    Xt.transformOrigin.var,
    Px(e.placement)
  );
}, Tx = {
  name: "positionArrow",
  enabled: !0,
  phase: "afterWrite",
  fn: ({ state: e }) => {
    Fx(e);
  }
}, Fx = (e) => {
  var r;
  if (!e.placement)
    return;
  const t = Nx(e.placement);
  if ((r = e.elements) != null && r.arrow && t) {
    Object.assign(e.elements.arrow.style, {
      [t.property]: t.value,
      width: Xt.arrowSize.varRef,
      height: Xt.arrowSize.varRef,
      zIndex: -1
    });
    const n = {
      [Xt.arrowSizeHalf.var]: `calc(${Xt.arrowSize.varRef} / 2 - 1px)`,
      [Xt.arrowOffset.var]: `calc(${Xt.arrowSizeHalf.varRef} * -1)`
    };
    for (const a in n)
      e.elements.arrow.style.setProperty(a, n[a]);
  }
}, Nx = (e) => {
  if (e.startsWith("top"))
    return { property: "bottom", value: Xt.arrowOffset.varRef };
  if (e.startsWith("bottom"))
    return { property: "top", value: Xt.arrowOffset.varRef };
  if (e.startsWith("left"))
    return { property: "right", value: Xt.arrowOffset.varRef };
  if (e.startsWith("right"))
    return { property: "left", value: Xt.arrowOffset.varRef };
}, Lx = {
  name: "innerArrow",
  enabled: !0,
  phase: "main",
  requires: ["arrow"],
  fn: ({ state: e }) => {
    Zd(e);
  },
  effect: ({ state: e }) => () => {
    Zd(e);
  }
}, Zd = (e) => {
  if (!e.elements.arrow)
    return;
  const r = e.elements.arrow.querySelector(
    "[data-popper-arrow-inner]"
  );
  if (!r)
    return;
  const t = Ex(e.placement);
  t && r.style.setProperty("--popper-arrow-default-shadow", t), Object.assign(r.style, {
    transform: "rotate(45deg)",
    background: Xt.arrowBg.varRef,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: "inherit",
    boxShadow: "var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))"
  });
}, Wx = {
  "start-start": { ltr: "left-start", rtl: "right-start" },
  "start-end": { ltr: "left-end", rtl: "right-end" },
  "end-start": { ltr: "right-start", rtl: "left-start" },
  "end-end": { ltr: "right-end", rtl: "left-end" },
  start: { ltr: "left", rtl: "right" },
  end: { ltr: "right", rtl: "left" }
}, Bx = {
  "auto-start": "auto-end",
  "auto-end": "auto-start",
  "top-start": "top-end",
  "top-end": "top-start",
  "bottom-start": "bottom-end",
  "bottom-end": "bottom-start"
};
function Vx(e, r = "ltr") {
  var t, n;
  const a = ((t = Wx[e]) == null ? void 0 : t[r]) || e;
  return r === "ltr" ? a : (n = Bx[e]) != null ? n : a;
}
var Nt = "top", cr = "bottom", dr = "right", Lt = "left", Ku = "auto", Zo = [Nt, cr, dr, Lt], La = "start", Ro = "end", Gx = "clippingParents", zh = "viewport", uo = "popper", Yx = "reference", Ud = /* @__PURE__ */ Zo.reduce(function(e, r) {
  return e.concat([r + "-" + La, r + "-" + Ro]);
}, []), $h = /* @__PURE__ */ [].concat(Zo, [Ku]).reduce(function(e, r) {
  return e.concat([r, r + "-" + La, r + "-" + Ro]);
}, []), Hx = "beforeRead", zx = "read", $x = "afterRead", Xx = "beforeMain", jx = "main", Zx = "afterMain", Ux = "beforeWrite", Jx = "write", Qx = "afterWrite", qx = [Hx, zx, $x, Xx, jx, Zx, Ux, Jx, Qx];
function Gr(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Ut(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var r = e.ownerDocument;
    return r && r.defaultView || window;
  }
  return e;
}
function Qn(e) {
  var r = Ut(e).Element;
  return e instanceof r || e instanceof Element;
}
function ir(e) {
  var r = Ut(e).HTMLElement;
  return e instanceof r || e instanceof HTMLElement;
}
function ec(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var r = Ut(e).ShadowRoot;
  return e instanceof r || e instanceof ShadowRoot;
}
function Kx(e) {
  var r = e.state;
  Object.keys(r.elements).forEach(function(t) {
    var n = r.styles[t] || {}, a = r.attributes[t] || {}, o = r.elements[t];
    !ir(o) || !Gr(o) || (Object.assign(o.style, n), Object.keys(a).forEach(function(i) {
      var s = a[i];
      s === !1 ? o.removeAttribute(i) : o.setAttribute(i, s === !0 ? "" : s);
    }));
  });
}
function eS(e) {
  var r = e.state, t = {
    popper: {
      position: r.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(r.elements.popper.style, t.popper), r.styles = t, r.elements.arrow && Object.assign(r.elements.arrow.style, t.arrow), function() {
    Object.keys(r.elements).forEach(function(n) {
      var a = r.elements[n], o = r.attributes[n] || {}, i = Object.keys(r.styles.hasOwnProperty(n) ? r.styles[n] : t[n]), s = i.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !ir(a) || !Gr(a) || (Object.assign(a.style, s), Object.keys(o).forEach(function(l) {
        a.removeAttribute(l);
      }));
    });
  };
}
const tS = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Kx,
  effect: eS,
  requires: ["computeStyles"]
};
function Nr(e) {
  return e.split("-")[0];
}
var Hn = Math.max, ns = Math.min, Wa = Math.round;
function uu() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(r) {
    return r.brand + "/" + r.version;
  }).join(" ") : navigator.userAgent;
}
function Xh() {
  return !/^((?!chrome|android).)*safari/i.test(uu());
}
function Ba(e, r, t) {
  r === void 0 && (r = !1), t === void 0 && (t = !1);
  var n = e.getBoundingClientRect(), a = 1, o = 1;
  r && ir(e) && (a = e.offsetWidth > 0 && Wa(n.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && Wa(n.height) / e.offsetHeight || 1);
  var i = Qn(e) ? Ut(e) : window, s = i.visualViewport, l = !Xh() && t, u = (n.left + (l && s ? s.offsetLeft : 0)) / a, c = (n.top + (l && s ? s.offsetTop : 0)) / o, d = n.width / a, p = n.height / o;
  return {
    width: d,
    height: p,
    top: c,
    right: u + d,
    bottom: c + p,
    left: u,
    x: u,
    y: c
  };
}
function tc(e) {
  var r = Ba(e), t = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(r.width - t) <= 1 && (t = r.width), Math.abs(r.height - n) <= 1 && (n = r.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: t,
    height: n
  };
}
function jh(e, r) {
  var t = r.getRootNode && r.getRootNode();
  if (e.contains(r))
    return !0;
  if (t && ec(t)) {
    var n = r;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function un(e) {
  return Ut(e).getComputedStyle(e);
}
function rS(e) {
  return ["table", "td", "th"].indexOf(Gr(e)) >= 0;
}
function An(e) {
  return ((Qn(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ns(e) {
  return Gr(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (ec(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    An(e)
  );
}
function Jd(e) {
  return !ir(e) || // https://github.com/popperjs/popper-core/issues/837
  un(e).position === "fixed" ? null : e.offsetParent;
}
function nS(e) {
  var r = /firefox/i.test(uu()), t = /Trident/i.test(uu());
  if (t && ir(e)) {
    var n = un(e);
    if (n.position === "fixed")
      return null;
  }
  var a = Ns(e);
  for (ec(a) && (a = a.host); ir(a) && ["html", "body"].indexOf(Gr(a)) < 0; ) {
    var o = un(a);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || r && o.willChange === "filter" || r && o.filter && o.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function Uo(e) {
  for (var r = Ut(e), t = Jd(e); t && rS(t) && un(t).position === "static"; )
    t = Jd(t);
  return t && (Gr(t) === "html" || Gr(t) === "body" && un(t).position === "static") ? r : t || nS(e) || r;
}
function rc(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Do(e, r, t) {
  return Hn(e, ns(r, t));
}
function aS(e, r, t) {
  var n = Do(e, r, t);
  return n > t ? t : n;
}
function Zh() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Uh(e) {
  return Object.assign({}, Zh(), e);
}
function Jh(e, r) {
  return r.reduce(function(t, n) {
    return t[n] = e, t;
  }, {});
}
var oS = function(r, t) {
  return r = typeof r == "function" ? r(Object.assign({}, t.rects, {
    placement: t.placement
  })) : r, Uh(typeof r != "number" ? r : Jh(r, Zo));
};
function iS(e) {
  var r, t = e.state, n = e.name, a = e.options, o = t.elements.arrow, i = t.modifiersData.popperOffsets, s = Nr(t.placement), l = rc(s), u = [Lt, dr].indexOf(s) >= 0, c = u ? "height" : "width";
  if (!(!o || !i)) {
    var d = oS(a.padding, t), p = tc(o), f = l === "y" ? Nt : Lt, h = l === "y" ? cr : dr, g = t.rects.reference[c] + t.rects.reference[l] - i[l] - t.rects.popper[c], m = i[l] - t.rects.reference[l], v = Uo(o), y = v ? l === "y" ? v.clientHeight || 0 : v.clientWidth || 0 : 0, w = g / 2 - m / 2, I = d[f], b = y - p[c] - d[h], D = y / 2 - p[c] / 2 + w, S = Do(I, D, b), _ = l;
    t.modifiersData[n] = (r = {}, r[_] = S, r.centerOffset = S - D, r);
  }
}
function sS(e) {
  var r = e.state, t = e.options, n = t.element, a = n === void 0 ? "[data-popper-arrow]" : n;
  a != null && (typeof a == "string" && (a = r.elements.popper.querySelector(a), !a) || jh(r.elements.popper, a) && (r.elements.arrow = a));
}
const lS = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: iS,
  effect: sS,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Va(e) {
  return e.split("-")[1];
}
var uS = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function cS(e, r) {
  var t = e.x, n = e.y, a = r.devicePixelRatio || 1;
  return {
    x: Wa(t * a) / a || 0,
    y: Wa(n * a) / a || 0
  };
}
function Qd(e) {
  var r, t = e.popper, n = e.popperRect, a = e.placement, o = e.variation, i = e.offsets, s = e.position, l = e.gpuAcceleration, u = e.adaptive, c = e.roundOffsets, d = e.isFixed, p = i.x, f = p === void 0 ? 0 : p, h = i.y, g = h === void 0 ? 0 : h, m = typeof c == "function" ? c({
    x: f,
    y: g
  }) : {
    x: f,
    y: g
  };
  f = m.x, g = m.y;
  var v = i.hasOwnProperty("x"), y = i.hasOwnProperty("y"), w = Lt, I = Nt, b = window;
  if (u) {
    var D = Uo(t), S = "clientHeight", _ = "clientWidth";
    if (D === Ut(t) && (D = An(t), un(D).position !== "static" && s === "absolute" && (S = "scrollHeight", _ = "scrollWidth")), D = D, a === Nt || (a === Lt || a === dr) && o === Ro) {
      I = cr;
      var k = d && D === b && b.visualViewport ? b.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        D[S]
      );
      g -= k - n.height, g *= l ? 1 : -1;
    }
    if (a === Lt || (a === Nt || a === cr) && o === Ro) {
      w = dr;
      var R = d && D === b && b.visualViewport ? b.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        D[_]
      );
      f -= R - n.width, f *= l ? 1 : -1;
    }
  }
  var W = Object.assign({
    position: s
  }, u && uS), B = c === !0 ? cS({
    x: f,
    y: g
  }, Ut(t)) : {
    x: f,
    y: g
  };
  if (f = B.x, g = B.y, l) {
    var V;
    return Object.assign({}, W, (V = {}, V[I] = y ? "0" : "", V[w] = v ? "0" : "", V.transform = (b.devicePixelRatio || 1) <= 1 ? "translate(" + f + "px, " + g + "px)" : "translate3d(" + f + "px, " + g + "px, 0)", V));
  }
  return Object.assign({}, W, (r = {}, r[I] = y ? g + "px" : "", r[w] = v ? f + "px" : "", r.transform = "", r));
}
function dS(e) {
  var r = e.state, t = e.options, n = t.gpuAcceleration, a = n === void 0 ? !0 : n, o = t.adaptive, i = o === void 0 ? !0 : o, s = t.roundOffsets, l = s === void 0 ? !0 : s, u = {
    placement: Nr(r.placement),
    variation: Va(r.placement),
    popper: r.elements.popper,
    popperRect: r.rects.popper,
    gpuAcceleration: a,
    isFixed: r.options.strategy === "fixed"
  };
  r.modifiersData.popperOffsets != null && (r.styles.popper = Object.assign({}, r.styles.popper, Qd(Object.assign({}, u, {
    offsets: r.modifiersData.popperOffsets,
    position: r.options.strategy,
    adaptive: i,
    roundOffsets: l
  })))), r.modifiersData.arrow != null && (r.styles.arrow = Object.assign({}, r.styles.arrow, Qd(Object.assign({}, u, {
    offsets: r.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), r.attributes.popper = Object.assign({}, r.attributes.popper, {
    "data-popper-placement": r.placement
  });
}
const fS = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: dS,
  data: {}
};
var pi = {
  passive: !0
};
function pS(e) {
  var r = e.state, t = e.instance, n = e.options, a = n.scroll, o = a === void 0 ? !0 : a, i = n.resize, s = i === void 0 ? !0 : i, l = Ut(r.elements.popper), u = [].concat(r.scrollParents.reference, r.scrollParents.popper);
  return o && u.forEach(function(c) {
    c.addEventListener("scroll", t.update, pi);
  }), s && l.addEventListener("resize", t.update, pi), function() {
    o && u.forEach(function(c) {
      c.removeEventListener("scroll", t.update, pi);
    }), s && l.removeEventListener("resize", t.update, pi);
  };
}
const hS = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: pS,
  data: {}
};
var gS = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Pi(e) {
  return e.replace(/left|right|bottom|top/g, function(r) {
    return gS[r];
  });
}
var mS = {
  start: "end",
  end: "start"
};
function qd(e) {
  return e.replace(/start|end/g, function(r) {
    return mS[r];
  });
}
function nc(e) {
  var r = Ut(e), t = r.pageXOffset, n = r.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: n
  };
}
function ac(e) {
  return Ba(An(e)).left + nc(e).scrollLeft;
}
function vS(e, r) {
  var t = Ut(e), n = An(e), a = t.visualViewport, o = n.clientWidth, i = n.clientHeight, s = 0, l = 0;
  if (a) {
    o = a.width, i = a.height;
    var u = Xh();
    (u || !u && r === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: s + ac(e),
    y: l
  };
}
function bS(e) {
  var r, t = An(e), n = nc(e), a = (r = e.ownerDocument) == null ? void 0 : r.body, o = Hn(t.scrollWidth, t.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), i = Hn(t.scrollHeight, t.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -n.scrollLeft + ac(e), l = -n.scrollTop;
  return un(a || t).direction === "rtl" && (s += Hn(t.clientWidth, a ? a.clientWidth : 0) - o), {
    width: o,
    height: i,
    x: s,
    y: l
  };
}
function oc(e) {
  var r = un(e), t = r.overflow, n = r.overflowX, a = r.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + a + n);
}
function Qh(e) {
  return ["html", "body", "#document"].indexOf(Gr(e)) >= 0 ? e.ownerDocument.body : ir(e) && oc(e) ? e : Qh(Ns(e));
}
function _o(e, r) {
  var t;
  r === void 0 && (r = []);
  var n = Qh(e), a = n === ((t = e.ownerDocument) == null ? void 0 : t.body), o = Ut(n), i = a ? [o].concat(o.visualViewport || [], oc(n) ? n : []) : n, s = r.concat(i);
  return a ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(_o(Ns(i)))
  );
}
function cu(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function yS(e, r) {
  var t = Ba(e, !1, r === "fixed");
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Kd(e, r, t) {
  return r === zh ? cu(vS(e, t)) : Qn(r) ? yS(r, t) : cu(bS(An(e)));
}
function wS(e) {
  var r = _o(Ns(e)), t = ["absolute", "fixed"].indexOf(un(e).position) >= 0, n = t && ir(e) ? Uo(e) : e;
  return Qn(n) ? r.filter(function(a) {
    return Qn(a) && jh(a, n) && Gr(a) !== "body";
  }) : [];
}
function CS(e, r, t, n) {
  var a = r === "clippingParents" ? wS(e) : [].concat(r), o = [].concat(a, [t]), i = o[0], s = o.reduce(function(l, u) {
    var c = Kd(e, u, n);
    return l.top = Hn(c.top, l.top), l.right = ns(c.right, l.right), l.bottom = ns(c.bottom, l.bottom), l.left = Hn(c.left, l.left), l;
  }, Kd(e, i, n));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function qh(e) {
  var r = e.reference, t = e.element, n = e.placement, a = n ? Nr(n) : null, o = n ? Va(n) : null, i = r.x + r.width / 2 - t.width / 2, s = r.y + r.height / 2 - t.height / 2, l;
  switch (a) {
    case Nt:
      l = {
        x: i,
        y: r.y - t.height
      };
      break;
    case cr:
      l = {
        x: i,
        y: r.y + r.height
      };
      break;
    case dr:
      l = {
        x: r.x + r.width,
        y: s
      };
      break;
    case Lt:
      l = {
        x: r.x - t.width,
        y: s
      };
      break;
    default:
      l = {
        x: r.x,
        y: r.y
      };
  }
  var u = a ? rc(a) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (o) {
      case La:
        l[u] = l[u] - (r[c] / 2 - t[c] / 2);
        break;
      case Ro:
        l[u] = l[u] + (r[c] / 2 - t[c] / 2);
        break;
    }
  }
  return l;
}
function Oo(e, r) {
  r === void 0 && (r = {});
  var t = r, n = t.placement, a = n === void 0 ? e.placement : n, o = t.strategy, i = o === void 0 ? e.strategy : o, s = t.boundary, l = s === void 0 ? Gx : s, u = t.rootBoundary, c = u === void 0 ? zh : u, d = t.elementContext, p = d === void 0 ? uo : d, f = t.altBoundary, h = f === void 0 ? !1 : f, g = t.padding, m = g === void 0 ? 0 : g, v = Uh(typeof m != "number" ? m : Jh(m, Zo)), y = p === uo ? Yx : uo, w = e.rects.popper, I = e.elements[h ? y : p], b = CS(Qn(I) ? I : I.contextElement || An(e.elements.popper), l, c, i), D = Ba(e.elements.reference), S = qh({
    reference: D,
    element: w,
    placement: a
  }), _ = cu(Object.assign({}, w, S)), k = p === uo ? _ : D, R = {
    top: b.top - k.top + v.top,
    bottom: k.bottom - b.bottom + v.bottom,
    left: b.left - k.left + v.left,
    right: k.right - b.right + v.right
  }, W = e.modifiersData.offset;
  if (p === uo && W) {
    var B = W[a];
    Object.keys(R).forEach(function(V) {
      var F = [dr, cr].indexOf(V) >= 0 ? 1 : -1, H = [Nt, cr].indexOf(V) >= 0 ? "y" : "x";
      R[V] += B[H] * F;
    });
  }
  return R;
}
function xS(e, r) {
  r === void 0 && (r = {});
  var t = r, n = t.placement, a = t.boundary, o = t.rootBoundary, i = t.padding, s = t.flipVariations, l = t.allowedAutoPlacements, u = l === void 0 ? $h : l, c = Va(n), d = c ? s ? Ud : Ud.filter(function(h) {
    return Va(h) === c;
  }) : Zo, p = d.filter(function(h) {
    return u.indexOf(h) >= 0;
  });
  p.length === 0 && (p = d);
  var f = p.reduce(function(h, g) {
    return h[g] = Oo(e, {
      placement: g,
      boundary: a,
      rootBoundary: o,
      padding: i
    })[Nr(g)], h;
  }, {});
  return Object.keys(f).sort(function(h, g) {
    return f[h] - f[g];
  });
}
function SS(e) {
  if (Nr(e) === Ku)
    return [];
  var r = Pi(e);
  return [qd(e), r, qd(r)];
}
function IS(e) {
  var r = e.state, t = e.options, n = e.name;
  if (!r.modifiersData[n]._skip) {
    for (var a = t.mainAxis, o = a === void 0 ? !0 : a, i = t.altAxis, s = i === void 0 ? !0 : i, l = t.fallbackPlacements, u = t.padding, c = t.boundary, d = t.rootBoundary, p = t.altBoundary, f = t.flipVariations, h = f === void 0 ? !0 : f, g = t.allowedAutoPlacements, m = r.options.placement, v = Nr(m), y = v === m, w = l || (y || !h ? [Pi(m)] : SS(m)), I = [m].concat(w).reduce(function(X, ne) {
      return X.concat(Nr(ne) === Ku ? xS(r, {
        placement: ne,
        boundary: c,
        rootBoundary: d,
        padding: u,
        flipVariations: h,
        allowedAutoPlacements: g
      }) : ne);
    }, []), b = r.rects.reference, D = r.rects.popper, S = /* @__PURE__ */ new Map(), _ = !0, k = I[0], R = 0; R < I.length; R++) {
      var W = I[R], B = Nr(W), V = Va(W) === La, F = [Nt, cr].indexOf(B) >= 0, H = F ? "width" : "height", A = Oo(r, {
        placement: W,
        boundary: c,
        rootBoundary: d,
        altBoundary: p,
        padding: u
      }), N = F ? V ? dr : Lt : V ? cr : Nt;
      b[H] > D[H] && (N = Pi(N));
      var G = Pi(N), Q = [];
      if (o && Q.push(A[B] <= 0), s && Q.push(A[N] <= 0, A[G] <= 0), Q.every(function(X) {
        return X;
      })) {
        k = W, _ = !1;
        break;
      }
      S.set(W, Q);
    }
    if (_)
      for (var L = h ? 3 : 1, O = function(ne) {
        var K = I.find(function(ue) {
          var se = S.get(ue);
          if (se)
            return se.slice(0, ne).every(function(be) {
              return be;
            });
        });
        if (K)
          return k = K, "break";
      }, $ = L; $ > 0; $--) {
        var Y = O($);
        if (Y === "break") break;
      }
    r.placement !== k && (r.modifiersData[n]._skip = !0, r.placement = k, r.reset = !0);
  }
}
const DS = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: IS,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ef(e, r, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: e.top - r.height - t.y,
    right: e.right - r.width + t.x,
    bottom: e.bottom - r.height + t.y,
    left: e.left - r.width - t.x
  };
}
function tf(e) {
  return [Nt, dr, cr, Lt].some(function(r) {
    return e[r] >= 0;
  });
}
function _S(e) {
  var r = e.state, t = e.name, n = r.rects.reference, a = r.rects.popper, o = r.modifiersData.preventOverflow, i = Oo(r, {
    elementContext: "reference"
  }), s = Oo(r, {
    altBoundary: !0
  }), l = ef(i, n), u = ef(s, a, o), c = tf(l), d = tf(u);
  r.modifiersData[t] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: d
  }, r.attributes.popper = Object.assign({}, r.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": d
  });
}
const kS = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: _S
};
function ES(e, r, t) {
  var n = Nr(e), a = [Lt, Nt].indexOf(n) >= 0 ? -1 : 1, o = typeof t == "function" ? t(Object.assign({}, r, {
    placement: e
  })) : t, i = o[0], s = o[1];
  return i = i || 0, s = (s || 0) * a, [Lt, dr].indexOf(n) >= 0 ? {
    x: s,
    y: i
  } : {
    x: i,
    y: s
  };
}
function MS(e) {
  var r = e.state, t = e.options, n = e.name, a = t.offset, o = a === void 0 ? [0, 0] : a, i = $h.reduce(function(c, d) {
    return c[d] = ES(d, r.rects, o), c;
  }, {}), s = i[r.placement], l = s.x, u = s.y;
  r.modifiersData.popperOffsets != null && (r.modifiersData.popperOffsets.x += l, r.modifiersData.popperOffsets.y += u), r.modifiersData[n] = i;
}
const PS = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: MS
};
function AS(e) {
  var r = e.state, t = e.name;
  r.modifiersData[t] = qh({
    reference: r.rects.reference,
    element: r.rects.popper,
    placement: r.placement
  });
}
const RS = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: AS,
  data: {}
};
function OS(e) {
  return e === "x" ? "y" : "x";
}
function TS(e) {
  var r = e.state, t = e.options, n = e.name, a = t.mainAxis, o = a === void 0 ? !0 : a, i = t.altAxis, s = i === void 0 ? !1 : i, l = t.boundary, u = t.rootBoundary, c = t.altBoundary, d = t.padding, p = t.tether, f = p === void 0 ? !0 : p, h = t.tetherOffset, g = h === void 0 ? 0 : h, m = Oo(r, {
    boundary: l,
    rootBoundary: u,
    padding: d,
    altBoundary: c
  }), v = Nr(r.placement), y = Va(r.placement), w = !y, I = rc(v), b = OS(I), D = r.modifiersData.popperOffsets, S = r.rects.reference, _ = r.rects.popper, k = typeof g == "function" ? g(Object.assign({}, r.rects, {
    placement: r.placement
  })) : g, R = typeof k == "number" ? {
    mainAxis: k,
    altAxis: k
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, k), W = r.modifiersData.offset ? r.modifiersData.offset[r.placement] : null, B = {
    x: 0,
    y: 0
  };
  if (D) {
    if (o) {
      var V, F = I === "y" ? Nt : Lt, H = I === "y" ? cr : dr, A = I === "y" ? "height" : "width", N = D[I], G = N + m[F], Q = N - m[H], L = f ? -_[A] / 2 : 0, O = y === La ? S[A] : _[A], $ = y === La ? -_[A] : -S[A], Y = r.elements.arrow, X = f && Y ? tc(Y) : {
        width: 0,
        height: 0
      }, ne = r.modifiersData["arrow#persistent"] ? r.modifiersData["arrow#persistent"].padding : Zh(), K = ne[F], ue = ne[H], se = Do(0, S[A], X[A]), be = w ? S[A] / 2 - L - se - K - R.mainAxis : O - se - K - R.mainAxis, ge = w ? -S[A] / 2 + L + se + ue + R.mainAxis : $ + se + ue + R.mainAxis, Ae = r.elements.arrow && Uo(r.elements.arrow), Z = Ae ? I === "y" ? Ae.clientTop || 0 : Ae.clientLeft || 0 : 0, ot = (V = W == null ? void 0 : W[I]) != null ? V : 0, It = N + be - ot - Z, Et = N + ge - ot, Xr = Do(f ? ns(G, It) : G, N, f ? Hn(Q, Et) : Q);
      D[I] = Xr, B[I] = Xr - N;
    }
    if (s) {
      var Wt, Bt = I === "x" ? Nt : Lt, Mt = I === "x" ? cr : dr, Re = D[b], Kt = b === "y" ? "height" : "width", Vt = Re + m[Bt], Gt = Re - m[Mt], q = [Nt, Lt].indexOf(v) !== -1, fe = (Wt = W == null ? void 0 : W[b]) != null ? Wt : 0, Ue = q ? Vt : Re - S[Kt] - _[Kt] - fe + R.altAxis, it = q ? Re + S[Kt] + _[Kt] - fe - R.altAxis : Gt, ct = f && q ? aS(Ue, Re, it) : Do(f ? Ue : Vt, Re, f ? it : Gt);
      D[b] = ct, B[b] = ct - Re;
    }
    r.modifiersData[n] = B;
  }
}
const FS = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: TS,
  requiresIfExists: ["offset"]
};
function NS(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function LS(e) {
  return e === Ut(e) || !ir(e) ? nc(e) : NS(e);
}
function WS(e) {
  var r = e.getBoundingClientRect(), t = Wa(r.width) / e.offsetWidth || 1, n = Wa(r.height) / e.offsetHeight || 1;
  return t !== 1 || n !== 1;
}
function BS(e, r, t) {
  t === void 0 && (t = !1);
  var n = ir(r), a = ir(r) && WS(r), o = An(r), i = Ba(e, a, t), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (n || !n && !t) && ((Gr(r) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  oc(o)) && (s = LS(r)), ir(r) ? (l = Ba(r, !0), l.x += r.clientLeft, l.y += r.clientTop) : o && (l.x = ac(o))), {
    x: i.left + s.scrollLeft - l.x,
    y: i.top + s.scrollTop - l.y,
    width: i.width,
    height: i.height
  };
}
function VS(e) {
  var r = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(o) {
    r.set(o.name, o);
  });
  function a(o) {
    t.add(o.name);
    var i = [].concat(o.requires || [], o.requiresIfExists || []);
    i.forEach(function(s) {
      if (!t.has(s)) {
        var l = r.get(s);
        l && a(l);
      }
    }), n.push(o);
  }
  return e.forEach(function(o) {
    t.has(o.name) || a(o);
  }), n;
}
function GS(e) {
  var r = VS(e);
  return qx.reduce(function(t, n) {
    return t.concat(r.filter(function(a) {
      return a.phase === n;
    }));
  }, []);
}
function YS(e) {
  var r;
  return function() {
    return r || (r = new Promise(function(t) {
      Promise.resolve().then(function() {
        r = void 0, t(e());
      });
    })), r;
  };
}
function HS(e) {
  var r = e.reduce(function(t, n) {
    var a = t[n.name];
    return t[n.name] = a ? Object.assign({}, a, n, {
      options: Object.assign({}, a.options, n.options),
      data: Object.assign({}, a.data, n.data)
    }) : n, t;
  }, {});
  return Object.keys(r).map(function(t) {
    return r[t];
  });
}
var rf = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function nf() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return !r.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function zS(e) {
  e === void 0 && (e = {});
  var r = e, t = r.defaultModifiers, n = t === void 0 ? [] : t, a = r.defaultOptions, o = a === void 0 ? rf : a;
  return function(s, l, u) {
    u === void 0 && (u = o);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, rf, o),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], p = !1, f = {
      state: c,
      setOptions: function(v) {
        var y = typeof v == "function" ? v(c.options) : v;
        g(), c.options = Object.assign({}, o, c.options, y), c.scrollParents = {
          reference: Qn(s) ? _o(s) : s.contextElement ? _o(s.contextElement) : [],
          popper: _o(l)
        };
        var w = GS(HS([].concat(n, c.options.modifiers)));
        return c.orderedModifiers = w.filter(function(I) {
          return I.enabled;
        }), h(), f.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var v = c.elements, y = v.reference, w = v.popper;
          if (nf(y, w)) {
            c.rects = {
              reference: BS(y, Uo(w), c.options.strategy === "fixed"),
              popper: tc(w)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(R) {
              return c.modifiersData[R.name] = Object.assign({}, R.data);
            });
            for (var I = 0; I < c.orderedModifiers.length; I++) {
              if (c.reset === !0) {
                c.reset = !1, I = -1;
                continue;
              }
              var b = c.orderedModifiers[I], D = b.fn, S = b.options, _ = S === void 0 ? {} : S, k = b.name;
              typeof D == "function" && (c = D({
                state: c,
                options: _,
                name: k,
                instance: f
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: YS(function() {
        return new Promise(function(m) {
          f.forceUpdate(), m(c);
        });
      }),
      destroy: function() {
        g(), p = !0;
      }
    };
    if (!nf(s, l))
      return f;
    f.setOptions(u).then(function(m) {
      !p && u.onFirstUpdate && u.onFirstUpdate(m);
    });
    function h() {
      c.orderedModifiers.forEach(function(m) {
        var v = m.name, y = m.options, w = y === void 0 ? {} : y, I = m.effect;
        if (typeof I == "function") {
          var b = I({
            state: c,
            name: v,
            instance: f,
            options: w
          }), D = function() {
          };
          d.push(b || D);
        }
      });
    }
    function g() {
      d.forEach(function(m) {
        return m();
      }), d = [];
    }
    return f;
  };
}
var $S = [hS, RS, fS, tS, PS, DS, FS, lS, kS], XS = /* @__PURE__ */ zS({
  defaultModifiers: $S
});
function jS(e = {}) {
  const {
    enabled: r = !0,
    modifiers: t,
    placement: n = "bottom",
    strategy: a = "absolute",
    arrowPadding: o = 8,
    eventListeners: i = !0,
    offset: s,
    gutter: l = 8,
    flip: u = !0,
    boundary: c = "clippingParents",
    preventOverflow: d = !0,
    matchWidth: p,
    direction: f = "ltr"
  } = e, h = ye(null), g = ye(null), m = ye(null), v = Vx(n, f), y = ye(() => {
  }), w = re(() => {
    var R;
    !r || !h.current || !g.current || ((R = y.current) == null || R.call(y), m.current = XS(h.current, g.current, {
      placement: v,
      modifiers: [
        Lx,
        Tx,
        Ox,
        {
          ...Rx,
          enabled: !!p
        },
        {
          name: "eventListeners",
          ...Ax(i)
        },
        {
          name: "arrow",
          options: { padding: o }
        },
        {
          name: "offset",
          options: {
            offset: s ?? [0, l]
          }
        },
        {
          name: "flip",
          enabled: !!u,
          options: { padding: 8 }
        },
        {
          name: "preventOverflow",
          enabled: !!d,
          options: { boundary: c }
        },
        // allow users override internal modifiers
        ...t ?? []
      ],
      strategy: a
    }), m.current.forceUpdate(), y.current = m.current.destroy);
  }, [
    v,
    r,
    t,
    p,
    i,
    o,
    s,
    l,
    u,
    d,
    c,
    a
  ]);
  He(() => () => {
    var R;
    !h.current && !g.current && ((R = m.current) == null || R.destroy(), m.current = null);
  }, []);
  const I = re(
    (R) => {
      h.current = R, w();
    },
    [w]
  ), b = re(
    (R = {}, W = null) => ({
      ...R,
      ref: Ao(I, W)
    }),
    [I]
  ), D = re(
    (R) => {
      g.current = R, w();
    },
    [w]
  ), S = re(
    (R = {}, W = null) => ({
      ...R,
      ref: Ao(D, W),
      style: {
        ...R.style,
        position: a,
        minWidth: p ? void 0 : "max-content",
        inset: "0 auto auto 0"
      }
    }),
    [a, D, p]
  ), _ = re((R = {}, W = null) => {
    const { size: B, shadowColor: V, bg: F, style: H, ...A } = R;
    return {
      ...A,
      ref: W,
      "data-popper-arrow": "",
      style: ZS(R)
    };
  }, []), k = re(
    (R = {}, W = null) => ({
      ...R,
      ref: W,
      "data-popper-arrow-inner": ""
    }),
    []
  );
  return {
    update() {
      var R;
      (R = m.current) == null || R.update();
    },
    forceUpdate() {
      var R;
      (R = m.current) == null || R.forceUpdate();
    },
    transformOrigin: Xt.transformOrigin.varRef,
    referenceRef: I,
    popperRef: D,
    getPopperProps: S,
    getArrowProps: _,
    getArrowInnerProps: k,
    getReferenceProps: b
  };
}
function ZS(e) {
  const { size: r, shadowColor: t, bg: n, style: a } = e, o = { ...a, position: "absolute" };
  return r && (o["--popper-arrow-size"] = r), t && (o["--popper-arrow-shadow-color"] = t), n && (o["--popper-arrow-bg"] = n), o;
}
function US(e = {}) {
  const {
    onClose: r,
    onOpen: t,
    isOpen: n,
    id: a
  } = e, o = rs(t), i = rs(r), [s, l] = ke(e.defaultIsOpen || !1), u = n !== void 0 ? n : s, c = n !== void 0, d = Bu(), p = a ?? `disclosure-${d}`, f = re(() => {
    c || l(!1), i == null || i();
  }, [c, i]), h = re(() => {
    c || l(!0), o == null || o();
  }, [c, o]), g = re(() => {
    u ? f() : h();
  }, [u, h, f]);
  function m(y = {}) {
    return {
      ...y,
      "aria-expanded": u,
      "aria-controls": p,
      onClick(w) {
        var I;
        (I = y.onClick) == null || I.call(y, w), g();
      }
    };
  }
  function v(y = {}) {
    return {
      ...y,
      hidden: !u,
      id: p
    };
  }
  return {
    isOpen: u,
    onOpen: h,
    onClose: f,
    onToggle: g,
    isControlled: c,
    getButtonProps: m,
    getDisclosureProps: v
  };
}
function JS(e) {
  const { ref: r, handler: t, enabled: n = !0 } = e, a = rs(t), i = ye({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }).current;
  He(() => {
    if (!n)
      return;
    const s = (d) => {
      xl(d, r) && (i.isPointerDown = !0);
    }, l = (d) => {
      if (i.ignoreEmulatedMouseEvents) {
        i.ignoreEmulatedMouseEvents = !1;
        return;
      }
      i.isPointerDown && t && xl(d, r) && (i.isPointerDown = !1, a(d));
    }, u = (d) => {
      i.ignoreEmulatedMouseEvents = !0, t && i.isPointerDown && xl(d, r) && (i.isPointerDown = !1, a(d));
    }, c = Kh(r.current);
    return c.addEventListener("mousedown", s, !0), c.addEventListener("mouseup", l, !0), c.addEventListener("touchstart", s, !0), c.addEventListener("touchend", u, !0), () => {
      c.removeEventListener("mousedown", s, !0), c.removeEventListener("mouseup", l, !0), c.removeEventListener("touchstart", s, !0), c.removeEventListener("touchend", u, !0);
    };
  }, [t, r, a, i, n]);
}
function xl(e, r) {
  var t;
  const n = e.target;
  return n && !Kh(n).contains(n) ? !1 : !((t = r.current) != null && t.contains(n));
}
function Kh(e) {
  var r;
  return (r = e == null ? void 0 : e.ownerDocument) != null ? r : document;
}
function QS(e) {
  const { isOpen: r, ref: t } = e, [n, a] = ke(r), [o, i] = ke(!1);
  return He(() => {
    o || (a(r), i(!0));
  }, [r, o, n]), Dx(
    () => t.current,
    "animationend",
    () => {
      a(r);
    }
  ), {
    present: !(r ? !1 : !n),
    onComplete() {
      var l;
      const u = bx(t.current), c = new u.CustomEvent("animationend", { bubbles: !0 });
      (l = t.current) == null || l.dispatchEvent(c);
    }
  };
}
var [
  qS,
  lF,
  KS
] = vx(), [eI] = jo({
  strict: !1,
  name: "MenuContext"
});
function tI(e, ...r) {
  const t = Bu(), n = e || t;
  return We(() => r.map((a) => `${a}-${n}`), [n, r]);
}
function rI(e) {
  var r;
  return (r = e == null ? void 0 : e.ownerDocument) != null ? r : document;
}
function nI(e = {}) {
  const {
    id: r,
    closeOnSelect: t = !0,
    closeOnBlur: n = !0,
    initialFocusRef: a,
    autoSelect: o = !0,
    isLazy: i,
    isOpen: s,
    defaultIsOpen: l,
    onClose: u,
    onOpen: c,
    placement: d = "bottom-start",
    lazyBehavior: p = "unmount",
    direction: f,
    computePositionOnMount: h = !1,
    ...g
  } = e, m = ye(null), v = ye(null), y = KS(), w = re(() => {
    requestAnimationFrame(() => {
      var Y;
      (Y = m.current) == null || Y.focus({ preventScroll: !1 });
    });
  }, []), I = re(() => {
    const Y = setTimeout(() => {
      var X;
      if (a)
        (X = a.current) == null || X.focus();
      else {
        const ne = y.firstEnabled();
        ne && V(ne.index);
      }
    });
    G.current.add(Y);
  }, [y, a]), b = re(() => {
    const Y = setTimeout(() => {
      const X = y.lastEnabled();
      X && V(X.index);
    });
    G.current.add(Y);
  }, [y]), D = re(() => {
    c == null || c(), o ? I() : w();
  }, [o, I, w, c]), { isOpen: S, onOpen: _, onClose: k, onToggle: R } = US({
    isOpen: s,
    defaultIsOpen: l,
    onClose: u,
    onOpen: D
  });
  JS({
    enabled: S && n,
    ref: m,
    handler: (Y) => {
      var X;
      (X = v.current) != null && X.contains(Y.target) || k();
    }
  });
  const W = jS({
    ...g,
    enabled: S || h,
    placement: d,
    direction: f
  }), [B, V] = ke(-1);
  Hh(() => {
    S || V(-1);
  }, [S]), kx(m, {
    focusRef: v,
    visible: S
  });
  const F = QS({ isOpen: S, ref: m }), [H, A] = tI(r, "menu-button", "menu-list"), N = re(() => {
    _(), w();
  }, [_, w]), G = ye(/* @__PURE__ */ new Set([]));
  He(() => {
    const Y = G.current;
    return () => {
      Y.forEach((X) => clearTimeout(X)), Y.clear();
    };
  }, []);
  const Q = re(() => {
    _(), I();
  }, [I, _]), L = re(() => {
    _(), b();
  }, [_, b]), O = re(() => {
    var Y, X;
    const ne = rI(m.current), K = (Y = m.current) == null ? void 0 : Y.contains(ne.activeElement);
    if (!(S && !K))
      return;
    const se = (X = y.item(B)) == null ? void 0 : X.node;
    se == null || se.focus({ preventScroll: !0 });
  }, [S, B, y]), $ = ye(null);
  return {
    openAndFocusMenu: N,
    openAndFocusFirstItem: Q,
    openAndFocusLastItem: L,
    onTransitionEnd: O,
    unstable__animationState: F,
    descendants: y,
    popper: W,
    buttonId: H,
    menuId: A,
    forceUpdate: W.forceUpdate,
    orientation: "vertical",
    isOpen: S,
    onToggle: R,
    onOpen: _,
    onClose: k,
    menuRef: m,
    buttonRef: v,
    focusedIndex: B,
    closeOnSelect: t,
    closeOnBlur: n,
    autoSelect: o,
    setFocusedIndex: V,
    isLazy: i,
    lazyBehavior: p,
    initialFocusRef: a,
    rafId: $
  };
}
var [aI, oI] = jo({
  name: "MenuStylesContext",
  errorMessage: `useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Menu />" `
}), eg = (e) => {
  const { children: r } = e, t = Vr("Menu", e), n = Os(e), { direction: a } = Xa(), { descendants: o, ...i } = nI({ ...n, direction: a }), s = We(() => i, [i]), { isOpen: l, onClose: u, forceUpdate: c } = s;
  return /* @__PURE__ */ x(qS, { value: o, children: /* @__PURE__ */ x(eI, { value: s, children: /* @__PURE__ */ x(aI, { value: t, children: wn(r, { isOpen: l, onClose: u, forceUpdate: c }) }) }) });
};
eg.displayName = "Menu";
var tg = (e) => {
  const { className: r, children: t, ...n } = e, a = oI(), o = fb.only(t), i = pb(o) ? Vu(o, {
    focusable: "false",
    "aria-hidden": !0,
    className: Jn("chakra-menu__icon", o.props.className)
  }) : null, s = Jn("chakra-menu__icon-wrapper", r);
  return /* @__PURE__ */ x(ur.span, { className: s, ...n, __css: a.icon, children: i });
};
tg.displayName = "MenuIcon";
var iI = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"], af = function() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0, n = arguments.length > 2 ? arguments[2] : void 0, a = String(r).toLowerCase(), o = String(n.getOptionValue(t)).toLowerCase(), i = String(n.getOptionLabel(t)).toLowerCase();
  return o === a || i === a;
}, Sl = {
  formatCreateLabel: function(r) {
    return 'Create "'.concat(r, '"');
  },
  isValidNewOption: function(r, t, n, a) {
    return !(!r || t.some(function(o) {
      return af(r, o, a);
    }) || n.some(function(o) {
      return af(r, o, a);
    }));
  },
  getNewOptionData: function(r, t) {
    return {
      label: t,
      value: r,
      __isNew__: !0
    };
  }
};
function rg(e) {
  var r = e.allowCreateWhileLoading, t = r === void 0 ? !1 : r, n = e.createOptionPosition, a = n === void 0 ? "last" : n, o = e.formatCreateLabel, i = o === void 0 ? Sl.formatCreateLabel : o, s = e.isValidNewOption, l = s === void 0 ? Sl.isValidNewOption : s, u = e.getNewOptionData, c = u === void 0 ? Sl.getNewOptionData : u, d = e.onCreateOption, p = e.options, f = p === void 0 ? [] : p, h = e.onChange, g = Cr(e, iI), m = g.getOptionValue, v = m === void 0 ? gh : m, y = g.getOptionLabel, w = y === void 0 ? hh : y, I = g.inputValue, b = g.isLoading, D = g.isMulti, S = g.value, _ = g.name, k = We(function() {
    return l(I, Ji(S), f, {
      getOptionValue: v,
      getOptionLabel: w
    }) ? c(I, i(I)) : void 0;
  }, [i, c, w, v, I, l, f, S]), R = We(function() {
    return (t || !b) && k ? a === "first" ? [k].concat(Ia(f)) : [].concat(Ia(f), [k]) : f;
  }, [t, a, b, k, f]), W = re(function(B, V) {
    if (V.action !== "select-option")
      return h(B, V);
    var F = Array.isArray(B) ? B : [B];
    if (F[F.length - 1] === k) {
      if (d) d(I);
      else {
        var H = c(I, I), A = {
          action: "create-option",
          name: _,
          option: H
        };
        h(yo(D, [].concat(Ia(Ji(S)), [H]), H), A);
      }
      return;
    }
    h(B, V);
  }, [c, I, D, _, k, d, h, S]);
  return ce(ce({}, g), {}, {
    options: R,
    onChange: W
  });
}
var sI = /* @__PURE__ */ at(function(e, r) {
  var t = Ds(e), n = rg(t);
  return /* @__PURE__ */ U.createElement(Xo, pe({
    ref: r
  }, n));
}), lI = sI, uI = ["defaultOptions", "cacheOptions", "loadOptions", "options", "isLoading", "onInputChange", "filterOption"];
function ng(e) {
  var r = e.defaultOptions, t = r === void 0 ? !1 : r, n = e.cacheOptions, a = n === void 0 ? !1 : n, o = e.loadOptions;
  e.options;
  var i = e.isLoading, s = i === void 0 ? !1 : i, l = e.onInputChange, u = e.filterOption, c = u === void 0 ? null : u, d = Cr(e, uI), p = d.inputValue, f = ye(void 0), h = ye(!1), g = ke(Array.isArray(t) ? t : void 0), m = wt(g, 2), v = m[0], y = m[1], w = ke(typeof p < "u" ? p : ""), I = wt(w, 2), b = I[0], D = I[1], S = ke(t === !0), _ = wt(S, 2), k = _[0], R = _[1], W = ke(void 0), B = wt(W, 2), V = B[0], F = B[1], H = ke([]), A = wt(H, 2), N = A[0], G = A[1], Q = ke(!1), L = wt(Q, 2), O = L[0], $ = L[1], Y = ke({}), X = wt(Y, 2), ne = X[0], K = X[1], ue = ke(void 0), se = wt(ue, 2), be = se[0], ge = se[1], Ae = ke(void 0), Z = wt(Ae, 2), ot = Z[0], It = Z[1];
  a !== ot && (K({}), It(a)), t !== be && (y(Array.isArray(t) ? t : void 0), ge(t)), He(function() {
    return h.current = !0, function() {
      h.current = !1;
    };
  }, []);
  var Et = re(function(Bt, Mt) {
    if (!o) return Mt();
    var Re = o(Bt, Mt);
    Re && typeof Re.then == "function" && Re.then(Mt, function() {
      return Mt();
    });
  }, [o]);
  He(function() {
    t === !0 && Et(b, function(Bt) {
      h.current && (y(Bt || []), R(!!f.current));
    });
  }, []);
  var Xr = re(function(Bt, Mt) {
    var Re = cy(Bt, Mt, l);
    if (!Re) {
      f.current = void 0, D(""), F(""), G([]), R(!1), $(!1);
      return;
    }
    if (a && ne[Re])
      D(Re), F(Re), G(ne[Re]), R(!1), $(!1);
    else {
      var Kt = f.current = {};
      D(Re), R(!0), $(!V), Et(Re, function(Vt) {
        h && Kt === f.current && (f.current = void 0, R(!1), F(Re), G(Vt || []), $(!1), K(Vt ? ce(ce({}, ne), {}, Ca({}, Re, Vt)) : ne));
      });
    }
  }, [a, Et, V, ne, l]), Wt = O ? [] : b && V ? N : v || [];
  return ce(ce({}, d), {}, {
    options: Wt,
    isLoading: k || s,
    onInputChange: Xr,
    filterOption: c
  });
}
var cI = /* @__PURE__ */ at(function(e, r) {
  var t = ng(e), n = Ds(t);
  return /* @__PURE__ */ U.createElement(Xo, pe({
    ref: r
  }, n));
}), dI = cI, fI = /* @__PURE__ */ at(function(e, r) {
  var t = ng(e), n = Ds(t), a = rg(n);
  return /* @__PURE__ */ U.createElement(Xo, pe({
    ref: r
  }, a));
}), pI = fI, ag = (e) => {
  let { className: r, clearValue: t, cx: n, getStyles: a, getClassNames: o, getValue: i, hasValue: s, isMulti: l, isRtl: u, options: c, selectOption: d, selectProps: p, setValue: f, theme: h, ...g } = e;
  return { ...g };
}, hI = (e) => typeof e == "string" && ["sm", "md", "lg"].includes(e), gI = (e) => hI(e) ? e : e === "xs" ? "sm" : e === "xl" ? "lg" : "md", xr = (e) => {
  let r = Xa(), t = gI(r.components.Input.defaultProps.size), n = e ?? t;
  return lx(typeof n == "string" ? [n] : n, { fallback: "md" }) || t;
}, mI = (e) => {
  let { children: r, className: t, cx: n, innerProps: a, isDisabled: o, isRtl: i, hasValue: s, selectProps: { chakraStyles: l } } = e, u = { position: "relative", direction: i ? "rtl" : void 0, ...o ? { cursor: "not-allowed" } : {} }, c = l != null && l.container ? l.container(u, e) : u;
  return x(bt, { ...a, className: n({ "--is-disabled": o, "--is-rtl": i, "--has-value": s }, t), sx: c, children: r });
}, vI = (e) => {
  let { children: r, className: t, cx: n, isMulti: a, hasValue: o, innerProps: i, selectProps: { chakraStyles: s, size: l, variant: u, focusBorderColor: c, errorBorderColor: d, controlShouldRenderValue: p } } = e, f = xr(l), h = Vr("Input", { size: f, variant: u, focusBorderColor: c, errorBorderColor: d }), g = { display: a && o && p ? "flex" : "grid", alignItems: "center", flex: 1, paddingY: "2px", paddingX: h.field.px, flexWrap: "wrap", WebkitOverflowScrolling: "touch", position: "relative", overflow: "hidden" }, m = s != null && s.valueContainer ? s.valueContainer(g, e) : g;
  return x(bt, { ...i, className: n({ "value-container": !0, "value-container--is-multi": a, "value-container--has-value": o }, t), sx: m, children: r });
}, bI = (e) => {
  let { children: r, className: t, cx: n, innerProps: a, selectProps: { chakraStyles: o } } = e, i = { display: "flex", alignItems: "center", alignSelf: "stretch", flexShrink: 0 }, s = o != null && o.indicatorsContainer ? o.indicatorsContainer(i, e) : i;
  return x(bt, { ...a, className: n({ indicators: !0 }, t), sx: s, children: r });
}, yI = (e) => {
  let { className: r, cx: t, children: n, innerRef: a, innerProps: o, isDisabled: i, isFocused: s, menuIsOpen: l, selectProps: { chakraStyles: u, size: c, variant: d, focusBorderColor: p, errorBorderColor: f, isInvalid: h, isReadOnly: g } } = e, m = xr(c), { field: { height: v, h: y, ...w } } = Vr("Input", { size: m, variant: d, focusBorderColor: p, errorBorderColor: f }), I = { ...w, position: "relative", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", padding: 0, overflow: "hidden", height: "auto", minH: v || y, ...i ? { pointerEvents: "none" } : {} }, b = u != null && u.control ? u.control(I, e) : I;
  return x(bt, { ref: a, className: t({ control: !0, "control--is-disabled": i, "control--is-focused": s, "control--menu-is-open": l }, r), sx: b, ...o, "data-focus": s ? !0 : void 0, "data-focus-visible": s ? !0 : void 0, "data-invalid": h ? !0 : void 0, "data-disabled": i ? !0 : void 0, "data-readonly": g ? !0 : void 0, children: n });
}, wI = (e) => {
  let { className: r, cx: t, selectProps: { chakraStyles: n, useBasicStyles: a, variant: o } } = e, i = { opacity: 1, ...a || o !== "outline" ? { display: "none" } : {} }, s = n != null && n.indicatorSeparator ? n.indicatorSeparator(i, e) : i;
  return x(Th, { className: t({ "indicator-separator": !0 }, r), sx: s, orientation: "vertical" });
}, CI = (e) => x(Fs, { role: "presentation", focusable: "false", "aria-hidden": "true", ...e, children: x("path", { fill: "currentColor", d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" }) }), xI = (e) => {
  let { children: r, className: t, cx: n, innerProps: a, selectProps: { chakraStyles: o, useBasicStyles: i, size: s, focusBorderColor: l, errorBorderColor: u, variant: c } } = e, d = xr(s), p = Vr("Input", { size: d, variant: c, focusBorderColor: l, errorBorderColor: u }), f = { sm: "16px", md: "20px", lg: "24px" }[d], h = { ...p.addon, display: "flex", alignItems: "center", justifyContent: "center", height: "100%", borderRadius: 0, borderWidth: 0, fontSize: f, ...i && { background: "transparent", padding: 0, width: 6, marginRight: 2, marginLeft: 1, cursor: "inherit" } }, g = o != null && o.dropdownIndicator ? o.dropdownIndicator(h, e) : h, m = { height: "1em", width: "1em" }, v = o != null && o.downChevron ? o.downChevron(m, e) : m;
  return x(bt, { ...a, className: n({ indicator: !0, "dropdown-indicator": !0 }, t), sx: g, children: r || x(CI, { sx: v }) });
}, SI = (e) => x(Fs, { focusable: "false", "aria-hidden": !0, ...e, children: x("path", { fill: "currentColor", d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z" }) }), II = (e) => {
  let { children: r, className: t, cx: n, innerProps: a, selectProps: { chakraStyles: o, size: i } } = e, s = xr(i), l = { ...Ts("CloseButton", { size: s }), marginX: 1, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, cursor: "pointer" }, u = o != null && o.clearIndicator ? o.clearIndicator(l, e) : l, c = { width: "1em", height: "1em" }, d = o != null && o.crossIcon ? o.crossIcon(c, e) : c;
  return x(bt, { role: "button", className: n({ indicator: !0, "clear-indicator": !0 }, t), sx: u, "aria-label": "Clear selected options", ...a, children: r || x(SI, { sx: d }) });
}, DI = (e) => {
  let { className: r, cx: t, innerProps: n, selectProps: { chakraStyles: a, size: o }, color: i, emptyColor: s, speed: l, thickness: u, spinnerSize: c } = e, d = xr(o), p = { sm: "xs", md: "sm", lg: "md" }[d], f = { marginRight: 3 }, h = a != null && a.loadingIndicator ? a.loadingIndicator(f, e) : f;
  return x(Nh, { className: t({ indicator: !0, "loading-indicator": !0 }, r), sx: h, ...n, size: c || p, color: i, emptyColor: s, speed: l, thickness: u });
}, _I = yI, kI = (e) => {
  let { className: r, cx: t, value: n, selectProps: { chakraStyles: a, isReadOnly: o } } = e, { innerRef: i, isDisabled: s, isHidden: l, inputClassName: u, ...c } = ag(e), d = { gridArea: "1 / 2", minW: "2px", border: 0, margin: 0, outline: 0, padding: 0 }, p = { flex: "1 1 auto", display: "inline-grid", gridArea: "1 / 1 / 2 / 3", gridTemplateColumns: "0 min-content", color: "inherit", marginX: "0.125rem", paddingY: "0.125rem", visibility: s ? "hidden" : "visible", transform: n ? "translateZ(0)" : "", _after: { content: 'attr(data-value) " "', visibility: "hidden", whiteSpace: "pre", padding: 0, ...d } }, f = a != null && a.inputContainer ? a.inputContainer(p, e) : p, h = { background: 0, opacity: l ? 0 : 1, width: "100%", ...d }, g = a != null && a.input ? a.input(h, e) : h;
  return x(bt, { className: t({ "input-container": !0 }, r), "data-value": n || "", sx: f, children: x(ur.input, { className: t({ input: !0 }, u), ref: i, sx: g, disabled: s, readOnly: o ? !0 : void 0, ...c }) });
}, EI = kI, MI = (e) => e ? { bottom: "top", top: "bottom" }[e] : "top", PI = (e) => {
  let { className: r, cx: t, children: n, innerProps: a, innerRef: o, placement: i, selectProps: { chakraStyles: s } } = e, l = { position: "absolute", [MI(i)]: "100%", marginY: "8px", width: "100%", zIndex: 1 }, u = s != null && s.menu ? s.menu(l, e) : l;
  return x(eg, { children: x(bt, { ...a, ref: o, className: t({ menu: !0 }, r), sx: u, children: n }) });
}, AI = PI, RI = (e) => {
  var r;
  let { className: t, cx: n, innerRef: a, children: o, maxHeight: i, isMulti: s, innerProps: l, selectProps: { chakraStyles: u, size: c, variant: d, focusBorderColor: p, errorBorderColor: f } } = e, h = Vr("Menu"), g = xr(c), m = Vr("Input", { size: g, variant: d, focusBorderColor: p, errorBorderColor: f }).field, v = { ...h.list, minW: "100%", maxHeight: `${i}px`, overflowY: "auto", "--input-border-radius": m == null ? void 0 : m["--input-border-radius"], borderRadius: (m == null ? void 0 : m.borderRadius) || ((r = h.list) == null ? void 0 : r.borderRadius), position: "relative", WebkitOverflowScrolling: "touch" }, y = u != null && u.menuList ? u.menuList(v, e) : v;
  return x(bt, { ...l, className: n({ "menu-list": !0, "menu-list--is-multi": s }, t), sx: y, ref: a, children: o });
}, OI = (e) => {
  let { children: r, className: t, cx: n, innerProps: a, selectProps: { chakraStyles: o, size: i } } = e, s = xr(i), l = { color: "chakra-subtle-text", textAlign: "center", paddingY: { sm: "6px", md: "8px", lg: "10px" }[s], fontSize: s }, u = o != null && o.loadingMessage ? o.loadingMessage(l, e) : l;
  return x(bt, { ...a, className: n({ "menu-notice": !0, "menu-notice--loading": !0 }, t), sx: u, children: r });
}, TI = (e) => {
  let { children: r, className: t, cx: n, innerProps: a, selectProps: { chakraStyles: o, size: i } } = e, s = xr(i), l = { color: "chakra-subtle-text", textAlign: "center", paddingY: { sm: "6px", md: "8px", lg: "10px" }[s], fontSize: s }, u = o != null && o.noOptionsMessage ? o.noOptionsMessage(l, e) : l;
  return x(bt, { ...a, className: n({ "menu-notice": !0, "menu-notice--no-options": !0 }, t), sx: u, children: r });
}, FI = (e) => {
  let { children: r, className: t, cx: n, theme: a, getStyles: o, Heading: i, headingProps: s, label: l, selectProps: u, innerProps: c, getClassNames: d } = e, { chakraStyles: p } = u, f = {}, h = p != null && p.group ? p.group(f, e) : f;
  return ee(bt, { ...c, className: n({ group: !0 }, t), sx: h, children: [x(i, { ...s, selectProps: u, cx: n, theme: a, getStyles: o, getClassNames: d, children: l }), x(bt, { children: r })] });
}, NI = (e) => {
  let { cx: r, className: t, selectProps: { chakraStyles: n, size: a, hasStickyGroupHeaders: o } } = e, { data: i, ...s } = ag(e), l = Vr("Menu"), u = xr(a), c = { sm: "xs", md: "sm", lg: "md" }, d = { sm: "0.4rem 0.8rem", md: "0.5rem 1rem", lg: "0.6rem 1.2rem" }, p = { ...l.groupTitle, fontSize: c[u], padding: d[u], margin: 0, borderBottomWidth: o ? "1px" : 0, position: o ? "sticky" : "static", top: -2, bg: l.list.bg, zIndex: 1 }, f = n != null && n.groupHeading ? n.groupHeading(p, e) : p;
  return x(bt, { ...s, className: r({ "group-heading": !0 }, t), sx: f });
}, LI = (e) => x("svg", { viewBox: "0 0 14 14", width: "1em", height: "1em", ...e, children: x("polygon", { fill: "currentColor", points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039" }) }), WI = (e) => {
  let { className: r, cx: t, innerRef: n, innerProps: a, children: o, isFocused: i, isDisabled: s, isSelected: l, selectProps: { chakraStyles: u, size: c, isMulti: d, hideSelectedOptions: p, selectedOptionStyle: f, selectedOptionColorScheme: h } } = e, g = Vr("Menu").item, m = xr(c), v = { sm: "0.6rem", md: "0.8rem", lg: "1rem" }, y = { sm: "0.3rem", md: "0.4rem", lg: "0.5rem" }, w = Od(`${h}.500`, `${h}.300`), I = Od("white", "black"), b = f === "check" && (!d || p === !1), D = f === "color", S = { ...g, cursor: "pointer", display: "flex", alignItems: "center", width: "100%", textAlign: "start", fontSize: m, paddingX: v[m], paddingY: y[m], ...D && { _selected: { bg: w, color: I, _active: { bg: w } } } }, _ = u != null && u.option ? u.option(S, e) : S;
  return ee(bt, { ...a, className: t({ option: !0, "option--is-disabled": s, "option--is-focused": i, "option--is-selected": l }, r), sx: _, ref: n, "data-focus": i ? !0 : void 0, "aria-disabled": s ? !0 : void 0, "aria-selected": l, children: [b && x(tg, { fontSize: "0.8em", marginEnd: "0.75rem", opacity: l ? 1 : 0, children: x(LI, {}) }), o] });
}, BI = (e) => typeof e == "object" && e !== null && "colorScheme" in e && typeof e.colorScheme == "string", VI = (e) => typeof e == "object" && e !== null && "variant" in e && typeof e.variant == "string", og = (e) => typeof e == "object" && e !== null && "isFixed" in e && typeof e.isFixed == "boolean", GI = (e) => {
  let { children: r, className: t, components: n, cx: a, data: o, innerProps: i, isDisabled: s, isFocused: l, removeProps: u, selectProps: c, cropWithEllipsis: d } = e, { Container: p, Label: f, Remove: h } = n, { chakraStyles: g, colorScheme: m, tagVariant: v, size: y } = c, w = xr(y), I = "", b = "", D = !1;
  BI(o) && (I = o.colorScheme), VI(o) && (b = o.variant), og(o) && (D = o.isFixed);
  let S = Vr("Tag", { size: w, colorScheme: I || m, variant: b || v || (D ? "solid" : "subtle") }), _ = { ...S.container, display: "flex", alignItems: "center", minWidth: 0, margin: "0.125rem" }, k = g != null && g.multiValue ? g.multiValue(_, e) : _, R = { ...S.label, overflow: "hidden", textOverflow: d || d === void 0 ? "ellipsis" : void 0, whiteSpace: "nowrap" }, W = g != null && g.multiValueLabel ? g.multiValueLabel(R, e) : R, B = { ...S.closeButton, display: "flex", alignItems: "center", justifyContent: "center" }, V = g != null && g.multiValueRemove ? g.multiValueRemove(B, e) : B;
  return ee(p, { data: o, innerProps: { className: a({ "multi-value": !0, "multi-value--is-disabled": s }, t), ...i }, sx: k, selectProps: c, children: [x(f, { data: o, innerProps: { className: a({ "multi-value__label": !0 }, t) }, sx: W, selectProps: c, children: r }), x(h, { data: o, innerProps: { className: a({ "multi-value__remove": !0 }, t), "aria-label": `Remove ${r || "option"}`, ...u }, sx: V, selectProps: c, isFocused: l })] });
}, YI = (e) => {
  let { children: r, innerProps: t, sx: n } = e;
  return x(ur.span, { ...t, sx: n, children: r });
}, HI = (e) => {
  let { children: r, innerProps: t, sx: n } = e;
  return x(ur.span, { ...t, sx: n, children: r });
}, zI = (e) => x(Fs, { verticalAlign: "inherit", viewBox: "0 0 512 512", ...e, children: x("path", { fill: "currentColor", d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" }) }), $I = (e) => {
  let { children: r, innerProps: t, isFocused: n, data: a, sx: o } = e;
  return og(a) && a.isFixed ? null : x(bt, { ...t, role: "button", sx: o, "data-focus": n ? !0 : void 0, "data-focus-visible": n ? !0 : void 0, children: r || x(zI, {}) });
}, XI = GI, jI = (e) => {
  let { children: r, className: t, cx: n, innerProps: a, selectProps: { chakraStyles: o } } = e, i = { gridArea: "1 / 1 / 2 / 3", color: "chakra-placeholder-color", mx: "0.125rem", userSelect: "none" }, s = o != null && o.placeholder ? o.placeholder(i, e) : i;
  return x(bt, { ...a, className: n({ placeholder: !0 }, t), sx: s, children: r });
}, ZI = jI, UI = (e) => {
  let { children: r, className: t, cx: n, isDisabled: a, innerProps: o, selectProps: { chakraStyles: i } } = e, s = { gridArea: "1 / 1 / 2 / 3", mx: "0.125rem", maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, l = i != null && i.singleValue ? i.singleValue(s, e) : s;
  return x(bt, { className: n({ "single-value": !0, "single-value--is-disabled": a }, t), sx: l, ...o, children: r });
}, JI = UI, QI = { ClearIndicator: II, Control: _I, DropdownIndicator: xI, Group: FI, GroupHeading: NI, IndicatorSeparator: wI, IndicatorsContainer: bI, Input: EI, LoadingIndicator: DI, LoadingMessage: OI, Menu: AI, MenuList: RI, MultiValue: XI, MultiValueContainer: YI, MultiValueLabel: HI, MultiValueRemove: $I, NoOptionsMessage: TI, Option: WI, Placeholder: ZI, SelectContainer: mI, SingleValue: JI, ValueContainer: vI }, ig = QI, qI = ({ components: e = {}, theme: r, size: t, colorScheme: n = "gray", isDisabled: a, isInvalid: o, isReadOnly: i, required: s, isRequired: l, inputId: u, tagVariant: c, selectedOptionStyle: d = "color", selectedOptionColorScheme: p, selectedOptionColor: f, variant: h, focusBorderColor: g, errorBorderColor: m, chakraStyles: v = {}, onFocus: y, onBlur: w, menuIsOpen: I, ...b }) => {
  var D;
  let S = Xa(), { variant: _ } = S.components.Input.defaultProps, k = ex({ id: u, isDisabled: a, isInvalid: o, isRequired: l, isReadOnly: i, onFocus: y, onBlur: w }), R = I ?? (k.readOnly ? !1 : void 0), W = d;
  ["color", "check"].includes(d) || (W = "color");
  let B = p || f || "blue";
  return typeof B != "string" && (B = "blue"), { components: { ...ig, ...e }, colorScheme: n, size: t, tagVariant: c, selectedOptionStyle: W, selectedOptionColorScheme: B, variant: h ?? _, chakraStyles: v, focusBorderColor: g, errorBorderColor: m, onFocus: k.onFocus, onBlur: k.onBlur, isDisabled: k.disabled, isInvalid: !!k["aria-invalid"], inputId: k.id, isReadOnly: k.readOnly, required: s ?? k.required, menuIsOpen: R, ...b, "aria-invalid": (D = b["aria-invalid"]) != null ? D : k["aria-invalid"] };
}, Ls = qI, KI = at((e, r) => {
  let t = Ls(e);
  return x(_C, { ref: r, ...t });
}), eD = KI;
at((e, r) => {
  let t = Ls(e);
  return x(lI, { ref: r, ...t });
});
var tD = at((e, r) => {
  let t = Ls(e);
  return x(dI, { ref: r, ...t });
}), rD = tD;
at((e, r) => {
  let t = Ls(e);
  return x(pI, { ref: r, ...t });
});
const nD = Ss({
  displayName: "ChevronDownIcon",
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), aD = Ss({
  d: "M21,5H3C2.621,5,2.275,5.214,2.105,5.553C1.937,5.892,1.973,6.297,2.2,6.6l9,12 c0.188,0.252,0.485,0.4,0.8,0.4s0.611-0.148,0.8-0.4l9-12c0.228-0.303,0.264-0.708,0.095-1.047C21.725,5.214,21.379,5,21,5z",
  displayName: "TriangleDownIcon"
}), oD = Ss({
  d: "M12.8,5.4c-0.377-0.504-1.223-0.504-1.6,0l-9,12c-0.228,0.303-0.264,0.708-0.095,1.047 C2.275,18.786,2.621,19,3,19h18c0.379,0,0.725-0.214,0.895-0.553c0.169-0.339,0.133-0.744-0.095-1.047L12.8,5.4z",
  displayName: "TriangleUpIcon"
}), iD = Ss({
  d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
}), sg = ({ label: e }) => /* @__PURE__ */ x(
  vb,
  {
    label: e,
    hasArrow: !0,
    placement: "top",
    bg: "gray.700",
    color: "white",
    fontSize: "sm",
    borderRadius: "md",
    p: 2,
    children: /* @__PURE__ */ x("span", { style: { display: "flex", alignItems: "center", cursor: "help" }, children: /* @__PURE__ */ x(
      iD,
      {
        w: 3,
        h: 3
      }
    ) })
  }
), lg = {
  selectPlaceholder: "Selecciona",
  searchPlaceholder: "Buscar...",
  moreSelected: (e) => `+${e} más`,
  confirm: "Confirmar",
  cancel: "Cancelar",
  dropFile: "Arrastra tu archivo aqui",
  upload: "Subir",
  fieldDisabled: "Campo deshabilitado",
  dropFileOrClick: "Haz clic o arrastra el archivo aquí",
  dropFilesOrClick: "Haz clic o arrastra los archivos aquí",
  maxFileSize: (e) => `Máx ${e}MB`,
  fileTooLarge: (e) => `El archivo excede el tamaño máximo de ${e}MB`,
  validationError: "Error de validación",
  loadingProgress: (e) => `Cargando... ${e}%`,
  removeFile: "Eliminar archivo"
}, ug = Yo(lg), sD = ({ texts: e, children: r }) => {
  const t = We(() => ({ ...lg, ...e }), [e]);
  return /* @__PURE__ */ x(ug.Provider, { value: t, children: r });
}, ja = () => za(ug), uF = ({ name: e = "", id: r, label: t, placeholder: n, options: a = [], isDisabled: o = !1, helperText: i = "", value: s, isInvalid: l, onChange: u, onBlur: c, onFocus: d, isRequired: p, isMulti: f = !1, isClearable: h = !0, customWidth: g, isSearchable: m = !0, preventEnterSubmit: v = !1, labelTooltip: y }) => {
  const w = ja(), I = P.useMemo(() => s == null ? null : f ? Array.isArray(s) && s.length ? s.map((b) => a.find((D) => D.value === b)) : [] : a.find((b) => b.value === s) ?? null, [s, a]);
  return /* @__PURE__ */ ee(
    ta,
    {
      width: g || oa,
      minH: sr.inputContainerHeight,
      id: r,
      isDisabled: o,
      isInvalid: l,
      children: [
        /* @__PURE__ */ x(
          ra,
          {
            opacity: 0.5,
            fontSize: je.label,
            fontWeight: ia.label,
            padding: sr.labelPadding,
            children: /* @__PURE__ */ ee(
              Rt,
              {
                align: "center",
                gap: 1,
                children: [
                  /* @__PURE__ */ ee("span", { children: [
                    t,
                    " ",
                    p ? /* @__PURE__ */ x("span", { style: { color: fn }, children: "*" }) : ""
                  ] }),
                  y && /* @__PURE__ */ x(sg, { label: y })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ x(
          eD,
          {
            menuPortalTarget: typeof document < "u" ? document.body : void 0,
            styles: {
              menuPortal: (b) => ({ ...b, zIndex: 9999 })
            },
            chakraStyles: {
              container: (b) => ({
                ...b,
                maxH: "fit-content"
              }),
              group: (b) => ({
                ...b,
                maxH: "fit-content"
              }),
              inputContainer: (b) => ({
                ...b,
                maxH: "fit-content"
              }),
              input: (b) => ({
                ...b,
                maxH: "fit-content",
                fontSize: je.input
              }),
              control: (b) => ({
                ...b,
                maxH: "fit-content",
                minHeight: ar,
                height: f ? "fit-content" : ar,
                fontSize: je.input
              }),
              valueContainer: (b) => ({
                ...b,
                padding: "0 8px",
                fontSize: je.input
              }),
              singleValue: (b) => ({
                ...b,
                fontSize: je.input
              }),
              placeholder: (b) => ({
                ...b,
                fontSize: je.input
              }),
              option: (b, { isSelected: D, isFocused: S }) => ({
                ...b,
                fontSize: je.input,
                backgroundColor: D || S ? "#D3D7FF" : "transparent",
                color: "#1B1C1E",
                ":hover": {
                  backgroundColor: "#D3D7FF"
                }
              })
            },
            inputId: r,
            isSearchable: m,
            id: r,
            options: a.map((b) => ({
              value: b.value !== null ? b.value : "",
              label: b.label || ""
            })),
            value: I,
            isInvalid: l,
            name: e,
            isMulti: f,
            placeholder: n ?? w.selectPlaceholder,
            closeMenuOnSelect: !f,
            isDisabled: o,
            errorBorderColor: zt.error.border,
            focusBorderColor: "#7A86FF",
            onFocus: d,
            onBlur: c,
            onKeyDown: v ? (b) => {
              b.key === "Enter" && b.preventDefault();
            } : void 0,
            onChange: (b) => {
              const D = f ? b.map(({ value: S }) => S) : b === null ? null : b.value;
              u && u(e, D);
            },
            isClearable: h
          }
        ),
        /* @__PURE__ */ x(aa, { height: 2, children: i })
      ]
    }
  );
}, cF = ({ name: e = "", id: r, label: t, placeholder: n, loadOptions: a, defaultOptions: o = !0, cacheOptions: i = !0, debounceMs: s = 300, isDisabled: l = !1, helperText: u = "", value: c, isInvalid: d, onChange: p, onBlur: f, onFocus: h, isRequired: g, isClearable: m = !0, isMulti: v = !1, customWidth: y, fixedOptions: w = [], initialOption: I = null, isSearchable: b = !0, maxVisibleTags: D = 2, initialOptions: S, preventEnterSubmit: _ = !1, labelTooltip: k }) => {
  const R = ja(), W = ye(null), B = ye(!1), [V, F] = P.useState(null);
  P.useEffect(() => {
    F(v ? S ?? [] : I);
  }, [I, S]);
  const H = re(
    (O, $) => {
      W.current && clearTimeout(W.current), W.current = setTimeout(async () => {
        const Y = await a(O);
        $([...O ? [] : w, ...Y]);
      }, s);
    },
    [a, s, w]
  ), A = re(async () => {
    if (Array.isArray(o))
      return [...w, ...o];
    if (o === !0) {
      const O = await a("");
      return [...w, ...O];
    }
    return w;
  }, [o, w, a]), [N, G] = P.useState(Array.isArray(o) ? [...w, ...o] : w);
  P.useEffect(() => {
    A().then(G);
  }, [o]);
  const Q = We(() => {
    if (!v || !Array.isArray(V) || V.length === 0)
      return N;
    const O = V.filter(($) => !N.some((Y) => Y.value === $.value));
    return O.length === 0 ? N : [...O, ...N];
  }, [v, V, N]);
  P.useEffect(() => {
    v || c == null && F(null);
  }, [c, v]), P.useEffect(() => {
    if (v) {
      if (B.current) {
        B.current = !1;
        return;
      }
      if (!c || Array.isArray(c) && c.length === 0) {
        F([]);
        return;
      }
      if (Array.isArray(c)) {
        const O = Array.isArray(V) ? V : [], $ = c.map((Y) => {
          const X = O.find((ne) => ne.value === Y);
          return X || (N.find((ne) => ne.value === Y) ?? null);
        }).filter((Y) => Y !== null);
        F($);
      }
    }
  }, [c, v, N]);
  const L = We(() => {
    if (v)
      return {
        MultiValue: ({ index: O, getValue: $, ...Y }) => {
          const ne = $().length;
          return O >= D ? O === D ? /* @__PURE__ */ x(
            bb,
            {
              size: "md",
              borderRadius: "md",
              variant: "solid",
              colorScheme: "blue",
              mx: 1,
              my: 0.5,
              children: /* @__PURE__ */ x(yb, { fontSize: je.input, children: R.moreSelected(ne - D) })
            }
          ) : null : /* @__PURE__ */ x(
            ig.MultiValue,
            {
              ...Y,
              index: O,
              getValue: $
            }
          );
        }
      };
  }, [v, D, R]);
  return /* @__PURE__ */ ee(
    ta,
    {
      width: y || oa,
      minH: sr.inputContainerHeight,
      id: r,
      isDisabled: l,
      isInvalid: d,
      children: [
        /* @__PURE__ */ x(
          ra,
          {
            opacity: 0.5,
            fontSize: je.label,
            fontWeight: ia.label,
            padding: sr.labelPadding,
            children: /* @__PURE__ */ ee(
              Rt,
              {
                align: "center",
                gap: 1,
                children: [
                  /* @__PURE__ */ ee("span", { children: [
                    t,
                    " ",
                    g ? /* @__PURE__ */ x("span", { style: { color: fn }, children: "*" }) : ""
                  ] }),
                  k && /* @__PURE__ */ x(sg, { label: k })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ x(
          rD,
          {
            menuPortalTarget: typeof document < "u" ? document.body : void 0,
            styles: {
              menuPortal: (O) => ({ ...O, zIndex: 9999 })
            },
            components: L,
            chakraStyles: {
              container: (O) => ({
                ...O,
                maxH: "fit-content"
              }),
              inputContainer: (O) => ({
                ...O,
                maxH: "fit-content"
              }),
              input: (O) => ({
                ...O,
                maxH: "fit-content",
                fontSize: je.input
              }),
              control: (O) => ({
                ...O,
                minHeight: ar,
                height: ar,
                fontSize: je.input,
                overflow: "hidden"
              }),
              valueContainer: (O) => ({
                ...O,
                padding: "0 8px",
                fontSize: je.input,
                flexWrap: v ? "nowrap" : "wrap",
                overflow: "hidden",
                maxHeight: ar
              }),
              singleValue: (O) => ({
                ...O,
                fontSize: je.input
              }),
              placeholder: (O) => ({
                ...O,
                fontSize: je.input
              }),
              option: (O, { isSelected: $, isFocused: Y }) => ({
                ...O,
                fontSize: je.input,
                backgroundColor: $ || Y ? "#D3D7FF" : "transparent",
                color: "#1B1C1E",
                ":hover": {
                  backgroundColor: "#D3D7FF"
                }
              })
            },
            inputId: r,
            id: r,
            loadOptions: H,
            defaultOptions: Q,
            cacheOptions: i,
            value: V,
            isMulti: v,
            closeMenuOnSelect: !v,
            hideSelectedOptions: !1,
            isInvalid: d,
            name: e,
            placeholder: n ?? R.searchPlaceholder,
            isDisabled: l,
            errorBorderColor: zt.error.border,
            focusBorderColor: "#7A86FF",
            onFocus: h,
            onBlur: f,
            onKeyDown: _ ? (O) => {
              O.key === "Enter" && O.preventDefault();
            } : void 0,
            isSearchable: b,
            onChange: (O) => {
              if (F(O), v) {
                B.current = !0;
                const $ = O ? O.map((Y) => Y.value) : [];
                p && p(e, $);
              } else {
                const $ = O === null ? null : O.value;
                p && p(e, $);
              }
            },
            isClearable: m,
            noOptionsMessage: ({ inputValue: O }) => O ? "No se encontraron resultados" : "Escribe para buscar",
            loadingMessage: () => "Buscando..."
          }
        ),
        /* @__PURE__ */ x(aa, { height: 2, children: u })
      ]
    }
  );
};
function lD(e) {
  return pr({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "line", attr: { x1: "18", y1: "6", x2: "6", y2: "18" }, child: [] }, { tag: "line", attr: { x1: "6", y1: "6", x2: "18", y2: "18" }, child: [] }] })(e);
}
function cg(e) {
  return pr({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }, child: [] }, { tag: "polyline", attr: { points: "17 8 12 3 7 8" }, child: [] }, { tag: "line", attr: { x1: "12", y1: "3", x2: "12", y2: "15" }, child: [] }] })(e);
}
function dg(e) {
  return pr({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" }, child: [] }, { tag: "polyline", attr: { points: "13 2 13 9 20 9" }, child: [] }] })(e);
}
function uD(e) {
  return pr({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" }, child: [] }, { tag: "rect", attr: { x: "8", y: "2", width: "8", height: "4", rx: "1", ry: "1" }, child: [] }] })(e);
}
function cD(e) {
  return pr({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "polyline", attr: { points: "20 6 9 17 4 12" }, child: [] }] })(e);
}
function dD(e) {
  return pr({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "circle", attr: { cx: "12", cy: "12", r: "10" }, child: [] }, { tag: "line", attr: { x1: "12", y1: "8", x2: "12", y2: "12" }, child: [] }, { tag: "line", attr: { x1: "12", y1: "16", x2: "12.01", y2: "16" }, child: [] }] })(e);
}
var du = { exports: {} }, hi = { exports: {} }, Ne = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var of;
function fD() {
  if (of) return Ne;
  of = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, f = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function w(b) {
    if (typeof b == "object" && b !== null) {
      var D = b.$$typeof;
      switch (D) {
        case r:
          switch (b = b.type, b) {
            case l:
            case u:
            case n:
            case o:
            case a:
            case d:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case c:
                case h:
                case f:
                case i:
                  return b;
                default:
                  return D;
              }
          }
        case t:
          return D;
      }
    }
  }
  function I(b) {
    return w(b) === u;
  }
  return Ne.AsyncMode = l, Ne.ConcurrentMode = u, Ne.ContextConsumer = s, Ne.ContextProvider = i, Ne.Element = r, Ne.ForwardRef = c, Ne.Fragment = n, Ne.Lazy = h, Ne.Memo = f, Ne.Portal = t, Ne.Profiler = o, Ne.StrictMode = a, Ne.Suspense = d, Ne.isAsyncMode = function(b) {
    return I(b) || w(b) === l;
  }, Ne.isConcurrentMode = I, Ne.isContextConsumer = function(b) {
    return w(b) === s;
  }, Ne.isContextProvider = function(b) {
    return w(b) === i;
  }, Ne.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === r;
  }, Ne.isForwardRef = function(b) {
    return w(b) === c;
  }, Ne.isFragment = function(b) {
    return w(b) === n;
  }, Ne.isLazy = function(b) {
    return w(b) === h;
  }, Ne.isMemo = function(b) {
    return w(b) === f;
  }, Ne.isPortal = function(b) {
    return w(b) === t;
  }, Ne.isProfiler = function(b) {
    return w(b) === o;
  }, Ne.isStrictMode = function(b) {
    return w(b) === a;
  }, Ne.isSuspense = function(b) {
    return w(b) === d;
  }, Ne.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === n || b === u || b === o || b === a || b === d || b === p || typeof b == "object" && b !== null && (b.$$typeof === h || b.$$typeof === f || b.$$typeof === i || b.$$typeof === s || b.$$typeof === c || b.$$typeof === m || b.$$typeof === v || b.$$typeof === y || b.$$typeof === g);
  }, Ne.typeOf = w, Ne;
}
var Le = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sf;
function pD() {
  return sf || (sf = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, f = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function w(Z) {
      return typeof Z == "string" || typeof Z == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Z === n || Z === u || Z === o || Z === a || Z === d || Z === p || typeof Z == "object" && Z !== null && (Z.$$typeof === h || Z.$$typeof === f || Z.$$typeof === i || Z.$$typeof === s || Z.$$typeof === c || Z.$$typeof === m || Z.$$typeof === v || Z.$$typeof === y || Z.$$typeof === g);
    }
    function I(Z) {
      if (typeof Z == "object" && Z !== null) {
        var ot = Z.$$typeof;
        switch (ot) {
          case r:
            var It = Z.type;
            switch (It) {
              case l:
              case u:
              case n:
              case o:
              case a:
              case d:
                return It;
              default:
                var Et = It && It.$$typeof;
                switch (Et) {
                  case s:
                  case c:
                  case h:
                  case f:
                  case i:
                    return Et;
                  default:
                    return ot;
                }
            }
          case t:
            return ot;
        }
      }
    }
    var b = l, D = u, S = s, _ = i, k = r, R = c, W = n, B = h, V = f, F = t, H = o, A = a, N = d, G = !1;
    function Q(Z) {
      return G || (G = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), L(Z) || I(Z) === l;
    }
    function L(Z) {
      return I(Z) === u;
    }
    function O(Z) {
      return I(Z) === s;
    }
    function $(Z) {
      return I(Z) === i;
    }
    function Y(Z) {
      return typeof Z == "object" && Z !== null && Z.$$typeof === r;
    }
    function X(Z) {
      return I(Z) === c;
    }
    function ne(Z) {
      return I(Z) === n;
    }
    function K(Z) {
      return I(Z) === h;
    }
    function ue(Z) {
      return I(Z) === f;
    }
    function se(Z) {
      return I(Z) === t;
    }
    function be(Z) {
      return I(Z) === o;
    }
    function ge(Z) {
      return I(Z) === a;
    }
    function Ae(Z) {
      return I(Z) === d;
    }
    Le.AsyncMode = b, Le.ConcurrentMode = D, Le.ContextConsumer = S, Le.ContextProvider = _, Le.Element = k, Le.ForwardRef = R, Le.Fragment = W, Le.Lazy = B, Le.Memo = V, Le.Portal = F, Le.Profiler = H, Le.StrictMode = A, Le.Suspense = N, Le.isAsyncMode = Q, Le.isConcurrentMode = L, Le.isContextConsumer = O, Le.isContextProvider = $, Le.isElement = Y, Le.isForwardRef = X, Le.isFragment = ne, Le.isLazy = K, Le.isMemo = ue, Le.isPortal = se, Le.isProfiler = be, Le.isStrictMode = ge, Le.isSuspense = Ae, Le.isValidElementType = w, Le.typeOf = I;
  }()), Le;
}
var lf;
function fg() {
  return lf || (lf = 1, process.env.NODE_ENV === "production" ? hi.exports = fD() : hi.exports = pD()), hi.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Il, uf;
function hD() {
  if (uf) return Il;
  uf = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(i).map(function(c) {
        return i[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Il = a() ? Object.assign : function(o, i) {
    for (var s, l = n(o), u, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var d in s)
        r.call(s, d) && (l[d] = s[d]);
      if (e) {
        u = e(s);
        for (var p = 0; p < u.length; p++)
          t.call(s, u[p]) && (l[u[p]] = s[u[p]]);
      }
    }
    return l;
  }, Il;
}
var Dl, cf;
function ic() {
  if (cf) return Dl;
  cf = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Dl = e, Dl;
}
var _l, df;
function pg() {
  return df || (df = 1, _l = Function.call.bind(Object.prototype.hasOwnProperty)), _l;
}
var kl, ff;
function gD() {
  if (ff) return kl;
  ff = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = ic(), t = {}, n = pg();
    e = function(o) {
      var i = "Warning: " + o;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function a(o, i, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in o)
        if (n(o, c)) {
          var d;
          try {
            if (typeof o[c] != "function") {
              var p = Error(
                (l || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            d = o[c](i, c, l, s, null, r);
          } catch (h) {
            d = h;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in t)) {
            t[d.message] = !0;
            var f = u ? u() : "";
            e(
              "Failed " + s + " type: " + d.message + (f ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, kl = a, kl;
}
var El, pf;
function mD() {
  if (pf) return El;
  pf = 1;
  var e = fg(), r = hD(), t = ic(), n = pg(), a = gD(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return El = function(s, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function d(L) {
      var O = L && (u && L[u] || L[c]);
      if (typeof O == "function")
        return O;
    }
    var p = "<<anonymous>>", f = {
      array: v("array"),
      bigint: v("bigint"),
      bool: v("boolean"),
      func: v("function"),
      number: v("number"),
      object: v("object"),
      string: v("string"),
      symbol: v("symbol"),
      any: y(),
      arrayOf: w,
      element: I(),
      elementType: b(),
      instanceOf: D,
      node: R(),
      objectOf: _,
      oneOf: S,
      oneOfType: k,
      shape: B,
      exact: V
    };
    function h(L, O) {
      return L === O ? L !== 0 || 1 / L === 1 / O : L !== L && O !== O;
    }
    function g(L, O) {
      this.message = L, this.data = O && typeof O == "object" ? O : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function m(L) {
      if (process.env.NODE_ENV !== "production")
        var O = {}, $ = 0;
      function Y(ne, K, ue, se, be, ge, Ae) {
        if (se = se || p, ge = ge || ue, Ae !== t) {
          if (l) {
            var Z = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Z.name = "Invariant Violation", Z;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ot = se + ":" + ue;
            !O[ot] && // Avoid spamming the console because they are often not actionable except for lib authors
            $ < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + ge + "` prop on `" + se + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), O[ot] = !0, $++);
          }
        }
        return K[ue] == null ? ne ? K[ue] === null ? new g("The " + be + " `" + ge + "` is marked as required " + ("in `" + se + "`, but its value is `null`.")) : new g("The " + be + " `" + ge + "` is marked as required in " + ("`" + se + "`, but its value is `undefined`.")) : null : L(K, ue, se, be, ge);
      }
      var X = Y.bind(null, !1);
      return X.isRequired = Y.bind(null, !0), X;
    }
    function v(L) {
      function O($, Y, X, ne, K, ue) {
        var se = $[Y], be = A(se);
        if (be !== L) {
          var ge = N(se);
          return new g(
            "Invalid " + ne + " `" + K + "` of type " + ("`" + ge + "` supplied to `" + X + "`, expected ") + ("`" + L + "`."),
            { expectedType: L }
          );
        }
        return null;
      }
      return m(O);
    }
    function y() {
      return m(i);
    }
    function w(L) {
      function O($, Y, X, ne, K) {
        if (typeof L != "function")
          return new g("Property `" + K + "` of component `" + X + "` has invalid PropType notation inside arrayOf.");
        var ue = $[Y];
        if (!Array.isArray(ue)) {
          var se = A(ue);
          return new g("Invalid " + ne + " `" + K + "` of type " + ("`" + se + "` supplied to `" + X + "`, expected an array."));
        }
        for (var be = 0; be < ue.length; be++) {
          var ge = L(ue, be, X, ne, K + "[" + be + "]", t);
          if (ge instanceof Error)
            return ge;
        }
        return null;
      }
      return m(O);
    }
    function I() {
      function L(O, $, Y, X, ne) {
        var K = O[$];
        if (!s(K)) {
          var ue = A(K);
          return new g("Invalid " + X + " `" + ne + "` of type " + ("`" + ue + "` supplied to `" + Y + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(L);
    }
    function b() {
      function L(O, $, Y, X, ne) {
        var K = O[$];
        if (!e.isValidElementType(K)) {
          var ue = A(K);
          return new g("Invalid " + X + " `" + ne + "` of type " + ("`" + ue + "` supplied to `" + Y + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(L);
    }
    function D(L) {
      function O($, Y, X, ne, K) {
        if (!($[Y] instanceof L)) {
          var ue = L.name || p, se = Q($[Y]);
          return new g("Invalid " + ne + " `" + K + "` of type " + ("`" + se + "` supplied to `" + X + "`, expected ") + ("instance of `" + ue + "`."));
        }
        return null;
      }
      return m(O);
    }
    function S(L) {
      if (!Array.isArray(L))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), i;
      function O($, Y, X, ne, K) {
        for (var ue = $[Y], se = 0; se < L.length; se++)
          if (h(ue, L[se]))
            return null;
        var be = JSON.stringify(L, function(Ae, Z) {
          var ot = N(Z);
          return ot === "symbol" ? String(Z) : Z;
        });
        return new g("Invalid " + ne + " `" + K + "` of value `" + String(ue) + "` " + ("supplied to `" + X + "`, expected one of " + be + "."));
      }
      return m(O);
    }
    function _(L) {
      function O($, Y, X, ne, K) {
        if (typeof L != "function")
          return new g("Property `" + K + "` of component `" + X + "` has invalid PropType notation inside objectOf.");
        var ue = $[Y], se = A(ue);
        if (se !== "object")
          return new g("Invalid " + ne + " `" + K + "` of type " + ("`" + se + "` supplied to `" + X + "`, expected an object."));
        for (var be in ue)
          if (n(ue, be)) {
            var ge = L(ue, be, X, ne, K + "." + be, t);
            if (ge instanceof Error)
              return ge;
          }
        return null;
      }
      return m(O);
    }
    function k(L) {
      if (!Array.isArray(L))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var O = 0; O < L.length; O++) {
        var $ = L[O];
        if (typeof $ != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + G($) + " at index " + O + "."
          ), i;
      }
      function Y(X, ne, K, ue, se) {
        for (var be = [], ge = 0; ge < L.length; ge++) {
          var Ae = L[ge], Z = Ae(X, ne, K, ue, se, t);
          if (Z == null)
            return null;
          Z.data && n(Z.data, "expectedType") && be.push(Z.data.expectedType);
        }
        var ot = be.length > 0 ? ", expected one of type [" + be.join(", ") + "]" : "";
        return new g("Invalid " + ue + " `" + se + "` supplied to " + ("`" + K + "`" + ot + "."));
      }
      return m(Y);
    }
    function R() {
      function L(O, $, Y, X, ne) {
        return F(O[$]) ? null : new g("Invalid " + X + " `" + ne + "` supplied to " + ("`" + Y + "`, expected a ReactNode."));
      }
      return m(L);
    }
    function W(L, O, $, Y, X) {
      return new g(
        (L || "React class") + ": " + O + " type `" + $ + "." + Y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + X + "`."
      );
    }
    function B(L) {
      function O($, Y, X, ne, K) {
        var ue = $[Y], se = A(ue);
        if (se !== "object")
          return new g("Invalid " + ne + " `" + K + "` of type `" + se + "` " + ("supplied to `" + X + "`, expected `object`."));
        for (var be in L) {
          var ge = L[be];
          if (typeof ge != "function")
            return W(X, ne, K, be, N(ge));
          var Ae = ge(ue, be, X, ne, K + "." + be, t);
          if (Ae)
            return Ae;
        }
        return null;
      }
      return m(O);
    }
    function V(L) {
      function O($, Y, X, ne, K) {
        var ue = $[Y], se = A(ue);
        if (se !== "object")
          return new g("Invalid " + ne + " `" + K + "` of type `" + se + "` " + ("supplied to `" + X + "`, expected `object`."));
        var be = r({}, $[Y], L);
        for (var ge in be) {
          var Ae = L[ge];
          if (n(L, ge) && typeof Ae != "function")
            return W(X, ne, K, ge, N(Ae));
          if (!Ae)
            return new g(
              "Invalid " + ne + " `" + K + "` key `" + ge + "` supplied to `" + X + "`.\nBad object: " + JSON.stringify($[Y], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(L), null, "  ")
            );
          var Z = Ae(ue, ge, X, ne, K + "." + ge, t);
          if (Z)
            return Z;
        }
        return null;
      }
      return m(O);
    }
    function F(L) {
      switch (typeof L) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !L;
        case "object":
          if (Array.isArray(L))
            return L.every(F);
          if (L === null || s(L))
            return !0;
          var O = d(L);
          if (O) {
            var $ = O.call(L), Y;
            if (O !== L.entries) {
              for (; !(Y = $.next()).done; )
                if (!F(Y.value))
                  return !1;
            } else
              for (; !(Y = $.next()).done; ) {
                var X = Y.value;
                if (X && !F(X[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function H(L, O) {
      return L === "symbol" ? !0 : O ? O["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && O instanceof Symbol : !1;
    }
    function A(L) {
      var O = typeof L;
      return Array.isArray(L) ? "array" : L instanceof RegExp ? "object" : H(O, L) ? "symbol" : O;
    }
    function N(L) {
      if (typeof L > "u" || L === null)
        return "" + L;
      var O = A(L);
      if (O === "object") {
        if (L instanceof Date)
          return "date";
        if (L instanceof RegExp)
          return "regexp";
      }
      return O;
    }
    function G(L) {
      var O = N(L);
      switch (O) {
        case "array":
        case "object":
          return "an " + O;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + O;
        default:
          return O;
      }
    }
    function Q(L) {
      return !L.constructor || !L.constructor.name ? p : L.constructor.name;
    }
    return f.checkPropTypes = a, f.resetWarningCache = a.resetWarningCache, f.PropTypes = f, f;
  }, El;
}
var Ml, hf;
function vD() {
  if (hf) return Ml;
  hf = 1;
  var e = ic();
  function r() {
  }
  function t() {
  }
  return t.resetWarningCache = r, Ml = function() {
    function n(i, s, l, u, c, d) {
      if (d !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var o = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: t,
      resetWarningCache: r
    };
    return o.PropTypes = o, o;
  }, Ml;
}
if (process.env.NODE_ENV !== "production") {
  var bD = fg(), yD = !0;
  du.exports = mD()(bD.isElement, yD);
} else
  du.exports = vD()();
var wD = du.exports;
const Xe = /* @__PURE__ */ Uu(wD);
function Za(e, r, t, n) {
  function a(o) {
    return o instanceof t ? o : new t(function(i) {
      i(o);
    });
  }
  return new (t || (t = Promise))(function(o, i) {
    function s(c) {
      try {
        u(n.next(c));
      } catch (d) {
        i(d);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (d) {
        i(d);
      }
    }
    function u(c) {
      c.done ? o(c.value) : a(c.value).then(s, l);
    }
    u((n = n.apply(e, r || [])).next());
  });
}
function Ua(e, r) {
  var t = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, a, o, i = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return i.next = s(0), i.throw = s(1), i.return = s(2), typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function s(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; i && (i = 0, u[0] && (t = 0)), t; ) try {
      if (n = 1, a && (o = u[0] & 2 ? a.return : u[0] ? a.throw || ((o = a.return) && o.call(a), 0) : a.next) && !(o = o.call(a, u[1])).done) return o;
      switch (a = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, a = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (o = t.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < o[1]) {
            t.label = o[1], o = u;
            break;
          }
          if (o && t.label < o[2]) {
            t.label = o[2], t.ops.push(u);
            break;
          }
          o[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = r.call(e, t);
    } catch (c) {
      u = [6, c], a = 0;
    } finally {
      n = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function gf(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t) return e;
  var n = t.call(e), a, o = [], i;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; ) o.push(a.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (i) throw i.error;
    }
  }
  return o;
}
function mf(e, r, t) {
  if (t || arguments.length === 2) for (var n = 0, a = r.length, o; n < a; n++)
    (o || !(n in r)) && (o || (o = Array.prototype.slice.call(r, 0, n)), o[n] = r[n]);
  return e.concat(o || Array.prototype.slice.call(r));
}
var CD = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function Jo(e, r) {
  var t = xD(e);
  if (typeof t.path != "string") {
    var n = e.webkitRelativePath;
    Object.defineProperty(t, "path", {
      value: typeof r == "string" ? r : typeof n == "string" && n.length > 0 ? n : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return t;
}
function xD(e) {
  var r = e.name, t = r && r.lastIndexOf(".") !== -1;
  if (t && !e.type) {
    var n = r.split(".").pop().toLowerCase(), a = CD.get(n);
    a && Object.defineProperty(e, "type", {
      value: a,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var SD = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function ID(e) {
  return Za(this, void 0, void 0, function() {
    return Ua(this, function(r) {
      return as(e) && DD(e.dataTransfer) ? [2, MD(e.dataTransfer, e.type)] : _D(e) ? [2, kD(e)] : Array.isArray(e) && e.every(function(t) {
        return "getFile" in t && typeof t.getFile == "function";
      }) ? [2, ED(e)] : [2, []];
    });
  });
}
function DD(e) {
  return as(e);
}
function _D(e) {
  return as(e) && as(e.target);
}
function as(e) {
  return typeof e == "object" && e !== null;
}
function kD(e) {
  return fu(e.target.files).map(function(r) {
    return Jo(r);
  });
}
function ED(e) {
  return Za(this, void 0, void 0, function() {
    var r;
    return Ua(this, function(t) {
      switch (t.label) {
        case 0:
          return [4, Promise.all(e.map(function(n) {
            return n.getFile();
          }))];
        case 1:
          return r = t.sent(), [2, r.map(function(n) {
            return Jo(n);
          })];
      }
    });
  });
}
function MD(e, r) {
  return Za(this, void 0, void 0, function() {
    var t, n;
    return Ua(this, function(a) {
      switch (a.label) {
        case 0:
          return e.items ? (t = fu(e.items).filter(function(o) {
            return o.kind === "file";
          }), r !== "drop" ? [2, t] : [4, Promise.all(t.map(PD))]) : [3, 2];
        case 1:
          return n = a.sent(), [2, vf(hg(n))];
        case 2:
          return [2, vf(fu(e.files).map(function(o) {
            return Jo(o);
          }))];
      }
    });
  });
}
function vf(e) {
  return e.filter(function(r) {
    return SD.indexOf(r.name) === -1;
  });
}
function fu(e) {
  if (e === null)
    return [];
  for (var r = [], t = 0; t < e.length; t++) {
    var n = e[t];
    r.push(n);
  }
  return r;
}
function PD(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return bf(e);
  var r = e.webkitGetAsEntry();
  return r && r.isDirectory ? gg(r) : bf(e);
}
function hg(e) {
  return e.reduce(function(r, t) {
    return mf(mf([], gf(r), !1), gf(Array.isArray(t) ? hg(t) : [t]), !1);
  }, []);
}
function bf(e) {
  var r = e.getAsFile();
  if (!r)
    return Promise.reject("".concat(e, " is not a File"));
  var t = Jo(r);
  return Promise.resolve(t);
}
function AD(e) {
  return Za(this, void 0, void 0, function() {
    return Ua(this, function(r) {
      return [2, e.isDirectory ? gg(e) : RD(e)];
    });
  });
}
function gg(e) {
  var r = e.createReader();
  return new Promise(function(t, n) {
    var a = [];
    function o() {
      var i = this;
      r.readEntries(function(s) {
        return Za(i, void 0, void 0, function() {
          var l, u, c;
          return Ua(this, function(d) {
            switch (d.label) {
              case 0:
                if (s.length) return [3, 5];
                d.label = 1;
              case 1:
                return d.trys.push([1, 3, , 4]), [4, Promise.all(a)];
              case 2:
                return l = d.sent(), t(l), [3, 4];
              case 3:
                return u = d.sent(), n(u), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                c = Promise.all(s.map(AD)), a.push(c), o(), d.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(s) {
        n(s);
      });
    }
    o();
  });
}
function RD(e) {
  return Za(this, void 0, void 0, function() {
    return Ua(this, function(r) {
      return [2, new Promise(function(t, n) {
        e.file(function(a) {
          var o = Jo(a, e.fullPath);
          t(o);
        }, function(a) {
          n(a);
        });
      })];
    });
  });
}
var OD = function(e, r) {
  if (e && r) {
    var t = Array.isArray(r) ? r : r.split(",");
    if (t.length === 0)
      return !0;
    var n = e.name || "", a = (e.type || "").toLowerCase(), o = a.replace(/\/.*$/, "");
    return t.some(function(i) {
      var s = i.trim().toLowerCase();
      return s.charAt(0) === "." ? n.toLowerCase().endsWith(s) : s.endsWith("/*") ? o === s.replace(/\/.*$/, "") : a === s;
    });
  }
  return !0;
};
function yf(e) {
  return ND(e) || FD(e) || vg(e) || TD();
}
function TD() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function FD(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function ND(e) {
  if (Array.isArray(e)) return pu(e);
}
function wf(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Cf(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? wf(Object(t), !0).forEach(function(n) {
      mg(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : wf(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function mg(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function To(e, r) {
  return BD(e) || WD(e, r) || vg(e, r) || LD();
}
function LD() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vg(e, r) {
  if (e) {
    if (typeof e == "string") return pu(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return pu(e, r);
  }
}
function pu(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function WD(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n = [], a = !0, o = !1, i, s;
    try {
      for (t = t.call(e); !(a = (i = t.next()).done) && (n.push(i.value), !(r && n.length === r)); a = !0)
        ;
    } catch (l) {
      o = !0, s = l;
    } finally {
      try {
        !a && t.return != null && t.return();
      } finally {
        if (o) throw s;
      }
    }
    return n;
  }
}
function BD(e) {
  if (Array.isArray(e)) return e;
}
var VD = "file-invalid-type", GD = "file-too-large", YD = "file-too-small", HD = "too-many-files", zD = function(r) {
  r = Array.isArray(r) && r.length === 1 ? r[0] : r;
  var t = Array.isArray(r) ? "one of ".concat(r.join(", ")) : r;
  return {
    code: VD,
    message: "File type must be ".concat(t)
  };
}, xf = function(r) {
  return {
    code: GD,
    message: "File is larger than ".concat(r, " ").concat(r === 1 ? "byte" : "bytes")
  };
}, Sf = function(r) {
  return {
    code: YD,
    message: "File is smaller than ".concat(r, " ").concat(r === 1 ? "byte" : "bytes")
  };
}, $D = {
  code: HD,
  message: "Too many files"
};
function bg(e, r) {
  var t = e.type === "application/x-moz-file" || OD(e, r);
  return [t, t ? null : zD(r)];
}
function yg(e, r, t) {
  if (Ln(e.size))
    if (Ln(r) && Ln(t)) {
      if (e.size > t) return [!1, xf(t)];
      if (e.size < r) return [!1, Sf(r)];
    } else {
      if (Ln(r) && e.size < r) return [!1, Sf(r)];
      if (Ln(t) && e.size > t) return [!1, xf(t)];
    }
  return [!0, null];
}
function Ln(e) {
  return e != null;
}
function XD(e) {
  var r = e.files, t = e.accept, n = e.minSize, a = e.maxSize, o = e.multiple, i = e.maxFiles, s = e.validator;
  return !o && r.length > 1 || o && i >= 1 && r.length > i ? !1 : r.every(function(l) {
    var u = bg(l, t), c = To(u, 1), d = c[0], p = yg(l, n, a), f = To(p, 1), h = f[0], g = s ? s(l) : null;
    return d && h && !g;
  });
}
function os(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function gi(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(r) {
    return r === "Files" || r === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function If(e) {
  e.preventDefault();
}
function jD(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function ZD(e) {
  return e.indexOf("Edge/") !== -1;
}
function UD() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return jD(e) || ZD(e);
}
function Dr() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return function(n) {
    for (var a = arguments.length, o = new Array(a > 1 ? a - 1 : 0), i = 1; i < a; i++)
      o[i - 1] = arguments[i];
    return r.some(function(s) {
      return !os(n) && s && s.apply(void 0, [n].concat(o)), os(n);
    });
  };
}
function JD() {
  return "showOpenFilePicker" in window;
}
function QD(e) {
  if (Ln(e)) {
    var r = Object.entries(e).filter(function(t) {
      var n = To(t, 2), a = n[0], o = n[1], i = !0;
      return wg(a) || (console.warn('Skipped "'.concat(a, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), i = !1), (!Array.isArray(o) || !o.every(Cg)) && (console.warn('Skipped "'.concat(a, '" because an invalid file extension was provided.')), i = !1), i;
    }).reduce(function(t, n) {
      var a = To(n, 2), o = a[0], i = a[1];
      return Cf(Cf({}, t), {}, mg({}, o, i));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: r
    }];
  }
  return e;
}
function qD(e) {
  if (Ln(e))
    return Object.entries(e).reduce(function(r, t) {
      var n = To(t, 2), a = n[0], o = n[1];
      return [].concat(yf(r), [a], yf(o));
    }, []).filter(function(r) {
      return wg(r) || Cg(r);
    }).join(",");
}
function KD(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function e_(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function wg(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function Cg(e) {
  return /^.*\.[\w]+$/.test(e);
}
var t_ = ["children"], r_ = ["open"], n_ = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], a_ = ["refKey", "onChange", "onClick"];
function o_(e) {
  return l_(e) || s_(e) || xg(e) || i_();
}
function i_() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function s_(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function l_(e) {
  if (Array.isArray(e)) return hu(e);
}
function Pl(e, r) {
  return d_(e) || c_(e, r) || xg(e, r) || u_();
}
function u_() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xg(e, r) {
  if (e) {
    if (typeof e == "string") return hu(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return hu(e, r);
  }
}
function hu(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function c_(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n = [], a = !0, o = !1, i, s;
    try {
      for (t = t.call(e); !(a = (i = t.next()).done) && (n.push(i.value), !(r && n.length === r)); a = !0)
        ;
    } catch (l) {
      o = !0, s = l;
    } finally {
      try {
        !a && t.return != null && t.return();
      } finally {
        if (o) throw s;
      }
    }
    return n;
  }
}
function d_(e) {
  if (Array.isArray(e)) return e;
}
function Df(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function rt(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Df(Object(t), !0).forEach(function(n) {
      gu(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Df(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function gu(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function is(e, r) {
  if (e == null) return {};
  var t = f_(e, r), n, a;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (a = 0; a < o.length; a++)
      n = o[a], !(r.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (t[n] = e[n]);
  }
  return t;
}
function f_(e, r) {
  if (e == null) return {};
  var t = {}, n = Object.keys(e), a, o;
  for (o = 0; o < n.length; o++)
    a = n[o], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var sc = /* @__PURE__ */ at(function(e, r) {
  var t = e.children, n = is(e, t_), a = lc(n), o = a.open, i = is(a, r_);
  return Ip(r, function() {
    return {
      open: o
    };
  }, [o]), /* @__PURE__ */ P.createElement(Gi, null, t(rt(rt({}, i), {}, {
    open: o
  })));
});
sc.displayName = "Dropzone";
var Sg = {
  disabled: !1,
  getFilesFromEvent: ID,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
sc.defaultProps = Sg;
sc.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: Xe.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: Xe.objectOf(Xe.arrayOf(Xe.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: Xe.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: Xe.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: Xe.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: Xe.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: Xe.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: Xe.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: Xe.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: Xe.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: Xe.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: Xe.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: Xe.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: Xe.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: Xe.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: Xe.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: Xe.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: Xe.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: Xe.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: Xe.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: Xe.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: Xe.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: Xe.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: Xe.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: Xe.func
};
var mu = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function lc() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = rt(rt({}, Sg), e), t = r.accept, n = r.disabled, a = r.getFilesFromEvent, o = r.maxSize, i = r.minSize, s = r.multiple, l = r.maxFiles, u = r.onDragEnter, c = r.onDragLeave, d = r.onDragOver, p = r.onDrop, f = r.onDropAccepted, h = r.onDropRejected, g = r.onFileDialogCancel, m = r.onFileDialogOpen, v = r.useFsAccessApi, y = r.autoFocus, w = r.preventDropOnDocument, I = r.noClick, b = r.noKeyboard, D = r.noDrag, S = r.noDragEventsBubbling, _ = r.onError, k = r.validator, R = We(function() {
    return qD(t);
  }, [t]), W = We(function() {
    return QD(t);
  }, [t]), B = We(function() {
    return typeof m == "function" ? m : _f;
  }, [m]), V = We(function() {
    return typeof g == "function" ? g : _f;
  }, [g]), F = ye(null), H = ye(null), A = Sp(p_, mu), N = Pl(A, 2), G = N[0], Q = N[1], L = G.isFocused, O = G.isFileDialogActive, $ = ye(typeof window < "u" && window.isSecureContext && v && JD()), Y = function() {
    !$.current && O && setTimeout(function() {
      if (H.current) {
        var fe = H.current.files;
        fe.length || (Q({
          type: "closeDialog"
        }), V());
      }
    }, 300);
  };
  He(function() {
    return window.addEventListener("focus", Y, !1), function() {
      window.removeEventListener("focus", Y, !1);
    };
  }, [H, O, V, $]);
  var X = ye([]), ne = function(fe) {
    F.current && F.current.contains(fe.target) || (fe.preventDefault(), X.current = []);
  };
  He(function() {
    return w && (document.addEventListener("dragover", If, !1), document.addEventListener("drop", ne, !1)), function() {
      w && (document.removeEventListener("dragover", If), document.removeEventListener("drop", ne));
    };
  }, [F, w]), He(function() {
    return !n && y && F.current && F.current.focus(), function() {
    };
  }, [F, y, n]);
  var K = re(function(q) {
    _ ? _(q) : console.error(q);
  }, [_]), ue = re(function(q) {
    q.preventDefault(), q.persist(), Re(q), X.current = [].concat(o_(X.current), [q.target]), gi(q) && Promise.resolve(a(q)).then(function(fe) {
      if (!(os(q) && !S)) {
        var Ue = fe.length, it = Ue > 0 && XD({
          files: fe,
          accept: R,
          minSize: i,
          maxSize: o,
          multiple: s,
          maxFiles: l,
          validator: k
        }), ct = Ue > 0 && !it;
        Q({
          isDragAccept: it,
          isDragReject: ct,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), u && u(q);
      }
    }).catch(function(fe) {
      return K(fe);
    });
  }, [a, u, K, S, R, i, o, s, l, k]), se = re(function(q) {
    q.preventDefault(), q.persist(), Re(q);
    var fe = gi(q);
    if (fe && q.dataTransfer)
      try {
        q.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return fe && d && d(q), !1;
  }, [d, S]), be = re(function(q) {
    q.preventDefault(), q.persist(), Re(q);
    var fe = X.current.filter(function(it) {
      return F.current && F.current.contains(it);
    }), Ue = fe.indexOf(q.target);
    Ue !== -1 && fe.splice(Ue, 1), X.current = fe, !(fe.length > 0) && (Q({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), gi(q) && c && c(q));
  }, [F, c, S]), ge = re(function(q, fe) {
    var Ue = [], it = [];
    q.forEach(function(ct) {
      var gn = bg(ct, R), jr = Pl(gn, 2), ca = jr[0], da = jr[1], to = yg(ct, i, o), fa = Pl(to, 2), mr = fa[0], mn = fa[1], ro = k ? k(ct) : null;
      if (ca && mr && !ro)
        Ue.push(ct);
      else {
        var pa = [da, mn];
        ro && (pa = pa.concat(ro)), it.push({
          file: ct,
          errors: pa.filter(function(el) {
            return el;
          })
        });
      }
    }), (!s && Ue.length > 1 || s && l >= 1 && Ue.length > l) && (Ue.forEach(function(ct) {
      it.push({
        file: ct,
        errors: [$D]
      });
    }), Ue.splice(0)), Q({
      acceptedFiles: Ue,
      fileRejections: it,
      type: "setFiles"
    }), p && p(Ue, it, fe), it.length > 0 && h && h(it, fe), Ue.length > 0 && f && f(Ue, fe);
  }, [Q, s, R, i, o, l, p, f, h, k]), Ae = re(function(q) {
    q.preventDefault(), q.persist(), Re(q), X.current = [], gi(q) && Promise.resolve(a(q)).then(function(fe) {
      os(q) && !S || ge(fe, q);
    }).catch(function(fe) {
      return K(fe);
    }), Q({
      type: "reset"
    });
  }, [a, ge, K, S]), Z = re(function() {
    if ($.current) {
      Q({
        type: "openDialog"
      }), B();
      var q = {
        multiple: s,
        types: W
      };
      window.showOpenFilePicker(q).then(function(fe) {
        return a(fe);
      }).then(function(fe) {
        ge(fe, null), Q({
          type: "closeDialog"
        });
      }).catch(function(fe) {
        KD(fe) ? (V(fe), Q({
          type: "closeDialog"
        })) : e_(fe) ? ($.current = !1, H.current ? (H.current.value = null, H.current.click()) : K(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : K(fe);
      });
      return;
    }
    H.current && (Q({
      type: "openDialog"
    }), B(), H.current.value = null, H.current.click());
  }, [Q, B, V, v, ge, K, W, s]), ot = re(function(q) {
    !F.current || !F.current.isEqualNode(q.target) || (q.key === " " || q.key === "Enter" || q.keyCode === 32 || q.keyCode === 13) && (q.preventDefault(), Z());
  }, [F, Z]), It = re(function() {
    Q({
      type: "focus"
    });
  }, []), Et = re(function() {
    Q({
      type: "blur"
    });
  }, []), Xr = re(function() {
    I || (UD() ? setTimeout(Z, 0) : Z());
  }, [I, Z]), Wt = function(fe) {
    return n ? null : fe;
  }, Bt = function(fe) {
    return b ? null : Wt(fe);
  }, Mt = function(fe) {
    return D ? null : Wt(fe);
  }, Re = function(fe) {
    S && fe.stopPropagation();
  }, Kt = We(function() {
    return function() {
      var q = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, fe = q.refKey, Ue = fe === void 0 ? "ref" : fe, it = q.role, ct = q.onKeyDown, gn = q.onFocus, jr = q.onBlur, ca = q.onClick, da = q.onDragEnter, to = q.onDragOver, fa = q.onDragLeave, mr = q.onDrop, mn = is(q, n_);
      return rt(rt(gu({
        onKeyDown: Bt(Dr(ct, ot)),
        onFocus: Bt(Dr(gn, It)),
        onBlur: Bt(Dr(jr, Et)),
        onClick: Wt(Dr(ca, Xr)),
        onDragEnter: Mt(Dr(da, ue)),
        onDragOver: Mt(Dr(to, se)),
        onDragLeave: Mt(Dr(fa, be)),
        onDrop: Mt(Dr(mr, Ae)),
        role: typeof it == "string" && it !== "" ? it : "presentation"
      }, Ue, F), !n && !b ? {
        tabIndex: 0
      } : {}), mn);
    };
  }, [F, ot, It, Et, Xr, ue, se, be, Ae, b, D, n]), Vt = re(function(q) {
    q.stopPropagation();
  }, []), Gt = We(function() {
    return function() {
      var q = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, fe = q.refKey, Ue = fe === void 0 ? "ref" : fe, it = q.onChange, ct = q.onClick, gn = is(q, a_), jr = gu({
        accept: R,
        multiple: s,
        type: "file",
        style: {
          display: "none"
        },
        onChange: Wt(Dr(it, Ae)),
        onClick: Wt(Dr(ct, Vt)),
        tabIndex: -1
      }, Ue, H);
      return rt(rt({}, jr), gn);
    };
  }, [H, t, s, Ae, n]);
  return rt(rt({}, G), {}, {
    isFocused: L && !n,
    getRootProps: Kt,
    getInputProps: Gt,
    rootRef: F,
    inputRef: H,
    open: Wt(Z)
  });
}
function p_(e, r) {
  switch (r.type) {
    case "focus":
      return rt(rt({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return rt(rt({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return rt(rt({}, mu), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return rt(rt({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return rt(rt({}, e), {}, {
        isDragActive: r.isDragActive,
        isDragAccept: r.isDragAccept,
        isDragReject: r.isDragReject
      });
    case "setFiles":
      return rt(rt({}, e), {}, {
        acceptedFiles: r.acceptedFiles,
        fileRejections: r.fileRejections
      });
    case "reset":
      return rt({}, mu);
    default:
      return e;
  }
}
function _f() {
}
const h_ = (e) => e ? Object.values(e).flat().map((t) => t.replace(".", "").toUpperCase()).join(", ") : "Todos los archivos", dF = P.memo(({ label: e, isRequired: r, isDisabled: t, accept: n, name: a, id: o, onChange: i, formValue: s, multiple: l, helperText: u, maxSizeMB: c = 10, fileCount: d }) => {
  const p = ja(), [f, h] = P.useState(""), g = P.useCallback(
    (S) => {
      var _;
      h(l ? `${S.length} ${S.length === 1 ? "archivo" : "archivos"}` : ((_ = S[0]) == null ? void 0 : _.name) || ""), i && i(a, S);
    },
    [i, h, l, a]
  );
  P.useEffect(() => {
    s || h("");
  }, [s, h]), P.useEffect(() => {
    d !== void 0 && l && h(d === 0 ? "" : `${d} ${d === 1 ? "archivo" : "archivos"}`);
  }, [d, l]);
  const { getRootProps: m, getInputProps: v, isDragActive: y } = lc({
    onDrop: g,
    accept: n,
    disabled: t,
    multiple: l !== !1
  }), w = P.useMemo(() => t ? j.border : y ? j.tertiary[1] : j.border, [t, y]), I = P.useMemo(() => t ? j.neutro[1] : y ? j.tertiary[3] : "transparent", [t, y]), b = P.useMemo(() => h_(n), [n]), D = P.useMemo(
    () => t ? void 0 : {
      borderColor: j.tertiary[1],
      bg: j.tertiary[3]
    },
    [t]
  );
  return /* @__PURE__ */ ee(
    Ze,
    {
      width: oa,
      maxH: "fit-content",
      mb: 2,
      children: [
        e && /* @__PURE__ */ ee(
          mt,
          {
            width: "100%",
            opacity: 0.5,
            fontSize: je.label,
            fontWeight: ia.label,
            padding: sr.labelPadding,
            mb: 1,
            children: [
              e,
              " ",
              r ? /* @__PURE__ */ x("span", { style: { color: fn }, children: "*" }) : ""
            ]
          }
        ),
        /* @__PURE__ */ ee(
          Ze,
          {
            ...m(),
            cursor: t ? "not-allowed" : "pointer",
            border: "2px dashed",
            borderColor: w,
            bg: I,
            rounded: Is.input,
            px: 3,
            py: 2,
            transition: "all 0.2s",
            _hover: D,
            children: [
              /* @__PURE__ */ x(
                "input",
                {
                  type: "file",
                  id: o,
                  name: a,
                  disabled: t,
                  ...v(),
                  style: { display: "none" }
                }
              ),
              f ? /* @__PURE__ */ ee(
                Rt,
                {
                  align: "center",
                  gap: 2,
                  children: [
                    /* @__PURE__ */ x(
                      Wn,
                      {
                        as: dg,
                        color: j.neutralDark,
                        boxSize: "18px"
                      }
                    ),
                    /* @__PURE__ */ x(Ze, { flex: 1, children: /* @__PURE__ */ x(
                      mt,
                      {
                        fontSize: je.input,
                        fontWeight: 400,
                        noOfLines: 1,
                        title: f,
                        children: f
                      }
                    ) })
                  ]
                }
              ) : /* @__PURE__ */ ee(
                Rt,
                {
                  direction: "row",
                  align: "center",
                  justify: "start",
                  gap: 3,
                  py: 1,
                  children: [
                    /* @__PURE__ */ x(
                      Wn,
                      {
                        as: cg,
                        boxSize: "20px",
                        color: t ? j.neutralDark : j.tertiary[1]
                      }
                    ),
                    /* @__PURE__ */ ee(
                      Ze,
                      {
                        textAlign: "left",
                        flex: 1,
                        children: [
                          /* @__PURE__ */ x(
                            mt,
                            {
                              fontSize: je.input,
                              fontWeight: 400,
                              color: t ? j.neutralDark : j.text[2],
                              children: t ? p.fieldDisabled : p.dropFilesOrClick
                            }
                          ),
                          /* @__PURE__ */ ee(
                            mt,
                            {
                              fontSize: "xs",
                              color: j.text[3],
                              children: [
                                b,
                                " • ",
                                p.maxFileSize(c)
                              ]
                            }
                          )
                        ]
                      }
                    )
                  ]
                }
              )
            ]
          }
        ),
        u && /* @__PURE__ */ x(
          mt,
          {
            fontSize: "xs",
            color: j.text[3],
            mt: 1,
            px: 1,
            children: u
          }
        )
      ]
    }
  );
});
var Ja = [["Afghanistan", "af", "93"], ["Albania", "al", "355"], ["Algeria", "dz", "213"], ["Andorra", "ad", "376"], ["Angola", "ao", "244"], ["Antigua and Barbuda", "ag", "1268"], ["Argentina", "ar", "54", { default: "(..) .... ....", "/^11/": "(..) .... ....", "/^15/": "(..) ... ....", "/^(2|3|4|5)/": "(.) .... ....", "/^9/": "(.) .... ....." }, 0], ["Armenia", "am", "374", ".. ......"], ["Aruba", "aw", "297"], ["Australia", "au", "61", { default: ". .... ....", "/^4/": "... ... ...", "/^5(?!50)/": "... ... ...", "/^1(3|8)00/": ".... ... ...", "/^13/": ".. .. ..", "/^180/": "... ...." }, 0, []], ["Austria", "at", "43"], ["Azerbaijan", "az", "994", "(..) ... .. .."], ["Bahamas", "bs", "1242"], ["Bahrain", "bh", "973", ".... ...."], ["Bangladesh", "bd", "880"], ["Barbados", "bb", "1246"], ["Belarus", "by", "375", "(..) ... .. .."], ["Belgium", "be", "32", "... .. .. .."], ["Belize", "bz", "501"], ["Benin", "bj", "229"], ["Bhutan", "bt", "975"], ["Bolivia", "bo", "591"], ["Bosnia and Herzegovina", "ba", "387"], ["Botswana", "bw", "267"], ["Brazil", "br", "55", "(..) .....-...."], ["British Indian Ocean Territory", "io", "246"], ["Brunei", "bn", "673"], ["Bulgaria", "bg", "359"], ["Burkina Faso", "bf", "226"], ["Burundi", "bi", "257"], ["Cambodia", "kh", "855"], ["Cameroon", "cm", "237"], ["Canada", "ca", "1", "(...) ...-....", 1, ["204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", "cv", "238"], ["Caribbean Netherlands", "bq", "599", "", 1], ["Cayman Islands", "ky", "1", "... ... ....", 4, ["345"]], ["Central African Republic", "cf", "236"], ["Chad", "td", "235"], ["Chile", "cl", "56"], ["China", "cn", "86", "... .... ...."], ["Colombia", "co", "57", "... ... ...."], ["Comoros", "km", "269"], ["Congo", "cd", "243"], ["Congo", "cg", "242"], ["Costa Rica", "cr", "506", "....-...."], ["Côte d'Ivoire", "ci", "225", ".. .. .. .. .."], ["Croatia", "hr", "385"], ["Cuba", "cu", "53"], ["Curaçao", "cw", "599", "", 0], ["Cyprus", "cy", "357", ".. ......"], ["Czech Republic", "cz", "420", "... ... ..."], ["Denmark", "dk", "45", ".. .. .. .."], ["Djibouti", "dj", "253", ".. .. ...."], ["Dominica", "dm", "1767"], ["Dominican Republic", "do", "1", "(...) ...-....", 2, ["809", "829", "849"]], ["Ecuador", "ec", "593"], ["Egypt", "eg", "20"], ["El Salvador", "sv", "503", "....-...."], ["Equatorial Guinea", "gq", "240"], ["Eritrea", "er", "291"], ["Estonia", "ee", "372", ".... ......"], ["Ethiopia", "et", "251", ".. ... ...."], ["Faroe Islands", "fo", "298", ".. .. .."], ["Fiji", "fj", "679"], ["Finland", "fi", "358", ".. ... .. .."], ["France", "fr", "33", ". .. .. .. .."], ["French Guiana", "gf", "594", "... .. .. .."], ["French Polynesia", "pf", "689", { "/^44/": ".. .. ..", "/^80[0-5]/": "... .. .. ..", default: ".. .. .. .." }], ["Gabon", "ga", "241"], ["Gambia", "gm", "220"], ["Georgia", "ge", "995"], ["Germany", "de", "49", "... ........."], ["Ghana", "gh", "233"], ["Gibraltar", "gi", "350"], ["Greece", "gr", "30"], ["Greenland", "gl", "299", ".. .. .."], ["Grenada", "gd", "1473"], ["Guadeloupe", "gp", "590", "... .. .. ..", 0], ["Guam", "gu", "1671"], ["Guatemala", "gt", "502", "....-...."], ["Guinea", "gn", "224"], ["Guinea-Bissau", "gw", "245"], ["Guyana", "gy", "592"], ["Haiti", "ht", "509", "....-...."], ["Honduras", "hn", "504"], ["Hong Kong", "hk", "852", ".... ...."], ["Hungary", "hu", "36"], ["Iceland", "is", "354", "... ...."], ["India", "in", "91", ".....-....."], ["Indonesia", "id", "62"], ["Iran", "ir", "98", "... ... ...."], ["Iraq", "iq", "964"], ["Ireland", "ie", "353", ".. ......."], ["Israel", "il", "972", "... ... ...."], ["Italy", "it", "39", "... .......", 0], ["Jamaica", "jm", "1876"], ["Japan", "jp", "81", ".. .... ...."], ["Jordan", "jo", "962"], ["Kazakhstan", "kz", "7", "... ...-..-..", 0], ["Kenya", "ke", "254"], ["Kiribati", "ki", "686"], ["Kosovo", "xk", "383"], ["Kuwait", "kw", "965", ".... ...."], ["Kyrgyzstan", "kg", "996", "... ... ..."], ["Laos", "la", "856"], ["Latvia", "lv", "371", ".. ... ..."], ["Lebanon", "lb", "961"], ["Lesotho", "ls", "266"], ["Liberia", "lr", "231"], ["Libya", "ly", "218"], ["Liechtenstein", "li", "423"], ["Lithuania", "lt", "370"], ["Luxembourg", "lu", "352"], ["Macau", "mo", "853"], ["Macedonia", "mk", "389"], ["Madagascar", "mg", "261"], ["Malawi", "mw", "265"], ["Malaysia", "my", "60", "..-....-...."], ["Maldives", "mv", "960"], ["Mali", "ml", "223"], ["Malta", "mt", "356"], ["Marshall Islands", "mh", "692"], ["Martinique", "mq", "596", "... .. .. .."], ["Mauritania", "mr", "222"], ["Mauritius", "mu", "230"], ["Mayotte", "yt", "262", "... .. .. ..", 1, ["269", "639"]], ["Mexico", "mx", "52", "... ... ....", 0], ["Micronesia", "fm", "691"], ["Moldova", "md", "373", "(..) ..-..-.."], ["Monaco", "mc", "377"], ["Mongolia", "mn", "976"], ["Montenegro", "me", "382"], ["Morocco", "ma", "212"], ["Mozambique", "mz", "258"], ["Myanmar", "mm", "95"], ["Namibia", "na", "264"], ["Nauru", "nr", "674"], ["Nepal", "np", "977"], ["Netherlands", "nl", "31", { "/^06/": "(.). .........", "/^6/": ". .........", "/^0(10|13|14|15|20|23|24|26|30|33|35|36|38|40|43|44|45|46|50|53|55|58|70|71|72|73|74|75|76|77|78|79|82|84|85|87|88|91)/": "(.).. ........", "/^(10|13|14|15|20|23|24|26|30|33|35|36|38|40|43|44|45|46|50|53|55|58|70|71|72|73|74|75|76|77|78|79|82|84|85|87|88|91)/": ".. ........", "/^0/": "(.)... .......", default: "... ......." }], ["New Caledonia", "nc", "687"], ["New Zealand", "nz", "64", "...-...-...."], ["Nicaragua", "ni", "505"], ["Niger", "ne", "227"], ["Nigeria", "ng", "234"], ["North Korea", "kp", "850"], ["Norway", "no", "47", "... .. ..."], ["Oman", "om", "968", ".... ...."], ["Pakistan", "pk", "92", "...-......."], ["Palau", "pw", "680"], ["Palestine", "ps", "970"], ["Panama", "pa", "507"], ["Papua New Guinea", "pg", "675"], ["Paraguay", "py", "595"], ["Peru", "pe", "51"], ["Philippines", "ph", "63", "... ... ...."], ["Poland", "pl", "48", "...-...-..."], ["Portugal", "pt", "351"], ["Puerto Rico", "pr", "1", "(...) ...-....", 3, ["787", "939"]], ["Qatar", "qa", "974", ".... ...."], ["Réunion", "re", "262", "... .. .. ..", 0], ["Romania", "ro", "40"], ["Russia", "ru", "7", "(...) ...-..-..", 1], ["Rwanda", "rw", "250"], ["Saint Kitts and Nevis", "kn", "1869"], ["Saint Lucia", "lc", "1758"], ["Saint Pierre & Miquelon", "pm", "508", { "/^708/": "... ... ...", "/^8/": "... .. .. ..", default: ".. .. .." }], ["Saint Vincent and the Grenadines", "vc", "1784"], ["Samoa", "ws", "685"], ["San Marino", "sm", "378"], ["São Tomé and Príncipe", "st", "239"], ["Saudi Arabia", "sa", "966", ".. ... ...."], ["Senegal", "sn", "221"], ["Serbia", "rs", "381"], ["Seychelles", "sc", "248"], ["Sierra Leone", "sl", "232"], ["Singapore", "sg", "65", "....-...."], ["Slovakia", "sk", "421"], ["Slovenia", "si", "386"], ["Solomon Islands", "sb", "677"], ["Somalia", "so", "252"], ["South Africa", "za", "27"], ["South Korea", "kr", "82", "... .... ...."], ["South Sudan", "ss", "211"], ["Spain", "es", "34", "... ... ..."], ["Sri Lanka", "lk", "94"], ["Sudan", "sd", "249"], ["Suriname", "sr", "597"], ["Swaziland", "sz", "268"], ["Sweden", "se", "46", "... ... ..."], ["Switzerland", "ch", "41", ".. ... .. .."], ["Syria", "sy", "963"], ["Taiwan", "tw", "886"], ["Tajikistan", "tj", "992"], ["Tanzania", "tz", "255"], ["Thailand", "th", "66"], ["Timor-Leste", "tl", "670"], ["Togo", "tg", "228"], ["Tonga", "to", "676"], ["Trinidad and Tobago", "tt", "1868"], ["Tunisia", "tn", "216"], ["Turkey", "tr", "90", "... ... .. .."], ["Turkmenistan", "tm", "993"], ["Tuvalu", "tv", "688"], ["Uganda", "ug", "256"], ["Ukraine", "ua", "380", "(..) ... .. .."], ["United Arab Emirates", "ae", "971", { default: ".. ... ....", "/^5[024568]/": ".. ... ....", "/^[234679]/": ". ... ...." }], ["United Kingdom", "gb", "44", ".... ......"], ["United States", "us", "1", "(...) ...-....", 0], ["Uruguay", "uy", "598"], ["Uzbekistan", "uz", "998", ".. ... .. .."], ["Vanuatu", "vu", "678"], ["Vatican City", "va", "39", ".. .... ....", 1], ["Venezuela", "ve", "58"], ["Vietnam", "vn", "84"], ["Wallis & Futuna", "wf", "681", ".. .. .."], ["Yemen", "ye", "967"], ["Zambia", "zm", "260"], ["Zimbabwe", "zw", "263"]], g_ = "react-international-phone-", Ig = (...e) => e.filter((r) => !!r).join(" ").trim(), m_ = (...e) => Ig(...e).split(" ").map((r) => `${g_}${r}`).join(" "), _t = ({ addPrefix: e, rawClassNames: r }) => Ig(m_(...e), ...r), v_ = ({ value: e, mask: r, maskSymbol: t, offset: n = 0, trimNonMaskCharsLeftover: a = !1, allowMaskOverflow: o = !1 }) => {
  if (e.length < n) return e;
  let i = e.slice(0, n), s = e.slice(n), l = r.split("").filter((f) => f === t).length, u = s.slice(0, l), c = o ? s.slice(l) : "", d = i, p = 0;
  for (let f of r.split("")) {
    if (p >= u.length) {
      if (!a && f !== t) {
        d += f;
        continue;
      }
      break;
    }
    f === t ? (d += u[p], p += 1) : d += f;
  }
  return d + c;
}, ya = (e) => e ? /^\d+$/.test(e) : !1, Ws = (e) => e.replace(/\D/g, ""), b_ = (e, r) => {
  let t = e.style.display;
  t !== "block" && (e.style.display = "block");
  let n = e.getBoundingClientRect(), a = r.getBoundingClientRect(), o = a.top - n.top, i = n.bottom - a.bottom;
  o >= 0 && i >= 0 || (Math.abs(o) < Math.abs(i) ? e.scrollTop += o : e.scrollTop -= i), e.style.display = t;
}, y_ = () => typeof window > "u" ? !1 : window.navigator.userAgent.toLowerCase().includes("macintosh"), w_ = (e, r) => {
  let t = r.disableDialCodeAndPrefix ? !1 : r.forceDialCode, n = r.disableDialCodeAndPrefix ? !1 : r.insertDialCodeOnEmpty, a = e, o = (u) => r.trimNonDigitsEnd ? u.trim() : u;
  if (!a) return n && !a.length || t ? o(`${r.prefix}${r.dialCode}${r.charAfterDialCode}`) : o(a);
  if (a = Ws(a), a === r.dialCode && !r.disableDialCodeAndPrefix) return o(`${r.prefix}${r.dialCode}${r.charAfterDialCode}`);
  if (r.dialCode.startsWith(a) && !r.disableDialCodeAndPrefix) return o(t ? `${r.prefix}${r.dialCode}${r.charAfterDialCode}` : `${r.prefix}${a}`);
  if (!a.startsWith(r.dialCode) && !r.disableDialCodeAndPrefix) {
    if (t) return o(`${r.prefix}${r.dialCode}${r.charAfterDialCode}`);
    if (a.length < r.dialCode.length) return o(`${r.prefix}${a}`);
  }
  let i = () => {
    let u = r.dialCode.length, c = a.slice(0, u), d = a.slice(u);
    return { phoneLeftSide: c, phoneRightSide: d };
  }, { phoneLeftSide: s, phoneRightSide: l } = i();
  return s = `${r.prefix}${s}${r.charAfterDialCode}`, l = v_({ value: l, mask: r.mask, maskSymbol: r.maskChar, trimNonMaskCharsLeftover: r.trimNonDigitsEnd || r.disableDialCodeAndPrefix && l.length === 0, allowMaskOverflow: r.allowMaskOverflow }), r.disableDialCodeAndPrefix && (s = ""), o(`${s}${l}`);
}, C_ = ({ phoneBeforeInput: e, phoneAfterInput: r, phoneAfterFormatted: t, cursorPositionAfterInput: n, leftOffset: a = 0, deletion: o }) => {
  if (n < a) return a;
  if (!e) return t.length;
  let i = null;
  for (let c = n - 1; c >= 0; c -= 1) if (ya(r[c])) {
    i = c;
    break;
  }
  if (i === null) {
    for (let c = 0; c < r.length; c += 1) if (ya(t[c])) return c;
    return r.length;
  }
  let s = 0;
  for (let c = 0; c < i; c += 1) ya(r[c]) && (s += 1);
  let l = 0, u = 0;
  for (let c = 0; c < t.length && (l += 1, ya(t[c]) && (u += 1), !(u >= s + 1)); c += 1) ;
  if (o !== "backward") for (; !ya(t[l]) && l < t.length; ) l += 1;
  return l;
}, Ai = ({ phone: e, prefix: r }) => e ? `${r}${Ws(e)}` : "";
function vu({ value: e, country: r, insertDialCodeOnEmpty: t, trimNonDigitsEnd: n, countries: a, prefix: o, charAfterDialCode: i, forceDialCode: s, disableDialCodeAndPrefix: l, defaultMask: u, countryGuessingEnabled: c, disableFormatting: d, allowMaskOverflow: p }) {
  let f = e;
  l && (f = f.startsWith(`${o}`) ? f : `${o}${r.dialCode}${f}`);
  let h = c ? P_({ phone: f, countries: a, currentCountryIso2: r == null ? void 0 : r.iso2 }) : void 0, g = (h == null ? void 0 : h.country) ?? r, m = w_(f, { prefix: o, mask: E_({ phone: f, country: g, defaultMask: u, disableFormatting: d }), maskChar: Dg, dialCode: g.dialCode, trimNonDigitsEnd: n, charAfterDialCode: i, forceDialCode: s, insertDialCodeOnEmpty: t, disableDialCodeAndPrefix: l, allowMaskOverflow: p }), v = c && !(h != null && h.fullDialCodeMatch) ? r : g;
  return { phone: Ai({ phone: l ? `${v.dialCode}${m}` : m, prefix: o }), inputValue: m, country: v };
}
var x_ = (e) => {
  if ((e == null ? void 0 : e.toLocaleLowerCase().includes("delete")) ?? !1) return e != null && e.toLocaleLowerCase().includes("forward") ? "forward" : "backward";
}, S_ = (e, { country: r, insertDialCodeOnEmpty: t, phoneBeforeInput: n, prefix: a, charAfterDialCode: o, forceDialCode: i, disableDialCodeAndPrefix: s, countryGuessingEnabled: l, defaultMask: u, disableFormatting: c, countries: d, allowMaskOverflow: p }) => {
  let f = e.nativeEvent, h = f.inputType, g = x_(h), m = !!(h != null && h.startsWith("insertFrom")), v = h === "insertText", y = (f == null ? void 0 : f.data) || void 0, w = e.target.value, I = e.target.selectionStart ?? 0;
  if (h != null && h.includes("history")) return { inputValue: n, phone: Ai({ phone: n, prefix: a }), cursorPosition: n.length, country: r };
  if (v && !ya(y) && w !== a) return { inputValue: n, phone: Ai({ phone: s ? `${r.dialCode}${n}` : n, prefix: a }), cursorPosition: I - ((y == null ? void 0 : y.length) ?? 0), country: r };
  if (i && !w.startsWith(`${a}${r.dialCode}`) && !m) {
    let k = w ? n : `${a}${r.dialCode}${o}`;
    return { inputValue: k, phone: Ai({ phone: k, prefix: a }), cursorPosition: a.length + r.dialCode.length + o.length, country: r };
  }
  let { phone: b, inputValue: D, country: S } = vu({ value: w, country: r, trimNonDigitsEnd: g === "backward", insertDialCodeOnEmpty: t, countryGuessingEnabled: l, countries: d, prefix: a, charAfterDialCode: o, forceDialCode: i, disableDialCodeAndPrefix: s, disableFormatting: c, defaultMask: u, allowMaskOverflow: p }), _ = C_({ cursorPositionAfterInput: I, phoneBeforeInput: n, phoneAfterInput: w, phoneAfterFormatted: D, leftOffset: i ? a.length + r.dialCode.length + o.length : 0, deletion: g });
  return { phone: b, inputValue: D, cursorPosition: _, country: S };
}, I_ = (e, r) => {
  let t = Object.keys(e), n = Object.keys(r);
  if (t.length !== n.length) return !1;
  for (let a of t) if (e[a] !== r[a]) return !1;
  return !0;
}, D_ = () => {
  let e = ye(), r = ye(Date.now()), t = re(() => {
    let n = Date.now(), a = e.current ? n - r.current : void 0;
    return e.current = r.current, r.current = n, a;
  }, []);
  return We(() => ({ check: t }), [t]);
}, __ = { size: 20, overrideLastItemDebounceMS: -1 };
function k_(e, r) {
  let { size: t, overrideLastItemDebounceMS: n, onChange: a } = { ...__, ...r }, [o, i] = ke(e), s = ye([o]), l = ye(0), u = D_(), c = re((f, h) => {
    let g = s.current[l.current];
    if (f === g || typeof f == "object" && typeof g == "object" && I_(f, g)) return;
    let m = n > 0, v = u.check(), y = m && v !== void 0 ? v > n : !0;
    if ((h == null ? void 0 : h.overrideLastItem) !== void 0 ? h.overrideLastItem : !y) s.current = [...s.current.slice(0, l.current), f];
    else {
      let w = s.current.length >= t;
      s.current = [...s.current.slice(w ? 1 : 0, l.current + 1), f], w || (l.current += 1);
    }
    i(f), a == null || a(f);
  }, [a, n, t, u]), d = re(() => {
    if (l.current <= 0) return { success: !1 };
    let f = s.current[l.current - 1];
    return i(f), l.current -= 1, a == null || a(f), { success: !0, value: f };
  }, [a]), p = re(() => {
    if (l.current + 1 >= s.current.length) return { success: !1 };
    let f = s.current[l.current + 1];
    return i(f), l.current += 1, a == null || a(f), { success: !0, value: f };
  }, [a]);
  return [o, c, d, p];
}
var Dg = ".", Ht = { defaultCountry: "us", value: "", prefix: "+", defaultMask: "............", charAfterDialCode: " ", historySaveDebounceMS: 200, disableCountryGuess: !1, disableDialCodePrefill: !1, forceDialCode: !1, disableDialCodeAndPrefix: !1, disableFormatting: !1, allowMaskOverflow: !1, countries: Ja }, _g = ({ defaultCountry: e = Ht.defaultCountry, value: r = Ht.value, countries: t = Ht.countries, prefix: n = Ht.prefix, defaultMask: a = Ht.defaultMask, charAfterDialCode: o = Ht.charAfterDialCode, historySaveDebounceMS: i = Ht.historySaveDebounceMS, disableCountryGuess: s = Ht.disableCountryGuess, disableDialCodePrefill: l = Ht.disableDialCodePrefill, forceDialCode: u = Ht.forceDialCode, disableDialCodeAndPrefix: c = Ht.disableDialCodeAndPrefix, disableFormatting: d = Ht.disableFormatting, allowMaskOverflow: p = Ht.allowMaskOverflow, onChange: f, inputRef: h }) => {
  let g = { countries: t, prefix: n, charAfterDialCode: o, forceDialCode: c ? !1 : u, disableDialCodeAndPrefix: c, defaultMask: a, countryGuessingEnabled: !s, disableFormatting: d, allowMaskOverflow: p }, m = ye(null), v = h || m, y = (A) => {
    Promise.resolve().then(() => {
      var N;
      typeof window > "u" || v.current !== (document == null ? void 0 : document.activeElement) || ((N = v.current) == null || N.setSelectionRange(A, A));
    });
  }, w = re((A) => xa({ value: A, field: "iso2", countries: t }), [t]), I = re(({ inputValue: A, phone: N, country: G }) => {
    if (!f) return;
    let Q = w(G);
    f({ phone: N, inputValue: A, country: Q });
  }, [w, f]), [{ phone: b, inputValue: D, country: S }, _, k, R] = k_(() => {
    let A = xa({ value: e, field: "iso2", countries: t });
    A || console.error(`[react-international-phone]: can not find a country with "${e}" iso2 code`);
    let N = A || xa({ value: "us", field: "iso2", countries: t }), { phone: G, inputValue: Q, country: L } = vu({ value: r, country: N, insertDialCodeOnEmpty: !l, ...g });
    return y(Q.length), { phone: G, inputValue: Q, country: L.iso2 };
  }, { overrideLastItemDebounceMS: i, onChange: I }), W = We(() => w(S), [S, w]);
  He(() => {
    let A = v.current;
    if (!A) return;
    let N = (G) => {
      if (!G.key) return;
      let Q = G.ctrlKey, L = G.metaKey, O = G.shiftKey;
      if (G.key.toLowerCase() === "z") {
        if (y_()) {
          if (!L) return;
        } else if (!Q) return;
        O ? R() : k();
      }
    };
    return A.addEventListener("keydown", N), () => {
      A.removeEventListener("keydown", N);
    };
  }, [v, k, R]);
  let B = (A) => {
    A.preventDefault();
    let { phone: N, inputValue: G, country: Q, cursorPosition: L } = S_(A, { country: W, phoneBeforeInput: D, insertDialCodeOnEmpty: !1, ...g });
    return _({ inputValue: G, phone: N, country: Q.iso2 }), y(L), r;
  }, V = re((A, N = { focusOnInput: !1 }) => {
    let G = xa({ value: A, field: "iso2", countries: t });
    if (!G) {
      console.error(`[react-international-phone]: can not find a country with "${A}" iso2 code`);
      return;
    }
    let Q = c ? "" : `${n}${G.dialCode}${o}`;
    _({ inputValue: Q, phone: `${n}${G.dialCode}`, country: G.iso2 }), N.focusOnInput && Promise.resolve().then(() => {
      var L;
      (L = v.current) == null || L.focus();
    });
  }, [t, c, n, o, _, v]), [F, H] = ke(!1);
  return He(() => {
    if (!F) {
      H(!0), r !== b && (f == null || f({ inputValue: D, phone: b, country: W }));
      return;
    }
    if (r === b) return;
    let { phone: A, inputValue: N, country: G } = vu({ value: r, country: W, insertDialCodeOnEmpty: !l, ...g });
    _({ phone: A, inputValue: N, country: G.iso2 });
  }, [r]), { phone: b, inputValue: D, country: W, setCountry: V, handlePhoneValueChange: B, inputRef: v };
}, E_ = ({ phone: e, country: r, defaultMask: t = "............", disableFormatting: n = !1 }) => {
  let a = r.format, o = (s) => n ? s.replace(new RegExp(`[^${Dg}]`, "g"), "") : s;
  if (!a) return o(t);
  if (typeof a == "string") return o(a);
  if (!a.default) return console.error(`[react-international-phone]: default mask for ${r.iso2} is not provided`), o(t);
  let i = Object.keys(a).find((s) => {
    if (s === "default") return !1;
    if (!(s.charAt(0) === "/" && s.charAt(s.length - 1) === "/")) return console.error(`[react-international-phone]: format regex "${s}" for ${r.iso2} is not valid`), !1;
    let l = new RegExp(s.substring(1, s.length - 1)), u = e.replace(r.dialCode, "");
    return l.test(Ws(u));
  });
  return o(i ? a[i] : a.default);
}, _r = (e) => {
  let [r, t, n, a, o, i] = e;
  return { name: r, iso2: t, dialCode: n, format: a, priority: o, areaCodes: i };
}, M_ = (e) => `Field "${e}" is not supported`, xa = ({ field: e, value: r, countries: t = Ja }) => {
  if (["priority"].includes(e)) throw new Error(M_(e));
  let n = t.find((a) => {
    let o = _r(a);
    return r === o[e];
  });
  if (n) return _r(n);
}, P_ = ({ phone: e, countries: r = Ja, currentCountryIso2: t }) => {
  var s;
  let n = { country: void 0, fullDialCodeMatch: !1 };
  if (!e) return n;
  let a = Ws(e);
  if (!a) return n;
  let o = n, i = ({ country: l, fullDialCodeMatch: u }) => {
    var p, f;
    let c = l.dialCode === ((p = o.country) == null ? void 0 : p.dialCode), d = (l.priority ?? 0) < (((f = o.country) == null ? void 0 : f.priority) ?? 0);
    (!c || d) && (o = { country: l, fullDialCodeMatch: u });
  };
  for (let l of r) {
    let u = _r(l), { dialCode: c, areaCodes: d } = u;
    if (a.startsWith(c)) {
      let p = o.country ? Number(c) >= Number(o.country.dialCode) : !0;
      if (d) {
        let f = a.substring(c.length);
        for (let h of d) if (f.startsWith(h)) return { country: u, fullDialCodeMatch: !0 };
      }
      (p || c === a || !o.fullDialCodeMatch) && i({ country: u, fullDialCodeMatch: !0 });
    }
    o.fullDialCodeMatch || a.length < c.length && c.startsWith(a) && (!o.country || Number(c) <= Number(o.country.dialCode)) && i({ country: u, fullDialCodeMatch: !1 });
  }
  if (t) {
    let l = xa({ value: t, field: "iso2", countries: r });
    if (!l) return o;
    let u = l ? ((c) => {
      if (!(c != null && c.areaCodes)) return !1;
      let d = a.substring(c.dialCode.length);
      return c.areaCodes.some((p) => p.startsWith(d));
    })(l) : !1;
    o && ((s = o.country) == null ? void 0 : s.dialCode) === l.dialCode && o.country !== l && o.fullDialCodeMatch && (!l.areaCodes || u) && (o = { country: l, fullDialCodeMatch: !0 });
  }
  return o;
}, A_ = (e, r) => {
  let t = parseInt(e, 16);
  return Number(t + r).toString(16);
}, R_ = "abcdefghijklmnopqrstuvwxyz", O_ = "1f1e6", kf = R_.split("").reduce((e, r, t) => ({ ...e, [r]: A_(O_, t) }), {}), T_ = (e) => [kf[e[0]], kf[e[1]]].join("-"), kg = ({ iso2: e, size: r, src: t, protocol: n = "https", disableLazyLoading: a, className: o, style: i, ...s }) => {
  if (!e) return P.createElement("img", { className: _t({ addPrefix: ["flag-emoji"], rawClassNames: [o] }), width: r, height: r, ...s });
  let l = () => {
    if (t) return t;
    let u = T_(e);
    return `${n}://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${u}.svg`;
  };
  return P.createElement("img", { className: _t({ addPrefix: ["flag-emoji"], rawClassNames: [o] }), src: l(), width: r, height: r, draggable: !1, "data-country": e, loading: a ? void 0 : "lazy", style: { width: r, height: r, ...i }, alt: "", ...s });
}, F_ = 1e3, N_ = ({ show: e, dialCodePrefix: r = "+", selectedCountry: t, countries: n = Ja, preferredCountries: a = [], flags: o, onSelect: i, onClose: s, ...l }) => {
  let u = ye(null), c = ye(), d = We(() => {
    if (!a || !a.length) return n;
    let D = [], S = [...n];
    for (let _ of a) {
      let k = S.findIndex((R) => _r(R).iso2 === _);
      if (k !== -1) {
        let R = S.splice(k, 1)[0];
        D.push(R);
      }
    }
    return D.concat(S);
  }, [n, a]), p = ye({ updatedAt: void 0, value: "" }), f = (D) => {
    let S = p.current.updatedAt && (/* @__PURE__ */ new Date()).getTime() - p.current.updatedAt.getTime() > F_;
    p.current = { value: S ? D : `${p.current.value}${D}`, updatedAt: /* @__PURE__ */ new Date() };
    let _ = d.findIndex((k) => _r(k).name.toLowerCase().startsWith(p.current.value));
    _ !== -1 && m(_);
  }, h = re((D) => d.findIndex((S) => _r(S).iso2 === D), [d]), [g, m] = ke(h(t)), v = () => {
    c.current !== t && m(h(t));
  }, y = re((D) => {
    m(h(D.iso2)), i == null || i(D);
  }, [i, h]), w = (D) => {
    let S = d.length - 1, _ = (k) => D === "prev" ? k - 1 : D === "next" ? k + 1 : D === "last" ? S : 0;
    m((k) => {
      let R = _(k);
      return R < 0 ? 0 : R > S ? S : R;
    });
  }, I = (D) => {
    if (D.stopPropagation(), D.key === "Enter") {
      D.preventDefault();
      let S = _r(d[g]);
      y(S);
      return;
    }
    if (D.key === "Escape") {
      s == null || s();
      return;
    }
    if (D.key === "ArrowUp") {
      D.preventDefault(), w("prev");
      return;
    }
    if (D.key === "ArrowDown") {
      D.preventDefault(), w("next");
      return;
    }
    if (D.key === "PageUp") {
      D.preventDefault(), w("first");
      return;
    }
    if (D.key === "PageDown") {
      D.preventDefault(), w("last");
      return;
    }
    D.key === " " && D.preventDefault(), D.key.length === 1 && !D.altKey && !D.ctrlKey && !D.metaKey && f(D.key.toLocaleLowerCase());
  }, b = re(() => {
    if (!u.current || g === void 0) return;
    let D = _r(d[g]).iso2;
    if (D === c.current) return;
    let S = u.current.querySelector(`[data-country="${D}"]`);
    S && (b_(u.current, S), c.current = D);
  }, [g, d]);
  return He(() => {
    b();
  }, [g, b]), He(() => {
    u.current && (e ? u.current.focus() : v());
  }, [e]), He(() => {
    v();
  }, [t]), P.createElement("ul", { ref: u, role: "listbox", className: _t({ addPrefix: ["country-selector-dropdown"], rawClassNames: [l.className] }), style: { display: e ? "block" : "none", ...l.style }, onKeyDown: I, onBlur: s, tabIndex: -1, "aria-activedescendant": `react-international-phone__${_r(d[g]).iso2}-option` }, d.map((D, S) => {
    let _ = _r(D), k = _.iso2 === t, R = S === g, W = a.includes(_.iso2), B = S === a.length - 1, V = o == null ? void 0 : o.find((F) => F.iso2 === _.iso2);
    return P.createElement(P.Fragment, { key: _.iso2 }, P.createElement("li", { "data-country": _.iso2, role: "option", "aria-selected": k, "aria-label": `${_.name} ${r}${_.dialCode}`, id: `react-international-phone__${_.iso2}-option`, className: _t({ addPrefix: ["country-selector-dropdown__list-item", W && "country-selector-dropdown__list-item--preferred", k && "country-selector-dropdown__list-item--selected", R && "country-selector-dropdown__list-item--focused"], rawClassNames: [l.listItemClassName, W && l.listItemPreferredClassName, k && l.listItemSelectedClassName, R && l.listItemFocusedClassName] }), onClick: () => y(_), style: l.listItemStyle, title: _.name }, P.createElement(kg, { iso2: _.iso2, src: V == null ? void 0 : V.src, className: _t({ addPrefix: ["country-selector-dropdown__list-item-flag-emoji"], rawClassNames: [l.listItemFlagClassName] }), style: l.listItemFlagStyle }), P.createElement("span", { className: _t({ addPrefix: ["country-selector-dropdown__list-item-country-name"], rawClassNames: [l.listItemCountryNameClassName] }), style: l.listItemCountryNameStyle }, _.name), P.createElement("span", { className: _t({ addPrefix: ["country-selector-dropdown__list-item-dial-code"], rawClassNames: [l.listItemDialCodeClassName] }), style: l.listItemDialCodeStyle }, r, _.dialCode)), B ? P.createElement("hr", { className: _t({ addPrefix: ["country-selector-dropdown__preferred-list-divider"], rawClassNames: [l.preferredListDividerClassName] }), style: l.preferredListDividerStyle }) : null);
  }));
}, Eg = P.memo(({ selectedCountry: e, onSelect: r, disabled: t, hideDropdown: n, countries: a = Ja, preferredCountries: o = [], flags: i, renderButtonWrapper: s, ...l }) => {
  let [u, c] = ke(!1), d = We(() => {
    if (e) return xa({ value: e, field: "iso2", countries: a });
  }, [a, e]), p = ye(null), f = (g) => {
    g.key && ["ArrowUp", "ArrowDown"].includes(g.key) && (g.preventDefault(), c(!0));
  }, h = () => {
    var v;
    let g = { title: d == null ? void 0 : d.name, onClick: () => c((y) => !y), onMouseDown: (y) => y.preventDefault(), onKeyDown: f, disabled: n || t, role: "combobox", "aria-label": "Country selector", "aria-haspopup": "listbox", "aria-expanded": u }, m = P.createElement("div", { className: _t({ addPrefix: ["country-selector-button__button-content"], rawClassNames: [l.buttonContentWrapperClassName] }), style: l.buttonContentWrapperStyle }, P.createElement(kg, { iso2: e, src: (v = i == null ? void 0 : i.find((y) => y.iso2 === e)) == null ? void 0 : v.src, className: _t({ addPrefix: ["country-selector-button__flag-emoji", t && "country-selector-button__flag-emoji--disabled"], rawClassNames: [l.flagClassName] }), style: { visibility: e ? "visible" : "hidden", ...l.flagStyle } }), !n && P.createElement("div", { className: _t({ addPrefix: ["country-selector-button__dropdown-arrow", t && "country-selector-button__dropdown-arrow--disabled", u && "country-selector-button__dropdown-arrow--active"], rawClassNames: [l.dropdownArrowClassName] }), style: l.dropdownArrowStyle }));
    return s ? s({ children: m, rootProps: g }) : P.createElement("button", { ...g, type: "button", className: _t({ addPrefix: ["country-selector-button", u && "country-selector-button--active", t && "country-selector-button--disabled", n && "country-selector-button--hide-dropdown"], rawClassNames: [l.buttonClassName] }), "data-country": e, style: l.buttonStyle }, m);
  };
  return P.createElement("div", { className: _t({ addPrefix: ["country-selector"], rawClassNames: [l.className] }), style: l.style, ref: p }, h(), P.createElement(N_, { show: u, countries: a, preferredCountries: o, flags: i, onSelect: (g) => {
    c(!1), r == null || r(g);
  }, selectedCountry: e, onClose: () => {
    c(!1);
  }, ...l.dropdownStyleProps }));
}), L_ = ({ dialCode: e, prefix: r, disabled: t, style: n, className: a }) => P.createElement("div", { className: _t({ addPrefix: ["dial-code-preview", t && "dial-code-preview--disabled"], rawClassNames: [a] }), style: n }, `${r}${e}`);
at(({ value: e, onChange: r, countries: t = Ja, preferredCountries: n, hideDropdown: a, showDisabledDialCodeAndPrefix: o, disableFocusAfterCountrySelect: i, flags: s, style: l, className: u, inputStyle: c, inputClassName: d, countrySelectorStyleProps: p, dialCodePreviewStyleProps: f, inputProps: h, placeholder: g, disabled: m, name: v, onFocus: y, onBlur: w, required: I, autoFocus: b, ...D }, S) => {
  let _ = re((N) => {
    r == null || r(N.phone, { country: N.country, inputValue: N.inputValue });
  }, [r]), { phone: k, inputValue: R, inputRef: W, country: B, setCountry: V, handlePhoneValueChange: F } = _g({ value: e, countries: t, ...D, onChange: _ }), H = D.disableDialCodeAndPrefix && o && (B == null ? void 0 : B.dialCode), A = re((N) => {
    V(N.iso2, { focusOnInput: !i });
  }, [V, i]);
  return Ip(S, () => W.current ? Object.assign(W.current, { setCountry: V, state: { phone: k, inputValue: R, country: B } }) : null, [W, V, k, R, B]), P.createElement("div", { ref: S, className: _t({ addPrefix: ["input-container"], rawClassNames: [u] }), style: l }, P.createElement(Eg, { onSelect: A, flags: s, selectedCountry: B == null ? void 0 : B.iso2, countries: t, preferredCountries: n, disabled: m, hideDropdown: a, ...p }), H && P.createElement(L_, { dialCode: B.dialCode, prefix: D.prefix ?? "+", disabled: m, ...f }), P.createElement("input", { onChange: F, value: R, type: "tel", ref: W, className: _t({ addPrefix: ["input", m && "input--disabled"], rawClassNames: [d] }), placeholder: g, disabled: m, style: c, name: v, onFocus: y, onBlur: w, autoFocus: b, required: I, ...h }));
});
const fF = ({ placeholder: e, addClass: r, name: t, helperText: n, label: a, id: o, isDisabled: i, onChange: s, isInvalid: l = !1, value: u, onFocus: c, onBlur: d, isReadOnly: p, isRequired: f }) => {
  const h = _g({
    defaultCountry: "mx",
    value: u,
    onChange: (g) => {
      s(g.phone);
    }
  });
  return /* @__PURE__ */ ee(
    ta,
    {
      zIndex: "sticky",
      width: oa,
      minH: sr.inputContainerHeight,
      id: o,
      isDisabled: i,
      isInvalid: l,
      children: [
        /* @__PURE__ */ ee(
          ra,
          {
            opacity: 0.5,
            fontSize: je.label,
            fontWeight: ia.label,
            padding: sr.labelPadding,
            children: [
              a,
              " ",
              f ? /* @__PURE__ */ x("span", { style: { color: fn }, children: "*" }) : ""
            ]
          }
        ),
        /* @__PURE__ */ x(
          na,
          {
            zIndex: "sticky",
            width: "100%",
            flexGrow: 1,
            children: /* @__PURE__ */ ee(
              Rt,
              {
                w: "100%",
                alignItems: "center",
                position: "relative",
                zIndex: "sticky",
                children: [
                  /* @__PURE__ */ x(
                    Eg,
                    {
                      selectedCountry: h.country.iso2,
                      onSelect: (g) => h.setCountry(g.iso2),
                      renderButtonWrapper: ({ children: g, rootProps: m }) => /* @__PURE__ */ x(
                        At,
                        {
                          ...m,
                          variant: "outline",
                          px: "10px",
                          mr: "8px",
                          children: g
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ x(
                    Ho,
                    {
                      height: ar,
                      width: "100%",
                      flexGrow: 1,
                      name: t,
                      type: "tel",
                      color: "primary",
                      value: h.inputValue,
                      onChange: h.handlePhoneValueChange,
                      ref: h.inputRef,
                      errorBorderColor: zt.error.border,
                      focusBorderColor: zt.default.focus.border,
                      className: r,
                      isInvalid: l,
                      onBlur: d,
                      onFocus: c,
                      placeholder: e,
                      isReadOnly: p
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ x(aa, { height: 2, children: n })
      ]
    }
  );
};
//! moment.js
//! version : 2.31.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var Mg;
function J() {
  return Mg.apply(null, arguments);
}
function W_(e) {
  Mg = e;
}
function yr(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function zn(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function Se(e, r) {
  return Object.prototype.hasOwnProperty.call(e, r);
}
function uc(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var r;
  for (r in e)
    if (Se(e, r))
      return !1;
  return !0;
}
function Tt(e) {
  return e === void 0;
}
function cn(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function Qo(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function Pg(e, r) {
  var t = [], n, a = e.length;
  for (n = 0; n < a; ++n)
    t.push(r(e[n], n));
  return t;
}
function Or(e, r) {
  for (var t in r)
    Se(r, t) && (e[t] = r[t]);
  return Se(r, "toString") && (e.toString = r.toString), Se(r, "valueOf") && (e.valueOf = r.valueOf), e;
}
function zr(e, r, t, n) {
  return tm(e, r, t, n, !0).utc();
}
function B_() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidOffset: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function we(e) {
  return e._pf == null && (e._pf = B_()), e._pf;
}
var bu;
Array.prototype.some ? bu = Array.prototype.some : bu = function(e) {
  var r = Object(this), t = r.length >>> 0, n;
  for (n = 0; n < t; n++)
    if (n in r && e.call(this, r[n], n, r))
      return !0;
  return !1;
};
function cc(e) {
  var r = null, t = !1, n = e._d && !isNaN(e._d.getTime());
  if (n && (r = we(e), t = bu.call(r.parsedDateParts, function(a) {
    return a != null;
  }), n = r.overflow < 0 && !r.empty && !r.invalidEra && !r.invalidMonth && !r.invalidOffset && !r.invalidWeekday && !r.weekdayMismatch && !r.nullInput && !r.invalidFormat && !r.userInvalidated && (!r.meridiem || r.meridiem && t), e._strict && (n = n && r.charsLeftOver === 0 && r.unusedTokens.length === 0 && r.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = n;
  else
    return n;
  return e._isValid;
}
function qo(e) {
  var r = zr(NaN);
  return e != null ? Or(we(r), e) : we(r).userInvalidated = !0, r;
}
var Ef = J.momentProperties = [], Al = !1;
function dc(e, r) {
  var t, n, a, o = Ef.length;
  if (Tt(r._isAMomentObject) || (e._isAMomentObject = r._isAMomentObject), Tt(r._i) || (e._i = r._i), Tt(r._f) || (e._f = r._f), Tt(r._l) || (e._l = r._l), Tt(r._strict) || (e._strict = r._strict), Tt(r._tzm) || (e._tzm = r._tzm), Tt(r._isUTC) || (e._isUTC = r._isUTC), Tt(r._offset) || (e._offset = r._offset), Tt(r._pf) || (e._pf = we(r)), Tt(r._locale) || (e._locale = r._locale), o > 0)
    for (t = 0; t < o; t++)
      n = Ef[t], a = r[n], Tt(a) || (e[n] = a);
  return e;
}
function Ko(e) {
  dc(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), Al === !1 && (Al = !0, J.updateOffset(this), Al = !1);
}
function Jt(e) {
  return e instanceof Ko || e != null && e._isAMomentObject != null;
}
function Ag(e) {
  J.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function hr(e, r) {
  var t = !0;
  return Or(function() {
    if (J.deprecationHandler != null && J.deprecationHandler(null, e), t) {
      var n = [], a, o, i, s = arguments.length;
      for (o = 0; o < s; o++) {
        if (a = "", typeof arguments[o] == "object") {
          a += `
[` + o + "] ";
          for (i in arguments[0])
            Se(arguments[0], i) && (a += i + ": " + arguments[0][i] + ", ");
          a = a.slice(0, -2);
        } else
          a = arguments[o];
        n.push(a);
      }
      Ag(
        e + `
Arguments: ` + Array.prototype.slice.call(n).join("") + `
` + new Error().stack
      ), t = !1;
    }
    return r.apply(this, arguments);
  }, r);
}
var Mf = {};
function Rg(e, r) {
  J.deprecationHandler != null && J.deprecationHandler(e, r), Mf[e] || (Ag(r + `
` + new Error().stack), Mf[e] = !0);
}
J.suppressDeprecationWarnings = !1;
J.deprecationHandler = null;
function $r(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
var Pf = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function gr(e) {
  return typeof e == "string" ? Pf[e] || Pf[e.toLowerCase()] : void 0;
}
function fc(e) {
  var r = {}, t, n;
  for (n in e)
    Se(e, n) && (t = gr(n), t && (r[t] = e[n]));
  return r;
}
var V_ = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function G_(e) {
  var r = [], t;
  for (t in e)
    Se(e, t) && r.push({ unit: t, priority: V_[t] });
  return r.sort(function(n, a) {
    return n.priority - a.priority;
  }), r;
}
function fr(e, r, t) {
  var n = "" + Math.abs(e), a = r - n.length, o = e >= 0;
  return (o ? t ? "+" : "" : "-") + Math.pow(10, Math.max(0, a)).toString().substr(1) + n;
}
var pc = /(\[[^\[]*\])|(\\e)|(\\)?(eHHmm|[Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, mi = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Rl = {}, _a = {};
function de(e, r, t, n) {
  var a = n;
  typeof n == "string" && (a = function() {
    return this[n]();
  }), e && (_a[e] = a), r && (_a[r[0]] = function() {
    return fr(a.apply(this, arguments), r[1], r[2]);
  }), t && (_a[t] = function() {
    return this.localeData().ordinal(
      a.apply(this, arguments),
      e
    );
  });
}
function Y_(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function H_(e) {
  var r = e.match(pc), t, n;
  for (t = 0, n = r.length; t < n; t++)
    _a[r[t]] ? r[t] = _a[r[t]] : r[t] = Y_(r[t]);
  return function(a) {
    var o = "", i;
    for (i = 0; i < n; i++)
      o += $r(r[i]) ? r[i].call(a, e) : r[i];
    return o;
  };
}
function Ri(e, r) {
  if (!e.isValid())
    return e.localeData().invalidDate();
  r = Og(r, e.localeData());
  var t = "$" + r;
  return Se(Rl, t) || (Rl[t] = H_(r)), Rl[t](e);
}
function Og(e, r) {
  var t = 5;
  function n(a) {
    return r.longDateFormat(a) || a;
  }
  for (mi.lastIndex = 0; t >= 0 && mi.test(e); )
    e = e.replace(
      mi,
      n
    ), mi.lastIndex = 0, t -= 1;
  return e;
}
var Tg = /\d/, qt = /\d\d/, Fg = /\d{3}/, hc = /\d{4}/, Bs = /[+-]?\d{6}/, qe = /\d\d?/, Ng = /\d\d\d\d?/, gc = /\d\d\d\d\d\d?/, Vs = /\d{1,3}/, mc = /\d{1,4}/, Gs = /[+-]?\d{1,6}/, Qa = /\d+/, Ys = /[+-]?\d+/, z_ = /Z|[+-]\d\d:?\d\d/gi, Hs = /Z|[+-]\d\d(?::?\d\d)?/gi, $_ = /[+-]?\d+(\.\d{1,3})?/, ei = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, qa = /^[1-9]\d?/, vc = /^([1-9]\d|\d)/, ss;
ss = {};
function oe(e, r, t) {
  ss[e] = $r(r) ? r : function(n, a) {
    return n && t ? t : r;
  };
}
function X_(e, r) {
  return Se(ss, e) ? ss[e](r._strict, r._locale) : new RegExp(j_(e));
}
function j_(e) {
  return nn(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(r, t, n, a, o) {
        return t || n || a || o;
      }
    )
  );
}
function nn(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function nr(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function Ce(e) {
  var r = +e, t = 0;
  return r !== 0 && isFinite(r) && (t = nr(r)), t;
}
var yu = {};
function ze(e, r) {
  var t, n = r, a;
  for (typeof e == "string" && (e = [e]), cn(r) && (n = function(o, i) {
    i[r] = Ce(o);
  }), a = e.length, t = 0; t < a; t++)
    yu[e[t]] = n;
}
function Ka(e, r) {
  ze(e, function(t, n, a, o) {
    a._w = a._w || {}, r(t, a._w, a, o);
  });
}
function Z_(e, r, t) {
  r != null && Se(yu, e) && yu[e](r, t._a, t, e);
}
function zs(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var ft = 0, jt = 1, Ft = 2, vt = 3, or = 4, tn = 5, Vn = 6, U_ = 7, J_ = 8;
de("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? fr(e, 4) : "+" + e;
});
de(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
de(0, ["YYYY", 4], 0, "year");
de(0, ["YYYYY", 5], 0, "year");
de(0, ["YYYYYY", 6, !0], 0, "year");
oe("Y", Ys);
oe("YY", qe, qt);
oe("YYYY", mc, hc);
oe("YYYYY", Gs, Bs);
oe("YYYYYY", Gs, Bs);
ze(["YYYYY", "YYYYYY"], ft);
ze("YYYY", function(e, r) {
  r[ft] = e.length === 2 ? J.parseTwoDigitYear(e) : Ce(e);
});
ze("YY", function(e, r) {
  r[ft] = J.parseTwoDigitYear(e);
});
ze("Y", function(e, r) {
  r[ft] = parseInt(e, 10);
});
function ko(e) {
  return zs(e) ? 366 : 365;
}
J.parseTwoDigitYear = function(e) {
  return Ce(e) + (Ce(e) > 68 ? 1900 : 2e3);
};
var Lg = eo("FullYear", !0);
function Q_() {
  return zs(this.year());
}
function eo(e, r) {
  return function(t) {
    return t != null ? (Wg(this, e, t), J.updateOffset(this, r), this) : Fo(this, e);
  };
}
function Fo(e, r) {
  if (!e.isValid())
    return NaN;
  var t = e._d, n = e._isUTC;
  switch (r) {
    case "Milliseconds":
      return n ? t.getUTCMilliseconds() : t.getMilliseconds();
    case "Seconds":
      return n ? t.getUTCSeconds() : t.getSeconds();
    case "Minutes":
      return n ? t.getUTCMinutes() : t.getMinutes();
    case "Hours":
      return n ? t.getUTCHours() : t.getHours();
    case "Date":
      return n ? t.getUTCDate() : t.getDate();
    case "Day":
      return n ? t.getUTCDay() : t.getDay();
    case "Month":
      return n ? t.getUTCMonth() : t.getMonth();
    case "FullYear":
      return n ? t.getUTCFullYear() : t.getFullYear();
    default:
      return NaN;
  }
}
function Wg(e, r, t) {
  var n, a, o, i, s;
  if (!(!e.isValid() || isNaN(t))) {
    switch (n = e._d, a = e._isUTC, r) {
      case "Milliseconds":
        return void (a ? n.setUTCMilliseconds(t) : n.setMilliseconds(t));
      case "Seconds":
        return void (a ? n.setUTCSeconds(t) : n.setSeconds(t));
      case "Minutes":
        return void (a ? n.setUTCMinutes(t) : n.setMinutes(t));
      case "Hours":
        return void (a ? n.setUTCHours(t) : n.setHours(t));
      case "Date":
        return void (a ? n.setUTCDate(t) : n.setDate(t));
      case "FullYear":
        break;
      default:
        return;
    }
    o = t, i = e.month(), s = e.date(), s = s === 29 && i === 1 && !zs(o) ? 28 : s, a ? n.setUTCFullYear(o, i, s) : n.setFullYear(o, i, s);
  }
}
function q_(e) {
  return e = gr(e), $r(this[e]) ? this[e]() : this;
}
function K_(e, r) {
  if (typeof e == "object") {
    e = fc(e);
    var t = G_(e), n, a = t.length;
    for (n = 0; n < a; n++)
      this[t[n].unit](e[t[n].unit]);
  } else if (e = gr(e), $r(this[e]))
    return this[e](r);
  return this;
}
function ek(e, r) {
  return (e % r + r) % r;
}
var dt;
Array.prototype.indexOf ? dt = Array.prototype.indexOf : dt = function(e) {
  var r;
  for (r = 0; r < this.length; ++r)
    if (this[r] === e)
      return r;
  return -1;
};
function bc(e, r) {
  if (isNaN(e) || isNaN(r))
    return NaN;
  var t = ek(r, 12);
  return e += (r - t) / 12, t === 1 ? zs(e) ? 29 : 28 : 31 - t % 7 % 2;
}
de("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
de("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
de("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
oe("M", qe, qa);
oe("MM", qe, qt);
oe("MMM", function(e, r) {
  return r.monthsShortRegex(e);
});
oe("MMMM", function(e, r) {
  return r.monthsRegex(e);
});
ze(["M", "MM"], function(e, r) {
  r[jt] = Ce(e) - 1;
});
ze(["MMM", "MMMM"], function(e, r, t, n) {
  var a = t._locale.monthsParse(e, n, t._strict);
  a != null ? r[jt] = a : we(t).invalidMonth = e;
});
var tk = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), Bg = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), Vg = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, rk = ei, nk = ei, Af = [
  "monthsParse",
  "longMonthsParse",
  "shortMonthsParse",
  "monthsRegex",
  "monthsShortRegex",
  "monthsStrictRegex",
  "monthsShortStrictRegex"
];
function ak(e, r) {
  var t, n;
  for (t = 0; t < Af.length; t++)
    n = Af[t], Se(r, n) || delete e["_" + n];
}
function ok(e, r) {
  return e ? yr(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Vg).test(r) ? "format" : "standalone"][e.month()] : yr(this._months) ? this._months : this._months.standalone;
}
function ik(e, r) {
  return e ? yr(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Vg.test(r) ? "format" : "standalone"][e.month()] : yr(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function sk(e, r, t) {
  var n, a, o, i = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n)
      o = zr([2e3, n]), this._shortMonthsParse[n] = this.monthsShort(
        o,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[n] = this.months(o, "").toLocaleLowerCase();
  return t ? r === "MMM" ? (a = dt.call(this._shortMonthsParse, i), a !== -1 ? a : null) : (a = dt.call(this._longMonthsParse, i), a !== -1 ? a : null) : r === "MMM" ? (a = dt.call(this._shortMonthsParse, i), a !== -1 ? a : (a = dt.call(this._longMonthsParse, i), a !== -1 ? a : null)) : (a = dt.call(this._longMonthsParse, i), a !== -1 ? a : (a = dt.call(this._shortMonthsParse, i), a !== -1 ? a : null));
}
function lk(e, r, t) {
  var n, a, o;
  if (this._monthsParseExact)
    return sk.call(this, e, r, t);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n = 0; n < 12; n++) {
    if (a = zr([2e3, n]), t && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp(
      "^" + this.months(a, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[n] = new RegExp(
      "^" + this.monthsShort(a, "").replace(".", "") + "$",
      "i"
    )), !t && !this._monthsParse[n] && (o = "^" + this.months(a, "") + "|^" + this.monthsShort(a, ""), this._monthsParse[n] = new RegExp(o.replace(".", ""), "i")), t && r === "MMMM" && this._longMonthsParse[n].test(e))
      return n;
    if (t && r === "MMM" && this._shortMonthsParse[n].test(e))
      return n;
    if (!t && this._monthsParse[n].test(e))
      return n;
  }
}
function Gg(e, r) {
  if (!e.isValid())
    return e;
  if (typeof r == "string") {
    if (/^\d+$/.test(r))
      r = Ce(r);
    else if (r = e.localeData().monthsParse(r), !cn(r))
      return e;
  }
  var t = r, n = e.date();
  return n = n < 29 ? n : Math.min(n, bc(e.year(), t)), e._isUTC ? e._d.setUTCMonth(t, n) : e._d.setMonth(t, n), e;
}
function Yg(e) {
  return e != null ? (Gg(this, e), J.updateOffset(this, !0), this) : Fo(this, "Month");
}
function uk() {
  return bc(this.year(), this.month());
}
function ck(e) {
  return this._monthsParseExact ? (Se(this, "_monthsRegex") || Hg.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (Se(this, "_monthsShortRegex") || (this._monthsShortRegex = rk), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function dk(e) {
  return this._monthsParseExact ? (Se(this, "_monthsRegex") || Hg.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (Se(this, "_monthsRegex") || (this._monthsRegex = nk), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function Hg() {
  function e(l, u) {
    return u.length - l.length;
  }
  var r = [], t = [], n = [], a, o, i, s;
  for (a = 0; a < 12; a++)
    o = zr([2e3, a]), i = nn(this.monthsShort(o, "")), s = nn(this.months(o, "")), r.push(i), t.push(s), n.push(s), n.push(i);
  r.sort(e), t.sort(e), n.sort(e), this._monthsRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
de("d", 0, "do", "day");
de("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
de("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
de("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
de("e", 0, 0, "weekday");
de("E", 0, 0, "isoWeekday");
de("eHHmm", 0, 0, function() {
  return "" + this.weekday() + fr(this.hours(), 2) + fr(this.minutes(), 2);
});
oe("d", qe);
oe("e", qe);
oe("E", qe);
oe("eHHmm", gc);
oe("dd", function(e, r) {
  return r.weekdaysMinRegex(e);
});
oe("ddd", function(e, r) {
  return r.weekdaysShortRegex(e);
});
oe("dddd", function(e, r) {
  return r.weekdaysRegex(e);
});
Ka(["dd", "ddd", "dddd"], function(e, r, t, n) {
  var a = t._locale.weekdaysParse(e, n, t._strict);
  a != null ? r.d = a : we(t).invalidWeekday = e;
});
Ka(["d", "e", "E"], function(e, r, t, n) {
  r[n] = Ce(e);
});
Ka("eHHmm", function(e, r, t) {
  var n = e.length - 4;
  r.e = Ce(e.substr(0, n)), t._a[vt] = Ce(e.substr(n, 2)), t._a[or] = Ce(e.substr(n + 2));
});
function fk(e, r) {
  return typeof e != "string" ? e : isNaN(e) ? (e = r.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function pk(e, r) {
  return typeof e == "string" ? r.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function yc(e, r) {
  return e.slice(r, 7).concat(e.slice(0, r));
}
var hk = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), zg = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), gk = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), mk = ei, vk = ei, bk = ei, Rf = [
  "weekdaysParse",
  "fullWeekdaysParse",
  "shortWeekdaysParse",
  "minWeekdaysParse",
  "weekdaysRegex",
  "weekdaysShortRegex",
  "weekdaysMinRegex",
  "weekdaysStrictRegex",
  "weekdaysShortStrictRegex",
  "weekdaysMinStrictRegex"
];
function yk(e, r) {
  var t, n;
  for (t = 0; t < Rf.length; t++)
    n = Rf[t], Se(r, n) || delete e["_" + n];
}
function wk(e, r) {
  var t = yr(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(r) ? "format" : "standalone"];
  return e === !0 ? yc(t, this._week.dow) : e ? t[e.day()] : t;
}
function Ck(e) {
  return e === !0 ? yc(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function xk(e) {
  return e === !0 ? yc(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function Sk(e, r, t) {
  var n, a, o, i = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n)
      o = zr([2e3, 1]).day(n), this._minWeekdaysParse[n] = this.weekdaysMin(
        o,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[n] = this.weekdaysShort(
        o,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[n] = this.weekdays(o, "").toLocaleLowerCase();
  return t ? r === "dddd" ? (a = dt.call(this._weekdaysParse, i), a !== -1 ? a : null) : r === "ddd" ? (a = dt.call(this._shortWeekdaysParse, i), a !== -1 ? a : null) : (a = dt.call(this._minWeekdaysParse, i), a !== -1 ? a : null) : r === "dddd" ? (a = dt.call(this._weekdaysParse, i), a !== -1 || (a = dt.call(this._shortWeekdaysParse, i), a !== -1) ? a : (a = dt.call(this._minWeekdaysParse, i), a !== -1 ? a : null)) : r === "ddd" ? (a = dt.call(this._shortWeekdaysParse, i), a !== -1 || (a = dt.call(this._weekdaysParse, i), a !== -1) ? a : (a = dt.call(this._minWeekdaysParse, i), a !== -1 ? a : null)) : (a = dt.call(this._minWeekdaysParse, i), a !== -1 || (a = dt.call(this._weekdaysParse, i), a !== -1) ? a : (a = dt.call(this._shortWeekdaysParse, i), a !== -1 ? a : null));
}
function Ik(e, r, t) {
  var n, a, o;
  if (this._weekdaysParseExact)
    return Sk.call(this, e, r, t);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n = 0; n < 7; n++) {
    if (a = zr([2e3, 1]).day(n), t && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp(
      "^" + this.weekdays(a, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysShort(a, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysMin(a, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[n] || (o = "^" + this.weekdays(a, "") + "|^" + this.weekdaysShort(a, "") + "|^" + this.weekdaysMin(a, ""), this._weekdaysParse[n] = new RegExp(o.replace(".", ""), "i")), t && r === "dddd" && this._fullWeekdaysParse[n].test(e))
      return n;
    if (t && r === "ddd" && this._shortWeekdaysParse[n].test(e))
      return n;
    if (t && r === "dd" && this._minWeekdaysParse[n].test(e))
      return n;
    if (!t && this._weekdaysParse[n].test(e))
      return n;
  }
}
function Dk(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var r = Fo(this, "Day");
  return e != null ? (e = fk(e, this.localeData()), this.add(e - r, "d")) : r;
}
function _k(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var r = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? r : this.add(e - r, "d");
}
function kk(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var r = pk(e, this.localeData());
    return this.day(this.day() % 7 ? r : r - 7);
  } else
    return this.day() || 7;
}
function Ek(e) {
  return this._weekdaysParseExact ? (Se(this, "_weekdaysRegex") || wc.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (Se(this, "_weekdaysRegex") || (this._weekdaysRegex = mk), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function Mk(e) {
  return this._weekdaysParseExact ? (Se(this, "_weekdaysRegex") || wc.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (Se(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = vk), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function Pk(e) {
  return this._weekdaysParseExact ? (Se(this, "_weekdaysRegex") || wc.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (Se(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = bk), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function wc() {
  function e(c, d) {
    return d.length - c.length;
  }
  var r = [], t = [], n = [], a = [], o, i, s, l, u;
  for (o = 0; o < 7; o++)
    i = zr([2e3, 1]).day(o), s = nn(this.weekdaysMin(i, "")), l = nn(this.weekdaysShort(i, "")), u = nn(this.weekdays(i, "")), r.push(s), t.push(l), n.push(u), a.push(s), a.push(l), a.push(u);
  r.sort(e), t.sort(e), n.sort(e), a.sort(e), this._weekdaysRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
function Ak(e) {
  var r, t;
  ak(this, e), yk(this, e);
  for (t in e)
    Se(e, t) && (r = e[t], $r(r) ? this[t] = r : this["_" + t] = r);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function wu(e, r) {
  var t = Or({}, e), n;
  for (n in r)
    Se(r, n) && (zn(e[n]) && zn(r[n]) ? (t[n] = {}, Or(t[n], e[n]), Or(t[n], r[n])) : r[n] != null ? t[n] = r[n] : delete t[n]);
  for (n in e)
    Se(e, n) && !Se(r, n) && zn(e[n]) && (t[n] = Or({}, t[n]));
  return t;
}
function Cc(e) {
  e != null && this.set(e);
}
var Cu;
Object.keys ? Cu = Object.keys : Cu = function(e) {
  var r, t = [];
  for (r in e)
    Se(e, r) && t.push(r);
  return t;
};
var Rk = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function Ok(e, r, t) {
  var n = this._calendar[e] || this._calendar.sameElse;
  return $r(n) ? n.call(r, t) : n;
}
var Tk = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function Fk(e) {
  var r = this._longDateFormat[e], t = this._longDateFormat[e.toUpperCase()], n = this._longDateFormatCache;
  return r || !t ? r : n && n[e] && n[e].formatUpper === t ? n[e].format : (r = t.match(pc).map(function(a) {
    return a === "MMMM" || a === "MM" || a === "DD" || a === "dddd" ? a.slice(1) : a;
  }).join(""), n || (n = this._longDateFormatCache = {}), n[e] = {
    formatUpper: t,
    format: r
  }, r);
}
var Nk = "Invalid date";
function Lk() {
  return this._invalidDate;
}
var Wk = "%d", Bk = /\d{1,2}/;
function Vk(e) {
  return this._ordinal.replace("%d", e);
}
var Gk = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function $g(e, r, t, n) {
  var a = this._relativeTime[t];
  return $r(a) ? a(e, r, t, n) : a.replace(/%d/i, e);
}
function Yk(e, r, t, n) {
  return this.postformat(
    $g.call(
      this,
      e,
      r,
      t,
      n
    )
  );
}
function Xg(e, r) {
  var t = this._relativeTime[e > 0 ? "future" : "past"];
  return $r(t) ? t(r) : t.replace(/%s/i, r);
}
function Hk(e, r) {
  return this.postformat(
    Xg.call(this, e, r)
  );
}
function zk(e, r, t, n, a, o, i) {
  var s;
  return e < 100 && e >= 0 ? (s = new Date(e + 400, r, t, n, a, o, i), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, r, t, n, a, o, i), s;
}
function qn(e) {
  var r, t;
  return e < 100 && e >= 0 ? (t = Array.prototype.slice.call(arguments), t[0] = e + 400, r = new Date(Date.UTC.apply(null, t)), isFinite(r.getUTCFullYear()) && r.setUTCFullYear(e)) : r = new Date(Date.UTC.apply(null, arguments)), r;
}
function ls(e, r, t) {
  var n = 7 + r - t, a = (7 + qn(e, 0, n).getUTCDay() - r) % 7;
  return -a + n - 1;
}
function jg(e, r, t, n, a) {
  var o = (7 + t - n) % 7, i = ls(e, n, a), s = 1 + 7 * (r - 1) + o + i, l, u;
  return s <= 0 ? (l = e - 1, u = ko(l) + s) : s > ko(e) ? (l = e + 1, u = s - ko(e)) : (l = e, u = s), {
    year: l,
    dayOfYear: u
  };
}
function Zg(e, r, t, n) {
  var a = ls(e, t, n), o = Math.floor((r - a - 1) / 7) + 1, i, s;
  return o < 1 ? (s = e - 1, i = o + an(s, t, n)) : o > an(e, t, n) ? (i = o - an(e, t, n), s = e + 1) : (s = e, i = o), {
    week: i,
    year: s
  };
}
function xc(e, r, t) {
  return Zg(e.year(), e.dayOfYear(), r, t);
}
function Of(e, r, t, n, a) {
  var o = Math.round(
    (qn(e, r, t) - qn(e, 0, 1)) / 864e5
  ) + 1;
  return Zg(e, o, n, a);
}
function an(e, r, t) {
  var n = ls(e, r, t), a = ls(e + 1, r, t);
  return (ko(e) - n + a) / 7;
}
de("w", ["ww", 2], "wo", "week");
de("W", ["WW", 2], "Wo", "isoWeek");
oe("w", qe, qa);
oe("ww", qe, qt);
oe("W", qe, qa);
oe("WW", qe, qt);
Ka(
  ["w", "ww", "W", "WW"],
  function(e, r, t, n) {
    r[n.substr(0, 1)] = Ce(e);
  }
);
function $k(e) {
  return xc(e, this._week.dow, this._week.doy).week;
}
var Xk = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function jk() {
  return this._week.dow;
}
function Zk() {
  return this._week.doy;
}
function Uk(e) {
  var r = this.localeData().week(this);
  return e == null ? r : this.add((e - r) * 7, "d");
}
function Jk(e) {
  var r = xc(this, 1, 4).week;
  return e == null ? r : this.add((e - r) * 7, "d");
}
function Sc() {
  return this.hours() % 12 || 12;
}
function Qk() {
  return this.hours() || 24;
}
de("H", ["HH", 2], 0, "hour");
de("h", ["hh", 2], 0, Sc);
de("k", ["kk", 2], 0, Qk);
de("hmm", 0, 0, function() {
  return "" + Sc.apply(this) + fr(this.minutes(), 2);
});
de("hmmss", 0, 0, function() {
  return "" + Sc.apply(this) + fr(this.minutes(), 2) + fr(this.seconds(), 2);
});
de("Hmm", 0, 0, function() {
  return "" + this.hours() + fr(this.minutes(), 2);
});
de("Hmmss", 0, 0, function() {
  return "" + this.hours() + fr(this.minutes(), 2) + fr(this.seconds(), 2);
});
function Ug(e, r) {
  de(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      r
    );
  });
}
Ug("a", !0);
Ug("A", !1);
function Jg(e, r) {
  return r._meridiemParse;
}
oe("a", Jg);
oe("A", Jg);
oe("H", qe, vc);
oe("h", qe, qa);
oe("k", qe, qa);
oe("HH", qe, qt);
oe("hh", qe, qt);
oe("kk", qe, qt);
oe("hmm", Ng);
oe("hmmss", gc);
oe("Hmm", Ng);
oe("Hmmss", gc);
ze(["H", "HH"], vt);
ze(["k", "kk"], function(e, r, t) {
  var n = Ce(e);
  r[vt] = n === 24 ? 0 : n;
});
ze(["a", "A"], function(e, r, t) {
  t._isPm = t._locale.isPM(e), t._meridiem = e;
});
ze(["h", "hh"], function(e, r, t) {
  r[vt] = Ce(e), we(t).bigHour = !0;
});
ze("hmm", function(e, r, t) {
  var n = e.length - 2;
  r[vt] = Ce(e.substr(0, n)), r[or] = Ce(e.substr(n)), we(t).bigHour = !0;
});
ze("hmmss", function(e, r, t) {
  var n = e.length - 4, a = e.length - 2;
  r[vt] = Ce(e.substr(0, n)), r[or] = Ce(e.substr(n, 2)), r[tn] = Ce(e.substr(a)), we(t).bigHour = !0;
});
ze("Hmm", function(e, r, t) {
  var n = e.length - 2;
  r[vt] = Ce(e.substr(0, n)), r[or] = Ce(e.substr(n));
});
ze("Hmmss", function(e, r, t) {
  var n = e.length - 4, a = e.length - 2;
  r[vt] = Ce(e.substr(0, n)), r[or] = Ce(e.substr(n, 2)), r[tn] = Ce(e.substr(a));
});
function qk(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var Kk = /[ap]\.?m?\.?/i, eE = eo("Hours", !0);
function tE(e, r, t) {
  return e > 11 ? t ? "pm" : "PM" : t ? "am" : "AM";
}
var Qg = {
  calendar: Rk,
  longDateFormat: Tk,
  invalidDate: Nk,
  ordinal: Wk,
  dayOfMonthOrdinalParse: Bk,
  relativeTime: Gk,
  months: tk,
  monthsShort: Bg,
  week: Xk,
  weekdays: hk,
  weekdaysMin: gk,
  weekdaysShort: zg,
  meridiemParse: Kk
}, Ye = {}, co = {}, No;
function rE(e, r) {
  var t, n = Math.min(e.length, r.length);
  for (t = 0; t < n; t += 1)
    if (e[t] !== r[t])
      return t;
  return n;
}
function xu(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function nE(e) {
  for (var r = 0, t, n, a, o; r < e.length; ) {
    for (o = xu(e[r]).split("-"), t = o.length, n = xu(e[r + 1]), n = n ? n.split("-") : null; t > 0; ) {
      if (a = $s(o.slice(0, t).join("-")), a)
        return a;
      if (n && n.length >= t && rE(o, n) >= t - 1)
        break;
      t--;
    }
    r++;
  }
  return No;
}
function aE(e) {
  return typeof e == "string" && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(e);
}
function $s(e) {
  var r = null, t, n;
  if (Se(Ye, e))
    return Ye[e];
  if (n = xu(e), Se(Ye, n))
    return Ye[n];
  if (typeof module < "u" && module && module.exports && aE(n))
    try {
      r = No._abbr, t = require, t("./locale/" + n), In(r);
    } catch {
      Ye[n] = null;
    }
  if (Se(Ye, n))
    return Ye[n];
}
function In(e, r) {
  var t;
  return e && (Tt(r) ? t = pn(e) : t = Ic(e, r), t ? No = t : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), No._abbr;
}
function Ic(e, r) {
  if (r !== null) {
    var t, n = Qg;
    if (r.abbr = e, Ye[e] != null)
      Rg(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), n = Ye[e]._config;
    else if (r.parentLocale != null)
      if (Ye[r.parentLocale] != null)
        n = Ye[r.parentLocale]._config;
      else if (t = $s(r.parentLocale), t != null)
        n = t._config;
      else
        return co[r.parentLocale] || (co[r.parentLocale] = []), co[r.parentLocale].push({
          name: e,
          config: r
        }), null;
    return Ye[e] = new Cc(wu(n, r)), co[e] && co[e].forEach(function(a) {
      Ic(a.name, a.config);
    }), In(e), Ye[e];
  } else
    return delete Ye[e], null;
}
function oE(e, r) {
  var t, n = $s(e), a = Qg;
  return n != null && (e = n._abbr), r != null ? (Ye[e] != null && Ye[e].parentLocale != null ? Ye[e].set(wu(Ye[e]._config, r)) : (n != null && (a = n._config), r = wu(a, r), n == null && (r.abbr = e), t = new Cc(r), t.parentLocale = Ye[e], Ye[e] = t), In(e)) : Ye[e] != null && (Ye[e].parentLocale != null ? (Ye[e] = Ye[e].parentLocale, e === In() && In(e)) : Ye[e] != null && delete Ye[e]), Ye[e];
}
function pn(e) {
  var r;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return No;
  if (!yr(e)) {
    if (r = $s(e), r)
      return r;
    e = [e];
  }
  return nE(e);
}
function iE() {
  return Cu(Ye);
}
function Dc(e) {
  var r, t = e._a;
  return t && we(e).overflow === -2 && (r = t[jt] < 0 || t[jt] > 11 ? jt : t[Ft] < 1 || t[Ft] > bc(t[ft], t[jt]) ? Ft : t[vt] < 0 || t[vt] > 24 || t[vt] === 24 && (t[or] !== 0 || t[tn] !== 0 || t[Vn] !== 0) ? vt : t[or] < 0 || t[or] > 59 ? or : t[tn] < 0 || t[tn] > 59 ? tn : t[Vn] < 0 || t[Vn] > 999 ? Vn : -1, we(e)._overflowDayOfYear && (r < ft || r > Ft) && (r = Ft), we(e)._overflowWeeks && r === -1 && (r = U_), we(e)._overflowWeekday && r === -1 && (r = J_), we(e).overflow = r), e;
}
var sE = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, lE = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, uE = /Z|[+-]\d\d(?::?\d\d)?/, vi = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], Ol = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], cE = /^\/?Date\((-?\d+)/i, dE = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, fE = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function qg(e) {
  var r, t, n = e._i, a = sE.exec(n) || lE.exec(n), o, i, s, l, u = vi.length, c = Ol.length;
  if (a) {
    for (we(e).iso = !0, r = 0, t = u; r < t; r++)
      if (vi[r][1].exec(a[1])) {
        i = vi[r][0], o = vi[r][2] !== !1;
        break;
      }
    if (i == null) {
      e._isValid = !1;
      return;
    }
    if (a[3]) {
      for (r = 0, t = c; r < t; r++)
        if (Ol[r][1].exec(a[3])) {
          s = (a[2] || " ") + Ol[r][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!o && s != null) {
      e._isValid = !1;
      return;
    }
    if (a[4])
      if (uE.exec(a[4]))
        l = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = i + (s || "") + (l || ""), kc(e);
  } else
    e._isValid = !1;
}
function pE(e, r, t, n, a, o) {
  var i = [
    hE(e),
    Bg.indexOf(r),
    parseInt(t, 10),
    parseInt(n, 10),
    parseInt(a, 10)
  ];
  return o && i.push(parseInt(o, 10)), i;
}
function hE(e) {
  var r = parseInt(e, 10);
  return r <= 49 ? 2e3 + r : r <= 999 ? 1900 + r : r;
}
function gE(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function mE(e, r, t) {
  if (e) {
    var n = zg.indexOf(e), a = new Date(
      r[0],
      r[1],
      r[2]
    ).getDay();
    if (n !== a)
      return we(t).weekdayMismatch = !0, t._isValid = !1, !1;
  }
  return !0;
}
function vE(e, r, t) {
  if (e)
    return fE[e];
  if (r)
    return 0;
  var n = parseInt(t, 10), a = n % 100, o = (n - a) / 100;
  return o * 60 + a;
}
function Kg(e) {
  var r = dE.exec(gE(e._i)), t;
  if (r) {
    if (t = pE(
      r[4],
      r[3],
      r[2],
      r[5],
      r[6],
      r[7]
    ), !mE(r[1], t, e))
      return;
    e._a = t, e._tzm = vE(r[8], r[9], r[10]), e._d = qn.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), we(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function bE(e) {
  var r = cE.exec(e._i);
  if (r !== null) {
    e._d = /* @__PURE__ */ new Date(+r[1]);
    return;
  }
  if (qg(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (Kg(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : J.createFromInputFallback(e);
}
J.createFromInputFallback = hr(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function fo(e, r, t) {
  return e ?? r ?? t;
}
function Tf(e, r, t) {
  var n = Object.prototype.hasOwnProperty.call(
    e,
    "_isDefaultDatePartsForWeek"
  ), a = e._isDefaultDatePartsForWeek;
  e._isDefaultDatePartsForWeek = !!t;
  try {
    return J._getDefaultDateParts(e, r, t);
  } finally {
    n ? e._isDefaultDatePartsForWeek = a : delete e._isDefaultDatePartsForWeek;
  }
}
function yE(e) {
  var r = e._defaultDatePartsNow;
  return r ? (r.hasValue || (r.value = J.now(), r.hasValue = !0), r.value) : J.now();
}
function wE(e, r, t) {
  var n = t || e._isDefaultDatePartsForWeek, a = n ? tt(r) : new Date(r);
  return n ? [a.year(), a.month(), a.date()] : e._useUTC ? [
    a.getUTCFullYear(),
    a.getUTCMonth(),
    a.getUTCDate()
  ] : [a.getFullYear(), a.getMonth(), a.getDate()];
}
J._getDefaultDateParts = wE;
function _c(e) {
  var r, t, n = [], a, o, i, s, l;
  if (!e._d) {
    for ((e._a[ft] == null || e._a[jt] == null || e._a[Ft] == null) && (a = yE(e), o = Tf(e, a)), e._w && e._a[Ft] == null && e._a[jt] == null && CE(e, Tf(e, a, !0)), e._dayOfYear != null && (s = e._a[ft] != null ? e._a[ft] : o[ft], (e._dayOfYear > ko(s) || e._dayOfYear === 0) && (we(e)._overflowDayOfYear = !0), t = qn(s, 0, e._dayOfYear), e._a[jt] = t.getUTCMonth(), e._a[Ft] = t.getUTCDate()), l = e._a[ft] == null || e._a[jt] == null || e._a[Ft] == null, r = 0; r < 3 && e._a[r] == null; ++r)
      e._a[r] = n[r] = o[r];
    for (; r < 7; r++)
      e._a[r] = n[r] = e._a[r] == null ? r === 2 ? 1 : 0 : e._a[r];
    e._a[vt] === 24 && e._a[or] === 0 && e._a[tn] === 0 && e._a[Vn] === 0 && (e._nextDay = !0, e._a[vt] = 0), e._d = (e._useUTC ? qn : zk).apply(
      null,
      n
    ), i = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[vt] = 24), e._w && typeof e._w.d < "u" && !l && e._w.d !== i && (we(e).weekdayMismatch = !0);
  }
}
function CE(e, r) {
  var t, n, a, o, i, s, l, u, c;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (i = 1, s = 4, n = fo(
    t.GG,
    e._a[ft],
    Of(
      r[ft],
      r[jt],
      r[Ft],
      1,
      4
    ).year
  ), a = fo(t.W, 1), o = fo(t.E, 1), (o < 1 || o > 7) && (u = !0)) : (i = e._locale._week.dow, s = e._locale._week.doy, c = Of(
    r[ft],
    r[jt],
    r[Ft],
    i,
    s
  ), n = fo(t.gg, e._a[ft], c.year), a = fo(t.w, c.week), t.d != null ? (o = t.d, (o < 0 || o > 6) && (u = !0)) : t.e != null ? (o = t.e + i, (t.e < 0 || t.e > 6) && (u = !0)) : o = i), a < 1 || a > an(n, i, s) ? we(e)._overflowWeeks = !0 : u != null ? we(e)._overflowWeekday = !0 : (l = jg(n, a, o, i, s), e._a[ft] = l.year, e._dayOfYear = l.dayOfYear);
}
J.ISO_8601 = function() {
};
J.RFC_2822 = function() {
};
function kc(e) {
  if (e._f === J.ISO_8601) {
    qg(e);
    return;
  }
  if (e._f === J.RFC_2822) {
    Kg(e);
    return;
  }
  e._a = [], we(e).empty = !0;
  var r = "" + e._i, t, n, a, o, i, s = r.length, l = 0, u, c;
  for (a = Og(e._f, e._locale).match(pc) || [], c = a.length, t = 0; t < c; t++)
    o = a[t], n = (r.match(X_(o, e)) || [])[0], n && (i = r.substr(0, r.indexOf(n)), i.length > 0 && we(e).unusedInput.push(i), r = r.slice(
      r.indexOf(n) + n.length
    ), l += n.length), _a[o] ? (n ? we(e).empty = !1 : we(e).unusedTokens.push(o), Z_(o, n, e)) : e._strict && !n && we(e).unusedTokens.push(o);
  we(e).charsLeftOver = s - l, r.length > 0 && we(e).unusedInput.push(r), e._a[vt] <= 12 && we(e).bigHour === !0 && e._a[vt] > 0 && (we(e).bigHour = void 0), we(e).parsedDateParts = e._a.slice(0), we(e).meridiem = e._meridiem, e._a[vt] = xE(
    e._locale,
    e._a[vt],
    e._meridiem
  ), u = we(e).era, u !== null && (e._a[ft] = e._locale.erasConvertYear(u, e._a[ft])), _c(e), Dc(e);
}
function xE(e, r, t) {
  var n;
  return t == null ? r : e.meridiemHour != null ? e.meridiemHour(r, t) : (e.isPM != null && (n = e.isPM(t), n && r < 12 && (r += 12), !n && r === 12 && (r = 0)), r);
}
function SE(e) {
  var r, t, n, a, o, i, s = !1, l = {}, u = e._f.length;
  if (u === 0) {
    we(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (a = 0; a < u; a++)
    o = 0, i = !1, r = dc({}, e), e._useUTC != null && (r._useUTC = e._useUTC), r._defaultDatePartsNow = l, r._f = e._f[a], kc(r), cc(r) && (i = !0), o += we(r).charsLeftOver, o += we(r).unusedTokens.length * 10, we(r).score = o, s ? o < n && (n = o, t = r) : (n == null || o < n || i) && (n = o, t = r, i && (s = !0));
  Or(e, t || r);
}
function IE(e) {
  if (!e._d) {
    var r = fc(e._i), t = r.day === void 0 ? r.date : r.day;
    e._a = Pg(
      [r.year, r.month, t, r.hour, r.minute, r.second, r.millisecond],
      function(n) {
        return n && parseInt(n, 10);
      }
    ), _c(e);
  }
}
function DE(e) {
  var r = new Ko(Dc(em(e)));
  return r._nextDay && (r.add(1, "d"), r._nextDay = void 0), r;
}
function em(e) {
  var r = e._i, t = e._f;
  return e._locale = e._locale || pn(e._l), r === null || t === void 0 && r === "" ? qo({ nullInput: !0 }) : (typeof r == "string" && (e._i = r = e._locale.preparse(r)), Jt(r) ? new Ko(Dc(r)) : (Qo(r) ? e._d = r : yr(t) ? SE(e) : t ? kc(e) : _E(e), cc(e) || (e._d = null), e));
}
function _E(e) {
  var r = e._i;
  Tt(r) ? e._d = new Date(J.now()) : Qo(r) ? e._d = new Date(r.valueOf()) : typeof r == "string" ? bE(e) : yr(r) ? (e._a = Pg(r.slice(0), function(t) {
    return parseInt(t, 10);
  }), _c(e)) : zn(r) ? IE(e) : cn(r) ? e._d = new Date(r) : J.createFromInputFallback(e);
}
function tm(e, r, t, n, a) {
  var o = {};
  return (r === !0 || r === !1) && (n = r, r = void 0), (t === !0 || t === !1) && (n = t, t = void 0), (zn(e) && uc(e) || yr(e) && e.length === 0) && (e = void 0), o._isAMomentObject = !0, o._useUTC = o._isUTC = a, o._l = t, o._i = e, o._f = r, o._strict = n, DE(o);
}
function tt(e, r, t, n) {
  return tm(e, r, t, n, !1);
}
var kE = hr(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = tt.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : qo();
  }
), EE = hr(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = tt.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : qo();
  }
);
function rm(e, r) {
  var t, n;
  if (r.length === 1 && yr(r[0]) && (r = r[0]), !r.length)
    return tt();
  for (n = 0; n < r.length; ++n)
    if (Jt(r[n])) {
      t = r[n];
      break;
    }
  if (!t)
    return qo();
  for (++n; n < r.length; ++n)
    Jt(r[n]) && (!r[n].isValid() || r[n][e](t)) && (t = r[n]);
  return t;
}
function ME() {
  var e = [].slice.call(arguments, 0);
  return rm("isBefore", e);
}
function PE() {
  var e = [].slice.call(arguments, 0);
  return rm("isAfter", e);
}
var AE = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, po = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function RE(e) {
  var r, t = !1, n, a = po.length;
  for (r in e)
    if (Se(e, r) && !(dt.call(po, r) !== -1 && (e[r] == null || !isNaN(e[r]))))
      return !1;
  for (n = 0; n < a; ++n)
    if (e[po[n]]) {
      if (t)
        return !1;
      parseFloat(e[po[n]]) !== Ce(e[po[n]]) && (t = !0);
    }
  return !0;
}
function OE() {
  return this._isValid;
}
function TE() {
  return Sr(NaN);
}
function Xs(e) {
  var r = fc(e), t = r.year || 0, n = r.quarter || 0, a = r.month || 0, o = r.week || r.isoWeek || 0, i = r.day || 0, s = r.hour || 0, l = r.minute || 0, u = r.second || 0, c = r.millisecond || 0;
  this._isValid = RE(r), this._milliseconds = +c + u * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +i + o * 7, this._months = +a + n * 3 + t * 12, this._data = {}, this._locale = pn(), this._bubble();
}
function Oi(e) {
  return e instanceof Xs;
}
function Su(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function FE(e, r, t) {
  var n = Math.min(e.length, r.length), a = Math.abs(e.length - r.length), o = 0, i;
  for (i = 0; i < n; i++)
    Ce(e[i]) !== Ce(r[i]) && o++;
  return o + a;
}
function nm(e, r) {
  de(e, 0, 0, function() {
    var t = this.utcOffset(), n = "+";
    return t < 0 && (t = -t, n = "-"), n + fr(~~(t / 60), 2) + r + fr(~~t % 60, 2);
  });
}
nm("Z", ":");
nm("ZZ", "");
oe("Z", Hs);
oe("ZZ", Hs);
ze(["Z", "ZZ"], function(e, r, t) {
  var n = Ec(Hs, e);
  t._useUTC = !0, t._tzm = n, n === null && (we(t).invalidOffset = e);
});
var NE = /([\+\-]|\d\d)/gi;
function Ec(e, r) {
  var t = (r || "").match(e), n, a, o;
  return t === null || (n = t[t.length - 1] || [], a = (n + "").match(NE) || ["-", 0, 0], o = +(a[1] * 60) + Ce(a[2]), Ce(a[2]) > 59 || (a[0] === "+" ? o > 14 * 60 : o > 12 * 60)) ? null : o === 0 ? 0 : a[0] === "+" ? o : -o;
}
function Mc(e, r) {
  var t, n;
  return r._isUTC ? (t = r.clone(), n = (Jt(e) || Qo(e) ? e.valueOf() : tt(e).valueOf()) - t.valueOf(), t._d.setTime(t._d.valueOf() + n), J.updateOffset(t, !1), t) : tt(e).local();
}
function Iu(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
J.updateOffset = function() {
};
function LE(e, r, t) {
  var n = this._offset || 0, a;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = Ec(Hs, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !t && (e = e * 60);
    return !this._isUTC && r && (a = Iu(this)), this._offset = e, this._isUTC = !0, a != null && this.add(a, "m"), n !== e && (!r || this._changeInProgress ? im(
      this,
      Sr(e - n, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, J.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? n : Iu(this);
}
function WE(e, r) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, r), this) : -this.utcOffset();
}
function BE(e) {
  return this.utcOffset(0, e);
}
function VE(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Iu(this), "m")), this;
}
function GE() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = Ec(z_, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function YE(e) {
  return this.isValid() ? (e = e ? tt(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function HE() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function zE() {
  if (!Tt(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, r;
  return dc(e, this), e = em(e), e._a ? (r = e._isUTC ? zr(e._a) : tt(e._a), this._isDSTShifted = this.isValid() && FE(e._a, r.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function $E() {
  return this.isValid() ? !this._isUTC : !1;
}
function XE() {
  return this.isValid() ? this._isUTC : !1;
}
function am() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var jE = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, ZE = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function Sr(e, r) {
  var t = e, n = null, a, o, i;
  return Oi(e) ? t = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : cn(e) || !isNaN(+e) ? (t = {}, r ? t[r] = +e : t.milliseconds = +e) : (n = jE.exec(e)) ? (a = n[1] === "-" ? -1 : 1, t = {
    y: 0,
    d: Ce(n[Ft]) * a,
    h: Ce(n[vt]) * a,
    m: Ce(n[or]) * a,
    s: Ce(n[tn]) * a,
    ms: Ce(Su(n[Vn] * 1e3)) * a
    // the millisecond decimal point is included in the match
  }) : (n = ZE.exec(e)) ? (a = n[1] === "-" ? -1 : 1, t = {
    y: Fn(n[2], a),
    M: Fn(n[3], a),
    w: Fn(n[4], a),
    d: Fn(n[5], a),
    h: Fn(n[6], a),
    m: Fn(n[7], a),
    s: Fn(n[8], a)
  }) : t == null ? t = {} : typeof t == "object" && ("from" in t || "to" in t) && (i = UE(
    tt(t.from),
    tt(t.to)
  ), t = {}, t.ms = i.milliseconds, t.M = i.months), o = new Xs(t), Oi(e) && Se(e, "_locale") && (o._locale = e._locale), Oi(e) && Se(e, "_isValid") && (o._isValid = e._isValid), o;
}
Sr.fn = Xs.prototype;
Sr.invalid = TE;
function Fn(e, r) {
  var t = e && parseFloat(e.replace(",", "."));
  return (isNaN(t) ? 0 : t) * r;
}
function Ff(e, r) {
  var t = {};
  return t.months = r.month() - e.month() + (r.year() - e.year()) * 12, e.clone().add(t.months, "M").isAfter(r) && --t.months, t.milliseconds = +r - +e.clone().add(t.months, "M"), t;
}
function UE(e, r) {
  var t;
  return e.isValid() && r.isValid() ? (r = Mc(r, e), e.isBefore(r) ? t = Ff(e, r) : (t = Ff(r, e), t.milliseconds = -t.milliseconds, t.months = -t.months), t) : { milliseconds: 0, months: 0 };
}
function om(e, r) {
  return function(t, n) {
    var a, o;
    return n !== null && !isNaN(+n) && (Rg(
      r,
      "moment()." + r + "(period, number) is deprecated. Please use moment()." + r + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), o = t, t = n, n = o), a = Sr(t, n), im(this, a, e), this;
  };
}
function im(e, r, t, n) {
  var a = r._milliseconds, o = Su(r._days), i = Su(r._months);
  e.isValid() && (n = n ?? !0, i && Gg(e, Fo(e, "Month") + i * t), o && Wg(e, "Date", Fo(e, "Date") + o * t), a && e._d.setTime(e._d.valueOf() + a * t), n && J.updateOffset(e, o || i));
}
var JE = om(1, "add"), QE = om(-1, "subtract");
function sm(e) {
  return typeof e == "string" || e instanceof String;
}
function qE(e) {
  return Jt(e) || Qo(e) || sm(e) || cn(e) || eM(e) || KE(e) || e === null || e === void 0;
}
function KE(e) {
  var r = zn(e) && !uc(e), t = !1, n = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], a, o, i = n.length;
  for (a = 0; a < i; a += 1)
    o = n[a], t = t || Se(e, o);
  return r && t;
}
function eM(e) {
  var r = yr(e), t = !1;
  return r && (t = e.filter(function(n) {
    return !cn(n) && sm(e);
  }).length === 0), r && t;
}
function tM(e) {
  var r = zn(e) && !uc(e), t = !1, n = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], a, o;
  for (a = 0; a < n.length; a += 1)
    o = n[a], t = t || Se(e, o);
  return r && t;
}
function rM(e, r) {
  var t = e.diff(r, "days", !0);
  return t < -6 ? "sameElse" : t < -1 ? "lastWeek" : t < 0 ? "lastDay" : t < 1 ? "sameDay" : t < 2 ? "nextDay" : t < 7 ? "nextWeek" : "sameElse";
}
function nM(e, r) {
  arguments.length === 1 && (arguments[0] ? qE(arguments[0]) ? (e = arguments[0], r = void 0) : tM(arguments[0]) && (r = arguments[0], e = void 0) : (e = void 0, r = void 0));
  var t = e || tt(), n = Mc(t, this).startOf("day"), a = J.calendarFormat(this, n) || "sameElse", o = r && ($r(r[a]) ? r[a].call(this, t) : r[a]);
  return this.format(
    o || this.localeData().calendar(a, this, tt(t))
  );
}
function aM() {
  return new Ko(this);
}
function oM(e, r) {
  var t = Jt(e) ? e : tt(e);
  return this.isValid() && t.isValid() ? (r = gr(r) || "millisecond", r === "millisecond" ? this.valueOf() > t.valueOf() : t.valueOf() < this.clone().startOf(r).valueOf()) : !1;
}
function iM(e, r) {
  var t = Jt(e) ? e : tt(e);
  return this.isValid() && t.isValid() ? (r = gr(r) || "millisecond", r === "millisecond" ? this.valueOf() < t.valueOf() : this.clone().endOf(r).valueOf() < t.valueOf()) : !1;
}
function sM(e, r, t, n) {
  var a = Jt(e) ? e : tt(e), o = Jt(r) ? r : tt(r);
  return this.isValid() && a.isValid() && o.isValid() ? (n = n || "()", (n[0] === "(" ? this.isAfter(a, t) : !this.isBefore(a, t)) && (n[1] === ")" ? this.isBefore(o, t) : !this.isAfter(o, t))) : !1;
}
function lM(e, r) {
  var t = Jt(e) ? e : tt(e), n;
  return this.isValid() && t.isValid() ? (r = gr(r) || "millisecond", r === "millisecond" ? this.valueOf() === t.valueOf() : (n = t.valueOf(), this.clone().startOf(r).valueOf() <= n && n <= this.clone().endOf(r).valueOf())) : !1;
}
function uM(e, r) {
  return this.isSame(e, r) || this.isAfter(e, r);
}
function cM(e, r) {
  return this.isSame(e, r) || this.isBefore(e, r);
}
function dM(e, r, t) {
  var n, a, o;
  if (!this.isValid())
    return NaN;
  if (n = Mc(e, this), !n.isValid())
    return NaN;
  switch (a = (n.utcOffset() - this.utcOffset()) * 6e4, r = gr(r), r) {
    case "year":
      o = Ti(this, n) / 12;
      break;
    case "month":
      o = Ti(this, n);
      break;
    case "quarter":
      o = Ti(this, n) / 3;
      break;
    case "second":
      o = (this - n) / 1e3;
      break;
    case "minute":
      o = (this - n) / 6e4;
      break;
    case "hour":
      o = (this - n) / 36e5;
      break;
    case "day":
      o = (this - n - a) / 864e5;
      break;
    case "week":
      o = (this - n - a) / 6048e5;
      break;
    default:
      o = this - n;
  }
  return t ? o : nr(o);
}
function Ti(e, r) {
  if (e.date() < r.date())
    return -Ti(r, e);
  var t = (r.year() - e.year()) * 12 + (r.month() - e.month()), n = e.clone().add(t, "months"), a, o;
  return r - n < 0 ? (a = e.clone().add(t - 1, "months"), o = (r - n) / (n - a)) : (a = e.clone().add(t + 1, "months"), o = (r - n) / (a - n)), -(t + o) || 0;
}
J.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
J.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function fM() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function pM(e) {
  if (!this.isValid())
    return null;
  var r = e !== !0, t = r ? this.clone().utc() : this;
  return t.year() < 0 || t.year() > 9999 ? Ri(
    t,
    r ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : $r(Date.prototype.toISOString) ? r ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Ri(t, "Z")) : Ri(
    t,
    r ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function hM() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", r = "", t, n, a, o;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", r = "Z"), t = "[" + e + '("]', n = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", a = "-MM-DD[T]HH:mm:ss.SSS", o = r + '[")]', this.format(t + n + a + o);
}
function gM(e) {
  e || (e = this.isUtc() ? J.defaultFormatUtc : J.defaultFormat);
  var r = Ri(this, e);
  return this.localeData().postformat(r);
}
function mM(e, r) {
  return this.isValid() && (Jt(e) && e.isValid() || tt(e).isValid()) ? Sr({ to: this, from: e }).locale(this.locale()).humanize(!r) : this.localeData().invalidDate();
}
function vM(e) {
  return this.from(tt(), e);
}
function bM(e, r) {
  return this.isValid() && (Jt(e) && e.isValid() || tt(e).isValid()) ? Sr({ from: this, to: e }).locale(this.locale()).humanize(!r) : this.localeData().invalidDate();
}
function yM(e) {
  return this.to(tt(), e);
}
function lm(e) {
  var r;
  return e === void 0 ? this._locale._abbr : (r = pn(e), r != null && (this._locale = r), this);
}
var um = hr(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function cm() {
  return this._locale;
}
var us = 1e3, ka = 60 * us, cs = 60 * ka, dm = (365 * 400 + 97) * 24 * cs;
function Ea(e, r) {
  return (e % r + r) % r;
}
function fm(e, r, t) {
  return e < 100 && e >= 0 ? new Date(e + 400, r, t) - dm : new Date(e, r, t).valueOf();
}
function pm(e, r, t) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, r, t) - dm : Date.UTC(e, r, t);
}
function wM(e) {
  var r, t;
  if (e = gr(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (t = this._isUTC ? pm : fm, e) {
    case "year":
      r = t(this.year(), 0, 1);
      break;
    case "quarter":
      r = t(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      r = t(this.year(), this.month(), 1);
      break;
    case "week":
      r = t(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      r = t(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      r = t(this.year(), this.month(), this.date());
      break;
    case "hour":
      r = this._d.valueOf(), r -= Ea(
        r + (this._isUTC ? 0 : this.utcOffset() * ka),
        cs
      );
      break;
    case "minute":
      r = this._d.valueOf(), r -= Ea(r, ka);
      break;
    case "second":
      r = this._d.valueOf(), r -= Ea(r, us);
      break;
  }
  return this._d.setTime(r), J.updateOffset(this, !0), this;
}
function CM(e) {
  var r, t;
  if (e = gr(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (t = this._isUTC ? pm : fm, e) {
    case "year":
      r = t(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      r = t(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      r = t(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      r = t(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      r = t(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      r = t(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      r = this._d.valueOf(), r += cs - Ea(
        r + (this._isUTC ? 0 : this.utcOffset() * ka),
        cs
      ) - 1;
      break;
    case "minute":
      r = this._d.valueOf(), r += ka - Ea(r, ka) - 1;
      break;
    case "second":
      r = this._d.valueOf(), r += us - Ea(r, us) - 1;
      break;
  }
  return this._d.setTime(r), J.updateOffset(this, !0), this;
}
function xM() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function SM() {
  return Math.floor(this.valueOf() / 1e3);
}
function IM() {
  return new Date(this.valueOf());
}
function DM() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function _M() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function kM() {
  return this.isValid() ? this.toISOString() : null;
}
function EM() {
  return cc(this);
}
function MM() {
  return Or({}, we(this));
}
function PM() {
  return we(this).overflow;
}
function AM() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
de("N", 0, 0, "eraAbbr");
de("NN", 0, 0, "eraAbbr");
de("NNN", 0, 0, "eraAbbr");
de("NNNN", 0, 0, "eraName");
de("NNNNN", 0, 0, "eraNarrow");
de("y", ["y", 1], "yo", "eraYear");
de("y", ["yy", 2], 0, "eraYear");
de("y", ["yyy", 3], 0, "eraYear");
de("y", ["yyyy", 4], 0, "eraYear");
oe("N", Pc);
oe("NN", Pc);
oe("NNN", Pc);
oe("NNNN", YM);
oe("NNNNN", HM);
ze(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, r, t, n) {
    var a = t._locale.erasParse(e, n, t._strict);
    a ? we(t).era = a : we(t).invalidEra = e;
  }
);
oe("y", Qa);
oe("yy", Qa);
oe("yyy", Qa);
oe("yyyy", Qa);
oe("yo", zM);
ze(["y", "yy", "yyy", "yyyy"], ft);
ze(["yo"], function(e, r, t, n) {
  var a;
  t._locale._eraYearOrdinalRegex && (a = e.match(t._locale._eraYearOrdinalRegex)), t._locale.eraYearOrdinalParse ? r[ft] = t._locale.eraYearOrdinalParse(e, a) : r[ft] = parseInt(e, 10);
});
function RM(e, r) {
  var t, n, a, o = this._eras || pn("en")._eras;
  for (t = 0, n = o.length; t < n; ++t) {
    switch (typeof o[t].since) {
      case "string":
        a = J(o[t].since).startOf("day"), o[t].since = a.valueOf();
        break;
    }
    switch (typeof o[t].until) {
      case "undefined":
        o[t].until = 1 / 0;
        break;
      case "string":
        a = J(o[t].until).startOf("day").valueOf(), o[t].until = a.valueOf();
        break;
    }
  }
  return o;
}
function OM(e, r, t) {
  var n, a, o = this.eras(), i, s, l;
  for (e = e.toUpperCase(), n = 0, a = o.length; n < a; ++n)
    if (i = o[n].name.toUpperCase(), s = o[n].abbr.toUpperCase(), l = o[n].narrow.toUpperCase(), t)
      switch (r) {
        case "N":
        case "NN":
        case "NNN":
          if (s === e)
            return o[n];
          break;
        case "NNNN":
          if (i === e)
            return o[n];
          break;
        case "NNNNN":
          if (l === e)
            return o[n];
          break;
      }
    else if ([i, s, l].indexOf(e) >= 0)
      return o[n];
}
function TM(e, r) {
  var t = e.since <= e.until ? 1 : -1;
  return r === void 0 ? J(e.since).year() : J(e.since).year() + (r - e.offset) * t;
}
function FM() {
  var e, r, t, n = this.localeData().eras();
  for (e = 0, r = n.length; e < r; ++e)
    if (t = this.clone().startOf("day").valueOf(), n[e].since <= t && t <= n[e].until || n[e].until <= t && t <= n[e].since)
      return n[e].name;
  return "";
}
function NM() {
  var e, r, t, n = this.localeData().eras();
  for (e = 0, r = n.length; e < r; ++e)
    if (t = this.clone().startOf("day").valueOf(), n[e].since <= t && t <= n[e].until || n[e].until <= t && t <= n[e].since)
      return n[e].narrow;
  return "";
}
function LM() {
  var e, r, t, n = this.localeData().eras();
  for (e = 0, r = n.length; e < r; ++e)
    if (t = this.clone().startOf("day").valueOf(), n[e].since <= t && t <= n[e].until || n[e].until <= t && t <= n[e].since)
      return n[e].abbr;
  return "";
}
function WM() {
  var e, r, t, n, a = this.localeData().eras();
  for (e = 0, r = a.length; e < r; ++e)
    if (t = a[e].since <= a[e].until ? 1 : -1, n = this.clone().startOf("day").valueOf(), a[e].since <= n && n <= a[e].until || a[e].until <= n && n <= a[e].since)
      return (this.year() - J(a[e].since).year()) * t + a[e].offset;
  return this.year();
}
function BM(e) {
  return Se(this, "_erasNameRegex") || Ac.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function VM(e) {
  return Se(this, "_erasAbbrRegex") || Ac.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function GM(e) {
  return Se(this, "_erasNarrowRegex") || Ac.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function Pc(e, r) {
  return r.erasAbbrRegex(e);
}
function YM(e, r) {
  return r.erasNameRegex(e);
}
function HM(e, r) {
  return r.erasNarrowRegex(e);
}
function zM(e, r) {
  return r._eraYearOrdinalRegex || Qa;
}
function Ac() {
  var e = [], r = [], t = [], n = [], a, o, i, s, l, u = this.eras();
  for (a = 0, o = u.length; a < o; ++a)
    i = nn(u[a].name), s = nn(u[a].abbr), l = nn(u[a].narrow), r.push(i), e.push(s), t.push(l), n.push(i), n.push(s), n.push(l);
  this._erasRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
de(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
de(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function js(e, r) {
  de(0, [e, e.length], 0, r);
}
js("gggg", "weekYear");
js("ggggg", "weekYear");
js("GGGG", "isoWeekYear");
js("GGGGG", "isoWeekYear");
oe("G", Ys);
oe("g", Ys);
oe("GG", qe, qt);
oe("gg", qe, qt);
oe("GGGG", mc, hc);
oe("gggg", mc, hc);
oe("GGGGG", Gs, Bs);
oe("ggggg", Gs, Bs);
Ka(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, r, t, n) {
    r[n.substr(0, 2)] = Ce(e);
  }
);
Ka(["gg", "GG"], function(e, r, t, n) {
  r[n] = J.parseTwoDigitYear(e);
});
function $M(e) {
  return hm.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function XM(e) {
  return hm.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function jM() {
  return an(this.year(), 1, 4);
}
function ZM() {
  return an(this.isoWeekYear(), 1, 4);
}
function UM() {
  var e = this.localeData()._week;
  return an(this.year(), e.dow, e.doy);
}
function JM() {
  var e = this.localeData()._week;
  return an(this.weekYear(), e.dow, e.doy);
}
function hm(e, r, t, n, a) {
  var o;
  return e == null ? xc(this, n, a).year : (o = an(e, n, a), r > o && (r = o), QM.call(this, e, r, t, n, a));
}
function QM(e, r, t, n, a) {
  var o = jg(e, r, t, n, a), i = qn(o.year, 0, o.dayOfYear);
  return this.year(i.getUTCFullYear()), this.month(i.getUTCMonth()), this.date(i.getUTCDate()), this;
}
de("Q", 0, "Qo", "quarter");
oe("Q", Tg);
ze("Q", function(e, r) {
  r[jt] = (Ce(e) - 1) * 3;
});
function qM(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
de("D", ["DD", 2], "Do", "date");
oe("D", qe, qa);
oe("DD", qe, qt);
oe("Do", function(e, r) {
  return e ? r._dayOfMonthOrdinalParse || r._ordinalParse : r._dayOfMonthOrdinalParseLenient;
});
ze(["D", "DD"], Ft);
ze("Do", function(e, r) {
  r[Ft] = Ce(e.match(qe)[0]);
});
var gm = eo("Date", !0);
de("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
oe("DDD", Vs);
oe("DDDD", Fg);
ze(["DDD", "DDDD"], function(e, r, t) {
  t._dayOfYear = Ce(e);
});
function KM(e) {
  var r = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? r : this.add(e - r, "d");
}
de("m", ["mm", 2], 0, "minute");
oe("m", qe, vc);
oe("mm", qe, qt);
ze(["m", "mm"], or);
var eP = eo("Minutes", !1);
de("s", ["ss", 2], 0, "second");
oe("s", qe, vc);
oe("ss", qe, qt);
ze(["s", "ss"], tn);
var tP = eo("Seconds", !1);
de("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
de(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
de(0, ["SSS", 3], 0, "millisecond");
de(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
de(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
de(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
de(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
de(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
de(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
oe("S", Vs, Tg);
oe("SS", Vs, qt);
oe("SSS", Vs, Fg);
var Cn, mm;
for (Cn = "SSSS"; Cn.length <= 9; Cn += "S")
  oe(Cn, Qa);
function rP(e, r) {
  r[Vn] = Ce(("0." + e) * 1e3);
}
for (Cn = "S"; Cn.length <= 9; Cn += "S")
  ze(Cn, rP);
mm = eo("Milliseconds", !1);
de("z", 0, 0, "zoneAbbr");
de("zz", 0, 0, "zoneName");
function nP() {
  return this._isUTC ? "UTC" : "";
}
function aP() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var z = Ko.prototype;
z.add = JE;
z.calendar = nM;
z.clone = aM;
z.diff = dM;
z.endOf = CM;
z.format = gM;
z.from = mM;
z.fromNow = vM;
z.to = bM;
z.toNow = yM;
z.get = q_;
z.invalidAt = PM;
z.isAfter = oM;
z.isBefore = iM;
z.isBetween = sM;
z.isSame = lM;
z.isSameOrAfter = uM;
z.isSameOrBefore = cM;
z.isValid = EM;
z.lang = um;
z.locale = lm;
z.localeData = cm;
z.max = EE;
z.min = kE;
z.parsingFlags = MM;
z.set = K_;
z.startOf = wM;
z.subtract = QE;
z.toArray = DM;
z.toObject = _M;
z.toDate = IM;
z.toISOString = pM;
z.inspect = hM;
typeof Symbol < "u" && Symbol.for != null && (z[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
z.toJSON = kM;
z.toString = fM;
z.unix = SM;
z.valueOf = xM;
z.creationData = AM;
z.eraName = FM;
z.eraNarrow = NM;
z.eraAbbr = LM;
z.eraYear = WM;
z.year = Lg;
z.isLeapYear = Q_;
z.weekYear = $M;
z.isoWeekYear = XM;
z.quarter = z.quarters = qM;
z.month = Yg;
z.daysInMonth = uk;
z.week = z.weeks = Uk;
z.isoWeek = z.isoWeeks = Jk;
z.weeksInYear = UM;
z.weeksInWeekYear = JM;
z.isoWeeksInYear = jM;
z.isoWeeksInISOWeekYear = ZM;
z.date = gm;
z.day = z.days = Dk;
z.weekday = _k;
z.isoWeekday = kk;
z.dayOfYear = KM;
z.hour = z.hours = eE;
z.minute = z.minutes = eP;
z.second = z.seconds = tP;
z.millisecond = z.milliseconds = mm;
z.utcOffset = LE;
z.utc = BE;
z.local = VE;
z.parseZone = GE;
z.hasAlignedHourOffset = YE;
z.isDST = HE;
z.isLocal = $E;
z.isUtcOffset = XE;
z.isUtc = am;
z.isUTC = am;
z.zoneAbbr = nP;
z.zoneName = aP;
z.dates = hr(
  "dates accessor is deprecated. Use date instead.",
  gm
);
z.months = hr(
  "months accessor is deprecated. Use month instead",
  Yg
);
z.years = hr(
  "years accessor is deprecated. Use year instead",
  Lg
);
z.zone = hr(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  WE
);
z.isDSTShifted = hr(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  zE
);
function oP(e) {
  return tt(e * 1e3);
}
function iP() {
  return tt.apply(null, arguments).parseZone();
}
function vm(e) {
  return e;
}
var Pe = Cc.prototype;
Pe.calendar = Ok;
Pe.longDateFormat = Fk;
Pe.invalidDate = Lk;
Pe.ordinal = Vk;
Pe.preparse = vm;
Pe.postformat = vm;
Pe.relativeTime = Yk;
Pe.pastFuture = Hk;
Pe.set = Ak;
Pe.eras = RM;
Pe.erasParse = OM;
Pe.erasConvertYear = TM;
Pe.erasAbbrRegex = VM;
Pe.erasNameRegex = BM;
Pe.erasNarrowRegex = GM;
Pe.months = ok;
Pe.monthsShort = ik;
Pe.monthsParse = lk;
Pe.monthsRegex = dk;
Pe.monthsShortRegex = ck;
Pe.week = $k;
Pe.firstDayOfYear = Zk;
Pe.firstDayOfWeek = jk;
Pe.weekdays = wk;
Pe.weekdaysMin = xk;
Pe.weekdaysShort = Ck;
Pe.weekdaysParse = Ik;
Pe.weekdaysRegex = Ek;
Pe.weekdaysShortRegex = Mk;
Pe.weekdaysMinRegex = Pk;
Pe.isPM = qk;
Pe.meridiem = tE;
function ds(e, r, t, n) {
  var a = pn(), o = zr().set(n, r);
  return a[t](o, e);
}
function bm(e, r, t) {
  if (cn(e) && (r = e, e = void 0), e = e || "", r != null)
    return ds(e, r, t, "month");
  var n, a = [];
  for (n = 0; n < 12; n++)
    a[n] = ds(e, n, t, "month");
  return a;
}
function Rc(e, r, t, n) {
  typeof e == "boolean" ? (cn(r) && (t = r, r = void 0), r = r || "") : (r = e, t = r, e = !1, cn(r) && (t = r, r = void 0), r = r || "");
  var a = pn(), o = e ? a._week.dow : 0, i, s = [];
  if (t != null)
    return ds(r, (t + o) % 7, n, "day");
  for (i = 0; i < 7; i++)
    s[i] = ds(r, (i + o) % 7, n, "day");
  return s;
}
function sP(e, r) {
  return bm(e, r, "months");
}
function lP(e, r) {
  return bm(e, r, "monthsShort");
}
function uP(e, r, t) {
  return Rc(e, r, t, "weekdays");
}
function cP(e, r, t) {
  return Rc(e, r, t, "weekdaysShort");
}
function dP(e, r, t) {
  return Rc(e, r, t, "weekdaysMin");
}
In("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var r = e % 10, t = Ce(e % 100 / 10) === 1 ? "th" : r === 1 ? "st" : r === 2 ? "nd" : r === 3 ? "rd" : "th";
    return e + t;
  }
});
J.lang = hr(
  "moment.lang is deprecated. Use moment.locale instead.",
  In
);
J.langData = hr(
  "moment.langData is deprecated. Use moment.localeData instead.",
  pn
);
var Jr = Math.abs;
function fP() {
  var e = this._data;
  return this._milliseconds = Jr(this._milliseconds), this._days = Jr(this._days), this._months = Jr(this._months), e.milliseconds = Jr(e.milliseconds), e.seconds = Jr(e.seconds), e.minutes = Jr(e.minutes), e.hours = Jr(e.hours), e.months = Jr(e.months), e.years = Jr(e.years), this;
}
function ym(e, r, t, n) {
  var a = Sr(r, t);
  return e._milliseconds += n * a._milliseconds, e._days += n * a._days, e._months += n * a._months, e._bubble();
}
function pP(e, r) {
  return ym(this, e, r, 1);
}
function hP(e, r) {
  return ym(this, e, r, -1);
}
function Nf(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function gP() {
  var e = this._milliseconds, r = this._days, t = this._months, n = this._data, a, o, i, s, l;
  return e >= 0 && r >= 0 && t >= 0 || e <= 0 && r <= 0 && t <= 0 || (e += Nf(Du(t) + r) * 864e5, r = 0, t = 0), n.milliseconds = e % 1e3, a = nr(e / 1e3), n.seconds = a % 60, o = nr(a / 60), n.minutes = o % 60, i = nr(o / 60), n.hours = i % 24, r += nr(i / 24), l = nr(wm(r)), t += l, r -= Nf(Du(l)), s = nr(t / 12), t %= 12, n.days = r, n.months = t, n.years = s, this;
}
function wm(e) {
  return e * 4800 / 146097;
}
function Du(e) {
  return e * 146097 / 4800;
}
function mP(e) {
  if (!this.isValid())
    return NaN;
  var r, t, n = this._milliseconds;
  if (e = gr(e), e === "month" || e === "quarter" || e === "year")
    switch (r = this._days + n / 864e5, t = this._months + wm(r), e) {
      case "month":
        return t;
      case "quarter":
        return t / 3;
      case "year":
        return t / 12;
    }
  else
    switch (r = this._days + Math.round(Du(this._months)), e) {
      case "week":
        return r / 7 + n / 6048e5;
      case "day":
        return r + n / 864e5;
      case "hour":
        return r * 24 + n / 36e5;
      case "minute":
        return r * 1440 + n / 6e4;
      case "second":
        return r * 86400 + n / 1e3;
      case "millisecond":
        return Math.floor(r * 864e5) + n;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function hn(e) {
  return function() {
    return this.as(e);
  };
}
var Cm = hn("ms"), vP = hn("s"), bP = hn("m"), yP = hn("h"), wP = hn("d"), CP = hn("w"), xP = hn("M"), SP = hn("Q"), IP = hn("y"), DP = Cm;
function _P() {
  return Sr(this);
}
function kP(e) {
  return e = gr(e), this.isValid() ? this[e + "s"]() : NaN;
}
function la(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var EP = la("milliseconds"), MP = la("seconds"), PP = la("minutes"), AP = la("hours"), RP = la("days"), OP = la("months"), TP = la("years");
function FP() {
  return nr(this.days() / 7);
}
var Qr = Math.round, Sa = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function NP(e, r, t, n, a) {
  return $g.call(
    a,
    r || 1,
    !!t,
    e,
    n
  );
}
function LP(e, r, t, n) {
  var a = Sr(e).abs(), o = Qr(a.as("s")), i = Qr(a.as("m")), s = Qr(a.as("h")), l = Qr(a.as("d")), u = Qr(a.as("M")), c = Qr(a.as("w")), d = Qr(a.as("y")), p = o <= t.ss && ["s", o] || o < t.s && ["ss", o] || i <= 1 && ["m"] || i < t.m && ["mm", i] || s <= 1 && ["h"] || s < t.h && ["hh", s] || l <= 1 && ["d"] || l < t.d && ["dd", l];
  return t.w != null && (p = p || c <= 1 && ["w"] || c < t.w && ["ww", c]), p = p || u <= 1 && ["M"] || u < t.M && ["MM", u] || d <= 1 && ["y"] || ["yy", d], p[2] = r, p[3] = +e > 0, p[4] = n, NP.apply(null, p);
}
function WP(e) {
  return e === void 0 ? Qr : typeof e == "function" ? (Qr = e, !0) : !1;
}
function BP(e, r) {
  return Sa[e] === void 0 ? !1 : r === void 0 ? Sa[e] : (Sa[e] = r, e === "s" && (Sa.ss = r - 1), !0);
}
function VP(e, r) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var t = !1, n = Sa, a, o;
  return typeof e == "object" && (r = e, e = !1), typeof e == "boolean" && (t = e), typeof r == "object" && (n = Or(Or({}, Sa), r || {}), r.s != null && r.ss == null && (n.ss = r.s - 1)), a = this.localeData(), o = LP(this, !t, n, a), t && (o = Xg.call(a, +this, o)), a.postformat(o);
}
var Tl = Math.abs;
function va(e) {
  return (e > 0) - (e < 0) || +e;
}
function Zs() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Tl(this._milliseconds) / 1e3, r = Tl(this._days), t = Tl(this._months), n, a, o, i, s = this.asSeconds(), l, u, c, d;
  return s ? (n = nr(e / 60), a = nr(n / 60), e %= 60, n %= 60, o = nr(t / 12), t %= 12, i = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", l = s < 0 ? "-" : "", u = va(this._months) !== va(s) ? "-" : "", c = va(this._days) !== va(s) ? "-" : "", d = va(this._milliseconds) !== va(s) ? "-" : "", l + "P" + (o ? u + o + "Y" : "") + (t ? u + t + "M" : "") + (r ? c + r + "D" : "") + (a || n || e ? "T" : "") + (a ? d + a + "H" : "") + (n ? d + n + "M" : "") + (e ? d + i + "S" : "")) : "P0D";
}
var Ee = Xs.prototype;
Ee.isValid = OE;
Ee.abs = fP;
Ee.add = pP;
Ee.subtract = hP;
Ee.as = mP;
Ee.asMilliseconds = Cm;
Ee.asSeconds = vP;
Ee.asMinutes = bP;
Ee.asHours = yP;
Ee.asDays = wP;
Ee.asWeeks = CP;
Ee.asMonths = xP;
Ee.asQuarters = SP;
Ee.asYears = IP;
Ee.valueOf = DP;
Ee._bubble = gP;
Ee.clone = _P;
Ee.get = kP;
Ee.milliseconds = EP;
Ee.seconds = MP;
Ee.minutes = PP;
Ee.hours = AP;
Ee.days = RP;
Ee.weeks = FP;
Ee.months = OP;
Ee.years = TP;
Ee.humanize = VP;
Ee.toISOString = Zs;
Ee.toString = Zs;
Ee.toJSON = Zs;
Ee.locale = lm;
Ee.localeData = cm;
Ee.toIsoString = hr(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Zs
);
Ee.lang = um;
de("X", 0, 0, "unix");
de("x", 0, 0, "valueOf");
oe("x", Ys);
oe("X", $_);
ze("X", function(e, r, t) {
  t._d = new Date(parseFloat(e) * 1e3);
});
ze("x", function(e, r, t) {
  t._d = new Date(Ce(e));
});
//! moment.js
J.version = "2.31.0";
W_(tt);
J.fn = z;
J.min = ME;
J.max = PE;
J.now = AE;
J.utc = zr;
J.unix = oP;
J.months = sP;
J.isDate = Qo;
J.locale = In;
J.invalid = qo;
J.duration = Sr;
J.isMoment = Jt;
J.weekdays = uP;
J.parseZone = iP;
J.localeData = pn;
J.isDuration = Oi;
J.monthsShort = lP;
J.weekdaysMin = dP;
J.defineLocale = Ic;
J.updateLocale = oE;
J.locales = iE;
J.weekdaysShort = cP;
J.normalizeUnits = gr;
J.relativeTimeRounding = WP;
J.relativeTimeThreshold = BP;
J.calendarFormat = rM;
J.prototype = z;
J.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
function xm(e) {
  var r, t, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (r = 0; r < a; r++) e[r] && (t = xm(e[r])) && (n && (n += " "), n += t);
  } else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function Ct() {
  for (var e, r, t = 0, n = "", a = arguments.length; t < a; t++) (e = arguments[t]) && (r = xm(e)) && (n && (n += " "), n += r);
  return n;
}
function ie(e) {
  const r = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && r === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || r === "[object Number]" || typeof e == "string" || r === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Ve(e, r) {
  return e instanceof Date ? new e.constructor(r) : new Date(r);
}
function Rn(e, r) {
  const t = ie(e);
  return isNaN(r) ? Ve(e, NaN) : (r && t.setDate(t.getDate() + r), t);
}
function Oc(e, r) {
  const t = +ie(e);
  return Ve(e, t + r);
}
const Sm = 6048e5, GP = 864e5, Us = 6e4, Js = 36e5, YP = 1e3;
function HP(e, r) {
  return Oc(e, r * Js);
}
function _u(e, r) {
  return Oc(e, r * Us);
}
function wr(e, r) {
  const t = ie(e);
  if (isNaN(r)) return Ve(e, NaN);
  if (!r)
    return t;
  const n = t.getDate(), a = Ve(e, t.getTime());
  a.setMonth(t.getMonth() + r + 1, 0);
  const o = a.getDate();
  return n >= o ? a : (t.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    n
  ), t);
}
function Tc(e, r) {
  const t = r * 3;
  return wr(e, t);
}
function zP(e, r) {
  return Oc(e, r * 1e3);
}
function fs(e, r) {
  const t = r * 7;
  return Rn(e, t);
}
function on(e, r) {
  return wr(e, r * 12);
}
function Kn(e) {
  const r = ie(e);
  return r.setHours(0, 0, 0, 0), r;
}
function ps(e) {
  const r = ie(e), t = new Date(
    Date.UTC(
      r.getFullYear(),
      r.getMonth(),
      r.getDate(),
      r.getHours(),
      r.getMinutes(),
      r.getSeconds(),
      r.getMilliseconds()
    )
  );
  return t.setUTCFullYear(r.getFullYear()), +e - +t;
}
function Lo(e, r) {
  const t = Kn(e), n = Kn(r), a = +t - ps(t), o = +n - ps(n);
  return Math.round((a - o) / GP);
}
function hs(e, r) {
  const t = ie(e), n = ie(r), a = t.getFullYear() - n.getFullYear(), o = t.getMonth() - n.getMonth();
  return a * 12 + o;
}
function $n(e) {
  const r = ie(e);
  return Math.trunc(r.getMonth() / 3) + 1;
}
function gs(e, r) {
  const t = ie(e), n = ie(r), a = t.getFullYear() - n.getFullYear(), o = $n(t) - $n(n);
  return a * 4 + o;
}
function ms(e, r) {
  const t = ie(e), n = ie(r);
  return t.getFullYear() - n.getFullYear();
}
function Im(e) {
  const r = ie(e);
  return r.setHours(23, 59, 59, 999), r;
}
function $P(e) {
  const r = ie(e), t = r.getMonth();
  return r.setFullYear(r.getFullYear(), t + 1, 0), r.setHours(23, 59, 59, 999), r;
}
let XP = {};
function ua() {
  return XP;
}
function jP(e, r) {
  var s, l;
  const t = ua(), n = t.weekStartsOn ?? ((l = (s = t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? 0, a = ie(e), o = a.getDay(), i = (o < n ? -7 : 0) + 6 - (o - n);
  return a.setDate(a.getDate() + i), a.setHours(23, 59, 59, 999), a;
}
function Dm(e) {
  const r = ie(e), t = r.getFullYear();
  return r.setFullYear(t + 1, 0, 0), r.setHours(23, 59, 59, 999), r;
}
const ZP = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, UP = (e, r, t) => {
  let n;
  const a = ZP[e];
  return typeof a == "string" ? n = a : r === 1 ? n = a.one : n = a.other.replace("{{count}}", r.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + n : n + " ago" : n;
};
function Fl(e) {
  return (r = {}) => {
    const t = r.width ? String(r.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const JP = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, QP = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, qP = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, KP = {
  date: Fl({
    formats: JP,
    defaultWidth: "full"
  }),
  time: Fl({
    formats: QP,
    defaultWidth: "full"
  }),
  dateTime: Fl({
    formats: qP,
    defaultWidth: "full"
  })
}, eA = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, tA = (e, r, t, n) => eA[e];
function ho(e) {
  return (r, t) => {
    const n = t != null && t.context ? String(t.context) : "standalone";
    let a;
    if (n === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = t != null && t.width ? String(t.width) : i;
      a = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = t != null && t.width ? String(t.width) : e.defaultWidth;
      a = e.values[s] || e.values[i];
    }
    const o = e.argumentCallback ? e.argumentCallback(r) : r;
    return a[o];
  };
}
const rA = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, nA = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, aA = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, oA = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, iA = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, sA = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, lA = (e, r) => {
  const t = Number(e), n = t % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, uA = {
  ordinalNumber: lA,
  era: ho({
    values: rA,
    defaultWidth: "wide"
  }),
  quarter: ho({
    values: nA,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: ho({
    values: aA,
    defaultWidth: "wide"
  }),
  day: ho({
    values: oA,
    defaultWidth: "wide"
  }),
  dayPeriod: ho({
    values: iA,
    defaultWidth: "wide",
    formattingValues: sA,
    defaultFormattingWidth: "wide"
  })
};
function go(e) {
  return (r, t = {}) => {
    const n = t.width, a = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], o = r.match(a);
    if (!o)
      return null;
    const i = o[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? dA(s, (d) => d.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      cA(s, (d) => d.test(i))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(l) : l, u = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(u)
    ) : u;
    const c = r.slice(i.length);
    return { value: u, rest: c };
  };
}
function cA(e, r) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && r(e[t]))
      return t;
}
function dA(e, r) {
  for (let t = 0; t < e.length; t++)
    if (r(e[t]))
      return t;
}
function fA(e) {
  return (r, t = {}) => {
    const n = r.match(e.matchPattern);
    if (!n) return null;
    const a = n[0], o = r.match(e.parsePattern);
    if (!o) return null;
    let i = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    i = t.valueCallback ? t.valueCallback(i) : i;
    const s = r.slice(a.length);
    return { value: i, rest: s };
  };
}
const pA = /^(\d+)(th|st|nd|rd)?/i, hA = /\d+/i, gA = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, mA = {
  any: [/^b/i, /^(a|c)/i]
}, vA = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, bA = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, yA = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, wA = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, CA = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, xA = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, SA = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, IA = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, DA = {
  ordinalNumber: fA({
    matchPattern: pA,
    parsePattern: hA,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: go({
    matchPatterns: gA,
    defaultMatchWidth: "wide",
    parsePatterns: mA,
    defaultParseWidth: "any"
  }),
  quarter: go({
    matchPatterns: vA,
    defaultMatchWidth: "wide",
    parsePatterns: bA,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: go({
    matchPatterns: yA,
    defaultMatchWidth: "wide",
    parsePatterns: wA,
    defaultParseWidth: "any"
  }),
  day: go({
    matchPatterns: CA,
    defaultMatchWidth: "wide",
    parsePatterns: xA,
    defaultParseWidth: "any"
  }),
  dayPeriod: go({
    matchPatterns: SA,
    defaultMatchWidth: "any",
    parsePatterns: IA,
    defaultParseWidth: "any"
  })
}, _m = {
  code: "en-US",
  formatDistance: UP,
  formatLong: KP,
  formatRelative: tA,
  localize: uA,
  match: DA,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Qs(e) {
  const r = ie(e), t = Ve(e, 0);
  return t.setFullYear(r.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function _A(e) {
  const r = ie(e);
  return Lo(r, Qs(r)) + 1;
}
function dn(e, r) {
  var s, l, u, c;
  const t = ua(), n = (r == null ? void 0 : r.weekStartsOn) ?? ((l = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, a = ie(e), o = a.getDay(), i = (o < n ? 7 : 0) + o - n;
  return a.setDate(a.getDate() - i), a.setHours(0, 0, 0, 0), a;
}
function Ga(e) {
  return dn(e, { weekStartsOn: 1 });
}
function km(e) {
  const r = ie(e), t = r.getFullYear(), n = Ve(e, 0);
  n.setFullYear(t + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const a = Ga(n), o = Ve(e, 0);
  o.setFullYear(t, 0, 4), o.setHours(0, 0, 0, 0);
  const i = Ga(o);
  return r.getTime() >= a.getTime() ? t + 1 : r.getTime() >= i.getTime() ? t : t - 1;
}
function kA(e) {
  const r = km(e), t = Ve(e, 0);
  return t.setFullYear(r, 0, 4), t.setHours(0, 0, 0, 0), Ga(t);
}
function Fc(e) {
  const r = ie(e), t = +Ga(r) - +kA(r);
  return Math.round(t / Sm) + 1;
}
function Nc(e, r) {
  var c, d, p, f;
  const t = ie(e), n = t.getFullYear(), a = ua(), o = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((d = (c = r == null ? void 0 : r.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((f = (p = a.locale) == null ? void 0 : p.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, i = Ve(e, 0);
  i.setFullYear(n + 1, 0, o), i.setHours(0, 0, 0, 0);
  const s = dn(i, r), l = Ve(e, 0);
  l.setFullYear(n, 0, o), l.setHours(0, 0, 0, 0);
  const u = dn(l, r);
  return t.getTime() >= s.getTime() ? n + 1 : t.getTime() >= u.getTime() ? n : n - 1;
}
function EA(e, r) {
  var s, l, u, c;
  const t = ua(), n = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((l = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, a = Nc(e, r), o = Ve(e, 0);
  return o.setFullYear(a, 0, n), o.setHours(0, 0, 0, 0), dn(o, r);
}
function Em(e, r) {
  const t = ie(e), n = +dn(t, r) - +EA(t, r);
  return Math.round(n / Sm) + 1;
}
function Be(e, r) {
  const t = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(r, "0");
  return t + n;
}
const yn = {
  // Year
  y(e, r) {
    const t = e.getFullYear(), n = t > 0 ? t : 1 - t;
    return Be(r === "yy" ? n % 100 : n, r.length);
  },
  // Month
  M(e, r) {
    const t = e.getMonth();
    return r === "M" ? String(t + 1) : Be(t + 1, 2);
  },
  // Day of the month
  d(e, r) {
    return Be(e.getDate(), r.length);
  },
  // AM or PM
  a(e, r) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, r) {
    return Be(e.getHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H(e, r) {
    return Be(e.getHours(), r.length);
  },
  // Minute
  m(e, r) {
    return Be(e.getMinutes(), r.length);
  },
  // Second
  s(e, r) {
    return Be(e.getSeconds(), r.length);
  },
  // Fraction of second
  S(e, r) {
    const t = r.length, n = e.getMilliseconds(), a = Math.trunc(
      n * Math.pow(10, t - 3)
    );
    return Be(a, r.length);
  }
}, ba = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Lf = {
  // Era
  G: function(e, r, t) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(n, { width: "abbreviated" });
      case "GGGGG":
        return t.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, r, t) {
    if (r === "yo") {
      const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
      return t.ordinalNumber(a, { unit: "year" });
    }
    return yn.y(e, r);
  },
  // Local week-numbering year
  Y: function(e, r, t, n) {
    const a = Nc(e, n), o = a > 0 ? a : 1 - a;
    if (r === "YY") {
      const i = o % 100;
      return Be(i, 2);
    }
    return r === "Yo" ? t.ordinalNumber(o, { unit: "year" }) : Be(o, r.length);
  },
  // ISO week-numbering year
  R: function(e, r) {
    const t = km(e);
    return Be(t, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, r) {
    const t = e.getFullYear();
    return Be(t, r.length);
  },
  // Quarter
  Q: function(e, r, t) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(n);
      case "QQ":
        return Be(n, 2);
      case "Qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return t.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, r, t) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(n);
      case "qq":
        return Be(n, 2);
      case "qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return t.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, r, t) {
    const n = e.getMonth();
    switch (r) {
      case "M":
      case "MM":
        return yn.M(e, r);
      case "Mo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return t.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, r, t) {
    const n = e.getMonth();
    switch (r) {
      case "L":
        return String(n + 1);
      case "LL":
        return Be(n + 1, 2);
      case "Lo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return t.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, r, t, n) {
    const a = Em(e, n);
    return r === "wo" ? t.ordinalNumber(a, { unit: "week" }) : Be(a, r.length);
  },
  // ISO week of year
  I: function(e, r, t) {
    const n = Fc(e);
    return r === "Io" ? t.ordinalNumber(n, { unit: "week" }) : Be(n, r.length);
  },
  // Day of the month
  d: function(e, r, t) {
    return r === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : yn.d(e, r);
  },
  // Day of year
  D: function(e, r, t) {
    const n = _A(e);
    return r === "Do" ? t.ordinalNumber(n, { unit: "dayOfYear" }) : Be(n, r.length);
  },
  // Day of week
  E: function(e, r, t) {
    const n = e.getDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, r, t, n) {
    const a = e.getDay(), o = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(o);
      case "ee":
        return Be(o, 2);
      case "eo":
        return t.ordinalNumber(o, { unit: "day" });
      case "eee":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, r, t, n) {
    const a = e.getDay(), o = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(o);
      case "cc":
        return Be(o, r.length);
      case "co":
        return t.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return t.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, r, t) {
    const n = e.getDay(), a = n === 0 ? 7 : n;
    switch (r) {
      case "i":
        return String(a);
      case "ii":
        return Be(a, r.length);
      case "io":
        return t.ordinalNumber(a, { unit: "day" });
      case "iii":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, r, t) {
    const a = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, r, t) {
    const n = e.getHours();
    let a;
    switch (n === 12 ? a = ba.noon : n === 0 ? a = ba.midnight : a = n / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, r, t) {
    const n = e.getHours();
    let a;
    switch (n >= 17 ? a = ba.evening : n >= 12 ? a = ba.afternoon : n >= 4 ? a = ba.morning : a = ba.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, r, t) {
    if (r === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), t.ordinalNumber(n, { unit: "hour" });
    }
    return yn.h(e, r);
  },
  // Hour [0-23]
  H: function(e, r, t) {
    return r === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : yn.H(e, r);
  },
  // Hour [0-11]
  K: function(e, r, t) {
    const n = e.getHours() % 12;
    return r === "Ko" ? t.ordinalNumber(n, { unit: "hour" }) : Be(n, r.length);
  },
  // Hour [1-24]
  k: function(e, r, t) {
    let n = e.getHours();
    return n === 0 && (n = 24), r === "ko" ? t.ordinalNumber(n, { unit: "hour" }) : Be(n, r.length);
  },
  // Minute
  m: function(e, r, t) {
    return r === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : yn.m(e, r);
  },
  // Second
  s: function(e, r, t) {
    return r === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : yn.s(e, r);
  },
  // Fraction of second
  S: function(e, r) {
    return yn.S(e, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, r, t) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (r) {
      case "X":
        return Bf(n);
      case "XXXX":
      case "XX":
        return Nn(n);
      case "XXXXX":
      case "XXX":
      default:
        return Nn(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, r, t) {
    const n = e.getTimezoneOffset();
    switch (r) {
      case "x":
        return Bf(n);
      case "xxxx":
      case "xx":
        return Nn(n);
      case "xxxxx":
      case "xxx":
      default:
        return Nn(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, r, t) {
    const n = e.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Wf(n, ":");
      case "OOOO":
      default:
        return "GMT" + Nn(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, r, t) {
    const n = e.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Wf(n, ":");
      case "zzzz":
      default:
        return "GMT" + Nn(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, r, t) {
    const n = Math.trunc(e.getTime() / 1e3);
    return Be(n, r.length);
  },
  // Milliseconds timestamp
  T: function(e, r, t) {
    const n = e.getTime();
    return Be(n, r.length);
  }
};
function Wf(e, r = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), a = Math.trunc(n / 60), o = n % 60;
  return o === 0 ? t + String(a) : t + String(a) + r + Be(o, 2);
}
function Bf(e, r) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Be(Math.abs(e) / 60, 2) : Nn(e, r);
}
function Nn(e, r = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), a = Be(Math.trunc(n / 60), 2), o = Be(n % 60, 2);
  return t + a + r + o;
}
const Vf = (e, r) => {
  switch (e) {
    case "P":
      return r.date({ width: "short" });
    case "PP":
      return r.date({ width: "medium" });
    case "PPP":
      return r.date({ width: "long" });
    case "PPPP":
    default:
      return r.date({ width: "full" });
  }
}, Mm = (e, r) => {
  switch (e) {
    case "p":
      return r.time({ width: "short" });
    case "pp":
      return r.time({ width: "medium" });
    case "ppp":
      return r.time({ width: "long" });
    case "pppp":
    default:
      return r.time({ width: "full" });
  }
}, MA = (e, r) => {
  const t = e.match(/(P+)(p+)?/) || [], n = t[1], a = t[2];
  if (!a)
    return Vf(e, r);
  let o;
  switch (n) {
    case "P":
      o = r.dateTime({ width: "short" });
      break;
    case "PP":
      o = r.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = r.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = r.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", Vf(n, r)).replace("{{time}}", Mm(a, r));
}, vs = {
  p: Mm,
  P: MA
}, PA = /^D+$/, AA = /^Y+$/, RA = ["D", "DD", "YY", "YYYY"];
function Pm(e) {
  return PA.test(e);
}
function Am(e) {
  return AA.test(e);
}
function ku(e, r, t) {
  const n = OA(e, r, t);
  if (console.warn(n), RA.includes(e)) throw new RangeError(n);
}
function OA(e, r, t) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${r}\`) for formatting ${n} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function sn(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function bs(e) {
  if (!sn(e) && typeof e != "number")
    return !1;
  const r = ie(e);
  return !isNaN(Number(r));
}
const TA = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, FA = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, NA = /^'([^]*?)'?$/, LA = /''/g, WA = /[a-zA-Z]/;
function Gf(e, r, t) {
  var c, d, p, f, h, g, m, v;
  const n = ua(), a = (t == null ? void 0 : t.locale) ?? n.locale ?? _m, o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((f = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, i = (t == null ? void 0 : t.weekStartsOn) ?? ((g = (h = t == null ? void 0 : t.locale) == null ? void 0 : h.options) == null ? void 0 : g.weekStartsOn) ?? n.weekStartsOn ?? ((v = (m = n.locale) == null ? void 0 : m.options) == null ? void 0 : v.weekStartsOn) ?? 0, s = ie(e);
  if (!bs(s))
    throw new RangeError("Invalid time value");
  let l = r.match(FA).map((y) => {
    const w = y[0];
    if (w === "p" || w === "P") {
      const I = vs[w];
      return I(y, a.formatLong);
    }
    return y;
  }).join("").match(TA).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const w = y[0];
    if (w === "'")
      return { isToken: !1, value: BA(y) };
    if (Lf[w])
      return { isToken: !0, value: y };
    if (w.match(WA))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: y };
  });
  a.localize.preprocessor && (l = a.localize.preprocessor(s, l));
  const u = {
    firstWeekContainsDate: o,
    weekStartsOn: i,
    locale: a
  };
  return l.map((y) => {
    if (!y.isToken) return y.value;
    const w = y.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && Am(w) || !(t != null && t.useAdditionalDayOfYearTokens) && Pm(w)) && ku(w, r, String(e));
    const I = Lf[w[0]];
    return I(s, w, a.localize, u);
  }).join("");
}
function BA(e) {
  const r = e.match(NA);
  return r ? r[1].replace(LA, "'") : e;
}
function Yf(e) {
  return ie(e).getDate();
}
function VA(e) {
  return ie(e).getDay();
}
function Lr(e) {
  return ie(e).getHours();
}
function Wr(e) {
  return ie(e).getMinutes();
}
function Ot(e) {
  return ie(e).getMonth();
}
function ln(e) {
  return ie(e).getSeconds();
}
function Eu(e) {
  return ie(e).getTime();
}
function xe(e) {
  return ie(e).getFullYear();
}
function Mn(e, r) {
  const t = ie(e), n = ie(r);
  return t.getTime() > n.getTime();
}
function ea(e, r) {
  const t = ie(e), n = ie(r);
  return +t < +n;
}
function GA(e, r) {
  const t = ie(e), n = ie(r);
  return +t == +n;
}
function YA(e, r) {
  const t = Kn(e), n = Kn(r);
  return +t == +n;
}
function HA(e, r) {
  const t = ie(e), n = ie(r);
  return t.getFullYear() === n.getFullYear() && t.getMonth() === n.getMonth();
}
function Mu(e) {
  const r = ie(e), t = r.getMonth(), n = t - t % 3;
  return r.setMonth(n, 1), r.setHours(0, 0, 0, 0), r;
}
function zA(e, r) {
  const t = Mu(e), n = Mu(r);
  return +t == +n;
}
function $A(e, r) {
  const t = ie(e), n = ie(r);
  return t.getFullYear() === n.getFullYear();
}
function Wo(e, r) {
  const t = +ie(e), [n, a] = [
    +ie(r.start),
    +ie(r.end)
  ].sort((o, i) => o - i);
  return t >= n && t <= a;
}
function Hf(e) {
  let r;
  return e.forEach(function(t) {
    const n = ie(t);
    (r === void 0 || r < n || isNaN(Number(n))) && (r = n);
  }), r || /* @__PURE__ */ new Date(NaN);
}
function zf(e) {
  let r;
  return e.forEach((t) => {
    const n = ie(t);
    (!r || r > n || isNaN(+n)) && (r = n);
  }), r || /* @__PURE__ */ new Date(NaN);
}
function XA() {
  return Object.assign({}, ua());
}
function jA(e, r) {
  const t = r instanceof Date ? Ve(r, 0) : new r(0);
  return t.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
const ZA = 10;
class Rm {
  constructor() {
    ae(this, "subPriority", 0);
  }
  validate(r, t) {
    return !0;
  }
}
class UA extends Rm {
  constructor(r, t, n, a, o) {
    super(), this.value = r, this.validateValue = t, this.setValue = n, this.priority = a, o && (this.subPriority = o);
  }
  validate(r, t) {
    return this.validateValue(r, this.value, t);
  }
  set(r, t, n) {
    return this.setValue(r, t, this.value, n);
  }
}
class JA extends Rm {
  constructor() {
    super(...arguments);
    ae(this, "priority", ZA);
    ae(this, "subPriority", -1);
  }
  set(t, n) {
    return n.timestampIsSet ? t : Ve(t, jA(t, Date));
  }
}
class Fe {
  run(r, t, n, a) {
    const o = this.parse(r, t, n, a);
    return o ? {
      setter: new UA(
        o.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: o.rest
    } : null;
  }
  validate(r, t, n) {
    return !0;
  }
}
class QA extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 140);
    ae(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, n, a) {
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return a.era(t, { width: "abbreviated" }) || a.era(t, { width: "narrow" });
      case "GGGGG":
        return a.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return a.era(t, { width: "wide" }) || a.era(t, { width: "abbreviated" }) || a.era(t, { width: "narrow" });
    }
  }
  set(t, n, a) {
    return n.era = a, t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const pt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Ar = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function ht(e, r) {
  return e && {
    value: r(e.value),
    rest: e.rest
  };
}
function nt(e, r) {
  const t = r.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: r.slice(t[0].length)
  } : null;
}
function Rr(e, r) {
  const t = r.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: r.slice(1)
    };
  const n = t[1] === "+" ? 1 : -1, a = t[2] ? parseInt(t[2], 10) : 0, o = t[3] ? parseInt(t[3], 10) : 0, i = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: n * (a * Js + o * Us + i * YP),
    rest: r.slice(t[0].length)
  };
}
function Om(e) {
  return nt(pt.anyDigitsSigned, e);
}
function ut(e, r) {
  switch (e) {
    case 1:
      return nt(pt.singleDigit, r);
    case 2:
      return nt(pt.twoDigits, r);
    case 3:
      return nt(pt.threeDigits, r);
    case 4:
      return nt(pt.fourDigits, r);
    default:
      return nt(new RegExp("^\\d{1," + e + "}"), r);
  }
}
function ys(e, r) {
  switch (e) {
    case 1:
      return nt(pt.singleDigitSigned, r);
    case 2:
      return nt(pt.twoDigitsSigned, r);
    case 3:
      return nt(pt.threeDigitsSigned, r);
    case 4:
      return nt(pt.fourDigitsSigned, r);
    default:
      return nt(new RegExp("^-?\\d{1," + e + "}"), r);
  }
}
function Lc(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Tm(e, r) {
  const t = r > 0, n = t ? r : 1 - r;
  let a;
  if (n <= 50)
    a = e || 100;
  else {
    const o = n + 50, i = Math.trunc(o / 100) * 100, s = e >= o % 100;
    a = e + i - (s ? 100 : 0);
  }
  return t ? a : 1 - a;
}
function Fm(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class qA extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 130);
    ae(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, n, a) {
    const o = (i) => ({
      year: i,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return ht(ut(4, t), o);
      case "yo":
        return ht(
          a.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return ht(ut(n.length, t), o);
    }
  }
  validate(t, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(t, n, a) {
    const o = t.getFullYear();
    if (a.isTwoDigitYear) {
      const s = Tm(
        a.year,
        o
      );
      return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const i = !("era" in n) || n.era === 1 ? a.year : 1 - a.year;
    return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class KA extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 130);
    ae(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, n, a) {
    const o = (i) => ({
      year: i,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return ht(ut(4, t), o);
      case "Yo":
        return ht(
          a.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return ht(ut(n.length, t), o);
    }
  }
  validate(t, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(t, n, a, o) {
    const i = Nc(t, o);
    if (a.isTwoDigitYear) {
      const l = Tm(
        a.year,
        i
      );
      return t.setFullYear(
        l,
        0,
        o.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), dn(t, o);
    }
    const s = !("era" in n) || n.era === 1 ? a.year : 1 - a.year;
    return t.setFullYear(s, 0, o.firstWeekContainsDate), t.setHours(0, 0, 0, 0), dn(t, o);
  }
}
class eR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 130);
    ae(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n) {
    return ys(n === "R" ? 4 : n.length, t);
  }
  set(t, n, a) {
    const o = Ve(t, 0);
    return o.setFullYear(a, 0, 4), o.setHours(0, 0, 0, 0), Ga(o);
  }
}
class tR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 130);
    ae(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, n) {
    return ys(n === "u" ? 4 : n.length, t);
  }
  set(t, n, a) {
    return t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class rR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 120);
    ae(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, a) {
    switch (n) {
      case "Q":
      case "QQ":
        return ut(n.length, t);
      case "Qo":
        return a.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return a.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return a.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return a.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || a.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 4;
  }
  set(t, n, a) {
    return t.setMonth((a - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class nR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 120);
    ae(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, a) {
    switch (n) {
      case "q":
      case "qq":
        return ut(n.length, t);
      case "qo":
        return a.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return a.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return a.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return a.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || a.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 4;
  }
  set(t, n, a) {
    return t.setMonth((a - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class aR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    ae(this, "priority", 110);
  }
  parse(t, n, a) {
    const o = (i) => i - 1;
    switch (n) {
      case "M":
        return ht(
          nt(pt.month, t),
          o
        );
      case "MM":
        return ht(ut(2, t), o);
      case "Mo":
        return ht(
          a.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      case "MMM":
        return a.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return a.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return a.month(t, { width: "wide", context: "formatting" }) || a.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, a) {
    return t.setMonth(a, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class oR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 110);
    ae(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, a) {
    const o = (i) => i - 1;
    switch (n) {
      case "L":
        return ht(
          nt(pt.month, t),
          o
        );
      case "LL":
        return ht(ut(2, t), o);
      case "Lo":
        return ht(
          a.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      case "LLL":
        return a.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return a.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return a.month(t, { width: "wide", context: "standalone" }) || a.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, a) {
    return t.setMonth(a, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function iR(e, r, t) {
  const n = ie(e), a = Em(n, t) - r;
  return n.setDate(n.getDate() - a * 7), n;
}
class sR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 100);
    ae(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, n, a) {
    switch (n) {
      case "w":
        return nt(pt.week, t);
      case "wo":
        return a.ordinalNumber(t, { unit: "week" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 53;
  }
  set(t, n, a, o) {
    return dn(iR(t, a, o), o);
  }
}
function lR(e, r) {
  const t = ie(e), n = Fc(t) - r;
  return t.setDate(t.getDate() - n * 7), t;
}
class uR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 100);
    ae(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, a) {
    switch (n) {
      case "I":
        return nt(pt.week, t);
      case "Io":
        return a.ordinalNumber(t, { unit: "week" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 53;
  }
  set(t, n, a) {
    return Ga(lR(t, a));
  }
}
const cR = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], dR = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class fR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 90);
    ae(this, "subPriority", 1);
    ae(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, a) {
    switch (n) {
      case "d":
        return nt(pt.date, t);
      case "do":
        return a.ordinalNumber(t, { unit: "date" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    const a = t.getFullYear(), o = Fm(a), i = t.getMonth();
    return o ? n >= 1 && n <= dR[i] : n >= 1 && n <= cR[i];
  }
  set(t, n, a) {
    return t.setDate(a), t.setHours(0, 0, 0, 0), t;
  }
}
class pR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 90);
    ae(this, "subpriority", 1);
    ae(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, a) {
    switch (n) {
      case "D":
      case "DD":
        return nt(pt.dayOfYear, t);
      case "Do":
        return a.ordinalNumber(t, { unit: "date" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    const a = t.getFullYear();
    return Fm(a) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(t, n, a) {
    return t.setMonth(0, a), t.setHours(0, 0, 0, 0), t;
  }
}
function Wc(e, r, t) {
  var d, p, f, h;
  const n = ua(), a = (t == null ? void 0 : t.weekStartsOn) ?? ((p = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : p.weekStartsOn) ?? n.weekStartsOn ?? ((h = (f = n.locale) == null ? void 0 : f.options) == null ? void 0 : h.weekStartsOn) ?? 0, o = ie(e), i = o.getDay(), l = (r % 7 + 7) % 7, u = 7 - a, c = r < 0 || r > 6 ? r - (i + u) % 7 : (l + u) % 7 - (i + u) % 7;
  return Rn(o, c);
}
class hR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 90);
    ae(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, n, a) {
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return a.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return a.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return a.day(t, { width: "wide", context: "formatting" }) || a.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, a, o) {
    return t = Wc(t, a, o), t.setHours(0, 0, 0, 0), t;
  }
}
class gR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 90);
    ae(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, a, o) {
    const i = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + o.weekStartsOn + 6) % 7 + l;
    };
    switch (n) {
      case "e":
      case "ee":
        return ht(ut(n.length, t), i);
      case "eo":
        return ht(
          a.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      case "eee":
        return a.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return a.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return a.day(t, { width: "wide", context: "formatting" }) || a.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, a, o) {
    return t = Wc(t, a, o), t.setHours(0, 0, 0, 0), t;
  }
}
class mR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 90);
    ae(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, n, a, o) {
    const i = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + o.weekStartsOn + 6) % 7 + l;
    };
    switch (n) {
      case "c":
      case "cc":
        return ht(ut(n.length, t), i);
      case "co":
        return ht(
          a.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      case "ccc":
        return a.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.day(t, { width: "short", context: "standalone" }) || a.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return a.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return a.day(t, { width: "short", context: "standalone" }) || a.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return a.day(t, { width: "wide", context: "standalone" }) || a.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.day(t, { width: "short", context: "standalone" }) || a.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, a, o) {
    return t = Wc(t, a, o), t.setHours(0, 0, 0, 0), t;
  }
}
function vR(e) {
  let t = ie(e).getDay();
  return t === 0 && (t = 7), t;
}
function bR(e, r) {
  const t = ie(e), n = vR(t), a = r - n;
  return Rn(t, a);
}
class yR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 90);
    ae(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, a) {
    const o = (i) => i === 0 ? 7 : i;
    switch (n) {
      case "i":
      case "ii":
        return ut(n.length, t);
      case "io":
        return a.ordinalNumber(t, { unit: "day" });
      case "iii":
        return ht(
          a.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiii":
        return ht(
          a.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiiii":
        return ht(
          a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiii":
      default:
        return ht(
          a.day(t, {
            width: "wide",
            context: "formatting"
          }) || a.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 7;
  }
  set(t, n, a) {
    return t = bR(t, a), t.setHours(0, 0, 0, 0), t;
  }
}
class wR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 80);
    ae(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, n, a) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return a.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, a) {
    return t.setHours(Lc(a), 0, 0, 0), t;
  }
}
class CR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 80);
    ae(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, n, a) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return a.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, a) {
    return t.setHours(Lc(a), 0, 0, 0), t;
  }
}
class xR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 80);
    ae(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, n, a) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return a.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, a) {
    return t.setHours(Lc(a), 0, 0, 0), t;
  }
}
class SR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 70);
    ae(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, n, a) {
    switch (n) {
      case "h":
        return nt(pt.hour12h, t);
      case "ho":
        return a.ordinalNumber(t, { unit: "hour" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 12;
  }
  set(t, n, a) {
    const o = t.getHours() >= 12;
    return o && a < 12 ? t.setHours(a + 12, 0, 0, 0) : !o && a === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(a, 0, 0, 0), t;
  }
}
class IR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 70);
    ae(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, n, a) {
    switch (n) {
      case "H":
        return nt(pt.hour23h, t);
      case "Ho":
        return a.ordinalNumber(t, { unit: "hour" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 23;
  }
  set(t, n, a) {
    return t.setHours(a, 0, 0, 0), t;
  }
}
class DR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 70);
    ae(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, n, a) {
    switch (n) {
      case "K":
        return nt(pt.hour11h, t);
      case "Ko":
        return a.ordinalNumber(t, { unit: "hour" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, a) {
    return t.getHours() >= 12 && a < 12 ? t.setHours(a + 12, 0, 0, 0) : t.setHours(a, 0, 0, 0), t;
  }
}
class _R extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 70);
    ae(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, n, a) {
    switch (n) {
      case "k":
        return nt(pt.hour24h, t);
      case "ko":
        return a.ordinalNumber(t, { unit: "hour" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 24;
  }
  set(t, n, a) {
    const o = a <= 24 ? a % 24 : a;
    return t.setHours(o, 0, 0, 0), t;
  }
}
class kR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 60);
    ae(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, n, a) {
    switch (n) {
      case "m":
        return nt(pt.minute, t);
      case "mo":
        return a.ordinalNumber(t, { unit: "minute" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 59;
  }
  set(t, n, a) {
    return t.setMinutes(a, 0, 0), t;
  }
}
class ER extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 50);
    ae(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, n, a) {
    switch (n) {
      case "s":
        return nt(pt.second, t);
      case "so":
        return a.ordinalNumber(t, { unit: "second" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 59;
  }
  set(t, n, a) {
    return t.setSeconds(a, 0), t;
  }
}
class MR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 30);
    ae(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, n) {
    const a = (o) => Math.trunc(o * Math.pow(10, -n.length + 3));
    return ht(ut(n.length, t), a);
  }
  set(t, n, a) {
    return t.setMilliseconds(a), t;
  }
}
class PR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 10);
    ae(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, n) {
    switch (n) {
      case "X":
        return Rr(
          Ar.basicOptionalMinutes,
          t
        );
      case "XX":
        return Rr(Ar.basic, t);
      case "XXXX":
        return Rr(
          Ar.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return Rr(
          Ar.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return Rr(Ar.extended, t);
    }
  }
  set(t, n, a) {
    return n.timestampIsSet ? t : Ve(
      t,
      t.getTime() - ps(t) - a
    );
  }
}
class AR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 10);
    ae(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, n) {
    switch (n) {
      case "x":
        return Rr(
          Ar.basicOptionalMinutes,
          t
        );
      case "xx":
        return Rr(Ar.basic, t);
      case "xxxx":
        return Rr(
          Ar.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return Rr(
          Ar.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return Rr(Ar.extended, t);
    }
  }
  set(t, n, a) {
    return n.timestampIsSet ? t : Ve(
      t,
      t.getTime() - ps(t) - a
    );
  }
}
class RR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 40);
    ae(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Om(t);
  }
  set(t, n, a) {
    return [Ve(t, a * 1e3), { timestampIsSet: !0 }];
  }
}
class OR extends Fe {
  constructor() {
    super(...arguments);
    ae(this, "priority", 20);
    ae(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Om(t);
  }
  set(t, n, a) {
    return [Ve(t, a), { timestampIsSet: !0 }];
  }
}
const TR = {
  G: new QA(),
  y: new qA(),
  Y: new KA(),
  R: new eR(),
  u: new tR(),
  Q: new rR(),
  q: new nR(),
  M: new aR(),
  L: new oR(),
  w: new sR(),
  I: new uR(),
  d: new fR(),
  D: new pR(),
  E: new hR(),
  e: new gR(),
  c: new mR(),
  i: new yR(),
  a: new wR(),
  b: new CR(),
  B: new xR(),
  h: new SR(),
  H: new IR(),
  K: new DR(),
  k: new _R(),
  m: new kR(),
  s: new ER(),
  S: new MR(),
  X: new PR(),
  x: new AR(),
  t: new RR(),
  T: new OR()
}, FR = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, NR = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, LR = /^'([^]*?)'?$/, WR = /''/g, BR = /\S/, VR = /[a-zA-Z]/;
function Nl(e, r, t, n) {
  var g, m, v, y, w, I, b, D;
  const a = XA(), o = (n == null ? void 0 : n.locale) ?? a.locale ?? _m, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((m = (g = n == null ? void 0 : n.locale) == null ? void 0 : g.options) == null ? void 0 : m.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((y = (v = a.locale) == null ? void 0 : v.options) == null ? void 0 : y.firstWeekContainsDate) ?? 1, s = (n == null ? void 0 : n.weekStartsOn) ?? ((I = (w = n == null ? void 0 : n.locale) == null ? void 0 : w.options) == null ? void 0 : I.weekStartsOn) ?? a.weekStartsOn ?? ((D = (b = a.locale) == null ? void 0 : b.options) == null ? void 0 : D.weekStartsOn) ?? 0;
  if (r === "")
    return e === "" ? ie(t) : Ve(t, NaN);
  const l = {
    firstWeekContainsDate: i,
    weekStartsOn: s,
    locale: o
  }, u = [new JA()], c = r.match(NR).map((S) => {
    const _ = S[0];
    if (_ in vs) {
      const k = vs[_];
      return k(S, o.formatLong);
    }
    return S;
  }).join("").match(FR), d = [];
  for (let S of c) {
    !(n != null && n.useAdditionalWeekYearTokens) && Am(S) && ku(S, r, e), !(n != null && n.useAdditionalDayOfYearTokens) && Pm(S) && ku(S, r, e);
    const _ = S[0], k = TR[_];
    if (k) {
      const { incompatibleTokens: R } = k;
      if (Array.isArray(R)) {
        const B = d.find(
          (V) => R.includes(V.token) || V.token === _
        );
        if (B)
          throw new RangeError(
            `The format string mustn't contain \`${B.fullToken}\` and \`${S}\` at the same time`
          );
      } else if (k.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${S}\` and any other token at the same time`
        );
      d.push({ token: _, fullToken: S });
      const W = k.run(
        e,
        S,
        o.match,
        l
      );
      if (!W)
        return Ve(t, NaN);
      u.push(W.setter), e = W.rest;
    } else {
      if (_.match(VR))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + _ + "`"
        );
      if (S === "''" ? S = "'" : _ === "'" && (S = GR(S)), e.indexOf(S) === 0)
        e = e.slice(S.length);
      else
        return Ve(t, NaN);
    }
  }
  if (e.length > 0 && BR.test(e))
    return Ve(t, NaN);
  const p = u.map((S) => S.priority).sort((S, _) => _ - S).filter((S, _, k) => k.indexOf(S) === _).map(
    (S) => u.filter((_) => _.priority === S).sort((_, k) => k.subPriority - _.subPriority)
  ).map((S) => S[0]);
  let f = ie(t);
  if (isNaN(f.getTime()))
    return Ve(t, NaN);
  const h = {};
  for (const S of p) {
    if (!S.validate(f, l))
      return Ve(t, NaN);
    const _ = S.set(f, h, l);
    Array.isArray(_) ? (f = _[0], Object.assign(h, _[1])) : f = _;
  }
  return Ve(t, f);
}
function GR(e) {
  return e.match(LR)[1].replace(WR, "'");
}
function YR(e, r) {
  const n = XR(e);
  let a;
  if (n.date) {
    const l = jR(n.date, 2);
    a = ZR(l.restDateString, l.year);
  }
  if (!a || isNaN(a.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const o = a.getTime();
  let i = 0, s;
  if (n.time && (i = UR(n.time), isNaN(i)))
    return /* @__PURE__ */ new Date(NaN);
  if (n.timezone) {
    if (s = JR(n.timezone), isNaN(s))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const l = new Date(o + i), u = /* @__PURE__ */ new Date(0);
    return u.setFullYear(
      l.getUTCFullYear(),
      l.getUTCMonth(),
      l.getUTCDate()
    ), u.setHours(
      l.getUTCHours(),
      l.getUTCMinutes(),
      l.getUTCSeconds(),
      l.getUTCMilliseconds()
    ), u;
  }
  return new Date(o + i + s);
}
const bi = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, HR = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, zR = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, $R = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function XR(e) {
  const r = {}, t = e.split(bi.dateTimeDelimiter);
  let n;
  if (t.length > 2)
    return r;
  if (/:/.test(t[0]) ? n = t[0] : (r.date = t[0], n = t[1], bi.timeZoneDelimiter.test(r.date) && (r.date = e.split(bi.timeZoneDelimiter)[0], n = e.substr(
    r.date.length,
    e.length
  ))), n) {
    const a = bi.timezone.exec(n);
    a ? (r.time = n.replace(a[1], ""), r.timezone = a[1]) : r.time = n;
  }
  return r;
}
function jR(e, r) {
  const t = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + r) + "})|(\\d{2}|[+-]\\d{" + (2 + r) + "})$)"
  ), n = e.match(t);
  if (!n) return { year: NaN, restDateString: "" };
  const a = n[1] ? parseInt(n[1]) : null, o = n[2] ? parseInt(n[2]) : null;
  return {
    year: o === null ? a : o * 100,
    restDateString: e.slice((n[1] || n[2]).length)
  };
}
function ZR(e, r) {
  if (r === null) return /* @__PURE__ */ new Date(NaN);
  const t = e.match(HR);
  if (!t) return /* @__PURE__ */ new Date(NaN);
  const n = !!t[4], a = mo(t[1]), o = mo(t[2]) - 1, i = mo(t[3]), s = mo(t[4]), l = mo(t[5]) - 1;
  if (n)
    return tO(r, s, l) ? QR(r, s, l) : /* @__PURE__ */ new Date(NaN);
  {
    const u = /* @__PURE__ */ new Date(0);
    return !KR(r, o, i) || !eO(r, a) ? /* @__PURE__ */ new Date(NaN) : (u.setUTCFullYear(r, o, Math.max(a, i)), u);
  }
}
function mo(e) {
  return e ? parseInt(e) : 1;
}
function UR(e) {
  const r = e.match(zR);
  if (!r) return NaN;
  const t = Ll(r[1]), n = Ll(r[2]), a = Ll(r[3]);
  return rO(t, n, a) ? t * Js + n * Us + a * 1e3 : NaN;
}
function Ll(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function JR(e) {
  if (e === "Z") return 0;
  const r = e.match($R);
  if (!r) return 0;
  const t = r[1] === "+" ? -1 : 1, n = parseInt(r[2]), a = r[3] && parseInt(r[3]) || 0;
  return nO(n, a) ? t * (n * Js + a * Us) : NaN;
}
function QR(e, r, t) {
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  const a = n.getUTCDay() || 7, o = (r - 1) * 7 + t + 1 - a;
  return n.setUTCDate(n.getUTCDate() + o), n;
}
const qR = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Nm(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function KR(e, r, t) {
  return r >= 0 && r <= 11 && t >= 1 && t <= (qR[r] || (Nm(e) ? 29 : 28));
}
function eO(e, r) {
  return r >= 1 && r <= (Nm(e) ? 366 : 365);
}
function tO(e, r, t) {
  return r >= 1 && r <= 53 && t >= 0 && t <= 6;
}
function rO(e, r, t) {
  return e === 24 ? r === 0 && t === 0 : t >= 0 && t < 60 && r >= 0 && r < 60 && e >= 0 && e < 25;
}
function nO(e, r) {
  return r >= 0 && r <= 59;
}
function aO(e) {
  const r = ie(e), t = r.getFullYear(), n = r.getMonth(), a = Ve(e, 0);
  return a.setFullYear(t, n + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function $t(e, r) {
  const t = ie(e), n = t.getFullYear(), a = t.getDate(), o = Ve(e, 0);
  o.setFullYear(n, r, 15), o.setHours(0, 0, 0, 0);
  const i = aO(o);
  return t.setMonth(r, Math.min(a, i)), t;
}
function oO(e, r) {
  let t = ie(e);
  return isNaN(+t) ? Ve(e, NaN) : (r.year != null && t.setFullYear(r.year), r.month != null && (t = $t(t, r.month)), r.date != null && t.setDate(r.date), r.hours != null && t.setHours(r.hours), r.minutes != null && t.setMinutes(r.minutes), r.seconds != null && t.setSeconds(r.seconds), r.milliseconds != null && t.setMilliseconds(r.milliseconds), t);
}
function Fi(e, r) {
  const t = ie(e);
  return t.setHours(r), t;
}
function Ni(e, r) {
  const t = ie(e);
  return t.setMinutes(r), t;
}
function wa(e, r) {
  const t = ie(e), n = Math.trunc(t.getMonth() / 3) + 1, a = r - n;
  return $t(t, t.getMonth() + a * 3);
}
function Li(e, r) {
  const t = ie(e);
  return t.setSeconds(r), t;
}
function kr(e, r) {
  const t = ie(e);
  return isNaN(+t) ? Ve(e, NaN) : (t.setFullYear(r), t);
}
function Lm(e) {
  const r = ie(e);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function iO(e, r) {
  return Rn(e, -1);
}
function Ya(e, r) {
  return wr(e, -r);
}
function Wm(e, r) {
  return Tc(e, -1);
}
function $f(e, r) {
  return fs(e, -1);
}
function Ha(e, r) {
  return on(e, -r);
}
var sO = typeof document < "u", lO = function() {
}, Wi = sO ? Go : lO;
function ws(e, r) {
  if (e === r)
    return !0;
  if (typeof e != typeof r)
    return !1;
  if (typeof e == "function" && e.toString() === r.toString())
    return !0;
  let t, n, a;
  if (e && r && typeof e == "object") {
    if (Array.isArray(e)) {
      if (t = e.length, t !== r.length) return !1;
      for (n = t; n-- !== 0; )
        if (!ws(e[n], r[n]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), t = a.length, t !== Object.keys(r).length)
      return !1;
    for (n = t; n-- !== 0; )
      if (!{}.hasOwnProperty.call(r, a[n]))
        return !1;
    for (n = t; n-- !== 0; ) {
      const o = a[n];
      if (!(o === "_owner" && e.$$typeof) && !ws(e[o], r[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && r !== r;
}
function Bm(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Xf(e, r) {
  const t = Bm(e);
  return Math.round(r * t) / t;
}
function Wl(e) {
  const r = U.useRef(e);
  return Wi(() => {
    r.current = e;
  }), r;
}
function uO(e) {
  e === void 0 && (e = {});
  const {
    placement: r = "bottom",
    strategy: t = "absolute",
    middleware: n = [],
    platform: a,
    elements: {
      reference: o,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: u
  } = e, [c, d] = U.useState({
    x: 0,
    y: 0,
    strategy: t,
    placement: r,
    middlewareData: {},
    isPositioned: !1
  }), [p, f] = U.useState(n);
  ws(p, n) || f(n);
  const [h, g] = U.useState(null), [m, v] = U.useState(null), y = U.useCallback((G) => {
    G !== D.current && (D.current = G, g(G));
  }, []), w = U.useCallback((G) => {
    G !== S.current && (S.current = G, v(G));
  }, []), I = o || h, b = i || m, D = U.useRef(null), S = U.useRef(null), _ = U.useRef(c), k = l != null, R = Wl(l), W = Wl(a), B = Wl(u), V = U.useCallback(() => {
    if (!D.current || !S.current)
      return;
    const G = {
      placement: r,
      strategy: t,
      middleware: p
    };
    W.current && (G.platform = W.current), iy(D.current, S.current, G).then((Q) => {
      const L = {
        ...Q,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: B.current !== !1
      };
      F.current && !ws(_.current, L) && (_.current = L, Vb.flushSync(() => {
        d(L);
      }));
    });
  }, [p, r, t, W, B]);
  Wi(() => {
    u === !1 && _.current.isPositioned && (_.current.isPositioned = !1, d((G) => ({
      ...G,
      isPositioned: !1
    })));
  }, [u]);
  const F = U.useRef(!1);
  Wi(() => (F.current = !0, () => {
    F.current = !1;
  }), []), Wi(() => {
    if (I && (D.current = I), b && (S.current = b), I && b) {
      if (R.current)
        return R.current(I, b, V);
      V();
    }
  }, [I, b, V, R, k]);
  const H = U.useMemo(() => ({
    reference: D,
    floating: S,
    setReference: y,
    setFloating: w
  }), [y, w]), A = U.useMemo(() => ({
    reference: I,
    floating: b
  }), [I, b]), N = U.useMemo(() => {
    const G = {
      position: t,
      left: 0,
      top: 0
    };
    if (!A.floating)
      return G;
    const Q = Xf(A.floating, c.x), L = Xf(A.floating, c.y);
    return s ? {
      ...G,
      transform: "translate(" + Q + "px, " + L + "px)",
      ...Bm(A.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: t,
      left: Q,
      top: L
    };
  }, [t, s, A.floating, c.x, c.y]);
  return U.useMemo(() => ({
    ...c,
    update: V,
    refs: H,
    elements: A,
    floatingStyles: N
  }), [c, V, H, A, N]);
}
const cO = (e) => {
  function r(t) {
    return {}.hasOwnProperty.call(t, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const {
        element: n,
        padding: a
      } = typeof e == "function" ? e(t) : e;
      return n && r(n) ? n.current != null ? md({
        element: n.current,
        padding: a
      }).fn(t) : {} : n ? md({
        element: n,
        padding: a
      }).fn(t) : {};
    }
  };
}, dO = (e, r) => ({
  ...ay(e),
  options: [e, r]
}), fO = (e, r) => ({
  ...oy(e),
  options: [e, r]
}), pO = (e, r) => ({
  ...cO(e),
  options: [e, r]
}), Vm = {
  ...U
}, hO = Vm.useInsertionEffect, gO = hO || ((e) => e());
function mO(e) {
  const r = U.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return gO(() => {
    r.current = e;
  }), U.useCallback(function() {
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    return r.current == null ? void 0 : r.current(...n);
  }, []);
}
var Cs = typeof document < "u" ? Go : He;
function Pu() {
  return Pu = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Pu.apply(this, arguments);
}
let jf = !1, vO = 0;
const Zf = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + vO++
);
function bO() {
  const [e, r] = U.useState(() => jf ? Zf() : void 0);
  return Cs(() => {
    e == null && r(Zf());
  }, []), U.useEffect(() => {
    jf = !0;
  }, []), e;
}
const yO = Vm.useId, Gm = yO || bO;
let Bo;
process.env.NODE_ENV !== "production" && (Bo = /* @__PURE__ */ new Set());
function wO() {
  for (var e, r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  const a = "Floating UI: " + t.join(" ");
  if (!((e = Bo) != null && e.has(a))) {
    var o;
    (o = Bo) == null || o.add(a), console.warn(a);
  }
}
function CO() {
  for (var e, r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  const a = "Floating UI: " + t.join(" ");
  if (!((e = Bo) != null && e.has(a))) {
    var o;
    (o = Bo) == null || o.add(a), console.error(a);
  }
}
const xO = /* @__PURE__ */ U.forwardRef(function(r, t) {
  const {
    context: {
      placement: n,
      elements: {
        floating: a
      },
      middlewareData: {
        arrow: o,
        shift: i
      }
    },
    width: s = 14,
    height: l = 7,
    tipRadius: u = 0,
    strokeWidth: c = 0,
    staticOffset: d,
    stroke: p,
    d: f,
    style: {
      transform: h,
      ...g
    } = {},
    ...m
  } = r;
  process.env.NODE_ENV !== "production" && (t || wO("The `ref` prop is required for `FloatingArrow`."));
  const v = Gm(), [y, w] = U.useState(!1);
  if (Cs(() => {
    if (!a) return;
    lr(a).direction === "rtl" && w(!0);
  }, [a]), !a)
    return null;
  const [I, b] = n.split("-"), D = I === "top" || I === "bottom";
  let S = d;
  (D && i != null && i.x || !D && i != null && i.y) && (S = null);
  const _ = c * 2, k = _ / 2, R = s / 2 * (u / -8 + 1), W = l / 2 * u / 4, B = !!f, V = S && b === "end" ? "bottom" : "top";
  let F = S && b === "end" ? "right" : "left";
  S && y && (F = b === "end" ? "left" : "right");
  const H = (o == null ? void 0 : o.x) != null ? S || o.x : "", A = (o == null ? void 0 : o.y) != null ? S || o.y : "", N = f || "M0,0" + (" H" + s) + (" L" + (s - R) + "," + (l - W)) + (" Q" + s / 2 + "," + l + " " + R + "," + (l - W)) + " Z", G = {
    top: B ? "rotate(180deg)" : "",
    left: B ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: B ? "" : "rotate(180deg)",
    right: B ? "rotate(-90deg)" : "rotate(90deg)"
  }[I];
  return /* @__PURE__ */ U.createElement("svg", Pu({}, m, {
    "aria-hidden": !0,
    ref: t,
    width: B ? s : s + _,
    height: s,
    viewBox: "0 0 " + s + " " + (l > s ? l : s),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [F]: H,
      [V]: A,
      [I]: D || B ? "100%" : "calc(100% - " + _ / 2 + "px)",
      transform: [G, h].filter((Q) => !!Q).join(" "),
      ...g
    }
  }), _ > 0 && /* @__PURE__ */ U.createElement("path", {
    clipPath: "url(#" + v + ")",
    fill: "none",
    stroke: p,
    strokeWidth: _ + (f ? 0 : 1),
    d: N
  }), /* @__PURE__ */ U.createElement("path", {
    stroke: _ && !f ? m.fill : "none",
    d: N
  }), /* @__PURE__ */ U.createElement("clipPath", {
    id: v
  }, /* @__PURE__ */ U.createElement("rect", {
    x: -k,
    y: k * (B ? -1 : 1),
    width: s + _,
    height: s
  })));
});
function SO() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(r, t) {
      var n;
      (n = e.get(r)) == null || n.forEach((a) => a(t));
    },
    on(r, t) {
      e.set(r, [...e.get(r) || [], t]);
    },
    off(r, t) {
      var n;
      e.set(r, ((n = e.get(r)) == null ? void 0 : n.filter((a) => a !== t)) || []);
    }
  };
}
const IO = /* @__PURE__ */ U.createContext(null), DO = /* @__PURE__ */ U.createContext(null), _O = () => {
  var e;
  return ((e = U.useContext(IO)) == null ? void 0 : e.id) || null;
}, kO = () => U.useContext(DO);
function EO(e) {
  const {
    open: r = !1,
    onOpenChange: t,
    elements: n
  } = e, a = Gm(), o = U.useRef({}), [i] = U.useState(() => SO()), s = _O() != null;
  if (process.env.NODE_ENV !== "production") {
    const f = n.reference;
    f && !kt(f) && CO("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, u] = U.useState(n.reference), c = mO((f, h, g) => {
    o.current.openEvent = f ? h : void 0, i.emit("openchange", {
      open: f,
      event: h,
      reason: g,
      nested: s
    }), t == null || t(f, h, g);
  }), d = U.useMemo(() => ({
    setPositionReference: u
  }), []), p = U.useMemo(() => ({
    reference: l || n.reference || null,
    floating: n.floating || null,
    domReference: n.reference
  }), [l, n.reference, n.floating]);
  return U.useMemo(() => ({
    dataRef: o,
    open: r,
    onOpenChange: c,
    elements: p,
    events: i,
    floatingId: a,
    refs: d
  }), [r, c, p, i, a, d]);
}
function MO(e) {
  e === void 0 && (e = {});
  const {
    nodeId: r
  } = e, t = EO({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), n = e.rootContext || t, a = n.elements, [o, i] = U.useState(null), [s, l] = U.useState(null), c = (a == null ? void 0 : a.domReference) || o, d = U.useRef(null), p = kO();
  Cs(() => {
    c && (d.current = c);
  }, [c]);
  const f = uO({
    ...e,
    elements: {
      ...a,
      ...s && {
        reference: s
      }
    }
  }), h = U.useCallback((w) => {
    const I = kt(w) ? {
      getBoundingClientRect: () => w.getBoundingClientRect(),
      contextElement: w
    } : w;
    l(I), f.refs.setReference(I);
  }, [f.refs]), g = U.useCallback((w) => {
    (kt(w) || w === null) && (d.current = w, i(w)), (kt(f.refs.reference.current) || f.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    w !== null && !kt(w)) && f.refs.setReference(w);
  }, [f.refs]), m = U.useMemo(() => ({
    ...f.refs,
    setReference: g,
    setPositionReference: h,
    domReference: d
  }), [f.refs, g, h]), v = U.useMemo(() => ({
    ...f.elements,
    domReference: c
  }), [f.elements, c]), y = U.useMemo(() => ({
    ...f,
    ...n,
    refs: m,
    elements: v,
    nodeId: r
  }), [f, m, v, r, n]);
  return Cs(() => {
    n.dataRef.current.floatingContext = y;
    const w = p == null ? void 0 : p.nodesRef.current.find((I) => I.id === r);
    w && (w.context = y);
  }), U.useMemo(() => ({
    ...f,
    context: y,
    refs: m,
    elements: v
  }), [f, m, v, y]);
}
/*!
  react-datepicker v7.4.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/
var Au = function(r, t) {
  return Au = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(n, a) {
    n.__proto__ = a;
  } || function(n, a) {
    for (var o in a) Object.prototype.hasOwnProperty.call(a, o) && (n[o] = a[o]);
  }, Au(r, t);
};
function xt(e, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  Au(e, r);
  function t() {
    this.constructor = e;
  }
  e.prototype = r === null ? Object.create(r) : (t.prototype = r.prototype, new t());
}
var Me = function() {
  return Me = Object.assign || function(t) {
    for (var n, a = 1, o = arguments.length; a < o; a++) {
      n = arguments[a];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Me.apply(this, arguments);
};
function Tr(e, r, t) {
  if (t || arguments.length === 2) for (var n = 0, a = r.length, o; n < a; n++)
    (o || !(n in r)) && (o || (o = Array.prototype.slice.call(r, 0, n)), o[n] = r[n]);
  return e.concat(o || Array.prototype.slice.call(r));
}
var PO = function(e) {
  var r = e.showTimeSelectOnly, t = r === void 0 ? !1 : r, n = e.showTime, a = n === void 0 ? !1 : n, o = e.className, i = e.children, s = t ? "Choose Time" : "Choose Date".concat(a ? " and Time" : "");
  return P.createElement("div", { className: o, role: "dialog", "aria-label": s, "aria-modal": "true" }, i);
}, AO = function(e, r) {
  var t = ye(null), n = ye(e);
  n.current = e;
  var a = re(function(o) {
    var i;
    t.current && !t.current.contains(o.target) && (r && o.target instanceof HTMLElement && o.target.classList.contains(r) || (i = n.current) === null || i === void 0 || i.call(n, o));
  }, [r]);
  return He(function() {
    return document.addEventListener("mousedown", a), function() {
      document.removeEventListener("mousedown", a);
    };
  }, [a]), t;
}, qs = function(e) {
  var r = e.children, t = e.onClickOutside, n = e.className, a = e.containerRef, o = e.style, i = e.ignoreClass, s = AO(t, i);
  return P.createElement("div", { className: n, style: o, ref: function(l) {
    s.current = l, a && (a.current = l);
  } }, r);
}, te;
(function(e) {
  e.ArrowUp = "ArrowUp", e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Home = "Home", e.End = "End", e.Enter = "Enter", e.Space = " ", e.Tab = "Tab", e.Escape = "Escape", e.Backspace = "Backspace", e.X = "x";
})(te || (te = {}));
function Ym() {
  var e = typeof window < "u" ? window : globalThis;
  return e;
}
var ti = 12, RO = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function Ge(e) {
  if (e == null)
    return /* @__PURE__ */ new Date();
  var r = typeof e == "string" ? YR(e) : ie(e);
  return Kr(r) ? r : /* @__PURE__ */ new Date();
}
function Bl(e, r, t, n, a) {
  var o, i = null, s = Xn(t) || Xn(Eo()), l = !0;
  if (Array.isArray(r))
    return r.forEach(function(c) {
      var d = Nl(e, c, /* @__PURE__ */ new Date(), {
        locale: s,
        useAdditionalWeekYearTokens: !0,
        useAdditionalDayOfYearTokens: !0
      });
      n && (l = Kr(d, a) && e === Qe(d, c, t)), Kr(d, a) && l && (i = d);
    }), i;
  if (i = Nl(e, r, /* @__PURE__ */ new Date(), {
    locale: s,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  }), n)
    l = Kr(i) && e === Qe(i, r, t);
  else if (!Kr(i)) {
    var u = ((o = r.match(RO)) !== null && o !== void 0 ? o : []).map(function(c) {
      var d = c[0];
      if (d === "p" || d === "P") {
        var p = vs[d];
        return s ? p(c, s.formatLong) : d;
      }
      return c;
    }).join("");
    e.length > 0 && (i = Nl(e, u.slice(0, e.length), /* @__PURE__ */ new Date(), {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    })), Kr(i) || (i = new Date(e));
  }
  return Kr(i) && l ? i : null;
}
function Kr(e, r) {
  return bs(e) && !ea(e, r ?? /* @__PURE__ */ new Date("1/1/1800"));
}
function Qe(e, r, t) {
  if (t === "en")
    return Gf(e, r, {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    });
  var n = t ? Xn(t) : void 0;
  return t && !n && console.warn('A locale object was not found for the provided string ["'.concat(t, '"].')), !n && Eo() && Xn(Eo()) && (n = Xn(Eo())), Gf(e, r, {
    locale: n,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  });
}
function rr(e, r) {
  var t = r.dateFormat, n = r.locale, a = Array.isArray(t) && t.length > 0 ? t[0] : t;
  return e && Qe(e, a, n) || "";
}
function OO(e, r, t) {
  if (!e)
    return "";
  var n = rr(e, t), a = r ? rr(r, t) : "";
  return "".concat(n, " - ").concat(a);
}
function TO(e, r) {
  if (!(e != null && e.length))
    return "";
  var t = e[0] ? rr(e[0], r) : "";
  if (e.length === 1)
    return t;
  if (e.length === 2 && e[1]) {
    var n = rr(e[1], r);
    return "".concat(t, ", ").concat(n);
  }
  var a = e.length - 1;
  return "".concat(t, " (+").concat(a, ")");
}
function Vl(e, r) {
  var t = r.hour, n = t === void 0 ? 0 : t, a = r.minute, o = a === void 0 ? 0 : a, i = r.second, s = i === void 0 ? 0 : i;
  return Fi(Ni(Li(e, s), o), n);
}
function FO(e) {
  return Fc(e);
}
function NO(e, r) {
  return Qe(e, "ddd", r);
}
function Bi(e) {
  return Kn(e);
}
function Dn(e, r, t) {
  var n = Xn(r || Eo());
  return dn(e, {
    locale: n,
    weekStartsOn: t
  });
}
function _n(e) {
  return Lm(e);
}
function wo(e) {
  return Qs(e);
}
function Uf(e) {
  return Mu(e);
}
function Jf() {
  return Kn(Ge());
}
function Qf(e) {
  return Im(e);
}
function LO(e) {
  return jP(e);
}
function Mr(e, r) {
  return e && r ? $A(e, r) : !e && !r;
}
function Pt(e, r) {
  return e && r ? HA(e, r) : !e && !r;
}
function xs(e, r) {
  return e && r ? zA(e, r) : !e && !r;
}
function _e(e, r) {
  return e && r ? YA(e, r) : !e && !r;
}
function Gn(e, r) {
  return e && r ? GA(e, r) : !e && !r;
}
function Co(e, r, t) {
  var n, a = Kn(r), o = Im(t);
  try {
    n = Wo(e, { start: a, end: o });
  } catch {
    n = !1;
  }
  return n;
}
function Eo() {
  var e = Ym();
  return e.__localeId__;
}
function Xn(e) {
  if (typeof e == "string") {
    var r = Ym();
    return r.__localeData__ ? r.__localeData__[e] : void 0;
  } else
    return e;
}
function WO(e, r, t) {
  return r(Qe(e, "EEEE", t));
}
function BO(e, r) {
  return Qe(e, "EEEEEE", r);
}
function VO(e, r) {
  return Qe(e, "EEE", r);
}
function Bc(e, r) {
  return Qe($t(Ge(), e), "LLLL", r);
}
function Hm(e, r) {
  return Qe($t(Ge(), e), "LLL", r);
}
function GO(e, r) {
  return Qe(wa(Ge(), e), "QQQ", r);
}
function Pr(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, a = t.maxDate, o = t.excludeDates, i = t.excludeDateIntervals, s = t.includeDates, l = t.includeDateIntervals, u = t.filterDate;
  return ri(e, { minDate: n, maxDate: a }) || o && o.some(function(c) {
    return c instanceof Date ? _e(e, c) : _e(e, c.date);
  }) || i && i.some(function(c) {
    var d = c.start, p = c.end;
    return Wo(e, { start: d, end: p });
  }) || s && !s.some(function(c) {
    return _e(e, c);
  }) || l && !l.some(function(c) {
    var d = c.start, p = c.end;
    return Wo(e, { start: d, end: p });
  }) || u && !u(Ge(e)) || !1;
}
function Vc(e, r) {
  var t = r === void 0 ? {} : r, n = t.excludeDates, a = t.excludeDateIntervals;
  return a && a.length > 0 ? a.some(function(o) {
    var i = o.start, s = o.end;
    return Wo(e, { start: i, end: s });
  }) : n && n.some(function(o) {
    var i;
    return o instanceof Date ? _e(e, o) : _e(e, (i = o.date) !== null && i !== void 0 ? i : /* @__PURE__ */ new Date());
  }) || !1;
}
function zm(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, a = t.maxDate, o = t.excludeDates, i = t.includeDates, s = t.filterDate;
  return ri(e, {
    minDate: n ? Lm(n) : void 0,
    maxDate: a ? $P(a) : void 0
  }) || (o == null ? void 0 : o.some(function(l) {
    return Pt(e, l instanceof Date ? l : l.date);
  })) || i && !i.some(function(l) {
    return Pt(e, l);
  }) || s && !s(Ge(e)) || !1;
}
function yi(e, r, t, n) {
  var a = xe(e), o = Ot(e), i = xe(r), s = Ot(r), l = xe(n);
  return a === i && a === l ? o <= t && t <= s : a < i ? l === a && o <= t || l === i && s >= t || l < i && l > a : !1;
}
function YO(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, a = t.maxDate, o = t.excludeDates, i = t.includeDates;
  return ri(e, { minDate: n, maxDate: a }) || o && o.some(function(s) {
    return Pt(s instanceof Date ? s : s.date, e);
  }) || i && !i.some(function(s) {
    return Pt(s, e);
  }) || !1;
}
function wi(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, a = t.maxDate, o = t.excludeDates, i = t.includeDates, s = t.filterDate;
  return ri(e, { minDate: n, maxDate: a }) || (o == null ? void 0 : o.some(function(l) {
    return xs(e, l instanceof Date ? l : l.date);
  })) || i && !i.some(function(l) {
    return xs(e, l);
  }) || s && !s(Ge(e)) || !1;
}
function Ci(e, r, t) {
  if (!r || !t || !bs(r) || !bs(t))
    return !1;
  var n = xe(r), a = xe(t);
  return n <= e && a >= e;
}
function Vi(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, a = t.maxDate, o = t.excludeDates, i = t.includeDates, s = t.filterDate, l = new Date(e, 0, 1);
  return ri(l, {
    minDate: n ? Qs(n) : void 0,
    maxDate: a ? Dm(a) : void 0
  }) || (o == null ? void 0 : o.some(function(u) {
    return Mr(l, u instanceof Date ? u : u.date);
  })) || i && !i.some(function(u) {
    return Mr(l, u);
  }) || s && !s(Ge(l)) || !1;
}
function xi(e, r, t, n) {
  var a = xe(e), o = $n(e), i = xe(r), s = $n(r), l = xe(n);
  return a === i && a === l ? o <= t && t <= s : a < i ? l === a && o <= t || l === i && s >= t || l < i && l > a : !1;
}
function ri(e, r) {
  var t, n = r === void 0 ? {} : r, a = n.minDate, o = n.maxDate;
  return (t = a && Lo(e, a) < 0 || o && Lo(e, o) > 0) !== null && t !== void 0 ? t : !1;
}
function qf(e, r) {
  return r.some(function(t) {
    return Lr(t) === Lr(e) && Wr(t) === Wr(e) && ln(t) === ln(e);
  });
}
function Kf(e, r) {
  var t = r === void 0 ? {} : r, n = t.excludeTimes, a = t.includeTimes, o = t.filterTime;
  return n && qf(e, n) || a && !qf(e, a) || o && !o(e) || !1;
}
function ep(e, r) {
  var t = r.minTime, n = r.maxTime;
  if (!t || !n)
    throw new Error("Both minTime and maxTime props required");
  var a = Ge();
  a = Fi(a, Lr(e)), a = Ni(a, Wr(e)), a = Li(a, ln(e));
  var o = Ge();
  o = Fi(o, Lr(t)), o = Ni(o, Wr(t)), o = Li(o, ln(t));
  var i = Ge();
  i = Fi(i, Lr(n)), i = Ni(i, Wr(n)), i = Li(i, ln(n));
  var s;
  try {
    s = !Wo(a, { start: o, end: i });
  } catch {
    s = !1;
  }
  return s;
}
function tp(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, a = t.includeDates, o = Ya(e, 1);
  return n && hs(n, o) > 0 || a && a.every(function(i) {
    return hs(i, o) > 0;
  }) || !1;
}
function rp(e, r) {
  var t = r === void 0 ? {} : r, n = t.maxDate, a = t.includeDates, o = wr(e, 1);
  return n && hs(o, n) > 0 || a && a.every(function(i) {
    return hs(o, i) > 0;
  }) || !1;
}
function HO(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, a = t.includeDates, o = Qs(e), i = Wm(o);
  return n && gs(n, i) > 0 || a && a.every(function(s) {
    return gs(s, i) > 0;
  }) || !1;
}
function zO(e, r) {
  var t = r === void 0 ? {} : r, n = t.maxDate, a = t.includeDates, o = Dm(e), i = Tc(o, 1);
  return n && gs(i, n) > 0 || a && a.every(function(s) {
    return gs(i, s) > 0;
  }) || !1;
}
function np(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, a = t.includeDates, o = Ha(e, 1);
  return n && ms(n, o) > 0 || a && a.every(function(i) {
    return ms(i, o) > 0;
  }) || !1;
}
function $O(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, a = t.yearItemNumber, o = a === void 0 ? ti : a, i = wo(Ha(e, o)), s = xn(i, o).endPeriod, l = n && xe(n);
  return l && l > s || !1;
}
function ap(e, r) {
  var t = r === void 0 ? {} : r, n = t.maxDate, a = t.includeDates, o = on(e, 1);
  return n && ms(o, n) > 0 || a && a.every(function(i) {
    return ms(o, i) > 0;
  }) || !1;
}
function XO(e, r) {
  var t = r === void 0 ? {} : r, n = t.maxDate, a = t.yearItemNumber, o = a === void 0 ? ti : a, i = on(e, o), s = xn(i, o).startPeriod, l = n && xe(n);
  return l && l < s || !1;
}
function $m(e) {
  var r = e.minDate, t = e.includeDates;
  if (t && r) {
    var n = t.filter(function(a) {
      return Lo(a, r) >= 0;
    });
    return zf(n);
  } else return t ? zf(t) : r;
}
function Xm(e) {
  var r = e.maxDate, t = e.includeDates;
  if (t && r) {
    var n = t.filter(function(a) {
      return Lo(a, r) <= 0;
    });
    return Hf(n);
  } else return t ? Hf(t) : r;
}
function op(e, r) {
  var t;
  e === void 0 && (e = []), r === void 0 && (r = "react-datepicker__day--highlighted");
  for (var n = /* @__PURE__ */ new Map(), a = 0, o = e.length; a < o; a++) {
    var i = e[a];
    if (sn(i)) {
      var s = Qe(i, "MM.dd.yyyy"), l = n.get(s) || [];
      l.includes(r) || (l.push(r), n.set(s, l));
    } else if (typeof i == "object") {
      var u = Object.keys(i), c = (t = u[0]) !== null && t !== void 0 ? t : "", d = i[c];
      if (typeof c == "string" && Array.isArray(d))
        for (var p = 0, f = d.length; p < f; p++) {
          var h = d[p];
          if (h) {
            var s = Qe(h, "MM.dd.yyyy"), l = n.get(s) || [];
            l.includes(c) || (l.push(c), n.set(s, l));
          }
        }
    }
  }
  return n;
}
function jO(e, r) {
  return e.length !== r.length ? !1 : e.every(function(t, n) {
    return t === r[n];
  });
}
function ZO(e, r) {
  e === void 0 && (e = []), r === void 0 && (r = "react-datepicker__day--holidays");
  var t = /* @__PURE__ */ new Map();
  return e.forEach(function(n) {
    var a = n.date, o = n.holidayName;
    if (sn(a)) {
      var i = Qe(a, "MM.dd.yyyy"), s = t.get(i) || {
        className: "",
        holidayNames: []
      };
      if (!("className" in s && s.className === r && jO(s.holidayNames, [o]))) {
        s.className = r;
        var l = s.holidayNames;
        s.holidayNames = l ? Tr(Tr([], l, !0), [o], !1) : [o], t.set(i, s);
      }
    }
  }), t;
}
function UO(e, r, t, n, a) {
  for (var o = a.length, i = [], s = 0; s < o; s++) {
    var l = e, u = a[s];
    u && (l = HP(l, Lr(u)), l = _u(l, Wr(u)), l = zP(l, ln(u)));
    var c = _u(e, (t + 1) * n);
    Mn(l, r) && ea(l, c) && u != null && i.push(u);
  }
  return i;
}
function ip(e) {
  return e < 10 ? "0".concat(e) : "".concat(e);
}
function xn(e, r) {
  r === void 0 && (r = ti);
  var t = Math.ceil(xe(e) / r) * r, n = t - (r - 1);
  return { startPeriod: n, endPeriod: t };
}
function JO(e) {
  var r = new Date(e.getFullYear(), e.getMonth(), e.getDate()), t = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
  return Math.round((+t - +r) / 36e5);
}
function sp(e) {
  var r = e.getSeconds(), t = e.getMilliseconds();
  return ie(e.getTime() - r * 1e3 - t);
}
function QO(e, r) {
  return sp(e).getTime() === sp(r).getTime();
}
function lp(e) {
  if (!sn(e))
    throw new Error("Invalid date");
  var r = new Date(e);
  return r.setHours(0, 0, 0, 0), r;
}
function up(e, r) {
  if (!sn(e) || !sn(r))
    throw new Error("Invalid date received");
  var t = lp(e), n = lp(r);
  return ea(t, n);
}
function jm(e) {
  return e.key === te.Space;
}
var qO = (
  /** @class */
  function(e) {
    xt(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      return n.inputRef = P.createRef(), n.onTimeChange = function(a) {
        var o, i;
        n.setState({ time: a });
        var s = n.props.date, l = s instanceof Date && !isNaN(+s), u = l ? s : /* @__PURE__ */ new Date();
        if (a != null && a.includes(":")) {
          var c = a.split(":"), d = c[0], p = c[1];
          u.setHours(Number(d)), u.setMinutes(Number(p));
        }
        (i = (o = n.props).onChange) === null || i === void 0 || i.call(o, u);
      }, n.renderTimeInput = function() {
        var a = n.state.time, o = n.props, i = o.date, s = o.timeString, l = o.customTimeInput;
        return l ? Vu(l, {
          date: i,
          value: a,
          onChange: n.onTimeChange
        }) : P.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", ref: n.inputRef, onClick: function() {
          var u;
          (u = n.inputRef.current) === null || u === void 0 || u.focus();
        }, required: !0, value: a, onChange: function(u) {
          n.onTimeChange(u.target.value || s);
        } });
      }, n.state = {
        time: n.props.timeString
      }, n;
    }
    return r.getDerivedStateFromProps = function(t, n) {
      return t.timeString !== n.time ? {
        time: t.timeString
      } : null;
    }, r.prototype.render = function() {
      return P.createElement(
        "div",
        { className: "react-datepicker__input-time-container" },
        P.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel),
        P.createElement(
          "div",
          { className: "react-datepicker-time__input-container" },
          P.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())
        )
      );
    }, r;
  }(yt)
), KO = (
  /** @class */
  function(e) {
    xt(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.dayEl = kn(), t.handleClick = function(n) {
        !t.isDisabled() && t.props.onClick && t.props.onClick(n);
      }, t.handleMouseEnter = function(n) {
        !t.isDisabled() && t.props.onMouseEnter && t.props.onMouseEnter(n);
      }, t.handleOnKeyDown = function(n) {
        var a, o, i = n.key;
        i === te.Space && (n.preventDefault(), n.key = te.Enter), (o = (a = t.props).handleOnKeyDown) === null || o === void 0 || o.call(a, n);
      }, t.isSameDay = function(n) {
        return _e(t.props.day, n);
      }, t.isKeyboardSelected = function() {
        var n;
        if (t.props.disabledKeyboardNavigation)
          return !1;
        var a = t.props.selectsMultiple ? (n = t.props.selectedDates) === null || n === void 0 ? void 0 : n.some(function(i) {
          return t.isSameDayOrWeek(i);
        }) : t.isSameDayOrWeek(t.props.selected), o = t.props.preSelection && t.isDisabled(t.props.preSelection);
        return !a && t.isSameDayOrWeek(t.props.preSelection) && !o;
      }, t.isDisabled = function(n) {
        return n === void 0 && (n = t.props.day), Pr(n, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.isExcluded = function() {
        return Vc(t.props.day, {
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals
        });
      }, t.isStartOfWeek = function() {
        return _e(t.props.day, Dn(t.props.day, t.props.locale, t.props.calendarStartDay));
      }, t.isSameWeek = function(n) {
        return t.props.showWeekPicker && _e(n, Dn(t.props.day, t.props.locale, t.props.calendarStartDay));
      }, t.isSameDayOrWeek = function(n) {
        return t.isSameDay(n) || t.isSameWeek(n);
      }, t.getHighLightedClass = function() {
        var n = t.props, a = n.day, o = n.highlightDates;
        if (!o)
          return !1;
        var i = Qe(a, "MM.dd.yyyy");
        return o.get(i);
      }, t.getHolidaysClass = function() {
        var n, a = t.props, o = a.day, i = a.holidays;
        if (!i)
          return [void 0];
        var s = Qe(o, "MM.dd.yyyy");
        return i.has(s) ? [(n = i.get(s)) === null || n === void 0 ? void 0 : n.className] : [void 0];
      }, t.isInRange = function() {
        var n = t.props, a = n.day, o = n.startDate, i = n.endDate;
        return !o || !i ? !1 : Co(a, o, i);
      }, t.isInSelectingRange = function() {
        var n, a = t.props, o = a.day, i = a.selectsStart, s = a.selectsEnd, l = a.selectsRange, u = a.selectsDisabledDaysInRange, c = a.startDate, d = a.endDate, p = (n = t.props.selectingDate) !== null && n !== void 0 ? n : t.props.preSelection;
        return !(i || s || l) || !p || !u && t.isDisabled() ? !1 : i && d && (ea(p, d) || Gn(p, d)) ? Co(o, p, d) : s && c && (Mn(p, c) || Gn(p, c)) || l && c && !d && (Mn(p, c) || Gn(p, c)) ? Co(o, c, p) : !1;
      }, t.isSelectingRangeStart = function() {
        var n;
        if (!t.isInSelectingRange())
          return !1;
        var a = t.props, o = a.day, i = a.startDate, s = a.selectsStart, l = (n = t.props.selectingDate) !== null && n !== void 0 ? n : t.props.preSelection;
        return s ? _e(o, l) : _e(o, i);
      }, t.isSelectingRangeEnd = function() {
        var n;
        if (!t.isInSelectingRange())
          return !1;
        var a = t.props, o = a.day, i = a.endDate, s = a.selectsEnd, l = a.selectsRange, u = (n = t.props.selectingDate) !== null && n !== void 0 ? n : t.props.preSelection;
        return s || l ? _e(o, u) : _e(o, i);
      }, t.isRangeStart = function() {
        var n = t.props, a = n.day, o = n.startDate, i = n.endDate;
        return !o || !i ? !1 : _e(o, a);
      }, t.isRangeEnd = function() {
        var n = t.props, a = n.day, o = n.startDate, i = n.endDate;
        return !o || !i ? !1 : _e(i, a);
      }, t.isWeekend = function() {
        var n = VA(t.props.day);
        return n === 0 || n === 6;
      }, t.isAfterMonth = function() {
        return t.props.month !== void 0 && (t.props.month + 1) % 12 === Ot(t.props.day);
      }, t.isBeforeMonth = function() {
        return t.props.month !== void 0 && (Ot(t.props.day) + 1) % 12 === t.props.month;
      }, t.isCurrentDay = function() {
        return t.isSameDay(Ge());
      }, t.isSelected = function() {
        var n;
        return t.props.selectsMultiple ? (n = t.props.selectedDates) === null || n === void 0 ? void 0 : n.some(function(a) {
          return t.isSameDayOrWeek(a);
        }) : t.isSameDayOrWeek(t.props.selected);
      }, t.getClassNames = function(n) {
        var a = t.props.dayClassName ? t.props.dayClassName(n) : void 0;
        return Ct("react-datepicker__day", a, "react-datepicker__day--" + NO(t.props.day), {
          "react-datepicker__day--disabled": t.isDisabled(),
          "react-datepicker__day--excluded": t.isExcluded(),
          "react-datepicker__day--selected": t.isSelected(),
          "react-datepicker__day--keyboard-selected": t.isKeyboardSelected(),
          "react-datepicker__day--range-start": t.isRangeStart(),
          "react-datepicker__day--range-end": t.isRangeEnd(),
          "react-datepicker__day--in-range": t.isInRange(),
          "react-datepicker__day--in-selecting-range": t.isInSelectingRange(),
          "react-datepicker__day--selecting-range-start": t.isSelectingRangeStart(),
          "react-datepicker__day--selecting-range-end": t.isSelectingRangeEnd(),
          "react-datepicker__day--today": t.isCurrentDay(),
          "react-datepicker__day--weekend": t.isWeekend(),
          "react-datepicker__day--outside-month": t.isAfterMonth() || t.isBeforeMonth()
        }, t.getHighLightedClass(), t.getHolidaysClass());
      }, t.getAriaLabel = function() {
        var n = t.props, a = n.day, o = n.ariaLabelPrefixWhenEnabled, i = o === void 0 ? "Choose" : o, s = n.ariaLabelPrefixWhenDisabled, l = s === void 0 ? "Not available" : s, u = t.isDisabled() || t.isExcluded() ? l : i;
        return "".concat(u, " ").concat(Qe(a, "PPPP", t.props.locale));
      }, t.getTitle = function() {
        var n = t.props, a = n.day, o = n.holidays, i = o === void 0 ? /* @__PURE__ */ new Map() : o, s = n.excludeDates, l = Qe(a, "MM.dd.yyyy"), u = [];
        return i.has(l) && u.push.apply(u, i.get(l).holidayNames), t.isExcluded() && u.push(s == null ? void 0 : s.filter(function(c) {
          return c instanceof Date ? _e(c, a) : _e(c == null ? void 0 : c.date, a);
        }).map(function(c) {
          if (!(c instanceof Date))
            return c == null ? void 0 : c.message;
        })), u.join(", ");
      }, t.getTabIndex = function() {
        var n = t.props.selected, a = t.props.preSelection, o = !(t.props.showWeekPicker && (t.props.showWeekNumber || !t.isStartOfWeek())) && (t.isKeyboardSelected() || t.isSameDay(n) && _e(a, n)) ? 0 : -1;
        return o;
      }, t.handleFocusDay = function() {
        var n;
        t.shouldFocusDay() && ((n = t.dayEl.current) === null || n === void 0 || n.focus({ preventScroll: !0 }));
      }, t.renderDayContents = function() {
        return t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() || t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() ? null : t.props.renderDayContents ? t.props.renderDayContents(Yf(t.props.day), t.props.day) : Yf(t.props.day);
      }, t.render = function() {
        return (
          // TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
          P.createElement(
            "div",
            { ref: t.dayEl, className: t.getClassNames(t.props.day), onKeyDown: t.handleOnKeyDown, onClick: t.handleClick, onMouseEnter: t.props.usePointerEvent ? void 0 : t.handleMouseEnter, onPointerEnter: t.props.usePointerEvent ? t.handleMouseEnter : void 0, tabIndex: t.getTabIndex(), "aria-label": t.getAriaLabel(), role: "option", title: t.getTitle(), "aria-disabled": t.isDisabled(), "aria-current": t.isCurrentDay() ? "date" : void 0, "aria-selected": t.isSelected() || t.isInRange() },
            t.renderDayContents(),
            t.getTitle() !== "" && P.createElement("span", { className: "overlay" }, t.getTitle())
          )
        );
      }, t;
    }
    return r.prototype.componentDidMount = function() {
      this.handleFocusDay();
    }, r.prototype.componentDidUpdate = function() {
      this.handleFocusDay();
    }, r.prototype.shouldFocusDay = function() {
      var t = !1;
      return this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (t = !0), this.props.inline && !this.props.shouldFocusDayInline && (t = !1), this.isDayActiveElement() && (t = !0), this.isDuplicateDay() && (t = !1)), t;
    }, r.prototype.isDayActiveElement = function() {
      var t, n, a;
      return ((n = (t = this.props.containerRef) === null || t === void 0 ? void 0 : t.current) === null || n === void 0 ? void 0 : n.contains(document.activeElement)) && ((a = document.activeElement) === null || a === void 0 ? void 0 : a.classList.contains("react-datepicker__day"));
    }, r.prototype.isDuplicateDay = function() {
      return (
        //day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth()
      );
    }, r;
  }(yt)
), e2 = (
  /** @class */
  function(e) {
    xt(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.weekNumberEl = kn(), t.handleClick = function(n) {
        t.props.onClick && t.props.onClick(n);
      }, t.handleOnKeyDown = function(n) {
        var a, o, i = n.key;
        i === te.Space && (n.preventDefault(), n.key = te.Enter), (o = (a = t.props).handleOnKeyDown) === null || o === void 0 || o.call(a, n);
      }, t.isKeyboardSelected = function() {
        return !t.props.disabledKeyboardNavigation && !_e(t.props.date, t.props.selected) && _e(t.props.date, t.props.preSelection);
      }, t.getTabIndex = function() {
        return t.props.showWeekPicker && t.props.showWeekNumber && (t.isKeyboardSelected() || _e(t.props.date, t.props.selected) && _e(t.props.preSelection, t.props.selected)) ? 0 : -1;
      }, t.handleFocusWeekNumber = function(n) {
        var a = !1;
        t.getTabIndex() === 0 && !(n != null && n.isInputFocused) && _e(t.props.date, t.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (a = !0), t.props.inline && !t.props.shouldFocusDayInline && (a = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (a = !0)), a && t.weekNumberEl.current && t.weekNumberEl.current.focus({ preventScroll: !0 });
      }, t;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          ariaLabelPrefix: "week "
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      this.handleFocusWeekNumber();
    }, r.prototype.componentDidUpdate = function(t) {
      this.handleFocusWeekNumber(t);
    }, r.prototype.render = function() {
      var t = this.props, n = t.weekNumber, a = t.ariaLabelPrefix, o = a === void 0 ? r.defaultProps.ariaLabelPrefix : a, i = t.onClick, s = {
        "react-datepicker__week-number": !0,
        "react-datepicker__week-number--clickable": !!i,
        "react-datepicker__week-number--selected": !!i && _e(this.props.date, this.props.selected),
        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
      };
      return P.createElement("div", { ref: this.weekNumberEl, className: Ct(s), "aria-label": "".concat(o, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, n);
    }, r;
  }(yt)
), t2 = (
  /** @class */
  function(e) {
    xt(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.isDisabled = function(n) {
        return Pr(n, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.handleDayClick = function(n, a) {
        t.props.onDayClick && t.props.onDayClick(n, a);
      }, t.handleDayMouseEnter = function(n) {
        t.props.onDayMouseEnter && t.props.onDayMouseEnter(n);
      }, t.handleWeekClick = function(n, a, o) {
        for (var i, s, l, u = new Date(n), c = 0; c < 7; c++) {
          var d = new Date(n);
          d.setDate(d.getDate() + c);
          var p = !t.isDisabled(d);
          if (p) {
            u = d;
            break;
          }
        }
        typeof t.props.onWeekSelect == "function" && t.props.onWeekSelect(u, a, o), t.props.showWeekPicker && t.handleDayClick(u, o), ((i = t.props.shouldCloseOnSelect) !== null && i !== void 0 ? i : r.defaultProps.shouldCloseOnSelect) && ((l = (s = t.props).setOpen) === null || l === void 0 || l.call(s, !1));
      }, t.formatWeekNumber = function(n) {
        return t.props.formatWeekNumber ? t.props.formatWeekNumber(n) : FO(n);
      }, t.renderDays = function() {
        var n = t.startOfWeek(), a = [], o = t.formatWeekNumber(n);
        if (t.props.showWeekNumber) {
          var i = t.props.onWeekSelect || t.props.showWeekPicker ? t.handleWeekClick.bind(t, n, o) : void 0;
          a.push(P.createElement(e2, Me({ key: "W" }, r.defaultProps, t.props, { weekNumber: o, date: n, onClick: i })));
        }
        return a.concat([0, 1, 2, 3, 4, 5, 6].map(function(s) {
          var l = Rn(n, s);
          return P.createElement(KO, Me({}, r.defaultProps, t.props, { ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix, key: l.valueOf(), day: l, onClick: t.handleDayClick.bind(t, l), onMouseEnter: t.handleDayMouseEnter.bind(t, l) }));
        }));
      }, t.startOfWeek = function() {
        return Dn(t.props.day, t.props.locale, t.props.calendarStartDay);
      }, t.isKeyboardSelected = function() {
        return !t.props.disabledKeyboardNavigation && !_e(t.startOfWeek(), t.props.selected) && _e(t.startOfWeek(), t.props.preSelection);
      }, t;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          shouldCloseOnSelect: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.render = function() {
      var t = {
        "react-datepicker__week": !0,
        "react-datepicker__week--selected": _e(this.startOfWeek(), this.props.selected),
        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
      };
      return P.createElement("div", { className: Ct(t) }, this.renderDays());
    }, r;
  }(yt)
), vo, r2 = 6, Ma = {
  TWO_COLUMNS: "two_columns",
  THREE_COLUMNS: "three_columns",
  FOUR_COLUMNS: "four_columns"
}, Gl = (vo = {}, vo[Ma.TWO_COLUMNS] = {
  grid: [
    [0, 1],
    [2, 3],
    [4, 5],
    [6, 7],
    [8, 9],
    [10, 11]
  ],
  verticalNavigationOffset: 2
}, vo[Ma.THREE_COLUMNS] = {
  grid: [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [9, 10, 11]
  ],
  verticalNavigationOffset: 3
}, vo[Ma.FOUR_COLUMNS] = {
  grid: [
    [0, 1, 2, 3],
    [4, 5, 6, 7],
    [8, 9, 10, 11]
  ],
  verticalNavigationOffset: 4
}, vo), Si = 1;
function cp(e, r) {
  return e ? Ma.FOUR_COLUMNS : r ? Ma.TWO_COLUMNS : Ma.THREE_COLUMNS;
}
var n2 = (
  /** @class */
  function(e) {
    xt(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.MONTH_REFS = Tr([], Array(12), !0).map(function() {
        return kn();
      }), t.QUARTER_REFS = Tr([], Array(4), !0).map(function() {
        return kn();
      }), t.isDisabled = function(n) {
        return Pr(n, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.isExcluded = function(n) {
        return Vc(n, {
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals
        });
      }, t.handleDayClick = function(n, a) {
        var o, i;
        (i = (o = t.props).onDayClick) === null || i === void 0 || i.call(o, n, a, t.props.orderInDisplay);
      }, t.handleDayMouseEnter = function(n) {
        var a, o;
        (o = (a = t.props).onDayMouseEnter) === null || o === void 0 || o.call(a, n);
      }, t.handleMouseLeave = function() {
        var n, a;
        (a = (n = t.props).onMouseLeave) === null || a === void 0 || a.call(n);
      }, t.isRangeStartMonth = function(n) {
        var a = t.props, o = a.day, i = a.startDate, s = a.endDate;
        return !i || !s ? !1 : Pt($t(o, n), i);
      }, t.isRangeStartQuarter = function(n) {
        var a = t.props, o = a.day, i = a.startDate, s = a.endDate;
        return !i || !s ? !1 : xs(wa(o, n), i);
      }, t.isRangeEndMonth = function(n) {
        var a = t.props, o = a.day, i = a.startDate, s = a.endDate;
        return !i || !s ? !1 : Pt($t(o, n), s);
      }, t.isRangeEndQuarter = function(n) {
        var a = t.props, o = a.day, i = a.startDate, s = a.endDate;
        return !i || !s ? !1 : xs(wa(o, n), s);
      }, t.isInSelectingRangeMonth = function(n) {
        var a, o = t.props, i = o.day, s = o.selectsStart, l = o.selectsEnd, u = o.selectsRange, c = o.startDate, d = o.endDate, p = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
        return !(s || l || u) || !p ? !1 : s && d ? yi(p, d, n, i) : l && c || u && c && !d ? yi(c, p, n, i) : !1;
      }, t.isSelectingMonthRangeStart = function(n) {
        var a;
        if (!t.isInSelectingRangeMonth(n))
          return !1;
        var o = t.props, i = o.day, s = o.startDate, l = o.selectsStart, u = $t(i, n), c = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
        return l ? Pt(u, c) : Pt(u, s);
      }, t.isSelectingMonthRangeEnd = function(n) {
        var a;
        if (!t.isInSelectingRangeMonth(n))
          return !1;
        var o = t.props, i = o.day, s = o.endDate, l = o.selectsEnd, u = o.selectsRange, c = $t(i, n), d = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
        return l || u ? Pt(c, d) : Pt(c, s);
      }, t.isInSelectingRangeQuarter = function(n) {
        var a, o = t.props, i = o.day, s = o.selectsStart, l = o.selectsEnd, u = o.selectsRange, c = o.startDate, d = o.endDate, p = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
        return !(s || l || u) || !p ? !1 : s && d ? xi(p, d, n, i) : l && c || u && c && !d ? xi(c, p, n, i) : !1;
      }, t.isWeekInMonth = function(n) {
        var a = t.props.day, o = Rn(n, 6);
        return Pt(n, a) || Pt(o, a);
      }, t.isCurrentMonth = function(n, a) {
        return xe(n) === xe(Ge()) && a === Ot(Ge());
      }, t.isCurrentQuarter = function(n, a) {
        return xe(n) === xe(Ge()) && a === $n(Ge());
      }, t.isSelectedMonth = function(n, a, o) {
        return Ot(o) === a && xe(n) === xe(o);
      }, t.isSelectMonthInList = function(n, a, o) {
        return o.some(function(i) {
          return t.isSelectedMonth(n, a, i);
        });
      }, t.isSelectedQuarter = function(n, a, o) {
        return $n(n) === a && xe(n) === xe(o);
      }, t.renderWeeks = function() {
        for (var n = [], a = t.props.fixedHeight, o = 0, i = !1, s = Dn(_n(t.props.day), t.props.locale, t.props.calendarStartDay), l = function(h) {
          return t.props.showWeekPicker ? Dn(h, t.props.locale, t.props.calendarStartDay) : t.props.preSelection;
        }, u = function(h) {
          return t.props.showWeekPicker ? Dn(h, t.props.locale, t.props.calendarStartDay) : t.props.selected;
        }, c = t.props.selected ? u(t.props.selected) : void 0, d = t.props.preSelection ? l(t.props.preSelection) : void 0; n.push(P.createElement(t2, Me({}, t.props, { ariaLabelPrefix: t.props.weekAriaLabelPrefix, key: o, day: s, month: Ot(t.props.day), onDayClick: t.handleDayClick, onDayMouseEnter: t.handleDayMouseEnter, selected: c, preSelection: d, showWeekNumber: t.props.showWeekNumbers }))), !i; ) {
          o++, s = fs(s, 1);
          var p = a && o >= r2, f = !a && !t.isWeekInMonth(s);
          if (p || f)
            if (t.props.peekNextMonth)
              i = !0;
            else
              break;
        }
        return n;
      }, t.onMonthClick = function(n, a) {
        var o = t.isMonthDisabledForLabelDate(a), i = o.isDisabled, s = o.labelDate;
        i || t.handleDayClick(_n(s), n);
      }, t.onMonthMouseEnter = function(n) {
        var a = t.isMonthDisabledForLabelDate(n), o = a.isDisabled, i = a.labelDate;
        o || t.handleDayMouseEnter(_n(i));
      }, t.handleMonthNavigation = function(n, a) {
        var o, i, s, l;
        (i = (o = t.props).setPreSelection) === null || i === void 0 || i.call(o, a), (l = (s = t.MONTH_REFS[n]) === null || s === void 0 ? void 0 : s.current) === null || l === void 0 || l.focus();
      }, t.handleKeyboardNavigation = function(n, a, o) {
        var i, s = t.props, l = s.selected, u = s.preSelection, c = s.setPreSelection, d = s.minDate, p = s.maxDate, f = s.showFourColumnMonthYearPicker, h = s.showTwoColumnMonthYearPicker;
        if (u) {
          var g = cp(f, h), m = t.getVerticalOffset(g), v = (i = Gl[g]) === null || i === void 0 ? void 0 : i.grid, y = function(S, _, k) {
            var R, W, B = _, V = k;
            switch (S) {
              case te.ArrowRight:
                B = wr(_, Si), V = k === 11 ? 0 : k + Si;
                break;
              case te.ArrowLeft:
                B = Ya(_, Si), V = k === 0 ? 11 : k - Si;
                break;
              case te.ArrowUp:
                B = Ya(_, m), V = !((R = v == null ? void 0 : v[0]) === null || R === void 0) && R.includes(k) ? k + 12 - m : k - m;
                break;
              case te.ArrowDown:
                B = wr(_, m), V = !((W = v == null ? void 0 : v[v.length - 1]) === null || W === void 0) && W.includes(k) ? k - 12 + m : k + m;
                break;
            }
            return { newCalculatedDate: B, newCalculatedMonth: V };
          }, w = function(S, _, k) {
            for (var R = 40, W = S, B = !1, V = 0, F = y(W, _, k), H = F.newCalculatedDate, A = F.newCalculatedMonth; !B; ) {
              if (V >= R) {
                H = _, A = k;
                break;
              }
              if (d && H < d) {
                W = te.ArrowRight;
                var N = y(W, H, A);
                H = N.newCalculatedDate, A = N.newCalculatedMonth;
              }
              if (p && H > p) {
                W = te.ArrowLeft;
                var N = y(W, H, A);
                H = N.newCalculatedDate, A = N.newCalculatedMonth;
              }
              if (YO(H, t.props)) {
                var N = y(W, H, A);
                H = N.newCalculatedDate, A = N.newCalculatedMonth;
              } else
                B = !0;
              V++;
            }
            return { newCalculatedDate: H, newCalculatedMonth: A };
          };
          if (a === te.Enter) {
            t.isMonthDisabled(o) || (t.onMonthClick(n, o), c == null || c(l));
            return;
          }
          var I = w(a, u, o), b = I.newCalculatedDate, D = I.newCalculatedMonth;
          switch (a) {
            case te.ArrowRight:
            case te.ArrowLeft:
            case te.ArrowUp:
            case te.ArrowDown:
              t.handleMonthNavigation(D, b);
              break;
          }
        }
      }, t.getVerticalOffset = function(n) {
        var a, o;
        return (o = (a = Gl[n]) === null || a === void 0 ? void 0 : a.verticalNavigationOffset) !== null && o !== void 0 ? o : 0;
      }, t.onMonthKeyDown = function(n, a) {
        var o = t.props, i = o.disabledKeyboardNavigation, s = o.handleOnMonthKeyDown, l = n.key;
        l !== te.Tab && n.preventDefault(), i || t.handleKeyboardNavigation(n, l, a), s && s(n);
      }, t.onQuarterClick = function(n, a) {
        var o = wa(t.props.day, a);
        wi(o, t.props) || t.handleDayClick(Uf(o), n);
      }, t.onQuarterMouseEnter = function(n) {
        var a = wa(t.props.day, n);
        wi(a, t.props) || t.handleDayMouseEnter(Uf(a));
      }, t.handleQuarterNavigation = function(n, a) {
        var o, i, s, l;
        t.isDisabled(a) || t.isExcluded(a) || ((i = (o = t.props).setPreSelection) === null || i === void 0 || i.call(o, a), (l = (s = t.QUARTER_REFS[n - 1]) === null || s === void 0 ? void 0 : s.current) === null || l === void 0 || l.focus());
      }, t.onQuarterKeyDown = function(n, a) {
        var o, i, s = n.key;
        if (!t.props.disabledKeyboardNavigation)
          switch (s) {
            case te.Enter:
              t.onQuarterClick(n, a), (i = (o = t.props).setPreSelection) === null || i === void 0 || i.call(o, t.props.selected);
              break;
            case te.ArrowRight:
              if (!t.props.preSelection)
                break;
              t.handleQuarterNavigation(a === 4 ? 1 : a + 1, Tc(t.props.preSelection, 1));
              break;
            case te.ArrowLeft:
              if (!t.props.preSelection)
                break;
              t.handleQuarterNavigation(a === 1 ? 4 : a - 1, Wm(t.props.preSelection));
              break;
          }
      }, t.isMonthDisabledForLabelDate = function(n) {
        var a, o = t.props, i = o.day, s = o.minDate, l = o.maxDate, u = o.excludeDates, c = o.includeDates, d = $t(i, n);
        return {
          isDisabled: (a = (s || l || u || c) && zm(d, t.props)) !== null && a !== void 0 ? a : !1,
          labelDate: d
        };
      }, t.isMonthDisabled = function(n) {
        var a = t.isMonthDisabledForLabelDate(n).isDisabled;
        return a;
      }, t.getMonthClassNames = function(n) {
        var a = t.props, o = a.day, i = a.startDate, s = a.endDate, l = a.preSelection, u = a.monthClassName, c = u ? u($t(o, n)) : void 0, d = t.getSelection();
        return Ct("react-datepicker__month-text", "react-datepicker__month-".concat(n), c, {
          "react-datepicker__month-text--disabled": t.isMonthDisabled(n),
          "react-datepicker__month-text--selected": d ? t.isSelectMonthInList(o, n, d) : void 0,
          "react-datepicker__month-text--keyboard-selected": !t.props.disabledKeyboardNavigation && l && t.isSelectedMonth(o, n, l) && !t.isMonthDisabled(n),
          "react-datepicker__month-text--in-selecting-range": t.isInSelectingRangeMonth(n),
          "react-datepicker__month-text--in-range": i && s ? yi(i, s, n, o) : void 0,
          "react-datepicker__month-text--range-start": t.isRangeStartMonth(n),
          "react-datepicker__month-text--range-end": t.isRangeEndMonth(n),
          "react-datepicker__month-text--selecting-range-start": t.isSelectingMonthRangeStart(n),
          "react-datepicker__month-text--selecting-range-end": t.isSelectingMonthRangeEnd(n),
          "react-datepicker__month-text--today": t.isCurrentMonth(o, n)
        });
      }, t.getTabIndex = function(n) {
        if (t.props.preSelection == null)
          return "-1";
        var a = Ot(t.props.preSelection), o = t.isMonthDisabledForLabelDate(a).isDisabled, i = n === a && !(o || t.props.disabledKeyboardNavigation) ? "0" : "-1";
        return i;
      }, t.getQuarterTabIndex = function(n) {
        if (t.props.preSelection == null)
          return "-1";
        var a = $n(t.props.preSelection), o = wi(t.props.day, t.props), i = n === a && !(o || t.props.disabledKeyboardNavigation) ? "0" : "-1";
        return i;
      }, t.getAriaLabel = function(n) {
        var a = t.props, o = a.chooseDayAriaLabelPrefix, i = o === void 0 ? "Choose" : o, s = a.disabledDayAriaLabelPrefix, l = s === void 0 ? "Not available" : s, u = a.day, c = a.locale, d = $t(u, n), p = t.isDisabled(d) || t.isExcluded(d) ? l : i;
        return "".concat(p, " ").concat(Qe(d, "MMMM yyyy", c));
      }, t.getQuarterClassNames = function(n) {
        var a = t.props, o = a.day, i = a.startDate, s = a.endDate, l = a.selected, u = a.minDate, c = a.maxDate, d = a.excludeDates, p = a.includeDates, f = a.filterDate, h = a.preSelection, g = a.disabledKeyboardNavigation, m = (u || c || d || p || f) && wi(wa(o, n), t.props);
        return Ct("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(n), {
          "react-datepicker__quarter-text--disabled": m,
          "react-datepicker__quarter-text--selected": l ? t.isSelectedQuarter(o, n, l) : void 0,
          "react-datepicker__quarter-text--keyboard-selected": !g && h && t.isSelectedQuarter(o, n, h) && !m,
          "react-datepicker__quarter-text--in-selecting-range": t.isInSelectingRangeQuarter(n),
          "react-datepicker__quarter-text--in-range": i && s ? xi(i, s, n, o) : void 0,
          "react-datepicker__quarter-text--range-start": t.isRangeStartQuarter(n),
          "react-datepicker__quarter-text--range-end": t.isRangeEndQuarter(n)
        });
      }, t.getMonthContent = function(n) {
        var a = t.props, o = a.showFullMonthYearPicker, i = a.renderMonthContent, s = a.locale, l = a.day, u = Hm(n, s), c = Bc(n, s);
        return i ? i(n, u, c, l) : o ? c : u;
      }, t.getQuarterContent = function(n) {
        var a, o = t.props, i = o.renderQuarterContent, s = o.locale, l = GO(n, s);
        return (a = i == null ? void 0 : i(n, l)) !== null && a !== void 0 ? a : l;
      }, t.renderMonths = function() {
        var n, a = t.props, o = a.showTwoColumnMonthYearPicker, i = a.showFourColumnMonthYearPicker, s = a.day, l = a.selected, u = (n = Gl[cp(i, o)]) === null || n === void 0 ? void 0 : n.grid;
        return u == null ? void 0 : u.map(function(c, d) {
          return P.createElement("div", { className: "react-datepicker__month-wrapper", key: d }, c.map(function(p, f) {
            return P.createElement("div", { ref: t.MONTH_REFS[p], key: f, onClick: function(h) {
              t.onMonthClick(h, p);
            }, onKeyDown: function(h) {
              jm(h) && (h.preventDefault(), h.key = te.Enter), t.onMonthKeyDown(h, p);
            }, onMouseEnter: t.props.usePointerEvent ? void 0 : function() {
              return t.onMonthMouseEnter(p);
            }, onPointerEnter: t.props.usePointerEvent ? function() {
              return t.onMonthMouseEnter(p);
            } : void 0, tabIndex: Number(t.getTabIndex(p)), className: t.getMonthClassNames(p), "aria-disabled": t.isMonthDisabled(p), role: "option", "aria-label": t.getAriaLabel(p), "aria-current": t.isCurrentMonth(s, p) ? "date" : void 0, "aria-selected": l ? t.isSelectedMonth(s, p, l) : void 0 }, t.getMonthContent(p));
          }));
        });
      }, t.renderQuarters = function() {
        var n = t.props, a = n.day, o = n.selected, i = [1, 2, 3, 4];
        return P.createElement("div", { className: "react-datepicker__quarter-wrapper" }, i.map(function(s, l) {
          return P.createElement("div", { key: l, ref: t.QUARTER_REFS[l], role: "option", onClick: function(u) {
            t.onQuarterClick(u, s);
          }, onKeyDown: function(u) {
            t.onQuarterKeyDown(u, s);
          }, onMouseEnter: t.props.usePointerEvent ? void 0 : function() {
            return t.onQuarterMouseEnter(s);
          }, onPointerEnter: t.props.usePointerEvent ? function() {
            return t.onQuarterMouseEnter(s);
          } : void 0, className: t.getQuarterClassNames(s), "aria-selected": o ? t.isSelectedQuarter(a, s, o) : void 0, tabIndex: Number(t.getQuarterTabIndex(s)), "aria-current": t.isCurrentQuarter(a, s) ? "date" : void 0 }, t.getQuarterContent(s));
        }));
      }, t.getClassNames = function() {
        var n = t.props, a = n.selectingDate, o = n.selectsStart, i = n.selectsEnd, s = n.showMonthYearPicker, l = n.showQuarterYearPicker, u = n.showWeekPicker;
        return Ct("react-datepicker__month", {
          "react-datepicker__month--selecting-range": a && (o || i)
        }, { "react-datepicker__monthPicker": s }, { "react-datepicker__quarterPicker": l }, { "react-datepicker__weekPicker": u });
      }, t;
    }
    return r.prototype.getSelection = function() {
      var t = this.props, n = t.selected, a = t.selectedDates, o = t.selectsMultiple;
      if (o)
        return a;
      if (n)
        return [n];
    }, r.prototype.render = function() {
      var t = this.props, n = t.showMonthYearPicker, a = t.showQuarterYearPicker, o = t.day, i = t.ariaLabelPrefix, s = i === void 0 ? "Month " : i, l = s ? s.trim() + " " : "";
      return P.createElement("div", { className: this.getClassNames(), onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave, onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0, "aria-label": "".concat(l).concat(Qe(o, "MMMM, yyyy", this.props.locale)), role: "listbox" }, n ? this.renderMonths() : a ? this.renderQuarters() : this.renderWeeks());
    }, r;
  }(yt)
), a2 = (
  /** @class */
  function(e) {
    xt(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.isSelectedMonth = function(n) {
        return t.props.month === n;
      }, t.renderOptions = function() {
        return t.props.monthNames.map(function(n, a) {
          return P.createElement(
            "div",
            { className: t.isSelectedMonth(a) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: n, onClick: t.onChange.bind(t, a), "aria-selected": t.isSelectedMonth(a) ? "true" : void 0 },
            t.isSelectedMonth(a) ? P.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "",
            n
          );
        });
      }, t.onChange = function(n) {
        return t.props.onChange(n);
      }, t.handleClickOutside = function() {
        return t.props.onCancel();
      }, t;
    }
    return r.prototype.render = function() {
      return P.createElement(qs, { className: "react-datepicker__month-dropdown", onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, r;
  }(yt)
), o2 = (
  /** @class */
  function(e) {
    xt(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function(n) {
        return n.map(function(a, o) {
          return P.createElement("option", { key: a, value: o }, a);
        });
      }, t.renderSelectMode = function(n) {
        return P.createElement("select", { value: t.props.month, className: "react-datepicker__month-select", onChange: function(a) {
          return t.onChange(parseInt(a.target.value));
        } }, t.renderSelectOptions(n));
      }, t.renderReadView = function(n, a) {
        return P.createElement(
          "div",
          { key: "read", style: { visibility: n ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: t.toggleDropdown },
          P.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
          P.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, a[t.props.month])
        );
      }, t.renderDropdown = function(n) {
        return P.createElement(a2, Me({ key: "dropdown" }, t.props, { monthNames: n, onChange: t.onChange, onCancel: t.toggleDropdown }));
      }, t.renderScrollMode = function(n) {
        var a = t.state.dropdownVisible, o = [t.renderReadView(!a, n)];
        return a && o.unshift(t.renderDropdown(n)), o;
      }, t.onChange = function(n) {
        t.toggleDropdown(), n !== t.props.month && t.props.onChange(n);
      }, t.toggleDropdown = function() {
        return t.setState({
          dropdownVisible: !t.state.dropdownVisible
        });
      }, t;
    }
    return r.prototype.render = function() {
      var t = this, n = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(o) {
        return Hm(o, t.props.locale);
      } : function(o) {
        return Bc(o, t.props.locale);
      }), a;
      switch (this.props.dropdownMode) {
        case "scroll":
          a = this.renderScrollMode(n);
          break;
        case "select":
          a = this.renderSelectMode(n);
          break;
      }
      return P.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, a);
    }, r;
  }(yt)
);
function i2(e, r) {
  for (var t = [], n = _n(e), a = _n(r); !Mn(n, a); )
    t.push(Ge(n)), n = wr(n, 1);
  return t;
}
var s2 = (
  /** @class */
  function(e) {
    xt(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      return n.renderOptions = function() {
        return n.state.monthYearsList.map(function(a) {
          var o = Eu(a), i = Mr(n.props.date, a) && Pt(n.props.date, a);
          return P.createElement(
            "div",
            { className: i ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: o, onClick: n.onChange.bind(n, o), "aria-selected": i ? "true" : void 0 },
            i ? P.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "",
            Qe(a, n.props.dateFormat, n.props.locale)
          );
        });
      }, n.onChange = function(a) {
        return n.props.onChange(a);
      }, n.handleClickOutside = function() {
        n.props.onCancel();
      }, n.state = {
        monthYearsList: i2(n.props.minDate, n.props.maxDate)
      }, n;
    }
    return r.prototype.render = function() {
      var t = Ct({
        "react-datepicker__month-year-dropdown": !0,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return P.createElement(qs, { className: t, onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, r;
  }(yt)
), l2 = (
  /** @class */
  function(e) {
    xt(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function() {
        for (var n = _n(t.props.minDate), a = _n(t.props.maxDate), o = []; !Mn(n, a); ) {
          var i = Eu(n);
          o.push(P.createElement("option", { key: i, value: i }, Qe(n, t.props.dateFormat, t.props.locale))), n = wr(n, 1);
        }
        return o;
      }, t.onSelectChange = function(n) {
        t.onChange(parseInt(n.target.value));
      }, t.renderSelectMode = function() {
        return P.createElement("select", { value: Eu(_n(t.props.date)), className: "react-datepicker__month-year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
      }, t.renderReadView = function(n) {
        var a = Qe(t.props.date, t.props.dateFormat, t.props.locale);
        return P.createElement(
          "div",
          { key: "read", style: { visibility: n ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: t.toggleDropdown },
          P.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
          P.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, a)
        );
      }, t.renderDropdown = function() {
        return P.createElement(s2, Me({ key: "dropdown" }, t.props, { onChange: t.onChange, onCancel: t.toggleDropdown }));
      }, t.renderScrollMode = function() {
        var n = t.state.dropdownVisible, a = [t.renderReadView(!n)];
        return n && a.unshift(t.renderDropdown()), a;
      }, t.onChange = function(n) {
        t.toggleDropdown();
        var a = Ge(n);
        Mr(t.props.date, a) && Pt(t.props.date, a) || t.props.onChange(a);
      }, t.toggleDropdown = function() {
        return t.setState({
          dropdownVisible: !t.state.dropdownVisible
        });
      }, t;
    }
    return r.prototype.render = function() {
      var t;
      switch (this.props.dropdownMode) {
        case "scroll":
          t = this.renderScrollMode();
          break;
        case "select":
          t = this.renderSelectMode();
          break;
      }
      return P.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, t);
    }, r;
  }(yt)
), u2 = (
  /** @class */
  function(e) {
    xt(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.state = {
        height: null
      }, t.scrollToTheSelectedTime = function() {
        requestAnimationFrame(function() {
          var n, a, o;
          t.list && (t.list.scrollTop = (o = t.centerLi && r.calcCenterPosition(t.props.monthRef ? t.props.monthRef.clientHeight - ((a = (n = t.header) === null || n === void 0 ? void 0 : n.clientHeight) !== null && a !== void 0 ? a : 0) : t.list.clientHeight, t.centerLi)) !== null && o !== void 0 ? o : 0);
        });
      }, t.handleClick = function(n) {
        var a, o;
        (t.props.minTime || t.props.maxTime) && ep(n, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Kf(n, t.props) || (o = (a = t.props).onChange) === null || o === void 0 || o.call(a, n);
      }, t.isSelectedTime = function(n) {
        return t.props.selected && QO(t.props.selected, n);
      }, t.isDisabledTime = function(n) {
        return (t.props.minTime || t.props.maxTime) && ep(n, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Kf(n, t.props);
      }, t.liClasses = function(n) {
        var a, o = [
          "react-datepicker__time-list-item",
          t.props.timeClassName ? t.props.timeClassName(n) : void 0
        ];
        return t.isSelectedTime(n) && o.push("react-datepicker__time-list-item--selected"), t.isDisabledTime(n) && o.push("react-datepicker__time-list-item--disabled"), t.props.injectTimes && (Lr(n) * 3600 + Wr(n) * 60 + ln(n)) % (((a = t.props.intervals) !== null && a !== void 0 ? a : r.defaultProps.intervals) * 60) !== 0 && o.push("react-datepicker__time-list-item--injected"), o.join(" ");
      }, t.handleOnKeyDown = function(n, a) {
        var o, i;
        n.key === te.Space && (n.preventDefault(), n.key = te.Enter), (n.key === te.ArrowUp || n.key === te.ArrowLeft) && n.target instanceof HTMLElement && n.target.previousSibling && (n.preventDefault(), n.target.previousSibling instanceof HTMLElement && n.target.previousSibling.focus()), (n.key === te.ArrowDown || n.key === te.ArrowRight) && n.target instanceof HTMLElement && n.target.nextSibling && (n.preventDefault(), n.target.nextSibling instanceof HTMLElement && n.target.nextSibling.focus()), n.key === te.Enter && t.handleClick(a), (i = (o = t.props).handleOnKeyDown) === null || i === void 0 || i.call(o, n);
      }, t.renderTimes = function() {
        for (var n, a = [], o = t.props.format ? t.props.format : "p", i = (n = t.props.intervals) !== null && n !== void 0 ? n : r.defaultProps.intervals, s = t.props.selected || t.props.openToDate || Ge(), l = Bi(s), u = t.props.injectTimes && t.props.injectTimes.sort(function(m, v) {
          return m.getTime() - v.getTime();
        }), c = 60 * JO(s), d = c / i, p = 0; p < d; p++) {
          var f = _u(l, p * i);
          if (a.push(f), u) {
            var h = UO(l, f, p, i, u);
            a = a.concat(h);
          }
        }
        var g = a.reduce(function(m, v) {
          return v.getTime() <= s.getTime() ? v : m;
        }, a[0]);
        return a.map(function(m) {
          return P.createElement("li", { key: m.valueOf(), onClick: t.handleClick.bind(t, m), className: t.liClasses(m), ref: function(v) {
            m === g && (t.centerLi = v);
          }, onKeyDown: function(v) {
            t.handleOnKeyDown(v, m);
          }, tabIndex: m === g ? 0 : -1, role: "option", "aria-selected": t.isSelectedTime(m) ? "true" : void 0, "aria-disabled": t.isDisabledTime(m) ? "true" : void 0 }, Qe(m, o, t.props.locale));
        });
      }, t.renderTimeCaption = function() {
        return t.props.showTimeCaption === !1 ? P.createElement(P.Fragment, null) : P.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--time ".concat(t.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(n) {
            t.header = n;
          } },
          P.createElement("div", { className: "react-datepicker-time__header" }, t.props.timeCaption)
        );
      }, t;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          intervals: 30,
          todayButton: null,
          timeCaption: "Time",
          showTimeCaption: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
        height: this.props.monthRef.clientHeight - this.header.clientHeight
      });
    }, r.prototype.render = function() {
      var t = this, n, a = this.state.height;
      return P.createElement(
        "div",
        { className: "react-datepicker__time-container ".concat(((n = this.props.todayButton) !== null && n !== void 0 ? n : r.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "") },
        this.renderTimeCaption(),
        P.createElement(
          "div",
          { className: "react-datepicker__time" },
          P.createElement(
            "div",
            { className: "react-datepicker__time-box" },
            P.createElement("ul", { className: "react-datepicker__time-list", ref: function(o) {
              t.list = o;
            }, style: a ? { height: a } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes())
          )
        )
      );
    }, r.calcCenterPosition = function(t, n) {
      return n.offsetTop - (t / 2 - n.clientHeight / 2);
    }, r;
  }(yt)
), dp = 3, c2 = (
  /** @class */
  function(e) {
    xt(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      return n.YEAR_REFS = Tr([], Array(n.props.yearItemNumber), !0).map(function() {
        return kn();
      }), n.isDisabled = function(a) {
        return Pr(a, {
          minDate: n.props.minDate,
          maxDate: n.props.maxDate,
          excludeDates: n.props.excludeDates,
          includeDates: n.props.includeDates,
          filterDate: n.props.filterDate
        });
      }, n.isExcluded = function(a) {
        return Vc(a, {
          excludeDates: n.props.excludeDates
        });
      }, n.selectingDate = function() {
        var a;
        return (a = n.props.selectingDate) !== null && a !== void 0 ? a : n.props.preSelection;
      }, n.updateFocusOnPaginate = function(a) {
        var o = function() {
          var i, s;
          (s = (i = n.YEAR_REFS[a]) === null || i === void 0 ? void 0 : i.current) === null || s === void 0 || s.focus();
        };
        window.requestAnimationFrame(o);
      }, n.handleYearClick = function(a, o) {
        n.props.onDayClick && n.props.onDayClick(a, o);
      }, n.handleYearNavigation = function(a, o) {
        var i, s, l, u, c = n.props, d = c.date, p = c.yearItemNumber;
        if (!(d === void 0 || p === void 0)) {
          var f = xn(d, p).startPeriod;
          n.isDisabled(o) || n.isExcluded(o) || ((s = (i = n.props).setPreSelection) === null || s === void 0 || s.call(i, o), a - f < 0 ? n.updateFocusOnPaginate(p - (f - a)) : a - f >= p ? n.updateFocusOnPaginate(Math.abs(p - (a - f))) : (u = (l = n.YEAR_REFS[a - f]) === null || l === void 0 ? void 0 : l.current) === null || u === void 0 || u.focus());
        }
      }, n.isSameDay = function(a, o) {
        return _e(a, o);
      }, n.isCurrentYear = function(a) {
        return a === xe(Ge());
      }, n.isRangeStart = function(a) {
        return n.props.startDate && n.props.endDate && Mr(kr(Ge(), a), n.props.startDate);
      }, n.isRangeEnd = function(a) {
        return n.props.startDate && n.props.endDate && Mr(kr(Ge(), a), n.props.endDate);
      }, n.isInRange = function(a) {
        return Ci(a, n.props.startDate, n.props.endDate);
      }, n.isInSelectingRange = function(a) {
        var o = n.props, i = o.selectsStart, s = o.selectsEnd, l = o.selectsRange, u = o.startDate, c = o.endDate;
        return !(i || s || l) || !n.selectingDate() ? !1 : i && c ? Ci(a, n.selectingDate(), c) : s && u || l && u && !c ? Ci(a, u, n.selectingDate()) : !1;
      }, n.isSelectingRangeStart = function(a) {
        var o;
        if (!n.isInSelectingRange(a))
          return !1;
        var i = n.props, s = i.startDate, l = i.selectsStart, u = kr(Ge(), a);
        return l ? Mr(u, (o = n.selectingDate()) !== null && o !== void 0 ? o : null) : Mr(u, s ?? null);
      }, n.isSelectingRangeEnd = function(a) {
        var o;
        if (!n.isInSelectingRange(a))
          return !1;
        var i = n.props, s = i.endDate, l = i.selectsEnd, u = i.selectsRange, c = kr(Ge(), a);
        return l || u ? Mr(c, (o = n.selectingDate()) !== null && o !== void 0 ? o : null) : Mr(c, s ?? null);
      }, n.isKeyboardSelected = function(a) {
        if (!(n.props.date === void 0 || n.props.selected == null || n.props.preSelection == null)) {
          var o = n.props, i = o.minDate, s = o.maxDate, l = o.excludeDates, u = o.includeDates, c = o.filterDate, d = wo(kr(n.props.date, a)), p = (i || s || l || u || c) && Vi(a, n.props);
          return !n.props.disabledKeyboardNavigation && !n.props.inline && !_e(d, wo(n.props.selected)) && _e(d, wo(n.props.preSelection)) && !p;
        }
      }, n.onYearClick = function(a, o) {
        var i = n.props.date;
        i !== void 0 && n.handleYearClick(wo(kr(i, o)), a);
      }, n.onYearKeyDown = function(a, o) {
        var i, s, l = a.key, u = n.props, c = u.date, d = u.yearItemNumber, p = u.handleOnKeyDown;
        if (l !== te.Tab && a.preventDefault(), !n.props.disabledKeyboardNavigation)
          switch (l) {
            case te.Enter:
              if (n.props.selected == null)
                break;
              n.onYearClick(a, o), (s = (i = n.props).setPreSelection) === null || s === void 0 || s.call(i, n.props.selected);
              break;
            case te.ArrowRight:
              if (n.props.preSelection == null)
                break;
              n.handleYearNavigation(o + 1, on(n.props.preSelection, 1));
              break;
            case te.ArrowLeft:
              if (n.props.preSelection == null)
                break;
              n.handleYearNavigation(o - 1, Ha(n.props.preSelection, 1));
              break;
            case te.ArrowUp: {
              if (c === void 0 || d === void 0 || n.props.preSelection == null)
                break;
              var f = xn(c, d).startPeriod, h = dp, g = o - h;
              if (g < f) {
                var m = d % h;
                o >= f && o < f + m ? h = m : h += m, g = o - h;
              }
              n.handleYearNavigation(g, Ha(n.props.preSelection, h));
              break;
            }
            case te.ArrowDown: {
              if (c === void 0 || d === void 0 || n.props.preSelection == null)
                break;
              var v = xn(c, d).endPeriod, h = dp, g = o + h;
              if (g > v) {
                var m = d % h;
                o <= v && o > v - m ? h = m : h += m, g = o + h;
              }
              n.handleYearNavigation(g, on(n.props.preSelection, h));
              break;
            }
          }
        p && p(a);
      }, n.getYearClassNames = function(a) {
        var o = n.props, i = o.date, s = o.minDate, l = o.maxDate, u = o.selected, c = o.excludeDates, d = o.includeDates, p = o.filterDate, f = o.yearClassName;
        return Ct("react-datepicker__year-text", "react-datepicker__year-".concat(a), i ? f == null ? void 0 : f(kr(i, a)) : void 0, {
          "react-datepicker__year-text--selected": u ? a === xe(u) : void 0,
          "react-datepicker__year-text--disabled": (s || l || c || d || p) && Vi(a, n.props),
          "react-datepicker__year-text--keyboard-selected": n.isKeyboardSelected(a),
          "react-datepicker__year-text--range-start": n.isRangeStart(a),
          "react-datepicker__year-text--range-end": n.isRangeEnd(a),
          "react-datepicker__year-text--in-range": n.isInRange(a),
          "react-datepicker__year-text--in-selecting-range": n.isInSelectingRange(a),
          "react-datepicker__year-text--selecting-range-start": n.isSelectingRangeStart(a),
          "react-datepicker__year-text--selecting-range-end": n.isSelectingRangeEnd(a),
          "react-datepicker__year-text--today": n.isCurrentYear(a)
        });
      }, n.getYearTabIndex = function(a) {
        if (n.props.disabledKeyboardNavigation || n.props.preSelection == null)
          return "-1";
        var o = xe(n.props.preSelection), i = Vi(a, n.props);
        return a === o && !i ? "0" : "-1";
      }, n.getYearContainerClassNames = function() {
        var a = n.props, o = a.selectingDate, i = a.selectsStart, s = a.selectsEnd, l = a.selectsRange;
        return Ct("react-datepicker__year", {
          "react-datepicker__year--selecting-range": o && (i || s || l)
        });
      }, n.getYearContent = function(a) {
        return n.props.renderYearContent ? n.props.renderYearContent(a) : a;
      }, n;
    }
    return r.prototype.render = function() {
      var t = this, n = [], a = this.props, o = a.date, i = a.yearItemNumber, s = a.onYearMouseEnter, l = a.onYearMouseLeave;
      if (o === void 0)
        return null;
      for (var u = xn(o, i), c = u.startPeriod, d = u.endPeriod, p = function(g) {
        n.push(P.createElement("div", { ref: f.YEAR_REFS[g - c], onClick: function(m) {
          t.onYearClick(m, g);
        }, onKeyDown: function(m) {
          jm(m) && (m.preventDefault(), m.key = te.Enter), t.onYearKeyDown(m, g);
        }, tabIndex: Number(f.getYearTabIndex(g)), className: f.getYearClassNames(g), onMouseEnter: f.props.usePointerEvent ? void 0 : function(m) {
          return s(m, g);
        }, onPointerEnter: f.props.usePointerEvent ? function(m) {
          return s(m, g);
        } : void 0, onMouseLeave: f.props.usePointerEvent ? void 0 : function(m) {
          return l(m, g);
        }, onPointerLeave: f.props.usePointerEvent ? function(m) {
          return l(m, g);
        } : void 0, key: g, "aria-current": f.isCurrentYear(g) ? "date" : void 0 }, f.getYearContent(g)));
      }, f = this, h = c; h <= d; h++)
        p(h);
      return P.createElement(
        "div",
        { className: this.getYearContainerClassNames() },
        P.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate, onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0 }, n)
      );
    }, r;
  }(yt)
);
function d2(e, r, t, n) {
  for (var a = [], o = 0; o < 2 * r + 1; o++) {
    var i = e + r - o, s = !0;
    t && (s = xe(t) <= i), n && s && (s = xe(n) >= i), s && a.push(i);
  }
  return a;
}
var f2 = (
  /** @class */
  function(e) {
    xt(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      n.renderOptions = function() {
        var s = n.props.year, l = n.state.yearsList.map(function(d) {
          return P.createElement(
            "div",
            { className: s === d ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: d, onClick: n.onChange.bind(n, d), "aria-selected": s === d ? "true" : void 0 },
            s === d ? P.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "",
            d
          );
        }), u = n.props.minDate ? xe(n.props.minDate) : null, c = n.props.maxDate ? xe(n.props.maxDate) : null;
        return (!c || !n.state.yearsList.find(function(d) {
          return d === c;
        })) && l.unshift(P.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "upcoming", onClick: n.incrementYears },
          P.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        )), (!u || !n.state.yearsList.find(function(d) {
          return d === u;
        })) && l.push(P.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "previous", onClick: n.decrementYears },
          P.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        )), l;
      }, n.onChange = function(s) {
        n.props.onChange(s);
      }, n.handleClickOutside = function() {
        n.props.onCancel();
      }, n.shiftYears = function(s) {
        var l = n.state.yearsList.map(function(u) {
          return u + s;
        });
        n.setState({
          yearsList: l
        });
      }, n.incrementYears = function() {
        return n.shiftYears(1);
      }, n.decrementYears = function() {
        return n.shiftYears(-1);
      };
      var a = t.yearDropdownItemNumber, o = t.scrollableYearDropdown, i = a || (o ? 10 : 5);
      return n.state = {
        yearsList: d2(n.props.year, i, n.props.minDate, n.props.maxDate)
      }, n.dropdownRef = kn(), n;
    }
    return r.prototype.componentDidMount = function() {
      var t = this.dropdownRef.current;
      if (t) {
        var n = t.children ? Array.from(t.children) : null, a = n ? n.find(function(o) {
          return o.ariaSelected;
        }) : null;
        t.scrollTop = a && a instanceof HTMLElement ? a.offsetTop + (a.clientHeight - t.clientHeight) / 2 : (t.scrollHeight - t.clientHeight) / 2;
      }
    }, r.prototype.render = function() {
      var t = Ct({
        "react-datepicker__year-dropdown": !0,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return P.createElement(qs, { className: t, containerRef: this.dropdownRef, onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, r;
  }(yt)
), p2 = (
  /** @class */
  function(e) {
    xt(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function() {
        for (var n = t.props.minDate ? xe(t.props.minDate) : 1900, a = t.props.maxDate ? xe(t.props.maxDate) : 2100, o = [], i = n; i <= a; i++)
          o.push(P.createElement("option", { key: i, value: i }, i));
        return o;
      }, t.onSelectChange = function(n) {
        t.onChange(parseInt(n.target.value));
      }, t.renderSelectMode = function() {
        return P.createElement("select", { value: t.props.year, className: "react-datepicker__year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
      }, t.renderReadView = function(n) {
        return P.createElement(
          "div",
          { key: "read", style: { visibility: n ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(a) {
            return t.toggleDropdown(a);
          } },
          P.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
          P.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, t.props.year)
        );
      }, t.renderDropdown = function() {
        return P.createElement(f2, Me({ key: "dropdown" }, t.props, { onChange: t.onChange, onCancel: t.toggleDropdown }));
      }, t.renderScrollMode = function() {
        var n = t.state.dropdownVisible, a = [t.renderReadView(!n)];
        return n && a.unshift(t.renderDropdown()), a;
      }, t.onChange = function(n) {
        t.toggleDropdown(), n !== t.props.year && t.props.onChange(n);
      }, t.toggleDropdown = function(n) {
        t.setState({
          dropdownVisible: !t.state.dropdownVisible
        }, function() {
          t.props.adjustDateOnChange && t.handleYearChange(t.props.date, n);
        });
      }, t.handleYearChange = function(n, a) {
        var o;
        (o = t.onSelect) === null || o === void 0 || o.call(t, n, a), t.setOpen();
      }, t.onSelect = function(n, a) {
        var o, i;
        (i = (o = t.props).onSelect) === null || i === void 0 || i.call(o, n, a);
      }, t.setOpen = function() {
        var n, a;
        (a = (n = t.props).setOpen) === null || a === void 0 || a.call(n, !0);
      }, t;
    }
    return r.prototype.render = function() {
      var t;
      switch (this.props.dropdownMode) {
        case "scroll":
          t = this.renderScrollMode();
          break;
        case "select":
          t = this.renderSelectMode();
          break;
      }
      return P.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, t);
    }, r;
  }(yt)
), h2 = [
  "react-datepicker__year-select",
  "react-datepicker__month-select",
  "react-datepicker__month-year-select"
], g2 = function(e) {
  var r = (e.className || "").split(/\s+/);
  return h2.some(function(t) {
    return r.indexOf(t) >= 0;
  });
}, m2 = (
  /** @class */
  function(e) {
    xt(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      return n.monthContainer = void 0, n.handleClickOutside = function(a) {
        n.props.onClickOutside(a);
      }, n.setClickOutsideRef = function() {
        return n.containerRef.current;
      }, n.handleDropdownFocus = function(a) {
        var o, i;
        g2(a.target) && ((i = (o = n.props).onDropdownFocus) === null || i === void 0 || i.call(o, a));
      }, n.getDateInView = function() {
        var a = n.props, o = a.preSelection, i = a.selected, s = a.openToDate, l = $m(n.props), u = Xm(n.props), c = Ge(), d = s || i || o;
        return d || (l && ea(c, l) ? l : u && Mn(c, u) ? u : c);
      }, n.increaseMonth = function() {
        n.setState(function(a) {
          var o = a.date;
          return {
            date: wr(o, 1)
          };
        }, function() {
          return n.handleMonthChange(n.state.date);
        });
      }, n.decreaseMonth = function() {
        n.setState(function(a) {
          var o = a.date;
          return {
            date: Ya(o, 1)
          };
        }, function() {
          return n.handleMonthChange(n.state.date);
        });
      }, n.handleDayClick = function(a, o, i) {
        n.props.onSelect(a, o, i), n.props.setPreSelection && n.props.setPreSelection(a);
      }, n.handleDayMouseEnter = function(a) {
        n.setState({ selectingDate: a }), n.props.onDayMouseEnter && n.props.onDayMouseEnter(a);
      }, n.handleMonthMouseLeave = function() {
        n.setState({ selectingDate: void 0 }), n.props.onMonthMouseLeave && n.props.onMonthMouseLeave();
      }, n.handleYearMouseEnter = function(a, o) {
        n.setState({ selectingDate: kr(Ge(), o) }), n.props.onYearMouseEnter && n.props.onYearMouseEnter(a, o);
      }, n.handleYearMouseLeave = function(a, o) {
        n.props.onYearMouseLeave && n.props.onYearMouseLeave(a, o);
      }, n.handleYearChange = function(a) {
        var o, i, s, l;
        (i = (o = n.props).onYearChange) === null || i === void 0 || i.call(o, a), n.setState({ isRenderAriaLiveMessage: !0 }), n.props.adjustDateOnChange && (n.props.onSelect(a), (l = (s = n.props).setOpen) === null || l === void 0 || l.call(s, !0)), n.props.setPreSelection && n.props.setPreSelection(a);
      }, n.handleMonthChange = function(a) {
        var o, i;
        n.handleCustomMonthChange(a), n.props.adjustDateOnChange && (n.props.onSelect(a), (i = (o = n.props).setOpen) === null || i === void 0 || i.call(o, !0)), n.props.setPreSelection && n.props.setPreSelection(a);
      }, n.handleCustomMonthChange = function(a) {
        var o, i;
        (i = (o = n.props).onMonthChange) === null || i === void 0 || i.call(o, a), n.setState({ isRenderAriaLiveMessage: !0 });
      }, n.handleMonthYearChange = function(a) {
        n.handleYearChange(a), n.handleMonthChange(a);
      }, n.changeYear = function(a) {
        n.setState(function(o) {
          var i = o.date;
          return {
            date: kr(i, Number(a))
          };
        }, function() {
          return n.handleYearChange(n.state.date);
        });
      }, n.changeMonth = function(a) {
        n.setState(function(o) {
          var i = o.date;
          return {
            date: $t(i, Number(a))
          };
        }, function() {
          return n.handleMonthChange(n.state.date);
        });
      }, n.changeMonthYear = function(a) {
        n.setState(function(o) {
          var i = o.date;
          return {
            date: kr($t(i, Ot(a)), xe(a))
          };
        }, function() {
          return n.handleMonthYearChange(n.state.date);
        });
      }, n.header = function(a) {
        a === void 0 && (a = n.state.date);
        var o = Dn(a, n.props.locale, n.props.calendarStartDay), i = [];
        return n.props.showWeekNumbers && i.push(P.createElement("div", { key: "W", className: "react-datepicker__day-name" }, n.props.weekLabel || "#")), i.concat([0, 1, 2, 3, 4, 5, 6].map(function(s) {
          var l = Rn(o, s), u = n.formatWeekday(l, n.props.locale), c = n.props.weekDayClassName ? n.props.weekDayClassName(l) : void 0;
          return P.createElement("div", { key: s, "aria-label": Qe(l, "EEEE", n.props.locale), className: Ct("react-datepicker__day-name", c) }, u);
        }));
      }, n.formatWeekday = function(a, o) {
        return n.props.formatWeekDay ? WO(a, n.props.formatWeekDay, o) : n.props.useWeekdaysShort ? VO(a, o) : BO(a, o);
      }, n.decreaseYear = function() {
        n.setState(function(a) {
          var o, i = a.date;
          return {
            date: Ha(i, n.props.showYearPicker ? (o = n.props.yearItemNumber) !== null && o !== void 0 ? o : r.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return n.handleYearChange(n.state.date);
        });
      }, n.clearSelectingDate = function() {
        n.setState({ selectingDate: void 0 });
      }, n.renderPreviousButton = function() {
        var a;
        if (!n.props.renderCustomHeader) {
          var o;
          switch (!0) {
            case n.props.showMonthYearPicker:
              o = np(n.state.date, n.props);
              break;
            case n.props.showYearPicker:
              o = $O(n.state.date, n.props);
              break;
            case n.props.showQuarterYearPicker:
              o = HO(n.state.date, n.props);
              break;
            default:
              o = tp(n.state.date, n.props);
              break;
          }
          if (!(!((a = n.props.forceShowMonthNavigation) !== null && a !== void 0 ? a : r.defaultProps.forceShowMonthNavigation) && !n.props.showDisabledMonthNavigation && o || n.props.showTimeSelectOnly)) {
            var i = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--previous"
            ], s = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--previous"
            ], l = n.decreaseMonth;
            (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker) && (l = n.decreaseYear), o && n.props.showDisabledMonthNavigation && (s.push("react-datepicker__navigation--previous--disabled"), l = void 0);
            var u = n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker, c = n.props, d = c.previousMonthButtonLabel, p = d === void 0 ? r.defaultProps.previousMonthButtonLabel : d, f = c.previousYearButtonLabel, h = f === void 0 ? r.defaultProps.previousYearButtonLabel : f, g = n.props, m = g.previousMonthAriaLabel, v = m === void 0 ? typeof p == "string" ? p : "Previous Month" : m, y = g.previousYearAriaLabel, w = y === void 0 ? typeof h == "string" ? h : "Previous Year" : y;
            return P.createElement(
              "button",
              { type: "button", className: s.join(" "), onClick: l, onKeyDown: n.props.handleOnKeyDown, "aria-label": u ? w : v },
              P.createElement("span", { className: i.join(" ") }, u ? h : p)
            );
          }
        }
      }, n.increaseYear = function() {
        n.setState(function(a) {
          var o, i = a.date;
          return {
            date: on(i, n.props.showYearPicker ? (o = n.props.yearItemNumber) !== null && o !== void 0 ? o : r.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return n.handleYearChange(n.state.date);
        });
      }, n.renderNextButton = function() {
        var a;
        if (!n.props.renderCustomHeader) {
          var o;
          switch (!0) {
            case n.props.showMonthYearPicker:
              o = ap(n.state.date, n.props);
              break;
            case n.props.showYearPicker:
              o = XO(n.state.date, n.props);
              break;
            case n.props.showQuarterYearPicker:
              o = zO(n.state.date, n.props);
              break;
            default:
              o = rp(n.state.date, n.props);
              break;
          }
          if (!(!((a = n.props.forceShowMonthNavigation) !== null && a !== void 0 ? a : r.defaultProps.forceShowMonthNavigation) && !n.props.showDisabledMonthNavigation && o || n.props.showTimeSelectOnly)) {
            var i = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--next"
            ], s = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--next"
            ];
            n.props.showTimeSelect && i.push("react-datepicker__navigation--next--with-time"), n.props.todayButton && i.push("react-datepicker__navigation--next--with-today-button");
            var l = n.increaseMonth;
            (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker) && (l = n.increaseYear), o && n.props.showDisabledMonthNavigation && (i.push("react-datepicker__navigation--next--disabled"), l = void 0);
            var u = n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker, c = n.props, d = c.nextMonthButtonLabel, p = d === void 0 ? r.defaultProps.nextMonthButtonLabel : d, f = c.nextYearButtonLabel, h = f === void 0 ? r.defaultProps.nextYearButtonLabel : f, g = n.props, m = g.nextMonthAriaLabel, v = m === void 0 ? typeof p == "string" ? p : "Next Month" : m, y = g.nextYearAriaLabel, w = y === void 0 ? typeof h == "string" ? h : "Next Year" : y;
            return P.createElement(
              "button",
              { type: "button", className: i.join(" "), onClick: l, onKeyDown: n.props.handleOnKeyDown, "aria-label": u ? w : v },
              P.createElement("span", { className: s.join(" ") }, u ? h : p)
            );
          }
        }
      }, n.renderCurrentMonth = function(a) {
        a === void 0 && (a = n.state.date);
        var o = ["react-datepicker__current-month"];
        return n.props.showYearDropdown && o.push("react-datepicker__current-month--hasYearDropdown"), n.props.showMonthDropdown && o.push("react-datepicker__current-month--hasMonthDropdown"), n.props.showMonthYearDropdown && o.push("react-datepicker__current-month--hasMonthYearDropdown"), P.createElement("h2", { className: o.join(" ") }, Qe(a, n.props.dateFormat, n.props.locale));
      }, n.renderYearDropdown = function(a) {
        if (a === void 0 && (a = !1), !(!n.props.showYearDropdown || a))
          return P.createElement(p2, Me({}, r.defaultProps, n.props, { date: n.state.date, onChange: n.changeYear, year: xe(n.state.date) }));
      }, n.renderMonthDropdown = function(a) {
        if (a === void 0 && (a = !1), !(!n.props.showMonthDropdown || a))
          return P.createElement(o2, Me({}, r.defaultProps, n.props, { month: Ot(n.state.date), onChange: n.changeMonth }));
      }, n.renderMonthYearDropdown = function(a) {
        if (a === void 0 && (a = !1), !(!n.props.showMonthYearDropdown || a))
          return P.createElement(l2, Me({}, r.defaultProps, n.props, { date: n.state.date, onChange: n.changeMonthYear }));
      }, n.handleTodayButtonClick = function(a) {
        n.props.onSelect(Jf(), a), n.props.setPreSelection && n.props.setPreSelection(Jf());
      }, n.renderTodayButton = function() {
        if (!(!n.props.todayButton || n.props.showTimeSelectOnly))
          return P.createElement("div", { className: "react-datepicker__today-button", onClick: n.handleTodayButtonClick }, n.props.todayButton);
      }, n.renderDefaultHeader = function(a) {
        var o = a.monthDate, i = a.i;
        return P.createElement(
          "div",
          { className: "react-datepicker__header ".concat(n.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") },
          n.renderCurrentMonth(o),
          P.createElement(
            "div",
            { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(n.props.dropdownMode), onFocus: n.handleDropdownFocus },
            n.renderMonthDropdown(i !== 0),
            n.renderMonthYearDropdown(i !== 0),
            n.renderYearDropdown(i !== 0)
          ),
          P.createElement("div", { className: "react-datepicker__day-names" }, n.header(o))
        );
      }, n.renderCustomHeader = function(a) {
        var o, i, s = a.monthDate, l = a.i;
        if (n.props.showTimeSelect && !n.state.monthContainer || n.props.showTimeSelectOnly)
          return null;
        var u = tp(n.state.date, n.props), c = rp(n.state.date, n.props), d = np(n.state.date, n.props), p = ap(n.state.date, n.props), f = !n.props.showMonthYearPicker && !n.props.showQuarterYearPicker && !n.props.showYearPicker;
        return P.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--custom", onFocus: n.props.onDropdownFocus },
          (i = (o = n.props).renderCustomHeader) === null || i === void 0 ? void 0 : i.call(o, Me(Me({}, n.state), { customHeaderCount: l, monthDate: s, changeMonth: n.changeMonth, changeYear: n.changeYear, decreaseMonth: n.decreaseMonth, increaseMonth: n.increaseMonth, decreaseYear: n.decreaseYear, increaseYear: n.increaseYear, prevMonthButtonDisabled: u, nextMonthButtonDisabled: c, prevYearButtonDisabled: d, nextYearButtonDisabled: p })),
          f && P.createElement("div", { className: "react-datepicker__day-names" }, n.header(s))
        );
      }, n.renderYearHeader = function(a) {
        var o = a.monthDate, i = n.props, s = i.showYearPicker, l = i.yearItemNumber, u = l === void 0 ? r.defaultProps.yearItemNumber : l, c = xn(o, u), d = c.startPeriod, p = c.endPeriod;
        return P.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, s ? "".concat(d, " - ").concat(p) : xe(o));
      }, n.renderHeader = function(a) {
        var o = a.monthDate, i = a.i, s = i === void 0 ? 0 : i, l = { monthDate: o, i: s };
        switch (!0) {
          case n.props.renderCustomHeader !== void 0:
            return n.renderCustomHeader(l);
          case (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker):
            return n.renderYearHeader(l);
          default:
            return n.renderDefaultHeader(l);
        }
      }, n.renderMonths = function() {
        var a, o;
        if (!(n.props.showTimeSelectOnly || n.props.showYearPicker)) {
          for (var i = [], s = (a = n.props.monthsShown) !== null && a !== void 0 ? a : r.defaultProps.monthsShown, l = n.props.showPreviousMonths ? s - 1 : 0, u = n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? on(n.state.date, l) : Ya(n.state.date, l), c = (o = n.props.monthSelectedIn) !== null && o !== void 0 ? o : l, d = 0; d < s; ++d) {
            var p = d - c + l, f = n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? on(u, p) : wr(u, p), h = "month-".concat(d), g = d < s - 1, m = d > 0;
            i.push(P.createElement(
              "div",
              { key: h, ref: function(v) {
                n.monthContainer = v ?? void 0;
              }, className: "react-datepicker__month-container" },
              n.renderHeader({ monthDate: f, i: d }),
              P.createElement(n2, Me({}, r.defaultProps, n.props, { ariaLabelPrefix: n.props.monthAriaLabelPrefix, day: f, onDayClick: n.handleDayClick, handleOnKeyDown: n.props.handleOnDayKeyDown, handleOnMonthKeyDown: n.props.handleOnKeyDown, onDayMouseEnter: n.handleDayMouseEnter, onMouseLeave: n.handleMonthMouseLeave, orderInDisplay: d, selectingDate: n.state.selectingDate, monthShowsDuplicateDaysEnd: g, monthShowsDuplicateDaysStart: m }))
            ));
          }
          return i;
        }
      }, n.renderYears = function() {
        if (!n.props.showTimeSelectOnly && n.props.showYearPicker)
          return P.createElement(
            "div",
            { className: "react-datepicker__year--container" },
            n.renderHeader({ monthDate: n.state.date }),
            P.createElement(c2, Me({}, r.defaultProps, n.props, { selectingDate: n.state.selectingDate, date: n.state.date, onDayClick: n.handleDayClick, clearSelectingDate: n.clearSelectingDate, onYearMouseEnter: n.handleYearMouseEnter, onYearMouseLeave: n.handleYearMouseLeave }))
          );
      }, n.renderTimeSection = function() {
        if (n.props.showTimeSelect && (n.state.monthContainer || n.props.showTimeSelectOnly))
          return P.createElement(u2, Me({}, r.defaultProps, n.props, { onChange: n.props.onTimeChange, format: n.props.timeFormat, intervals: n.props.timeIntervals, monthRef: n.state.monthContainer }));
      }, n.renderInputTimeSection = function() {
        var a = n.props.selected ? new Date(n.props.selected) : void 0, o = a && Kr(a) && !!n.props.selected, i = o ? "".concat(ip(a.getHours()), ":").concat(ip(a.getMinutes())) : "";
        if (n.props.showTimeInput)
          return P.createElement(qO, Me({}, r.defaultProps, n.props, { date: a, timeString: i, onChange: n.props.onTimeChange }));
      }, n.renderAriaLiveRegion = function() {
        var a, o = xn(n.state.date, (a = n.props.yearItemNumber) !== null && a !== void 0 ? a : r.defaultProps.yearItemNumber), i = o.startPeriod, s = o.endPeriod, l;
        return n.props.showYearPicker ? l = "".concat(i, " - ").concat(s) : n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? l = xe(n.state.date) : l = "".concat(Bc(Ot(n.state.date), n.props.locale), " ").concat(xe(n.state.date)), P.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, n.state.isRenderAriaLiveMessage && l);
      }, n.renderChildren = function() {
        if (n.props.children)
          return P.createElement("div", { className: "react-datepicker__children-container" }, n.props.children);
      }, n.containerRef = kn(), n.state = {
        date: n.getDateInView(),
        selectingDate: void 0,
        monthContainer: void 0,
        isRenderAriaLiveMessage: !1
      }, n;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          monthsShown: 1,
          forceShowMonthNavigation: !1,
          timeCaption: "Time",
          previousYearButtonLabel: "Previous Year",
          nextYearButtonLabel: "Next Year",
          previousMonthButtonLabel: "Previous Month",
          nextMonthButtonLabel: "Next Month",
          yearItemNumber: ti
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      var t = this;
      this.props.showTimeSelect && (this.assignMonthContainer = function() {
        t.setState({ monthContainer: t.monthContainer });
      }());
    }, r.prototype.componentDidUpdate = function(t) {
      var n = this;
      if (this.props.preSelection && (!_e(this.props.preSelection, t.preSelection) || this.props.monthSelectedIn !== t.monthSelectedIn)) {
        var a = !Pt(this.state.date, this.props.preSelection);
        this.setState({
          date: this.props.preSelection
        }, function() {
          return a && n.handleCustomMonthChange(n.state.date);
        });
      } else this.props.openToDate && !_e(this.props.openToDate, t.openToDate) && this.setState({
        date: this.props.openToDate
      });
    }, r.prototype.render = function() {
      var t = this.props.container || PO;
      return P.createElement(
        qs,
        { onClickOutside: this.handleClickOutside, style: { display: "contents" }, containerRef: this.containerRef, ignoreClass: this.props.outsideClickIgnoreClass },
        P.createElement(
          t,
          { className: Ct("react-datepicker", this.props.className, {
            "react-datepicker--time-only": this.props.showTimeSelectOnly
          }), showTime: this.props.showTimeSelect || this.props.showTimeInput, showTimeSelectOnly: this.props.showTimeSelectOnly },
          this.renderAriaLiveRegion(),
          this.renderPreviousButton(),
          this.renderNextButton(),
          this.renderMonths(),
          this.renderYears(),
          this.renderTodayButton(),
          this.renderTimeSection(),
          this.renderInputTimeSection(),
          this.renderChildren()
        )
      );
    }, r;
  }(yt)
), v2 = function(e) {
  var r = e.icon, t = e.className, n = t === void 0 ? "" : t, a = e.onClick, o = "react-datepicker__calendar-icon";
  return typeof r == "string" ? P.createElement("i", { className: "".concat(o, " ").concat(r, " ").concat(n), "aria-hidden": "true", onClick: a }) : P.isValidElement(r) ? P.cloneElement(r, {
    className: "".concat(r.props.className || "", " ").concat(o, " ").concat(n),
    onClick: function(i) {
      typeof r.props.onClick == "function" && r.props.onClick(i), typeof a == "function" && a(i);
    }
  }) : P.createElement(
    "svg",
    { className: "".concat(o, " ").concat(n), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: a },
    P.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" })
  );
}, Zm = (
  /** @class */
  function(e) {
    xt(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      return n.portalRoot = null, n.el = document.createElement("div"), n;
    }
    return r.prototype.componentDidMount = function() {
      this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
    }, r.prototype.componentWillUnmount = function() {
      this.portalRoot && this.portalRoot.removeChild(this.el);
    }, r.prototype.render = function() {
      return Gb.createPortal(this.props.children, this.el);
    }, r;
  }(yt)
), b2 = "[tabindex], a, button, input, select, textarea", y2 = function(e) {
  return (e instanceof HTMLAnchorElement || !e.disabled) && e.tabIndex !== -1;
}, Um = (
  /** @class */
  function(e) {
    xt(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      return n.getTabChildren = function() {
        var a;
        return Array.prototype.slice.call((a = n.tabLoopRef.current) === null || a === void 0 ? void 0 : a.querySelectorAll(b2), 1, -1).filter(y2);
      }, n.handleFocusStart = function() {
        var a = n.getTabChildren();
        a && a.length > 1 && a[a.length - 1].focus();
      }, n.handleFocusEnd = function() {
        var a = n.getTabChildren();
        a && a.length > 1 && a[0].focus();
      }, n.tabLoopRef = kn(), n;
    }
    return r.prototype.render = function() {
      var t;
      return ((t = this.props.enableTabLoop) !== null && t !== void 0 ? t : r.defaultProps.enableTabLoop) ? P.createElement(
        "div",
        { className: "react-datepicker__tab-loop", ref: this.tabLoopRef },
        P.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: 0, onFocus: this.handleFocusStart }),
        this.props.children,
        P.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: 0, onFocus: this.handleFocusEnd })
      ) : this.props.children;
    }, r.defaultProps = {
      enableTabLoop: !0
    }, r;
  }(yt)
);
function w2(e) {
  var r = function(t) {
    var n, a = typeof t.hidePopper == "boolean" ? t.hidePopper : !0, o = ye(null), i = MO(Me({ open: !a, whileElementsMounted: Kp, placement: t.popperPlacement, middleware: Tr([
      fO({ padding: 15 }),
      dO(10),
      pO({ element: o })
    ], (n = t.popperModifiers) !== null && n !== void 0 ? n : [], !0) }, t.popperProps)), s = Me(Me({}, t), { hidePopper: a, popperProps: Me(Me({}, i), { arrowRef: o }) });
    return P.createElement(e, Me({}, s));
  };
  return r;
}
var C2 = (
  /** @class */
  function(e) {
    xt(r, e);
    function r() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          hidePopper: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.render = function() {
      var t = this.props, n = t.className, a = t.wrapperClassName, o = t.hidePopper, i = o === void 0 ? r.defaultProps.hidePopper : o, s = t.popperComponent, l = t.targetComponent, u = t.enableTabLoop, c = t.popperOnKeyDown, d = t.portalId, p = t.portalHost, f = t.popperProps, h = t.showArrow, g = void 0;
      if (!i) {
        var m = Ct("react-datepicker-popper", n);
        g = P.createElement(
          Um,
          { enableTabLoop: u },
          P.createElement(
            "div",
            { ref: f.refs.setFloating, style: f.floatingStyles, className: m, "data-placement": f.placement, onKeyDown: c },
            s,
            h && P.createElement(xO, { ref: f.arrowRef, context: f.context, fill: "currentColor", strokeWidth: 1, height: 8, width: 16, style: { transform: "translateY(-1px)" }, className: "react-datepicker__triangle" })
          )
        );
      }
      this.props.popperContainer && (g = hb(this.props.popperContainer, {}, g)), d && !i && (g = P.createElement(Zm, { portalId: d, portalHost: p }, g));
      var v = Ct("react-datepicker-wrapper", a);
      return P.createElement(
        P.Fragment,
        null,
        P.createElement("div", { ref: f.refs.setReference, className: v }, l),
        g
      );
    }, r;
  }(yt)
), x2 = w2(C2), fp = "react-datepicker-ignore-onclickoutside";
function S2(e, r) {
  return e && r ? Ot(e) !== Ot(r) || xe(e) !== xe(r) : e !== r;
}
var Yl = "Date input not valid.", Jm = (
  /** @class */
  function(e) {
    xt(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      return n.calendar = null, n.input = null, n.getPreSelection = function() {
        return n.props.openToDate ? n.props.openToDate : n.props.selectsEnd && n.props.startDate ? n.props.startDate : n.props.selectsStart && n.props.endDate ? n.props.endDate : Ge();
      }, n.modifyHolidays = function() {
        var a;
        return (a = n.props.holidays) === null || a === void 0 ? void 0 : a.reduce(function(o, i) {
          var s = new Date(i.date);
          return Kr(s) ? Tr(Tr([], o, !0), [Me(Me({}, i), { date: s })], !1) : o;
        }, []);
      }, n.calcInitialState = function() {
        var a, o = n.getPreSelection(), i = $m(n.props), s = Xm(n.props), l = i && ea(o, Bi(i)) ? i : s && Mn(o, Qf(s)) ? s : o;
        return {
          open: n.props.startOpen || !1,
          preventFocus: !1,
          inputValue: null,
          preSelection: (a = n.props.selectsRange ? n.props.startDate : n.props.selected) !== null && a !== void 0 ? a : l,
          // transforming highlighted days (perhaps nested array)
          // to flat Map for faster access in day.jsx
          highlightDates: op(n.props.highlightDates),
          focused: !1,
          // used to focus day in inline version after month has changed, but not on
          // initial render
          shouldFocusDayInline: !1,
          isRenderAriaLiveMessage: !1,
          wasHidden: !1
        };
      }, n.resetHiddenStatus = function() {
        n.setState(Me(Me({}, n.state), { wasHidden: !1 }));
      }, n.setHiddenStatus = function() {
        n.setState(Me(Me({}, n.state), { wasHidden: !0 }));
      }, n.setHiddenStateOnVisibilityHidden = function() {
        document.visibilityState === "hidden" && n.setHiddenStatus();
      }, n.clearPreventFocusTimeout = function() {
        n.preventFocusTimeout && clearTimeout(n.preventFocusTimeout);
      }, n.setFocus = function() {
        n.input && n.input.focus && n.input.focus({ preventScroll: !0 });
      }, n.setBlur = function() {
        n.input && n.input.blur && n.input.blur(), n.cancelFocusInput();
      }, n.setOpen = function(a, o) {
        o === void 0 && (o = !1), n.setState({
          open: a,
          preSelection: a && n.state.open ? n.state.preSelection : n.calcInitialState().preSelection,
          lastPreSelectChange: Hl
        }, function() {
          a || n.setState(function(i) {
            return {
              focused: o ? i.focused : !1
            };
          }, function() {
            !o && n.setBlur(), n.setState({ inputValue: null });
          });
        });
      }, n.inputOk = function() {
        return sn(n.state.preSelection);
      }, n.isCalendarOpen = function() {
        return n.props.open === void 0 ? n.state.open && !n.props.disabled && !n.props.readOnly : n.props.open;
      }, n.handleFocus = function(a) {
        var o, i, s = n.state.wasHidden, l = s ? n.state.open : !0;
        s && n.resetHiddenStatus(), !n.state.preventFocus && l && ((i = (o = n.props).onFocus) === null || i === void 0 || i.call(o, a), !n.props.preventOpenOnFocus && !n.props.readOnly && n.setOpen(!0)), n.setState({ focused: !0 });
      }, n.sendFocusBackToInput = function() {
        n.preventFocusTimeout && n.clearPreventFocusTimeout(), n.setState({ preventFocus: !0 }, function() {
          n.preventFocusTimeout = setTimeout(function() {
            n.setFocus(), n.setState({ preventFocus: !1 });
          });
        });
      }, n.cancelFocusInput = function() {
        clearTimeout(n.inputFocusTimeout), n.inputFocusTimeout = void 0;
      }, n.deferFocusInput = function() {
        n.cancelFocusInput(), n.inputFocusTimeout = setTimeout(function() {
          return n.setFocus();
        }, 1);
      }, n.handleDropdownFocus = function() {
        n.cancelFocusInput();
      }, n.handleBlur = function(a) {
        var o, i;
        (!n.state.open || n.props.withPortal || n.props.showTimeInput) && ((i = (o = n.props).onBlur) === null || i === void 0 || i.call(o, a)), n.setState({ focused: !1 });
      }, n.handleCalendarClickOutside = function(a) {
        var o, i;
        n.props.inline || n.setOpen(!1), (i = (o = n.props).onClickOutside) === null || i === void 0 || i.call(o, a), n.props.withPortal && a.preventDefault();
      }, n.handleChange = function() {
        for (var a, o, i = [], s = 0; s < arguments.length; s++)
          i[s] = arguments[s];
        var l = i[0];
        if (!(n.props.onChangeRaw && (n.props.onChangeRaw.apply(n, i), !l || typeof l.isDefaultPrevented != "function" || l.isDefaultPrevented()))) {
          n.setState({
            inputValue: (l == null ? void 0 : l.target) instanceof HTMLInputElement ? l.target.value : null,
            lastPreSelectChange: I2
          });
          var u = n.props, c = u.dateFormat, d = c === void 0 ? r.defaultProps.dateFormat : c, p = u.strictParsing, f = p === void 0 ? r.defaultProps.strictParsing : p, h = u.selectsRange, g = u.startDate, m = u.endDate, v = (l == null ? void 0 : l.target) instanceof HTMLInputElement ? l.target.value : "";
          if (h) {
            var y = v.split("-", 2).map(function(R) {
              return R.trim();
            }), w = y[0], I = y[1], b = Bl(w ?? "", d, n.props.locale, f), D = Bl(I ?? "", d, n.props.locale, f), S = (g == null ? void 0 : g.getTime()) !== (b == null ? void 0 : b.getTime()), _ = (m == null ? void 0 : m.getTime()) !== (D == null ? void 0 : D.getTime());
            if (!S && !_ || b && Pr(b, n.props) || D && Pr(D, n.props))
              return;
            (o = (a = n.props).onChange) === null || o === void 0 || o.call(a, [b, D], l);
          } else {
            var k = Bl(v, d, n.props.locale, f, n.props.minDate);
            n.props.showTimeSelectOnly && n.props.selected && k && !_e(k, n.props.selected) && (k = oO(n.props.selected, {
              hours: Lr(k),
              minutes: Wr(k),
              seconds: ln(k)
            })), (k || !v) && n.setSelected(k, l, !0);
          }
        }
      }, n.handleSelect = function(a, o, i) {
        if (n.props.shouldCloseOnSelect && !n.props.showTimeSelect && n.sendFocusBackToInput(), n.props.onChangeRaw && n.props.onChangeRaw(o), n.setSelected(a, o, !1, i), n.props.showDateSelect && n.setState({ isRenderAriaLiveMessage: !0 }), !n.props.shouldCloseOnSelect || n.props.showTimeSelect)
          n.setPreSelection(a);
        else if (!n.props.inline) {
          n.props.selectsRange || n.setOpen(!1);
          var s = n.props, l = s.startDate, u = s.endDate;
          l && !u && (n.props.swapRange || !up(a, l)) && n.setOpen(!1);
        }
      }, n.setSelected = function(a, o, i, s) {
        var l, u, c = a;
        if (n.props.showYearPicker) {
          if (c !== null && Vi(xe(c), n.props))
            return;
        } else if (n.props.showMonthYearPicker) {
          if (c !== null && zm(c, n.props))
            return;
        } else if (c !== null && Pr(c, n.props))
          return;
        var d = n.props, p = d.onChange, f = d.selectsRange, h = d.startDate, g = d.endDate, m = d.selectsMultiple, v = d.selectedDates, y = d.minTime, w = d.swapRange;
        if (!Gn(n.props.selected, c) || n.props.allowSameDay || f || m)
          if (c !== null && (n.props.selected && (!i || !n.props.showTimeSelect && !n.props.showTimeSelectOnly && !n.props.showTimeInput) && (c = Vl(c, {
            hour: Lr(n.props.selected),
            minute: Wr(n.props.selected),
            second: ln(n.props.selected)
          })), !i && (n.props.showTimeSelect || n.props.showTimeSelectOnly) && y && (c = Vl(c, {
            hour: y.getHours(),
            minute: y.getMinutes(),
            second: y.getSeconds()
          })), n.props.inline || n.setState({
            preSelection: c
          }), n.props.focusSelectedMonth || n.setState({ monthSelectedIn: s })), f) {
            var I = !h && !g, b = h && !g, D = h && g;
            I ? p == null || p([c, null], o) : b && (c === null ? p == null || p([null, null], o) : up(c, h) ? w ? p == null || p([c, h], o) : p == null || p([c, null], o) : p == null || p([h, c], o)), D && (p == null || p([c, null], o));
          } else if (m) {
            if (c !== null)
              if (!(v != null && v.length))
                p == null || p([c], o);
              else {
                var S = v.some(function(k) {
                  return _e(k, c);
                });
                if (S) {
                  var _ = v.filter(function(k) {
                    return !_e(k, c);
                  });
                  p == null || p(_, o);
                } else
                  p == null || p(Tr(Tr([], v, !0), [c], !1), o);
              }
          } else
            p == null || p(c, o);
        i || ((u = (l = n.props).onSelect) === null || u === void 0 || u.call(l, c, o), n.setState({ inputValue: null }));
      }, n.setPreSelection = function(a) {
        var o = sn(n.props.minDate), i = sn(n.props.maxDate), s = !0;
        if (a) {
          var l = Bi(a);
          if (o && i)
            s = Co(a, n.props.minDate, n.props.maxDate);
          else if (o) {
            var u = Bi(n.props.minDate);
            s = Mn(a, u) || Gn(l, u);
          } else if (i) {
            var c = Qf(n.props.maxDate);
            s = ea(a, c) || Gn(l, c);
          }
        }
        s && n.setState({
          preSelection: a
        });
      }, n.toggleCalendar = function() {
        n.setOpen(!n.state.open);
      }, n.handleTimeChange = function(a) {
        var o, i;
        if (!(n.props.selectsRange || n.props.selectsMultiple)) {
          var s = n.props.selected ? n.props.selected : n.getPreSelection(), l = n.props.selected ? a : Vl(s, {
            hour: Lr(a),
            minute: Wr(a)
          });
          n.setState({
            preSelection: l
          }), (i = (o = n.props).onChange) === null || i === void 0 || i.call(o, l), n.props.shouldCloseOnSelect && !n.props.showTimeInput && (n.sendFocusBackToInput(), n.setOpen(!1)), n.props.showTimeInput && n.setOpen(!0), (n.props.showTimeSelectOnly || n.props.showTimeSelect) && n.setState({ isRenderAriaLiveMessage: !0 }), n.setState({ inputValue: null });
        }
      }, n.onInputClick = function() {
        var a, o;
        !n.props.disabled && !n.props.readOnly && n.setOpen(!0), (o = (a = n.props).onInputClick) === null || o === void 0 || o.call(a);
      }, n.onInputKeyDown = function(a) {
        var o, i, s, l, u, c;
        (i = (o = n.props).onKeyDown) === null || i === void 0 || i.call(o, a);
        var d = a.key;
        if (!n.state.open && !n.props.inline && !n.props.preventOpenOnFocus) {
          (d === te.ArrowDown || d === te.ArrowUp || d === te.Enter) && ((s = n.onInputClick) === null || s === void 0 || s.call(n));
          return;
        }
        if (n.state.open) {
          if (d === te.ArrowDown || d === te.ArrowUp) {
            a.preventDefault();
            var p = n.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : n.props.showWeekPicker && n.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : n.props.showFullMonthYearPicker || n.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', f = ((l = n.calendar) === null || l === void 0 ? void 0 : l.containerRef.current) instanceof Element && n.calendar.containerRef.current.querySelector(p);
            f instanceof HTMLElement && f.focus({ preventScroll: !0 });
            return;
          }
          var h = Ge(n.state.preSelection);
          d === te.Enter ? (a.preventDefault(), n.inputOk() && n.state.lastPreSelectChange === Hl ? (n.handleSelect(h, a), !n.props.shouldCloseOnSelect && n.setPreSelection(h)) : n.setOpen(!1)) : d === te.Escape ? (a.preventDefault(), n.sendFocusBackToInput(), n.setOpen(!1)) : d === te.Tab && n.setOpen(!1), n.inputOk() || (c = (u = n.props).onInputError) === null || c === void 0 || c.call(u, { code: 1, msg: Yl });
        }
      }, n.onPortalKeyDown = function(a) {
        var o = a.key;
        o === te.Escape && (a.preventDefault(), n.setState({
          preventFocus: !0
        }, function() {
          n.setOpen(!1), setTimeout(function() {
            n.setFocus(), n.setState({ preventFocus: !1 });
          });
        }));
      }, n.onDayKeyDown = function(a) {
        var o, i, s, l, u, c, d = n.props, p = d.minDate, f = d.maxDate, h = d.disabledKeyboardNavigation, g = d.showWeekPicker, m = d.shouldCloseOnSelect, v = d.locale, y = d.calendarStartDay, w = d.adjustDateOnChange, I = d.inline;
        if ((i = (o = n.props).onKeyDown) === null || i === void 0 || i.call(o, a), !h) {
          var b = a.key, D = a.shiftKey, S = Ge(n.state.preSelection), _ = function(H, A) {
            var N = A;
            switch (H) {
              case te.ArrowRight:
                N = g ? fs(A, 1) : Rn(A, 1);
                break;
              case te.ArrowLeft:
                N = g ? $f(A) : iO(A);
                break;
              case te.ArrowUp:
                N = $f(A);
                break;
              case te.ArrowDown:
                N = fs(A, 1);
                break;
              case te.PageUp:
                N = D ? Ha(A, 1) : Ya(A, 1);
                break;
              case te.PageDown:
                N = D ? on(A, 1) : wr(A, 1);
                break;
              case te.Home:
                N = Dn(A, v, y);
                break;
              case te.End:
                N = LO(A);
                break;
            }
            return N;
          }, k = function(H, A) {
            for (var N = 40, G = H, Q = !1, L = 0, O = _(H, A); !Q; ) {
              if (L >= N) {
                O = A;
                break;
              }
              p && O < p && (G = te.ArrowRight, O = Pr(p, n.props) ? _(G, O) : p), f && O > f && (G = te.ArrowLeft, O = Pr(f, n.props) ? _(G, O) : f), Pr(O, n.props) ? ((G === te.PageUp || G === te.Home) && (G = te.ArrowRight), (G === te.PageDown || G === te.End) && (G = te.ArrowLeft), O = _(G, O)) : Q = !0, L++;
            }
            return O;
          };
          if (b === te.Enter) {
            a.preventDefault(), n.handleSelect(S, a), !m && n.setPreSelection(S);
            return;
          } else if (b === te.Escape) {
            a.preventDefault(), n.setOpen(!1), n.inputOk() || (l = (s = n.props).onInputError) === null || l === void 0 || l.call(s, { code: 1, msg: Yl });
            return;
          }
          var R = null;
          switch (b) {
            case te.ArrowLeft:
            case te.ArrowRight:
            case te.ArrowUp:
            case te.ArrowDown:
            case te.PageUp:
            case te.PageDown:
            case te.Home:
            case te.End:
              R = k(b, S);
              break;
          }
          if (!R) {
            (c = (u = n.props).onInputError) === null || c === void 0 || c.call(u, { code: 1, msg: Yl });
            return;
          }
          if (a.preventDefault(), n.setState({ lastPreSelectChange: Hl }), w && n.setSelected(R), n.setPreSelection(R), I) {
            var W = Ot(S), B = Ot(R), V = xe(S), F = xe(R);
            W !== B || V !== F ? n.setState({ shouldFocusDayInline: !0 }) : n.setState({ shouldFocusDayInline: !1 });
          }
        }
      }, n.onPopperKeyDown = function(a) {
        var o = a.key;
        o === te.Escape && (a.preventDefault(), n.sendFocusBackToInput());
      }, n.onClearClick = function(a) {
        a && a.preventDefault && a.preventDefault(), n.sendFocusBackToInput();
        var o = n.props, i = o.selectsRange, s = o.onChange;
        i ? s == null || s([null, null], a) : s == null || s(null, a), n.setState({ inputValue: null });
      }, n.clear = function() {
        n.onClearClick();
      }, n.onScroll = function(a) {
        typeof n.props.closeOnScroll == "boolean" && n.props.closeOnScroll ? (a.target === document || a.target === document.documentElement || a.target === document.body) && n.setOpen(!1) : typeof n.props.closeOnScroll == "function" && n.props.closeOnScroll(a) && n.setOpen(!1);
      }, n.renderCalendar = function() {
        var a, o;
        return !n.props.inline && !n.isCalendarOpen() ? null : P.createElement(m2, Me({ showMonthYearDropdown: void 0, ref: function(i) {
          n.calendar = i;
        } }, n.props, n.state, { setOpen: n.setOpen, dateFormat: (a = n.props.dateFormatCalendar) !== null && a !== void 0 ? a : r.defaultProps.dateFormatCalendar, onSelect: n.handleSelect, onClickOutside: n.handleCalendarClickOutside, holidays: ZO(n.modifyHolidays()), outsideClickIgnoreClass: fp, onDropdownFocus: n.handleDropdownFocus, onTimeChange: n.handleTimeChange, className: n.props.calendarClassName, container: n.props.calendarContainer, handleOnKeyDown: n.props.onKeyDown, handleOnDayKeyDown: n.onDayKeyDown, setPreSelection: n.setPreSelection, dropdownMode: (o = n.props.dropdownMode) !== null && o !== void 0 ? o : r.defaultProps.dropdownMode }), n.props.children);
      }, n.renderAriaLiveRegion = function() {
        var a = n.props, o = a.dateFormat, i = o === void 0 ? r.defaultProps.dateFormat : o, s = a.locale, l = n.props.showTimeInput || n.props.showTimeSelect, u = l ? "PPPPp" : "PPPP", c;
        return n.props.selectsRange ? c = "Selected start date: ".concat(rr(n.props.startDate, {
          dateFormat: u,
          locale: s
        }), ". ").concat(n.props.endDate ? "End date: " + rr(n.props.endDate, {
          dateFormat: u,
          locale: s
        }) : "") : n.props.showTimeSelectOnly ? c = "Selected time: ".concat(rr(n.props.selected, { dateFormat: i, locale: s })) : n.props.showYearPicker ? c = "Selected year: ".concat(rr(n.props.selected, { dateFormat: "yyyy", locale: s })) : n.props.showMonthYearPicker ? c = "Selected month: ".concat(rr(n.props.selected, { dateFormat: "MMMM yyyy", locale: s })) : n.props.showQuarterYearPicker ? c = "Selected quarter: ".concat(rr(n.props.selected, {
          dateFormat: "yyyy, QQQ",
          locale: s
        })) : c = "Selected date: ".concat(rr(n.props.selected, {
          dateFormat: u,
          locale: s
        })), P.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, c);
      }, n.renderDateInput = function() {
        var a, o, i, s = Ct(n.props.className, (a = {}, a[fp] = n.state.open, a)), l = n.props.customInput || P.createElement("input", { type: "text" }), u = n.props.customInputRef || "ref", c = n.props, d = c.dateFormat, p = d === void 0 ? r.defaultProps.dateFormat : d, f = c.locale, h = typeof n.props.value == "string" ? n.props.value : typeof n.state.inputValue == "string" ? n.state.inputValue : n.props.selectsRange ? OO(n.props.startDate, n.props.endDate, {
          dateFormat: p,
          locale: f
        }) : n.props.selectsMultiple ? TO((i = n.props.selectedDates) !== null && i !== void 0 ? i : [], {
          dateFormat: p,
          locale: f
        }) : rr(n.props.selected, {
          dateFormat: p,
          locale: f
        });
        return Vu(l, (o = {}, o[u] = function(g) {
          n.input = g;
        }, o.value = h, o.onBlur = n.handleBlur, o.onChange = n.handleChange, o.onClick = n.onInputClick, o.onFocus = n.handleFocus, o.onKeyDown = n.onInputKeyDown, o.id = n.props.id, o.name = n.props.name, o.form = n.props.form, o.autoFocus = n.props.autoFocus, o.placeholder = n.props.placeholderText, o.disabled = n.props.disabled, o.autoComplete = n.props.autoComplete, o.className = Ct(l.props.className, s), o.title = n.props.title, o.readOnly = n.props.readOnly, o.required = n.props.required, o.tabIndex = n.props.tabIndex, o["aria-describedby"] = n.props.ariaDescribedBy, o["aria-invalid"] = n.props.ariaInvalid, o["aria-labelledby"] = n.props.ariaLabelledBy, o["aria-required"] = n.props.ariaRequired, o));
      }, n.renderClearButton = function() {
        var a = n.props, o = a.isClearable, i = a.disabled, s = a.selected, l = a.startDate, u = a.endDate, c = a.clearButtonTitle, d = a.clearButtonClassName, p = d === void 0 ? "" : d, f = a.ariaLabelClose, h = f === void 0 ? "Close" : f, g = a.selectedDates;
        return o && (s != null || l != null || u != null || g != null && g.length) ? P.createElement("button", { type: "button", className: Ct("react-datepicker__close-icon", p, { "react-datepicker__close-icon--disabled": i }), disabled: i, "aria-label": h, onClick: n.onClearClick, title: c, tabIndex: -1 }) : null;
      }, n.state = n.calcInitialState(), n.preventFocusTimeout = void 0, n;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          allowSameDay: !1,
          dateFormat: "MM/dd/yyyy",
          dateFormatCalendar: "LLLL yyyy",
          disabled: !1,
          disabledKeyboardNavigation: !1,
          dropdownMode: "scroll",
          preventOpenOnFocus: !1,
          monthsShown: 1,
          readOnly: !1,
          withPortal: !1,
          selectsDisabledDaysInRange: !1,
          shouldCloseOnSelect: !0,
          showTimeSelect: !1,
          showTimeInput: !1,
          showPreviousMonths: !1,
          showMonthYearPicker: !1,
          showFullMonthYearPicker: !1,
          showTwoColumnMonthYearPicker: !1,
          showFourColumnMonthYearPicker: !1,
          showYearPicker: !1,
          showQuarterYearPicker: !1,
          showWeekPicker: !1,
          strictParsing: !1,
          swapRange: !1,
          timeIntervals: 30,
          timeCaption: "Time",
          previousMonthAriaLabel: "Previous Month",
          previousMonthButtonLabel: "Previous Month",
          nextMonthAriaLabel: "Next Month",
          nextMonthButtonLabel: "Next Month",
          previousYearAriaLabel: "Previous Year",
          previousYearButtonLabel: "Previous Year",
          nextYearAriaLabel: "Next Year",
          nextYearButtonLabel: "Next Year",
          timeInputLabel: "Time",
          enableTabLoop: !0,
          yearItemNumber: ti,
          focusSelectedMonth: !1,
          showPopperArrow: !0,
          excludeScrollbar: !0,
          customTimeInput: null,
          calendarStartDay: void 0,
          toggleCalendarOnIconClick: !1,
          usePointerEvent: !1
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      window.addEventListener("scroll", this.onScroll, !0), document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, r.prototype.componentDidUpdate = function(t, n) {
      var a, o, i, s;
      t.inline && S2(t.selected, this.props.selected) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && t.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), t.highlightDates !== this.props.highlightDates && this.setState({
        highlightDates: op(this.props.highlightDates)
      }), !n.focused && !Gn(t.selected, this.props.selected) && this.setState({ inputValue: null }), n.open !== this.state.open && (n.open === !1 && this.state.open === !0 && ((o = (a = this.props).onCalendarOpen) === null || o === void 0 || o.call(a)), n.open === !0 && this.state.open === !1 && ((s = (i = this.props).onCalendarClose) === null || s === void 0 || s.call(i)));
    }, r.prototype.componentWillUnmount = function() {
      this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0), document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, r.prototype.renderInputContainer = function() {
      var t = this.props, n = t.showIcon, a = t.icon, o = t.calendarIconClassname, i = t.calendarIconClassName, s = t.toggleCalendarOnIconClick, l = this.state.open;
      return o && console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props."), P.createElement(
        "div",
        { className: "react-datepicker__input-container".concat(n ? " react-datepicker__view-calendar-icon" : "") },
        n && P.createElement(v2, Me({ icon: a, className: Ct(i, !i && o, l && "react-datepicker-ignore-onclickoutside") }, s ? {
          onClick: this.toggleCalendar
        } : null)),
        this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(),
        this.renderDateInput(),
        this.renderClearButton()
      );
    }, r.prototype.render = function() {
      var t = this.renderCalendar();
      if (this.props.inline)
        return t;
      if (this.props.withPortal) {
        var n = this.state.open ? P.createElement(
          Um,
          { enableTabLoop: this.props.enableTabLoop },
          P.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, t)
        ) : null;
        return this.state.open && this.props.portalId && (n = P.createElement(Zm, Me({ portalId: this.props.portalId }, this.props), n)), P.createElement(
          "div",
          null,
          this.renderInputContainer(),
          n
        );
      }
      return P.createElement(x2, Me({}, this.props, { className: this.props.popperClassName, hidePopper: !this.isCalendarOpen(), targetComponent: this.renderInputContainer(), popperComponent: t, popperOnKeyDown: this.onPopperKeyDown, showArrow: this.props.showPopperArrow }));
    }, r;
  }(yt)
), I2 = "input", Hl = "navigate";
function Vo(e) {
  return pr({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "48", d: "m112 268 144 144 144-144M256 392V100" }, child: [] }] })(e);
}
const pp = Symbol.for("constructDateFrom");
function D2(e, r) {
  return typeof e == "function" ? e(r) : e && typeof e == "object" && pp in e ? e[pp](r) : e instanceof Date ? new e.constructor(r) : new Date(r);
}
function Qm(e, r) {
  return D2(e, e);
}
function qm(e, r) {
  return Qm(e).getMonth();
}
function Km(e, r) {
  return Qm(e).getFullYear();
}
const gt = {
  /** Styles for navigation arrow buttons (prev/next month) */
  navigationButton: {
    size: "xs",
    variant: "ghost"
  },
  /** Styles for dropdown buttons (month/year selectors) */
  dropdownButton: {
    size: "xs",
    fontSize: "xs",
    variant: "ghost"
  },
  /** Styles for dropdown menu lists */
  menuList: {
    maxH: "200px",
    overflowY: "scroll",
    zIndex: 9999
  },
  /** Styles for menu items */
  menuItem: {
    fontSize: "sm"
  },
  /** Container styles for the custom header */
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "8px 12px",
    gap: "8px"
  },
  /** Inner container for dropdown buttons */
  dropdownContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px"
  }
};
J.locale("es");
const _2 = (e) => {
  let r = (/* @__PURE__ */ new Date()).getFullYear(), t = [];
  for (e = e || 1935; e <= r; )
    t.push(e++);
  return t;
}, hp = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"], k2 = {
  Monday: "L",
  Tuesday: "M",
  Wednesday: "X",
  Thursday: "J",
  Friday: "V",
  Saturday: "S",
  Sunday: "D"
}, E2 = _2(1930).reverse(), ev = "zumma-date-picker-portal", M2 = P.forwardRef((e, r) => {
  const { isClearable: t, size: n, ...a } = e;
  return /* @__PURE__ */ ee(na, { children: [
    /* @__PURE__ */ x(
      Ho,
      {
        cursor: "pointer",
        width: "100%",
        height: "34px",
        fontSize: "0.85rem",
        focusBorderColor: "#7A86FF",
        ref: r,
        ...a
      }
    ),
    e.value && t ? null : /* @__PURE__ */ x(
      _p,
      {
        cursor: "pointer",
        height: "34px",
        onClick: e.onFocus,
        children: /* @__PURE__ */ x(Vp, { color: "#707070" })
      }
    )
  ] });
}), pF = P.memo(({ helperText: e, label: r, id: t, isDisabled: n, onChange: a, isInvalid: o = !1, value: i, onBlur: s, isRequired: l, minDate: u, maxDate: c = /* @__PURE__ */ new Date(), isClearable: d = !1, customWidth: p, onInvalidDate: f, normalizeToFullDay: h = !1 }) => {
  const g = P.useRef(null), m = P.useCallback(
    (v) => {
      if (!h || !v) return v;
      const [y, w] = v, I = [y, w];
      if (y) {
        const b = J(y).startOf("day").toDate();
        I[0] = b;
      }
      if (w) {
        const b = J(w).endOf("day").toDate();
        I[1] = b;
      }
      return I;
    },
    [h]
  );
  return /* @__PURE__ */ ee(
    ta,
    {
      width: p || "260px",
      minH: "70px",
      id: t,
      isDisabled: n,
      isInvalid: o,
      children: [
        /* @__PURE__ */ ee(
          ra,
          {
            opacity: 0.5,
            fontSize: "0.8rem",
            fontWeight: 500,
            padding: "0 12px 4px 0",
            children: [
              r,
              " ",
              l ? /* @__PURE__ */ x("span", { style: { color: fn }, children: "*" }) : ""
            ]
          }
        ),
        /* @__PURE__ */ x(
          na,
          {
            width: "100%",
            flexGrow: 1,
            children: /* @__PURE__ */ x(
              Jm,
              {
                strictParsing: !0,
                customInput: /* @__PURE__ */ x(
                  M2,
                  {
                    ref: g,
                    isClearable: d
                  }
                ),
                selectsRange: !0,
                dateFormat: "dd/MM/yyyy",
                startDate: (i == null ? void 0 : i[0]) || void 0,
                endDate: (i == null ? void 0 : i[1]) || void 0,
                minDate: u ?? void 0,
                maxDate: c ?? void 0,
                isClearable: d,
                showPopperArrow: !1,
                disabled: n,
                fixedHeight: !0,
                portalId: ev,
                popperPlacement: "bottom-start",
                popperProps: {
                  strategy: "fixed"
                },
                popperClassName: "date-picker-popper",
                clearButtonClassName: "date-field__light-clear-button",
                showYearDropdown: !0,
                dateFormatCalendar: "MMMM",
                yearDropdownItemNumber: 90,
                scrollableYearDropdown: !0,
                onChangeRaw: () => {
                },
                onBlur: (v) => {
                  var y;
                  try {
                    const w = (y = v == null ? void 0 : v.target) == null ? void 0 : y.value;
                    if (!w || w.trim() === "") {
                      s && s(v);
                      return;
                    }
                    const I = (D) => {
                      const _ = D.trim().replace(/[\s\-\/]+/g, "/").split("/");
                      if (_.length !== 3) return null;
                      const [k, R, W] = _;
                      if (!k || !R || !W || isNaN(Number(k)) || isNaN(Number(R)) || isNaN(Number(W))) return null;
                      const B = `${R}/${k}/${W}`;
                      return J(B).isValid() ? J(B).toDate() : null;
                    }, b = w.split(" - ");
                    if (b.length > 1) {
                      const D = I(b[0]), S = I(b[1]);
                      if (!D || !S) {
                        f == null || f(), s && s(v);
                        return;
                      }
                      a(m([D, S]));
                    } else if (b[0] && b[0].trim() !== "") {
                      const D = I(b[0]);
                      if (!D) {
                        f == null || f(), s && s(v);
                        return;
                      }
                      a(m([D, null]));
                    }
                  } catch {
                    f == null || f();
                  }
                  s && s(v);
                },
                onChange: (v) => {
                  a && a(m(v));
                },
                formatWeekDay: (v) => k2[v],
                renderCustomHeader: ({ date: v, changeYear: y, changeMonth: w, decreaseMonth: I, increaseMonth: b, prevMonthButtonDisabled: D, nextMonthButtonDisabled: S }) => /* @__PURE__ */ ee("div", { style: gt.container, children: [
                  /* @__PURE__ */ x(
                    jn,
                    {
                      "aria-label": "previous month",
                      icon: /* @__PURE__ */ x(Bp, { size: 12 }),
                      ...gt.navigationButton,
                      onClick: (_) => {
                        _.preventDefault(), I();
                      },
                      isDisabled: D
                    }
                  ),
                  /* @__PURE__ */ ee("div", { style: gt.dropdownContainer, children: [
                    /* @__PURE__ */ ee(Pa, { children: [
                      /* @__PURE__ */ x(
                        Aa,
                        {
                          as: At,
                          ...gt.dropdownButton,
                          rightIcon: /* @__PURE__ */ x(Vo, { size: 10 }),
                          children: Km(v)
                        }
                      ),
                      /* @__PURE__ */ x(Ra, { ...gt.menuList, children: E2.map((_) => /* @__PURE__ */ x(
                        Oa,
                        {
                          ...gt.menuItem,
                          onClick: () => y(_),
                          children: _
                        },
                        _
                      )) })
                    ] }),
                    /* @__PURE__ */ ee(Pa, { children: [
                      /* @__PURE__ */ x(
                        Aa,
                        {
                          as: At,
                          ...gt.dropdownButton,
                          rightIcon: /* @__PURE__ */ x(Vo, { size: 10 }),
                          children: hp[qm(v)]
                        }
                      ),
                      /* @__PURE__ */ x(Ra, { ...gt.menuList, children: hp.map((_, k) => /* @__PURE__ */ x(
                        Oa,
                        {
                          ...gt.menuItem,
                          onClick: () => w(k),
                          children: _
                        },
                        _
                      )) })
                    ] })
                  ] }),
                  /* @__PURE__ */ x(
                    jn,
                    {
                      "aria-label": "next month",
                      icon: /* @__PURE__ */ x(Wp, { size: 12 }),
                      ...gt.navigationButton,
                      onClick: (_) => {
                        _.preventDefault(), b();
                      },
                      isDisabled: S
                    }
                  )
                ] })
              }
            )
          }
        ),
        /* @__PURE__ */ x(aa, { height: 2, children: e })
      ]
    }
  );
});
J.locale("es");
const P2 = (e) => {
  let r = (/* @__PURE__ */ new Date()).getFullYear(), t = [];
  for (e = e || 1935; e <= r; )
    t.push(e++);
  return t;
}, gp = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"], A2 = {
  Monday: "L",
  Tuesday: "M",
  Wednesday: "X",
  Thursday: "J",
  Friday: "V",
  Saturday: "S",
  Sunday: "D"
}, R2 = P2(1930).reverse(), O2 = P.forwardRef((e, r) => {
  const { isClearable: t, size: n, ...a } = e;
  return /* @__PURE__ */ ee(na, { children: [
    /* @__PURE__ */ x(
      Ho,
      {
        cursor: "pointer",
        width: "100%",
        height: "34px",
        fontSize: "0.85rem",
        focusBorderColor: "#7A86FF",
        ref: r,
        ...a
      }
    ),
    e.value && t ? null : /* @__PURE__ */ x(
      _p,
      {
        cursor: "pointer",
        height: "34px",
        onClick: e.onFocus,
        children: /* @__PURE__ */ x(Vp, { color: "#707070" })
      }
    )
  ] });
}), mp = P.memo(({ helperText: e, label: r, id: t, isDisabled: n, onChange: a, isInvalid: o = !1, value: i, isRequired: s, minDate: l, maxDate: u = /* @__PURE__ */ new Date(), isClearable: c = !1, customWidth: d }) => {
  const p = P.useRef(null);
  return /* @__PURE__ */ ee(
    ta,
    {
      width: d || "260px",
      minH: "70px",
      id: t,
      isDisabled: n,
      isInvalid: o,
      children: [
        /* @__PURE__ */ ee(
          ra,
          {
            opacity: 0.5,
            fontSize: "0.8rem",
            fontWeight: 500,
            padding: "0 12px 4px 0",
            children: [
              r,
              " ",
              s ? /* @__PURE__ */ x("span", { style: { color: fn }, children: "*" }) : ""
            ]
          }
        ),
        /* @__PURE__ */ x(
          na,
          {
            width: "100%",
            flexGrow: 1,
            children: /* @__PURE__ */ x(
              Jm,
              {
                strictParsing: !0,
                customInput: /* @__PURE__ */ x(
                  O2,
                  {
                    ref: p,
                    isClearable: c
                  }
                ),
                dateFormat: "dd/MM/yyyy",
                selected: i,
                minDate: l ?? void 0,
                maxDate: u ?? void 0,
                isClearable: c,
                showPopperArrow: !1,
                disabled: n,
                fixedHeight: !0,
                portalId: ev,
                clearButtonClassName: "date-field__light-clear-button",
                showYearDropdown: !0,
                dateFormatCalendar: "MMMM",
                yearDropdownItemNumber: 90,
                scrollableYearDropdown: !0,
                popperProps: {
                  strategy: "fixed"
                },
                popperClassName: "date-picker-popper",
                onChange: (f) => {
                  a && a(f);
                },
                formatWeekDay: (f) => A2[f],
                renderCustomHeader: ({ date: f, changeYear: h, changeMonth: g, decreaseMonth: m, increaseMonth: v, prevMonthButtonDisabled: y, nextMonthButtonDisabled: w }) => /* @__PURE__ */ ee("div", { style: gt.container, children: [
                  /* @__PURE__ */ x(
                    jn,
                    {
                      "aria-label": "previous month",
                      icon: /* @__PURE__ */ x(Bp, { size: 12 }),
                      ...gt.navigationButton,
                      onClick: (I) => {
                        I.preventDefault(), m();
                      },
                      isDisabled: y
                    }
                  ),
                  /* @__PURE__ */ ee("div", { style: gt.dropdownContainer, children: [
                    /* @__PURE__ */ ee(Pa, { children: [
                      /* @__PURE__ */ x(
                        Aa,
                        {
                          as: At,
                          ...gt.dropdownButton,
                          rightIcon: /* @__PURE__ */ x(Vo, { size: 10 }),
                          children: Km(f)
                        }
                      ),
                      /* @__PURE__ */ x(Ra, { ...gt.menuList, children: R2.map((I) => /* @__PURE__ */ x(
                        Oa,
                        {
                          ...gt.menuItem,
                          onClick: () => h(I),
                          children: I
                        },
                        I
                      )) })
                    ] }),
                    /* @__PURE__ */ ee(Pa, { children: [
                      /* @__PURE__ */ x(
                        Aa,
                        {
                          as: At,
                          ...gt.dropdownButton,
                          rightIcon: /* @__PURE__ */ x(Vo, { size: 10 }),
                          children: gp[qm(f)]
                        }
                      ),
                      /* @__PURE__ */ x(Ra, { ...gt.menuList, children: gp.map((I, b) => /* @__PURE__ */ x(
                        Oa,
                        {
                          ...gt.menuItem,
                          onClick: () => g(b),
                          children: I
                        },
                        I
                      )) })
                    ] })
                  ] }),
                  /* @__PURE__ */ x(
                    jn,
                    {
                      "aria-label": "next month",
                      icon: /* @__PURE__ */ x(Wp, { size: 12 }),
                      ...gt.navigationButton,
                      onClick: (I) => {
                        I.preventDefault(), v();
                      },
                      isDisabled: w
                    }
                  )
                ] })
              }
            )
          }
        ),
        /* @__PURE__ */ x(aa, { height: 2, children: e })
      ]
    }
  );
}), hF = ({ value: e, onChange: r, fromLabel: t = "Desde", toLabel: n = "Hasta", isDisabled: a = !1, isRequired: o = !1, minWidth: i = "160px", gap: s = "12px", maxDate: l, allowFutureDates: u = !1, isClearable: c = !1 }) => {
  const d = We(() => e.from || void 0, [e.from]), p = We(() => e.to || void 0, [e.to]), f = We(() => l || (u ? null : /* @__PURE__ */ new Date()), [l, u]), h = re(
    (y) => {
      if (y && e.to && y > e.to) {
        r({
          from: y,
          to: y
        });
        return;
      }
      r({
        ...e,
        from: y || null
      });
    },
    [e, r]
  ), g = re(
    (y) => {
      if (y && e.from && y < e.from) {
        r({
          from: y,
          to: y
        });
        return;
      }
      r({
        ...e,
        to: y || null
      });
    },
    [e, r]
  ), m = We(() => e.to ? f && e.to > f ? f : e.to : f, [e.to, f]), v = We(() => e.from, [e.from]);
  return /* @__PURE__ */ ee(
    Rt,
    {
      gap: s,
      align: "flex-end",
      w: { base: "full", md: "auto" },
      flexWrap: { base: "wrap", md: "nowrap" },
      children: [
        /* @__PURE__ */ x(
          Ze,
          {
            minW: typeof i == "object" ? i : { base: "0", md: i },
            flex: { base: "1 1 100%", md: "0 0 auto" },
            maxW: "100%",
            children: /* @__PURE__ */ x(
              mp,
              {
                label: t,
                value: d,
                onChange: h,
                maxDate: m,
                isDisabled: a,
                isRequired: o,
                isClearable: c,
                customWidth: typeof i == "string" ? "100%" : i
              }
            )
          }
        ),
        /* @__PURE__ */ x(
          Ze,
          {
            minW: typeof i == "object" ? i : { base: "0", md: i },
            flex: { base: "1 1 100%", md: "0 0 auto" },
            maxW: "100%",
            children: /* @__PURE__ */ x(
              mp,
              {
                label: n,
                value: p,
                onChange: g,
                minDate: v,
                maxDate: f,
                isDisabled: a,
                isRequired: o,
                isClearable: c,
                customWidth: typeof i == "string" ? "100%" : i
              }
            )
          }
        )
      ]
    }
  );
}, vp = (e) => {
  if (e === 0) return "0 Bytes";
  const r = 1024, t = ["Bytes", "KB", "MB", "GB"], n = Math.floor(Math.log(e) / Math.log(r));
  return Math.round(e / Math.pow(r, n) * 100) / 100 + " " + t[n];
}, T2 = (e) => e ? Object.values(e).flat().join(",") : "*", bp = (e) => e ? Object.values(e).flat().map((t) => t.replace(".", "").toUpperCase()).join(", ") : "Todos los archivos", gF = P.memo(({ id: e, name: r, label: t, isRequired: n, isDisabled: a, accept: o, value: i, onChange: s, helperText: l, maxSizeMB: u = 10 }) => {
  const c = wb(), d = ja(), p = P.useRef(null), [f, h] = P.useState({
    file: null,
    fileName: "",
    fileSize: 0,
    status: "idle",
    error: null,
    progress: 0
  }), [g, m] = P.useState(!1);
  P.useEffect(() => {
    !i && f.fileName ? h({
      file: null,
      fileName: "",
      fileSize: 0,
      status: "idle",
      error: null,
      progress: 0
    }) : i && !f.file && typeof i == "string" && h({
      file: null,
      fileName: "Archivo existente",
      fileSize: 0,
      status: "success",
      error: null,
      progress: 100
    });
  }, [i]);
  const v = async (F) => new Promise((H, A) => {
    const N = new FileReader();
    N.onloadstart = () => {
      h((G) => ({ ...G, status: "loading", progress: 0 }));
    }, N.onprogress = (G) => {
      if (G.lengthComputable) {
        const Q = Math.round(G.loaded / G.total * 100);
        h((L) => ({ ...L, progress: Q }));
      }
    }, N.onload = () => {
      try {
        const Q = N.result.split(",")[1];
        H(Q);
      } catch {
        A(new Error("Error al procesar el archivo"));
      }
    }, N.onerror = () => {
      A(new Error("Error al leer el archivo"));
    }, N.readAsDataURL(F);
  }), y = (F) => {
    var A;
    const H = u * 1024 * 1024;
    if (F.size > H)
      return {
        valid: !1,
        error: d.fileTooLarge(u)
      };
    if (o) {
      const N = Object.values(o).flat(), G = "." + ((A = F.name.split(".").pop()) == null ? void 0 : A.toLowerCase());
      if (!N.includes(G))
        return {
          valid: !1,
          error: `Tipo de archivo no permitido. Se aceptan: ${bp(o)}`
        };
    }
    return { valid: !0 };
  }, w = async (F) => {
    try {
      const H = y(F);
      if (!H.valid) {
        h({
          file: null,
          fileName: F.name,
          fileSize: F.size,
          status: "error",
          error: H.error || d.validationError,
          progress: 0
        }), c({
          title: "Error al seleccionar archivo",
          description: H.error,
          status: "error",
          duration: 5e3,
          isClosable: !0
        });
        return;
      }
      h({
        file: F,
        fileName: F.name,
        fileSize: F.size,
        status: "loading",
        error: null,
        progress: 0
      });
      const A = await v(F);
      h((N) => ({
        ...N,
        status: "success",
        progress: 100
      })), s(r, A), c({
        title: "Archivo cargado exitosamente",
        description: `${F.name} (${vp(F.size)})`,
        status: "success",
        duration: 3e3,
        isClosable: !0
      });
    } catch (H) {
      const A = H instanceof Error ? H.message : "Error desconocido al cargar el archivo";
      h((N) => ({
        ...N,
        status: "error",
        error: A,
        progress: 0
      })), c({
        title: "Error al cargar archivo",
        description: A,
        status: "error",
        duration: 5e3,
        isClosable: !0
      }), s(r, null);
    }
  }, I = (F) => {
    const H = F.target.files;
    H && H.length > 0 && w(H[0]);
  }, b = () => {
    h({
      file: null,
      fileName: "",
      fileSize: 0,
      status: "idle",
      error: null,
      progress: 0
    }), s(r, null), p.current && (p.current.value = "");
  }, D = (F) => {
    F.preventDefault(), F.stopPropagation(), a || m(!0);
  }, S = (F) => {
    F.preventDefault(), F.stopPropagation(), m(!1);
  }, _ = (F) => {
    F.preventDefault(), F.stopPropagation();
  }, k = (F) => {
    if (F.preventDefault(), F.stopPropagation(), m(!1), a) return;
    const H = F.dataTransfer.files;
    H && H.length > 0 && w(H[0]);
  }, R = () => {
    !a && p.current && p.current.click();
  }, W = () => {
    switch (f.status) {
      case "loading":
        return null;
      case "success":
        return /* @__PURE__ */ x(
          Wn,
          {
            as: cD,
            color: "green.500",
            boxSize: "18px"
          }
        );
      case "error":
        return /* @__PURE__ */ x(
          Wn,
          {
            as: dD,
            color: "red.500",
            boxSize: "18px"
          }
        );
      default:
        return /* @__PURE__ */ x(
          Wn,
          {
            as: dg,
            color: j.neutralDark,
            boxSize: "18px",
            opacity: 0.6
          }
        );
    }
  }, B = () => a ? j.border : g ? j.primary[2] : f.status === "error" ? "red.400" : f.status === "success" ? "green.400" : j.border, V = () => a ? "gray.50" : g ? "blue.50" : "transparent";
  return /* @__PURE__ */ ee(
    Ze,
    {
      width: oa,
      maxH: "fit-content",
      mb: 2,
      children: [
        t && /* @__PURE__ */ ee(
          mt,
          {
            width: "100%",
            opacity: 0.5,
            fontSize: je.label,
            fontWeight: ia.label,
            padding: sr.labelPadding,
            mb: 1,
            children: [
              t,
              " ",
              n ? /* @__PURE__ */ x("span", { style: { color: fn }, children: "*" }) : ""
            ]
          }
        ),
        /* @__PURE__ */ x(
          "input",
          {
            ref: p,
            type: "file",
            id: e,
            name: r,
            disabled: a,
            accept: T2(o),
            onChange: I,
            style: { display: "none" }
          }
        ),
        /* @__PURE__ */ x(
          Ze,
          {
            onDragEnter: D,
            onDragLeave: S,
            onDragOver: _,
            onDrop: k,
            onClick: R,
            cursor: a ? "not-allowed" : "pointer",
            border: "2px dashed",
            borderColor: B(),
            bg: V(),
            rounded: Is.input,
            px: 3,
            py: 2,
            transition: "all 0.2s",
            _hover: a ? void 0 : {
              borderColor: j.primary[2],
              bg: "blue.50"
            },
            children: f.fileName ? /* @__PURE__ */ ee(
              Rt,
              {
                direction: "column",
                gap: 1,
                children: [
                  /* @__PURE__ */ ee(
                    Rt,
                    {
                      justify: "space-between",
                      align: "center",
                      children: [
                        /* @__PURE__ */ ee(
                          Rt,
                          {
                            align: "center",
                            gap: 2,
                            flex: 1,
                            minW: 0,
                            children: [
                              W(),
                              /* @__PURE__ */ ee(
                                Ze,
                                {
                                  flex: 1,
                                  minW: 0,
                                  children: [
                                    /* @__PURE__ */ x(
                                      mt,
                                      {
                                        fontSize: je.input,
                                        fontWeight: 400,
                                        noOfLines: 1,
                                        title: f.fileName,
                                        children: f.fileName
                                      }
                                    ),
                                    f.fileSize > 0 && /* @__PURE__ */ x(
                                      mt,
                                      {
                                        fontSize: "xs",
                                        color: "gray.500",
                                        children: vp(f.fileSize)
                                      }
                                    )
                                  ]
                                }
                              )
                            ]
                          }
                        ),
                        !a && f.status !== "loading" && /* @__PURE__ */ x(
                          jn,
                          {
                            "aria-label": d.removeFile,
                            icon: /* @__PURE__ */ x(lD, {}),
                            size: "xs",
                            variant: "ghost",
                            colorScheme: "red",
                            onClick: (F) => {
                              F.stopPropagation(), b();
                            }
                          }
                        )
                      ]
                    }
                  ),
                  f.status === "loading" && /* @__PURE__ */ ee(Ze, { children: [
                    /* @__PURE__ */ x(
                      Cb,
                      {
                        value: f.progress,
                        size: "sm",
                        colorScheme: "blue",
                        rounded: "full"
                      }
                    ),
                    /* @__PURE__ */ x(
                      mt,
                      {
                        fontSize: "xs",
                        color: "gray.500",
                        mt: 1,
                        children: d.loadingProgress(f.progress)
                      }
                    )
                  ] }),
                  f.status === "error" && f.error && /* @__PURE__ */ x(
                    mt,
                    {
                      fontSize: "xs",
                      color: "red.500",
                      children: f.error
                    }
                  )
                ]
              }
            ) : /* @__PURE__ */ ee(
              Rt,
              {
                direction: "row",
                align: "center",
                justify: "start",
                gap: 3,
                py: 1,
                children: [
                  /* @__PURE__ */ x(
                    Wn,
                    {
                      as: cg,
                      boxSize: "20px",
                      color: a ? "gray.400" : j.primary[2]
                    }
                  ),
                  /* @__PURE__ */ ee(
                    Ze,
                    {
                      textAlign: "left",
                      flex: 1,
                      children: [
                        /* @__PURE__ */ x(
                          mt,
                          {
                            fontSize: je.input,
                            fontWeight: 400,
                            color: a ? "gray.400" : "gray.700",
                            children: a ? d.fieldDisabled : d.dropFileOrClick
                          }
                        ),
                        /* @__PURE__ */ ee(
                          mt,
                          {
                            fontSize: "xs",
                            color: "gray.500",
                            children: [
                              bp(o),
                              " • ",
                              d.maxFileSize(u)
                            ]
                          }
                        )
                      ]
                    }
                  )
                ]
              }
            )
          }
        ),
        l && /* @__PURE__ */ x(
          mt,
          {
            fontSize: "xs",
            color: "gray.500",
            mt: 1,
            px: 1,
            children: l
          }
        )
      ]
    }
  );
});
function F2(e) {
  return pr({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z" }, child: [] }] })(e);
}
const xo = Yr(({ children: e, ...r }) => /* @__PURE__ */ x(mt, { ...r, children: e }));
xo.displayName = "Text";
const mF = P.memo(({ onSubmit: e, accept: r, error: t = null, label: n, hint: a, submitLabel: o, cancelLabel: i, submitVariant: s = "tertiary", cancelVariant: l = "default", isLoading: u = !1 }) => {
  const c = ja(), [d, p] = ke(null), f = re((y) => {
    y.length > 0 && p(y[0]);
  }, []), { getRootProps: h, getInputProps: g, isDragActive: m } = lc({
    onDrop: f,
    accept: r,
    maxFiles: 1,
    multiple: !1,
    disabled: u
  }), v = re(() => {
    d && e(d);
  }, [d, e]);
  return /* @__PURE__ */ ee(Ze, { children: [
    /* @__PURE__ */ ee(
      Ze,
      {
        ...h(),
        border: "2px dashed",
        borderColor: m ? j.tertiary[1] : j.tertiary[3],
        borderRadius: Is.input,
        p: "2rem",
        textAlign: "center",
        cursor: u ? "not-allowed" : "pointer",
        opacity: u ? 0.6 : 1,
        bg: m ? j.tertiary[3] : "transparent",
        transition: "all 0.2s",
        _hover: { borderColor: j.tertiary[1], bg: j.tertiary[3] },
        children: [
          /* @__PURE__ */ x("input", { ...g() }),
          /* @__PURE__ */ x(
            Wn,
            {
              as: F2,
              boxSize: 10,
              color: j.tertiary[2],
              mb: "0.5rem"
            }
          ),
          d ? /* @__PURE__ */ x(xo, { fontWeight: 500, children: d.name }) : m ? /* @__PURE__ */ x(xo, { children: "Suelta el archivo aqui..." }) : /* @__PURE__ */ ee(Wu, { children: [
            /* @__PURE__ */ x(xo, { fontWeight: 500, children: n ?? c.dropFile }),
            a && /* @__PURE__ */ x(
              xo,
              {
                fontSize: "sm",
                color: j.text[3],
                mt: "0.25rem",
                children: a
              }
            )
          ] })
        ]
      }
    ),
    t && /* @__PURE__ */ ee(
      xb,
      {
        status: "error",
        mt: "1rem",
        borderRadius: "md",
        children: [
          /* @__PURE__ */ x(Sb, {}),
          t
        ]
      }
    ),
    /* @__PURE__ */ ee(
      Rt,
      {
        mt: "1rem",
        gap: "0.5rem",
        justifyContent: {
          base: "center",
          md: "space-around"
        },
        children: [
          /* @__PURE__ */ x(
            Yi,
            {
              variant: s,
              onClick: v,
              isDisabled: !d,
              isLoading: u,
              children: o ?? c.upload
            }
          ),
          d && /* @__PURE__ */ x(
            Yi,
            {
              variant: l,
              onClick: () => p(null),
              isDisabled: u,
              children: i ?? c.cancel
            }
          )
        ]
      }
    )
  ] });
}), vF = P.memo(({ id: e, isDisabled: r, items: t, onChangeType: n }) => {
  var i;
  const [a, o] = P.useState(0);
  return /* @__PURE__ */ ee("div", { children: [
    /* @__PURE__ */ x(
      kp,
      {
        columns: {
          base: 1,
          lg: 2
        },
        columnGap: {
          base: "2rem"
        },
        rowGap: {
          base: "2rem"
        },
        children: (i = t[a]) == null ? void 0 : i.input
      }
    ),
    /* @__PURE__ */ x(
      Ib,
      {
        id: e,
        isDisabled: r,
        onChange: (s) => {
          o(Number(s)), n && n(s);
        },
        value: a.toString(),
        children: /* @__PURE__ */ x(Db, { direction: "row", children: t.map((s, l) => /* @__PURE__ */ x(
          _b,
          {
            size: "md",
            value: l.toString(),
            children: s.title
          },
          l
        )) })
      }
    )
  ] });
}), N2 = {
  default: {
    bg: "white",
    boxShadow: "sm",
    border: "1px solid",
    borderColor: "gray.100"
  },
  elevated: {
    bg: "white",
    boxShadow: "md",
    border: "none"
  },
  outline: {
    bg: "white",
    boxShadow: "none",
    border: "1px solid",
    borderColor: "gray.200"
  },
  filled: {
    bg: "gray.50",
    boxShadow: "none",
    border: "none"
  }
}, L2 = at(({ variant: e = "default", children: r, ...t }, n) => /* @__PURE__ */ x(
  Ze,
  {
    ref: n,
    borderRadius: "lg",
    overflow: "hidden",
    transition: "box-shadow 0.2s",
    _hover: { boxShadow: "md" },
    ...N2[e],
    ...t,
    children: r
  }
));
L2.displayName = "Card";
const W2 = at(({ children: e, ...r }, t) => /* @__PURE__ */ x(
  Ze,
  {
    ref: t,
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    p: 6,
    ...r,
    children: e
  }
));
W2.displayName = "CardHeader";
const B2 = at(({ children: e, ...r }, t) => /* @__PURE__ */ x(
  kb,
  {
    ref: t,
    as: "h3",
    size: "lg",
    fontWeight: "semibold",
    lineHeight: "none",
    letterSpacing: "tight",
    ...r,
    children: e
  }
));
B2.displayName = "CardTitle";
const V2 = at(({ children: e, ...r }, t) => /* @__PURE__ */ x(
  mt,
  {
    ref: t,
    fontSize: "sm",
    color: "gray.500",
    ...r,
    children: e
  }
));
V2.displayName = "CardDescription";
const G2 = at(({ children: e, ...r }, t) => /* @__PURE__ */ x(
  Ze,
  {
    ref: t,
    p: 6,
    ...r,
    children: e
  }
));
G2.displayName = "CardContent";
const Y2 = at(({ children: e, ...r }, t) => /* @__PURE__ */ x(
  Ze,
  {
    ref: t,
    display: "flex",
    alignItems: "center",
    p: 6,
    pt: 0,
    ...r,
    children: e
  }
));
Y2.displayName = "CardFooter";
const H2 = Yr(({ isOpen: e, onClose: r, title: t, message: n, confirmMethod: a, confirmMessage: o, cancelMessage: i, confirmType: s = "red", cancelType: l = "blue", cancelMethod: u }) => {
  const c = ja();
  return /* @__PURE__ */ ee(
    Ep,
    {
      trapFocus: !1,
      closeOnOverlayClick: !1,
      isOpen: e,
      onClose: r,
      isCentered: !0,
      size: "md",
      children: [
        /* @__PURE__ */ x(Mp, {}),
        /* @__PURE__ */ ee(Pp, { children: [
          /* @__PURE__ */ x(Eb, { textAlign: "center", children: t }),
          u ? /* @__PURE__ */ x(Ap, {}) : null,
          /* @__PURE__ */ x(Rp, { children: n }),
          /* @__PURE__ */ ee(Mb, { justifyContent: "center", children: [
            /* @__PURE__ */ x(
              At,
              {
                id: "confirmDialogConfirmActionButton",
                colorScheme: s,
                mr: 3,
                onClick: () => {
                  a(), r();
                },
                children: o ?? c.confirm
              }
            ),
            /* @__PURE__ */ x(
              At,
              {
                id: "confirmDialogCancelActionButton",
                colorScheme: l,
                mr: 3,
                onClick: () => {
                  u == null || u(), r();
                },
                children: i ?? c.cancel
              }
            )
          ] })
        ] })
      ]
    }
  );
});
H2.displayName = "ConfirmDialog";
const z2 = P.memo(({ value: e, "aria-label": r, ...t }) => {
  const n = P.useCallback(() => {
    navigator.clipboard.writeText(e);
  }, [e]);
  return /* @__PURE__ */ x(
    jn,
    {
      onClick: n,
      "aria-label": r || "Copy to clipboard",
      icon: /* @__PURE__ */ x(uD, {}),
      bg: j.tertiary[1],
      color: "white",
      borderRadius: "full",
      p: "10px",
      transition: "transform 0.2s",
      _active: {
        transform: "scale(1.1)"
      },
      _hover: {
        bg: j.tertiary[2]
      },
      ...t
    }
  );
});
z2.displayName = "CopyToClipboardButton";
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Sn(e, r) {
  return typeof e == "function" ? e(r) : e;
}
function Qt(e, r) {
  return (t) => {
    r.setState((n) => ({
      ...n,
      [e]: Sn(t, n[e])
    }));
  };
}
function Ks(e) {
  return e instanceof Function;
}
function $2(e) {
  return Array.isArray(e) && e.every((r) => typeof r == "number");
}
function X2(e, r) {
  const t = [], n = (a) => {
    a.forEach((o) => {
      t.push(o);
      const i = r(o);
      i != null && i.length && n(i);
    });
  };
  return n(e), t;
}
function me(e, r, t) {
  let n = [], a;
  return (o) => {
    let i;
    t.key && t.debug && (i = Date.now());
    const s = e(o);
    if (!(s.length !== n.length || s.some((c, d) => n[d] !== c)))
      return a;
    n = s;
    let u;
    if (t.key && t.debug && (u = Date.now()), a = r(...s), t == null || t.onChange == null || t.onChange(a), t.key && t.debug && t != null && t.debug()) {
      const c = Math.round((Date.now() - i) * 100) / 100, d = Math.round((Date.now() - u) * 100) / 100, p = d / 16, f = (h, g) => {
        for (h = String(h); h.length < g; )
          h = " " + h;
        return h;
      };
      console.info(`%c⏱ ${f(d, 5)} /${f(c, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * p, 120))}deg 100% 31%);`, t == null ? void 0 : t.key);
    }
    return a;
  };
}
function ve(e, r, t, n) {
  return {
    debug: () => {
      var a;
      return (a = e == null ? void 0 : e.debugAll) != null ? a : e[r];
    },
    key: process.env.NODE_ENV === "development" && t,
    onChange: n
  };
}
function j2(e, r, t, n) {
  const a = () => {
    var i;
    return (i = o.getValue()) != null ? i : e.options.renderFallbackValue;
  }, o = {
    id: `${r.id}_${t.id}`,
    row: r,
    column: t,
    getValue: () => r.getValue(n),
    renderValue: a,
    getContext: me(() => [e, t, r, o], (i, s, l, u) => ({
      table: i,
      column: s,
      row: l,
      cell: u,
      getValue: u.getValue,
      renderValue: u.renderValue
    }), ve(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((i) => {
    i.createCell == null || i.createCell(o, t, r, e);
  }, {}), o;
}
function Z2(e, r, t, n) {
  var a, o;
  const s = {
    ...e._getDefaultColumnDef(),
    ...r
  }, l = s.accessorKey;
  let u = (a = (o = s.id) != null ? o : l ? l.replace(".", "_") : void 0) != null ? a : typeof s.header == "string" ? s.header : void 0, c;
  if (s.accessorFn ? c = s.accessorFn : l && (l.includes(".") ? c = (p) => {
    let f = p;
    for (const g of l.split(".")) {
      var h;
      f = (h = f) == null ? void 0 : h[g], process.env.NODE_ENV !== "production" && f === void 0 && console.warn(`"${g}" in deeply nested key "${l}" returned undefined.`);
    }
    return f;
  } : c = (p) => p[s.accessorKey]), !u)
    throw process.env.NODE_ENV !== "production" ? new Error(s.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let d = {
    id: `${String(u)}`,
    accessorFn: c,
    parent: n,
    depth: t,
    columnDef: s,
    columns: [],
    getFlatColumns: me(() => [!0], () => {
      var p;
      return [d, ...(p = d.columns) == null ? void 0 : p.flatMap((f) => f.getFlatColumns())];
    }, ve(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: me(() => [e._getOrderColumnsFn()], (p) => {
      var f;
      if ((f = d.columns) != null && f.length) {
        let h = d.columns.flatMap((g) => g.getLeafColumns());
        return p(h);
      }
      return [d];
    }, ve(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const p of e._features)
    p.createColumn == null || p.createColumn(d, e);
  return d;
}
const Dt = "debugHeaders";
function yp(e, r, t) {
  var n;
  let o = {
    id: (n = t.id) != null ? n : r.id,
    column: r,
    index: t.index,
    isPlaceholder: !!t.isPlaceholder,
    placeholderId: t.placeholderId,
    depth: t.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const i = [], s = (l) => {
        l.subHeaders && l.subHeaders.length && l.subHeaders.map(s), i.push(l);
      };
      return s(o), i;
    },
    getContext: () => ({
      table: e,
      header: o,
      column: r
    })
  };
  return e._features.forEach((i) => {
    i.createHeader == null || i.createHeader(o, e);
  }), o;
}
const U2 = {
  createTable: (e) => {
    e.getHeaderGroups = me(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (r, t, n, a) => {
      var o, i;
      const s = (o = n == null ? void 0 : n.map((d) => t.find((p) => p.id === d)).filter(Boolean)) != null ? o : [], l = (i = a == null ? void 0 : a.map((d) => t.find((p) => p.id === d)).filter(Boolean)) != null ? i : [], u = t.filter((d) => !(n != null && n.includes(d.id)) && !(a != null && a.includes(d.id)));
      return Ii(r, [...s, ...u, ...l], e);
    }, ve(e.options, Dt, "getHeaderGroups")), e.getCenterHeaderGroups = me(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (r, t, n, a) => (t = t.filter((o) => !(n != null && n.includes(o.id)) && !(a != null && a.includes(o.id))), Ii(r, t, e, "center")), ve(e.options, Dt, "getCenterHeaderGroups")), e.getLeftHeaderGroups = me(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (r, t, n) => {
      var a;
      const o = (a = n == null ? void 0 : n.map((i) => t.find((s) => s.id === i)).filter(Boolean)) != null ? a : [];
      return Ii(r, o, e, "left");
    }, ve(e.options, Dt, "getLeftHeaderGroups")), e.getRightHeaderGroups = me(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (r, t, n) => {
      var a;
      const o = (a = n == null ? void 0 : n.map((i) => t.find((s) => s.id === i)).filter(Boolean)) != null ? a : [];
      return Ii(r, o, e, "right");
    }, ve(e.options, Dt, "getRightHeaderGroups")), e.getFooterGroups = me(() => [e.getHeaderGroups()], (r) => [...r].reverse(), ve(e.options, Dt, "getFooterGroups")), e.getLeftFooterGroups = me(() => [e.getLeftHeaderGroups()], (r) => [...r].reverse(), ve(e.options, Dt, "getLeftFooterGroups")), e.getCenterFooterGroups = me(() => [e.getCenterHeaderGroups()], (r) => [...r].reverse(), ve(e.options, Dt, "getCenterFooterGroups")), e.getRightFooterGroups = me(() => [e.getRightHeaderGroups()], (r) => [...r].reverse(), ve(e.options, Dt, "getRightFooterGroups")), e.getFlatHeaders = me(() => [e.getHeaderGroups()], (r) => r.map((t) => t.headers).flat(), ve(e.options, Dt, "getFlatHeaders")), e.getLeftFlatHeaders = me(() => [e.getLeftHeaderGroups()], (r) => r.map((t) => t.headers).flat(), ve(e.options, Dt, "getLeftFlatHeaders")), e.getCenterFlatHeaders = me(() => [e.getCenterHeaderGroups()], (r) => r.map((t) => t.headers).flat(), ve(e.options, Dt, "getCenterFlatHeaders")), e.getRightFlatHeaders = me(() => [e.getRightHeaderGroups()], (r) => r.map((t) => t.headers).flat(), ve(e.options, Dt, "getRightFlatHeaders")), e.getCenterLeafHeaders = me(() => [e.getCenterFlatHeaders()], (r) => r.filter((t) => {
      var n;
      return !((n = t.subHeaders) != null && n.length);
    }), ve(e.options, Dt, "getCenterLeafHeaders")), e.getLeftLeafHeaders = me(() => [e.getLeftFlatHeaders()], (r) => r.filter((t) => {
      var n;
      return !((n = t.subHeaders) != null && n.length);
    }), ve(e.options, Dt, "getLeftLeafHeaders")), e.getRightLeafHeaders = me(() => [e.getRightFlatHeaders()], (r) => r.filter((t) => {
      var n;
      return !((n = t.subHeaders) != null && n.length);
    }), ve(e.options, Dt, "getRightLeafHeaders")), e.getLeafHeaders = me(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (r, t, n) => {
      var a, o, i, s, l, u;
      return [...(a = (o = r[0]) == null ? void 0 : o.headers) != null ? a : [], ...(i = (s = t[0]) == null ? void 0 : s.headers) != null ? i : [], ...(l = (u = n[0]) == null ? void 0 : u.headers) != null ? l : []].map((c) => c.getLeafHeaders()).flat();
    }, ve(e.options, Dt, "getLeafHeaders"));
  }
};
function Ii(e, r, t, n) {
  var a, o;
  let i = 0;
  const s = function(p, f) {
    f === void 0 && (f = 1), i = Math.max(i, f), p.filter((h) => h.getIsVisible()).forEach((h) => {
      var g;
      (g = h.columns) != null && g.length && s(h.columns, f + 1);
    }, 0);
  };
  s(e);
  let l = [];
  const u = (p, f) => {
    const h = {
      depth: f,
      id: [n, `${f}`].filter(Boolean).join("_"),
      headers: []
    }, g = [];
    p.forEach((m) => {
      const v = [...g].reverse()[0], y = m.column.depth === h.depth;
      let w, I = !1;
      if (y && m.column.parent ? w = m.column.parent : (w = m.column, I = !0), v && (v == null ? void 0 : v.column) === w)
        v.subHeaders.push(m);
      else {
        const b = yp(t, w, {
          id: [n, f, w.id, m == null ? void 0 : m.id].filter(Boolean).join("_"),
          isPlaceholder: I,
          placeholderId: I ? `${g.filter((D) => D.column === w).length}` : void 0,
          depth: f,
          index: g.length
        });
        b.subHeaders.push(m), g.push(b);
      }
      h.headers.push(m), m.headerGroup = h;
    }), l.push(h), f > 0 && u(g, f - 1);
  }, c = r.map((p, f) => yp(t, p, {
    depth: i,
    index: f
  }));
  u(c, i - 1), l.reverse();
  const d = (p) => p.filter((h) => h.column.getIsVisible()).map((h) => {
    let g = 0, m = 0, v = [0];
    h.subHeaders && h.subHeaders.length ? (v = [], d(h.subHeaders).forEach((w) => {
      let {
        colSpan: I,
        rowSpan: b
      } = w;
      g += I, v.push(b);
    })) : g = 1;
    const y = Math.min(...v);
    return m = m + y, h.colSpan = g, h.rowSpan = m, {
      colSpan: g,
      rowSpan: m
    };
  });
  return d((a = (o = l[0]) == null ? void 0 : o.headers) != null ? a : []), l;
}
const J2 = (e, r, t, n, a, o, i) => {
  let s = {
    id: r,
    index: n,
    original: t,
    depth: a,
    parentId: i,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (l) => {
      if (s._valuesCache.hasOwnProperty(l))
        return s._valuesCache[l];
      const u = e.getColumn(l);
      if (u != null && u.accessorFn)
        return s._valuesCache[l] = u.accessorFn(s.original, n), s._valuesCache[l];
    },
    getUniqueValues: (l) => {
      if (s._uniqueValuesCache.hasOwnProperty(l))
        return s._uniqueValuesCache[l];
      const u = e.getColumn(l);
      if (u != null && u.accessorFn)
        return u.columnDef.getUniqueValues ? (s._uniqueValuesCache[l] = u.columnDef.getUniqueValues(s.original, n), s._uniqueValuesCache[l]) : (s._uniqueValuesCache[l] = [s.getValue(l)], s._uniqueValuesCache[l]);
    },
    renderValue: (l) => {
      var u;
      return (u = s.getValue(l)) != null ? u : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => X2(s.subRows, (l) => l.subRows),
    getParentRow: () => s.parentId ? e.getRow(s.parentId, !0) : void 0,
    getParentRows: () => {
      let l = [], u = s;
      for (; ; ) {
        const c = u.getParentRow();
        if (!c) break;
        l.push(c), u = c;
      }
      return l.reverse();
    },
    getAllCells: me(() => [e.getAllLeafColumns()], (l) => l.map((u) => j2(e, s, u, u.id)), ve(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: me(() => [s.getAllCells()], (l) => l.reduce((u, c) => (u[c.column.id] = c, u), {}), ve(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let l = 0; l < e._features.length; l++) {
    const u = e._features[l];
    u == null || u.createRow == null || u.createRow(s, e);
  }
  return s;
}, Q2 = {
  createColumn: (e, r) => {
    e._getFacetedRowModel = r.options.getFacetedRowModel && r.options.getFacetedRowModel(r, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : r.getPreFilteredRowModel(), e._getFacetedUniqueValues = r.options.getFacetedUniqueValues && r.options.getFacetedUniqueValues(r, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = r.options.getFacetedMinMaxValues && r.options.getFacetedMinMaxValues(r, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, tv = (e, r, t) => {
  var n;
  const a = t.toLowerCase();
  return !!(!((n = e.getValue(r)) == null || (n = n.toString()) == null || (n = n.toLowerCase()) == null) && n.includes(a));
};
tv.autoRemove = (e) => br(e);
const rv = (e, r, t) => {
  var n;
  return !!(!((n = e.getValue(r)) == null || (n = n.toString()) == null) && n.includes(t));
};
rv.autoRemove = (e) => br(e);
const nv = (e, r, t) => {
  var n;
  return ((n = e.getValue(r)) == null || (n = n.toString()) == null ? void 0 : n.toLowerCase()) === (t == null ? void 0 : t.toLowerCase());
};
nv.autoRemove = (e) => br(e);
const av = (e, r, t) => {
  var n;
  return (n = e.getValue(r)) == null ? void 0 : n.includes(t);
};
av.autoRemove = (e) => br(e) || !(e != null && e.length);
const ov = (e, r, t) => !t.some((n) => {
  var a;
  return !((a = e.getValue(r)) != null && a.includes(n));
});
ov.autoRemove = (e) => br(e) || !(e != null && e.length);
const iv = (e, r, t) => t.some((n) => {
  var a;
  return (a = e.getValue(r)) == null ? void 0 : a.includes(n);
});
iv.autoRemove = (e) => br(e) || !(e != null && e.length);
const sv = (e, r, t) => e.getValue(r) === t;
sv.autoRemove = (e) => br(e);
const lv = (e, r, t) => e.getValue(r) == t;
lv.autoRemove = (e) => br(e);
const Gc = (e, r, t) => {
  let [n, a] = t;
  const o = e.getValue(r);
  return o >= n && o <= a;
};
Gc.resolveFilterValue = (e) => {
  let [r, t] = e, n = typeof r != "number" ? parseFloat(r) : r, a = typeof t != "number" ? parseFloat(t) : t, o = r === null || Number.isNaN(n) ? -1 / 0 : n, i = t === null || Number.isNaN(a) ? 1 / 0 : a;
  if (o > i) {
    const s = o;
    o = i, i = s;
  }
  return [o, i];
};
Gc.autoRemove = (e) => br(e) || br(e[0]) && br(e[1]);
const qr = {
  includesString: tv,
  includesStringSensitive: rv,
  equalsString: nv,
  arrIncludes: av,
  arrIncludesAll: ov,
  arrIncludesSome: iv,
  equals: sv,
  weakEquals: lv,
  inNumberRange: Gc
};
function br(e) {
  return e == null || e === "";
}
const q2 = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: Qt("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, r) => {
    e.getAutoFilterFn = () => {
      const t = r.getCoreRowModel().flatRows[0], n = t == null ? void 0 : t.getValue(e.id);
      return typeof n == "string" ? qr.includesString : typeof n == "number" ? qr.inNumberRange : typeof n == "boolean" || n !== null && typeof n == "object" ? qr.equals : Array.isArray(n) ? qr.arrIncludes : qr.weakEquals;
    }, e.getFilterFn = () => {
      var t, n;
      return Ks(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (t = (n = r.options.filterFns) == null ? void 0 : n[e.columnDef.filterFn]) != null ? t : qr[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var t, n, a;
      return ((t = e.columnDef.enableColumnFilter) != null ? t : !0) && ((n = r.options.enableColumnFilters) != null ? n : !0) && ((a = r.options.enableFilters) != null ? a : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var t;
      return (t = r.getState().columnFilters) == null || (t = t.find((n) => n.id === e.id)) == null ? void 0 : t.value;
    }, e.getFilterIndex = () => {
      var t, n;
      return (t = (n = r.getState().columnFilters) == null ? void 0 : n.findIndex((a) => a.id === e.id)) != null ? t : -1;
    }, e.setFilterValue = (t) => {
      r.setColumnFilters((n) => {
        const a = e.getFilterFn(), o = n == null ? void 0 : n.find((c) => c.id === e.id), i = Sn(t, o ? o.value : void 0);
        if (wp(a, i, e)) {
          var s;
          return (s = n == null ? void 0 : n.filter((c) => c.id !== e.id)) != null ? s : [];
        }
        const l = {
          id: e.id,
          value: i
        };
        if (o) {
          var u;
          return (u = n == null ? void 0 : n.map((c) => c.id === e.id ? l : c)) != null ? u : [];
        }
        return n != null && n.length ? [...n, l] : [l];
      });
    };
  },
  createRow: (e, r) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (r) => {
      const t = e.getAllLeafColumns(), n = (a) => {
        var o;
        return (o = Sn(r, a)) == null ? void 0 : o.filter((i) => {
          const s = t.find((l) => l.id === i.id);
          if (s) {
            const l = s.getFilterFn();
            if (wp(l, i.value, s))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(n);
    }, e.resetColumnFilters = (r) => {
      var t, n;
      e.setColumnFilters(r ? [] : (t = (n = e.initialState) == null ? void 0 : n.columnFilters) != null ? t : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function wp(e, r, t) {
  return (e && e.autoRemove ? e.autoRemove(r, t) : !1) || typeof r > "u" || typeof r == "string" && !r;
}
const K2 = (e, r, t) => t.reduce((n, a) => {
  const o = a.getValue(e);
  return n + (typeof o == "number" ? o : 0);
}, 0), eT = (e, r, t) => {
  let n;
  return t.forEach((a) => {
    const o = a.getValue(e);
    o != null && (n > o || n === void 0 && o >= o) && (n = o);
  }), n;
}, tT = (e, r, t) => {
  let n;
  return t.forEach((a) => {
    const o = a.getValue(e);
    o != null && (n < o || n === void 0 && o >= o) && (n = o);
  }), n;
}, rT = (e, r, t) => {
  let n, a;
  return t.forEach((o) => {
    const i = o.getValue(e);
    i != null && (n === void 0 ? i >= i && (n = a = i) : (n > i && (n = i), a < i && (a = i)));
  }), [n, a];
}, nT = (e, r) => {
  let t = 0, n = 0;
  if (r.forEach((a) => {
    let o = a.getValue(e);
    o != null && (o = +o) >= o && (++t, n += o);
  }), t) return n / t;
}, aT = (e, r) => {
  if (!r.length)
    return;
  const t = r.map((o) => o.getValue(e));
  if (!$2(t))
    return;
  if (t.length === 1)
    return t[0];
  const n = Math.floor(t.length / 2), a = t.sort((o, i) => o - i);
  return t.length % 2 !== 0 ? a[n] : (a[n - 1] + a[n]) / 2;
}, oT = (e, r) => Array.from(new Set(r.map((t) => t.getValue(e))).values()), iT = (e, r) => new Set(r.map((t) => t.getValue(e))).size, sT = (e, r) => r.length, zl = {
  sum: K2,
  min: eT,
  max: tT,
  extent: rT,
  mean: nT,
  median: aT,
  unique: oT,
  uniqueCount: iT,
  count: sT
}, lT = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var r, t;
      return (r = (t = e.getValue()) == null || t.toString == null ? void 0 : t.toString()) != null ? r : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: Qt("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, r) => {
    e.toggleGrouping = () => {
      r.setGrouping((t) => t != null && t.includes(e.id) ? t.filter((n) => n !== e.id) : [...t ?? [], e.id]);
    }, e.getCanGroup = () => {
      var t, n;
      return ((t = e.columnDef.enableGrouping) != null ? t : !0) && ((n = r.options.enableGrouping) != null ? n : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var t;
      return (t = r.getState().grouping) == null ? void 0 : t.includes(e.id);
    }, e.getGroupedIndex = () => {
      var t;
      return (t = r.getState().grouping) == null ? void 0 : t.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const t = e.getCanGroup();
      return () => {
        t && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const t = r.getCoreRowModel().flatRows[0], n = t == null ? void 0 : t.getValue(e.id);
      if (typeof n == "number")
        return zl.sum;
      if (Object.prototype.toString.call(n) === "[object Date]")
        return zl.extent;
    }, e.getAggregationFn = () => {
      var t, n;
      if (!e)
        throw new Error();
      return Ks(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (t = (n = r.options.aggregationFns) == null ? void 0 : n[e.columnDef.aggregationFn]) != null ? t : zl[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (r) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(r), e.resetGrouping = (r) => {
      var t, n;
      e.setGrouping(r ? [] : (t = (n = e.initialState) == null ? void 0 : n.grouping) != null ? t : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, r) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (t) => {
      if (e._groupingValuesCache.hasOwnProperty(t))
        return e._groupingValuesCache[t];
      const n = r.getColumn(t);
      return n != null && n.columnDef.getGroupingValue ? (e._groupingValuesCache[t] = n.columnDef.getGroupingValue(e.original), e._groupingValuesCache[t]) : e.getValue(t);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, r, t, n) => {
    e.getIsGrouped = () => r.getIsGrouped() && r.id === t.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && r.getIsGrouped(), e.getIsAggregated = () => {
      var a;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((a = t.subRows) != null && a.length);
    };
  }
};
function uT(e, r, t) {
  if (!(r != null && r.length) || !t)
    return e;
  const n = e.filter((o) => !r.includes(o.id));
  return t === "remove" ? n : [...r.map((o) => e.find((i) => i.id === o)).filter(Boolean), ...n];
}
const cT = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: Qt("columnOrder", e)
  }),
  createColumn: (e, r) => {
    e.getIndex = me((t) => [Mo(r, t)], (t) => t.findIndex((n) => n.id === e.id), ve(r.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (t) => {
      var n;
      return ((n = Mo(r, t)[0]) == null ? void 0 : n.id) === e.id;
    }, e.getIsLastColumn = (t) => {
      var n;
      const a = Mo(r, t);
      return ((n = a[a.length - 1]) == null ? void 0 : n.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (r) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(r), e.resetColumnOrder = (r) => {
      var t;
      e.setColumnOrder(r ? [] : (t = e.initialState.columnOrder) != null ? t : []);
    }, e._getOrderColumnsFn = me(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (r, t, n) => (a) => {
      let o = [];
      if (!(r != null && r.length))
        o = a;
      else {
        const i = [...r], s = [...a];
        for (; s.length && i.length; ) {
          const l = i.shift(), u = s.findIndex((c) => c.id === l);
          u > -1 && o.push(s.splice(u, 1)[0]);
        }
        o = [...o, ...s];
      }
      return uT(o, t, n);
    }, ve(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, $l = () => ({
  left: [],
  right: []
}), dT = {
  getInitialState: (e) => ({
    columnPinning: $l(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: Qt("columnPinning", e)
  }),
  createColumn: (e, r) => {
    e.pin = (t) => {
      const n = e.getLeafColumns().map((a) => a.id).filter(Boolean);
      r.setColumnPinning((a) => {
        var o, i;
        if (t === "right") {
          var s, l;
          return {
            left: ((s = a == null ? void 0 : a.left) != null ? s : []).filter((d) => !(n != null && n.includes(d))),
            right: [...((l = a == null ? void 0 : a.right) != null ? l : []).filter((d) => !(n != null && n.includes(d))), ...n]
          };
        }
        if (t === "left") {
          var u, c;
          return {
            left: [...((u = a == null ? void 0 : a.left) != null ? u : []).filter((d) => !(n != null && n.includes(d))), ...n],
            right: ((c = a == null ? void 0 : a.right) != null ? c : []).filter((d) => !(n != null && n.includes(d)))
          };
        }
        return {
          left: ((o = a == null ? void 0 : a.left) != null ? o : []).filter((d) => !(n != null && n.includes(d))),
          right: ((i = a == null ? void 0 : a.right) != null ? i : []).filter((d) => !(n != null && n.includes(d)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((n) => {
      var a, o, i;
      return ((a = n.columnDef.enablePinning) != null ? a : !0) && ((o = (i = r.options.enableColumnPinning) != null ? i : r.options.enablePinning) != null ? o : !0);
    }), e.getIsPinned = () => {
      const t = e.getLeafColumns().map((s) => s.id), {
        left: n,
        right: a
      } = r.getState().columnPinning, o = t.some((s) => n == null ? void 0 : n.includes(s)), i = t.some((s) => a == null ? void 0 : a.includes(s));
      return o ? "left" : i ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var t, n;
      const a = e.getIsPinned();
      return a ? (t = (n = r.getState().columnPinning) == null || (n = n[a]) == null ? void 0 : n.indexOf(e.id)) != null ? t : -1 : 0;
    };
  },
  createRow: (e, r) => {
    e.getCenterVisibleCells = me(() => [e._getAllVisibleCells(), r.getState().columnPinning.left, r.getState().columnPinning.right], (t, n, a) => {
      const o = [...n ?? [], ...a ?? []];
      return t.filter((i) => !o.includes(i.column.id));
    }, ve(r.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = me(() => [e._getAllVisibleCells(), r.getState().columnPinning.left], (t, n) => (n ?? []).map((o) => t.find((i) => i.column.id === o)).filter(Boolean).map((o) => ({
      ...o,
      position: "left"
    })), ve(r.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = me(() => [e._getAllVisibleCells(), r.getState().columnPinning.right], (t, n) => (n ?? []).map((o) => t.find((i) => i.column.id === o)).filter(Boolean).map((o) => ({
      ...o,
      position: "right"
    })), ve(r.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (r) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(r), e.resetColumnPinning = (r) => {
      var t, n;
      return e.setColumnPinning(r ? $l() : (t = (n = e.initialState) == null ? void 0 : n.columnPinning) != null ? t : $l());
    }, e.getIsSomeColumnsPinned = (r) => {
      var t;
      const n = e.getState().columnPinning;
      if (!r) {
        var a, o;
        return !!((a = n.left) != null && a.length || (o = n.right) != null && o.length);
      }
      return !!((t = n[r]) != null && t.length);
    }, e.getLeftLeafColumns = me(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (r, t) => (t ?? []).map((n) => r.find((a) => a.id === n)).filter(Boolean), ve(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = me(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (r, t) => (t ?? []).map((n) => r.find((a) => a.id === n)).filter(Boolean), ve(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = me(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (r, t, n) => {
      const a = [...t ?? [], ...n ?? []];
      return r.filter((o) => !a.includes(o.id));
    }, ve(e.options, "debugColumns", "getCenterLeafColumns"));
  }
}, Di = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, Xl = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), fT = {
  getDefaultColumnDef: () => Di,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: Xl(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: Qt("columnSizing", e),
    onColumnSizingInfoChange: Qt("columnSizingInfo", e)
  }),
  createColumn: (e, r) => {
    e.getSize = () => {
      var t, n, a;
      const o = r.getState().columnSizing[e.id];
      return Math.min(Math.max((t = e.columnDef.minSize) != null ? t : Di.minSize, (n = o ?? e.columnDef.size) != null ? n : Di.size), (a = e.columnDef.maxSize) != null ? a : Di.maxSize);
    }, e.getStart = me((t) => [t, Mo(r, t), r.getState().columnSizing], (t, n) => n.slice(0, e.getIndex(t)).reduce((a, o) => a + o.getSize(), 0), ve(r.options, "debugColumns", "getStart")), e.getAfter = me((t) => [t, Mo(r, t), r.getState().columnSizing], (t, n) => n.slice(e.getIndex(t) + 1).reduce((a, o) => a + o.getSize(), 0), ve(r.options, "debugColumns", "getAfter")), e.resetSize = () => {
      r.setColumnSizing((t) => {
        let {
          [e.id]: n,
          ...a
        } = t;
        return a;
      });
    }, e.getCanResize = () => {
      var t, n;
      return ((t = e.columnDef.enableResizing) != null ? t : !0) && ((n = r.options.enableColumnResizing) != null ? n : !0);
    }, e.getIsResizing = () => r.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, r) => {
    e.getSize = () => {
      let t = 0;
      const n = (a) => {
        if (a.subHeaders.length)
          a.subHeaders.forEach(n);
        else {
          var o;
          t += (o = a.column.getSize()) != null ? o : 0;
        }
      };
      return n(e), t;
    }, e.getStart = () => {
      if (e.index > 0) {
        const t = e.headerGroup.headers[e.index - 1];
        return t.getStart() + t.getSize();
      }
      return 0;
    }, e.getResizeHandler = (t) => {
      const n = r.getColumn(e.column.id), a = n == null ? void 0 : n.getCanResize();
      return (o) => {
        if (!n || !a || (o.persist == null || o.persist(), jl(o) && o.touches && o.touches.length > 1))
          return;
        const i = e.getSize(), s = e ? e.getLeafHeaders().map((v) => [v.column.id, v.column.getSize()]) : [[n.id, n.getSize()]], l = jl(o) ? Math.round(o.touches[0].clientX) : o.clientX, u = {}, c = (v, y) => {
          typeof y == "number" && (r.setColumnSizingInfo((w) => {
            var I, b;
            const D = r.options.columnResizeDirection === "rtl" ? -1 : 1, S = (y - ((I = w == null ? void 0 : w.startOffset) != null ? I : 0)) * D, _ = Math.max(S / ((b = w == null ? void 0 : w.startSize) != null ? b : 0), -0.999999);
            return w.columnSizingStart.forEach((k) => {
              let [R, W] = k;
              u[R] = Math.round(Math.max(W + W * _, 0) * 100) / 100;
            }), {
              ...w,
              deltaOffset: S,
              deltaPercentage: _
            };
          }), (r.options.columnResizeMode === "onChange" || v === "end") && r.setColumnSizing((w) => ({
            ...w,
            ...u
          })));
        }, d = (v) => c("move", v), p = (v) => {
          c("end", v), r.setColumnSizingInfo((y) => ({
            ...y,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, f = t || typeof document < "u" ? document : null, h = {
          moveHandler: (v) => d(v.clientX),
          upHandler: (v) => {
            f == null || f.removeEventListener("mousemove", h.moveHandler), f == null || f.removeEventListener("mouseup", h.upHandler), p(v.clientX);
          }
        }, g = {
          moveHandler: (v) => (v.cancelable && (v.preventDefault(), v.stopPropagation()), d(v.touches[0].clientX), !1),
          upHandler: (v) => {
            var y;
            f == null || f.removeEventListener("touchmove", g.moveHandler), f == null || f.removeEventListener("touchend", g.upHandler), v.cancelable && (v.preventDefault(), v.stopPropagation()), p((y = v.touches[0]) == null ? void 0 : y.clientX);
          }
        }, m = pT() ? {
          passive: !1
        } : !1;
        jl(o) ? (f == null || f.addEventListener("touchmove", g.moveHandler, m), f == null || f.addEventListener("touchend", g.upHandler, m)) : (f == null || f.addEventListener("mousemove", h.moveHandler, m), f == null || f.addEventListener("mouseup", h.upHandler, m)), r.setColumnSizingInfo((v) => ({
          ...v,
          startOffset: l,
          startSize: i,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: s,
          isResizingColumn: n.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (r) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(r), e.setColumnSizingInfo = (r) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(r), e.resetColumnSizing = (r) => {
      var t;
      e.setColumnSizing(r ? {} : (t = e.initialState.columnSizing) != null ? t : {});
    }, e.resetHeaderSizeInfo = (r) => {
      var t;
      e.setColumnSizingInfo(r ? Xl() : (t = e.initialState.columnSizingInfo) != null ? t : Xl());
    }, e.getTotalSize = () => {
      var r, t;
      return (r = (t = e.getHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((n, a) => n + a.getSize(), 0)) != null ? r : 0;
    }, e.getLeftTotalSize = () => {
      var r, t;
      return (r = (t = e.getLeftHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((n, a) => n + a.getSize(), 0)) != null ? r : 0;
    }, e.getCenterTotalSize = () => {
      var r, t;
      return (r = (t = e.getCenterHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((n, a) => n + a.getSize(), 0)) != null ? r : 0;
    }, e.getRightTotalSize = () => {
      var r, t;
      return (r = (t = e.getRightHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((n, a) => n + a.getSize(), 0)) != null ? r : 0;
    };
  }
};
let _i = null;
function pT() {
  if (typeof _i == "boolean") return _i;
  let e = !1;
  try {
    const r = {
      get passive() {
        return e = !0, !1;
      }
    }, t = () => {
    };
    window.addEventListener("test", t, r), window.removeEventListener("test", t);
  } catch {
    e = !1;
  }
  return _i = e, _i;
}
function jl(e) {
  return e.type === "touchstart";
}
const hT = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: Qt("columnVisibility", e)
  }),
  createColumn: (e, r) => {
    e.toggleVisibility = (t) => {
      e.getCanHide() && r.setColumnVisibility((n) => ({
        ...n,
        [e.id]: t ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var t, n;
      const a = e.columns;
      return (t = a.length ? a.some((o) => o.getIsVisible()) : (n = r.getState().columnVisibility) == null ? void 0 : n[e.id]) != null ? t : !0;
    }, e.getCanHide = () => {
      var t, n;
      return ((t = e.columnDef.enableHiding) != null ? t : !0) && ((n = r.options.enableHiding) != null ? n : !0);
    }, e.getToggleVisibilityHandler = () => (t) => {
      e.toggleVisibility == null || e.toggleVisibility(t.target.checked);
    };
  },
  createRow: (e, r) => {
    e._getAllVisibleCells = me(() => [e.getAllCells(), r.getState().columnVisibility], (t) => t.filter((n) => n.column.getIsVisible()), ve(r.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = me(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (t, n, a) => [...t, ...n, ...a], ve(r.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const r = (t, n) => me(() => [n(), n().filter((a) => a.getIsVisible()).map((a) => a.id).join("_")], (a) => a.filter((o) => o.getIsVisible == null ? void 0 : o.getIsVisible()), ve(e.options, "debugColumns", t));
    e.getVisibleFlatColumns = r("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = r("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = r("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = r("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = r("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (t) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(t), e.resetColumnVisibility = (t) => {
      var n;
      e.setColumnVisibility(t ? {} : (n = e.initialState.columnVisibility) != null ? n : {});
    }, e.toggleAllColumnsVisible = (t) => {
      var n;
      t = (n = t) != null ? n : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((a, o) => ({
        ...a,
        [o.id]: t || !(o.getCanHide != null && o.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((t) => !(t.getIsVisible != null && t.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((t) => t.getIsVisible == null ? void 0 : t.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (t) => {
      var n;
      e.toggleAllColumnsVisible((n = t.target) == null ? void 0 : n.checked);
    };
  }
};
function Mo(e, r) {
  return r ? r === "center" ? e.getCenterVisibleLeafColumns() : r === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const gT = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, mT = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: Qt("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (r) => {
      var t;
      const n = (t = e.getCoreRowModel().flatRows[0]) == null || (t = t._getAllCellsByColumnId()[r.id]) == null ? void 0 : t.getValue();
      return typeof n == "string" || typeof n == "number";
    }
  }),
  createColumn: (e, r) => {
    e.getCanGlobalFilter = () => {
      var t, n, a, o;
      return ((t = e.columnDef.enableGlobalFilter) != null ? t : !0) && ((n = r.options.enableGlobalFilter) != null ? n : !0) && ((a = r.options.enableFilters) != null ? a : !0) && ((o = r.options.getColumnCanGlobalFilter == null ? void 0 : r.options.getColumnCanGlobalFilter(e)) != null ? o : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => qr.includesString, e.getGlobalFilterFn = () => {
      var r, t;
      const {
        globalFilterFn: n
      } = e.options;
      return Ks(n) ? n : n === "auto" ? e.getGlobalAutoFilterFn() : (r = (t = e.options.filterFns) == null ? void 0 : t[n]) != null ? r : qr[n];
    }, e.setGlobalFilter = (r) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(r);
    }, e.resetGlobalFilter = (r) => {
      e.setGlobalFilter(r ? void 0 : e.initialState.globalFilter);
    };
  }
}, vT = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: Qt("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let r = !1, t = !1;
    e._autoResetExpanded = () => {
      var n, a;
      if (!r) {
        e._queue(() => {
          r = !0;
        });
        return;
      }
      if ((n = (a = e.options.autoResetAll) != null ? a : e.options.autoResetExpanded) != null ? n : !e.options.manualExpanding) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetExpanded(), t = !1;
        });
      }
    }, e.setExpanded = (n) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(n), e.toggleAllRowsExpanded = (n) => {
      n ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (n) => {
      var a, o;
      e.setExpanded(n ? {} : (a = (o = e.initialState) == null ? void 0 : o.expanded) != null ? a : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((n) => n.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (n) => {
      n.persist == null || n.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const n = e.getState().expanded;
      return n === !0 || Object.values(n).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const n = e.getState().expanded;
      return typeof n == "boolean" ? n === !0 : !(!Object.keys(n).length || e.getRowModel().flatRows.some((a) => !a.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let n = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((o) => {
        const i = o.split(".");
        n = Math.max(n, i.length);
      }), n;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, r) => {
    e.toggleExpanded = (t) => {
      r.setExpanded((n) => {
        var a;
        const o = n === !0 ? !0 : !!(n != null && n[e.id]);
        let i = {};
        if (n === !0 ? Object.keys(r.getRowModel().rowsById).forEach((s) => {
          i[s] = !0;
        }) : i = n, t = (a = t) != null ? a : !o, !o && t)
          return {
            ...i,
            [e.id]: !0
          };
        if (o && !t) {
          const {
            [e.id]: s,
            ...l
          } = i;
          return l;
        }
        return n;
      });
    }, e.getIsExpanded = () => {
      var t;
      const n = r.getState().expanded;
      return !!((t = r.options.getIsRowExpanded == null ? void 0 : r.options.getIsRowExpanded(e)) != null ? t : n === !0 || n != null && n[e.id]);
    }, e.getCanExpand = () => {
      var t, n, a;
      return (t = r.options.getRowCanExpand == null ? void 0 : r.options.getRowCanExpand(e)) != null ? t : ((n = r.options.enableExpanding) != null ? n : !0) && !!((a = e.subRows) != null && a.length);
    }, e.getIsAllParentsExpanded = () => {
      let t = !0, n = e;
      for (; t && n.parentId; )
        n = r.getRow(n.parentId, !0), t = n.getIsExpanded();
      return t;
    }, e.getToggleExpandedHandler = () => {
      const t = e.getCanExpand();
      return () => {
        t && e.toggleExpanded();
      };
    };
  }
}, Ru = 0, Ou = 10, Zl = () => ({
  pageIndex: Ru,
  pageSize: Ou
}), bT = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...Zl(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: Qt("pagination", e)
  }),
  createTable: (e) => {
    let r = !1, t = !1;
    e._autoResetPageIndex = () => {
      var n, a;
      if (!r) {
        e._queue(() => {
          r = !0;
        });
        return;
      }
      if ((n = (a = e.options.autoResetAll) != null ? a : e.options.autoResetPageIndex) != null ? n : !e.options.manualPagination) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetPageIndex(), t = !1;
        });
      }
    }, e.setPagination = (n) => {
      const a = (o) => Sn(n, o);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(a);
    }, e.resetPagination = (n) => {
      var a;
      e.setPagination(n ? Zl() : (a = e.initialState.pagination) != null ? a : Zl());
    }, e.setPageIndex = (n) => {
      e.setPagination((a) => {
        let o = Sn(n, a.pageIndex);
        const i = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return o = Math.max(0, Math.min(o, i)), {
          ...a,
          pageIndex: o
        };
      });
    }, e.resetPageIndex = (n) => {
      var a, o;
      e.setPageIndex(n ? Ru : (a = (o = e.initialState) == null || (o = o.pagination) == null ? void 0 : o.pageIndex) != null ? a : Ru);
    }, e.resetPageSize = (n) => {
      var a, o;
      e.setPageSize(n ? Ou : (a = (o = e.initialState) == null || (o = o.pagination) == null ? void 0 : o.pageSize) != null ? a : Ou);
    }, e.setPageSize = (n) => {
      e.setPagination((a) => {
        const o = Math.max(1, Sn(n, a.pageSize)), i = a.pageSize * a.pageIndex, s = Math.floor(i / o);
        return {
          ...a,
          pageIndex: s,
          pageSize: o
        };
      });
    }, e.setPageCount = (n) => e.setPagination((a) => {
      var o;
      let i = Sn(n, (o = e.options.pageCount) != null ? o : -1);
      return typeof i == "number" && (i = Math.max(-1, i)), {
        ...a,
        pageCount: i
      };
    }), e.getPageOptions = me(() => [e.getPageCount()], (n) => {
      let a = [];
      return n && n > 0 && (a = [...new Array(n)].fill(null).map((o, i) => i)), a;
    }, ve(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: n
      } = e.getState().pagination, a = e.getPageCount();
      return a === -1 ? !0 : a === 0 ? !1 : n < a - 1;
    }, e.previousPage = () => e.setPageIndex((n) => n - 1), e.nextPage = () => e.setPageIndex((n) => n + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var n;
      return (n = e.options.pageCount) != null ? n : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var n;
      return (n = e.options.rowCount) != null ? n : e.getPrePaginationRowModel().rows.length;
    };
  }
}, Ul = () => ({
  top: [],
  bottom: []
}), yT = {
  getInitialState: (e) => ({
    rowPinning: Ul(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: Qt("rowPinning", e)
  }),
  createRow: (e, r) => {
    e.pin = (t, n, a) => {
      const o = n ? e.getLeafRows().map((l) => {
        let {
          id: u
        } = l;
        return u;
      }) : [], i = a ? e.getParentRows().map((l) => {
        let {
          id: u
        } = l;
        return u;
      }) : [], s = /* @__PURE__ */ new Set([...i, e.id, ...o]);
      r.setRowPinning((l) => {
        var u, c;
        if (t === "bottom") {
          var d, p;
          return {
            top: ((d = l == null ? void 0 : l.top) != null ? d : []).filter((g) => !(s != null && s.has(g))),
            bottom: [...((p = l == null ? void 0 : l.bottom) != null ? p : []).filter((g) => !(s != null && s.has(g))), ...Array.from(s)]
          };
        }
        if (t === "top") {
          var f, h;
          return {
            top: [...((f = l == null ? void 0 : l.top) != null ? f : []).filter((g) => !(s != null && s.has(g))), ...Array.from(s)],
            bottom: ((h = l == null ? void 0 : l.bottom) != null ? h : []).filter((g) => !(s != null && s.has(g)))
          };
        }
        return {
          top: ((u = l == null ? void 0 : l.top) != null ? u : []).filter((g) => !(s != null && s.has(g))),
          bottom: ((c = l == null ? void 0 : l.bottom) != null ? c : []).filter((g) => !(s != null && s.has(g)))
        };
      });
    }, e.getCanPin = () => {
      var t;
      const {
        enableRowPinning: n,
        enablePinning: a
      } = r.options;
      return typeof n == "function" ? n(e) : (t = n ?? a) != null ? t : !0;
    }, e.getIsPinned = () => {
      const t = [e.id], {
        top: n,
        bottom: a
      } = r.getState().rowPinning, o = t.some((s) => n == null ? void 0 : n.includes(s)), i = t.some((s) => a == null ? void 0 : a.includes(s));
      return o ? "top" : i ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var t, n;
      const a = e.getIsPinned();
      if (!a) return -1;
      const o = (t = r._getPinnedRows(a)) == null ? void 0 : t.map((i) => {
        let {
          id: s
        } = i;
        return s;
      });
      return (n = o == null ? void 0 : o.indexOf(e.id)) != null ? n : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (r) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(r), e.resetRowPinning = (r) => {
      var t, n;
      return e.setRowPinning(r ? Ul() : (t = (n = e.initialState) == null ? void 0 : n.rowPinning) != null ? t : Ul());
    }, e.getIsSomeRowsPinned = (r) => {
      var t;
      const n = e.getState().rowPinning;
      if (!r) {
        var a, o;
        return !!((a = n.top) != null && a.length || (o = n.bottom) != null && o.length);
      }
      return !!((t = n[r]) != null && t.length);
    }, e._getPinnedRows = me((r) => [e.getRowModel().rows, e.getState().rowPinning[r], r], (r, t, n) => {
      var a;
      return ((a = e.options.keepPinnedRows) == null || a ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (t ?? []).map((i) => {
          const s = e.getRow(i, !0);
          return s.getIsAllParentsExpanded() ? s : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (t ?? []).map((i) => r.find((s) => s.id === i))
      )).filter(Boolean).map((i) => ({
        ...i,
        position: n
      }));
    }, ve(e.options, "debugRows", "_getPinnedRows")), e.getTopRows = () => e._getPinnedRows("top"), e.getBottomRows = () => e._getPinnedRows("bottom"), e.getCenterRows = me(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (r, t, n) => {
      const a = /* @__PURE__ */ new Set([...t ?? [], ...n ?? []]);
      return r.filter((o) => !a.has(o.id));
    }, ve(e.options, "debugRows", "getCenterRows"));
  }
}, wT = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: Qt("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (r) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(r), e.resetRowSelection = (r) => {
      var t;
      return e.setRowSelection(r ? {} : (t = e.initialState.rowSelection) != null ? t : {});
    }, e.toggleAllRowsSelected = (r) => {
      e.setRowSelection((t) => {
        r = typeof r < "u" ? r : !e.getIsAllRowsSelected();
        const n = {
          ...t
        }, a = e.getPreGroupedRowModel().flatRows;
        return r ? a.forEach((o) => {
          o.getCanSelect() && (n[o.id] = !0);
        }) : a.forEach((o) => {
          delete n[o.id];
        }), n;
      });
    }, e.toggleAllPageRowsSelected = (r) => e.setRowSelection((t) => {
      const n = typeof r < "u" ? r : !e.getIsAllPageRowsSelected(), a = {
        ...t
      };
      return e.getRowModel().rows.forEach((o) => {
        Tu(a, o.id, n, !0, e);
      }), a;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = me(() => [e.getState().rowSelection, e.getCoreRowModel()], (r, t) => Object.keys(r).length ? Jl(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ve(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = me(() => [e.getState().rowSelection, e.getFilteredRowModel()], (r, t) => Object.keys(r).length ? Jl(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ve(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = me(() => [e.getState().rowSelection, e.getSortedRowModel()], (r, t) => Object.keys(r).length ? Jl(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ve(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const r = e.getFilteredRowModel().flatRows, {
        rowSelection: t
      } = e.getState();
      let n = !!(r.length && Object.keys(t).length);
      return n && r.some((a) => a.getCanSelect() && !t[a.id]) && (n = !1), n;
    }, e.getIsAllPageRowsSelected = () => {
      const r = e.getPaginationRowModel().flatRows.filter((a) => a.getCanSelect()), {
        rowSelection: t
      } = e.getState();
      let n = !!r.length;
      return n && r.some((a) => !t[a.id]) && (n = !1), n;
    }, e.getIsSomeRowsSelected = () => {
      var r;
      const t = Object.keys((r = e.getState().rowSelection) != null ? r : {}).length;
      return t > 0 && t < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const r = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : r.filter((t) => t.getCanSelect()).some((t) => t.getIsSelected() || t.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (r) => {
      e.toggleAllRowsSelected(r.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (r) => {
      e.toggleAllPageRowsSelected(r.target.checked);
    };
  },
  createRow: (e, r) => {
    e.toggleSelected = (t, n) => {
      const a = e.getIsSelected();
      r.setRowSelection((o) => {
        var i;
        if (t = typeof t < "u" ? t : !a, e.getCanSelect() && a === t)
          return o;
        const s = {
          ...o
        };
        return Tu(s, e.id, t, (i = n == null ? void 0 : n.selectChildren) != null ? i : !0, r), s;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: t
      } = r.getState();
      return Yc(e, t);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: t
      } = r.getState();
      return Fu(e, t) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: t
      } = r.getState();
      return Fu(e, t) === "all";
    }, e.getCanSelect = () => {
      var t;
      return typeof r.options.enableRowSelection == "function" ? r.options.enableRowSelection(e) : (t = r.options.enableRowSelection) != null ? t : !0;
    }, e.getCanSelectSubRows = () => {
      var t;
      return typeof r.options.enableSubRowSelection == "function" ? r.options.enableSubRowSelection(e) : (t = r.options.enableSubRowSelection) != null ? t : !0;
    }, e.getCanMultiSelect = () => {
      var t;
      return typeof r.options.enableMultiRowSelection == "function" ? r.options.enableMultiRowSelection(e) : (t = r.options.enableMultiRowSelection) != null ? t : !0;
    }, e.getToggleSelectedHandler = () => {
      const t = e.getCanSelect();
      return (n) => {
        var a;
        t && e.toggleSelected((a = n.target) == null ? void 0 : a.checked);
      };
    };
  }
}, Tu = (e, r, t, n, a) => {
  var o;
  const i = a.getRow(r, !0);
  t ? (i.getCanMultiSelect() || Object.keys(e).forEach((s) => delete e[s]), i.getCanSelect() && (e[r] = !0)) : delete e[r], n && (o = i.subRows) != null && o.length && i.getCanSelectSubRows() && i.subRows.forEach((s) => Tu(e, s.id, t, n, a));
};
function Jl(e, r) {
  const t = e.getState().rowSelection, n = [], a = {}, o = function(i, s) {
    return i.map((l) => {
      var u;
      const c = Yc(l, t);
      if (c && (n.push(l), a[l.id] = l), (u = l.subRows) != null && u.length && (l = {
        ...l,
        subRows: o(l.subRows)
      }), c)
        return l;
    }).filter(Boolean);
  };
  return {
    rows: o(r.rows),
    flatRows: n,
    rowsById: a
  };
}
function Yc(e, r) {
  var t;
  return (t = r[e.id]) != null ? t : !1;
}
function Fu(e, r, t) {
  var n;
  if (!((n = e.subRows) != null && n.length)) return !1;
  let a = !0, o = !1;
  return e.subRows.forEach((i) => {
    if (!(o && !a) && (i.getCanSelect() && (Yc(i, r) ? o = !0 : a = !1), i.subRows && i.subRows.length)) {
      const s = Fu(i, r);
      s === "all" ? o = !0 : (s === "some" && (o = !0), a = !1);
    }
  }), a ? "all" : o ? "some" : !1;
}
const Nu = /([0-9]+)/gm, CT = (e, r, t) => uv(Pn(e.getValue(t)).toLowerCase(), Pn(r.getValue(t)).toLowerCase()), xT = (e, r, t) => uv(Pn(e.getValue(t)), Pn(r.getValue(t))), ST = (e, r, t) => Hc(Pn(e.getValue(t)).toLowerCase(), Pn(r.getValue(t)).toLowerCase()), IT = (e, r, t) => Hc(Pn(e.getValue(t)), Pn(r.getValue(t))), DT = (e, r, t) => {
  const n = e.getValue(t), a = r.getValue(t);
  return n > a ? 1 : n < a ? -1 : 0;
}, _T = (e, r, t) => Hc(e.getValue(t), r.getValue(t));
function Hc(e, r) {
  return e === r ? 0 : e > r ? 1 : -1;
}
function Pn(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function uv(e, r) {
  const t = e.split(Nu).filter(Boolean), n = r.split(Nu).filter(Boolean);
  for (; t.length && n.length; ) {
    const a = t.shift(), o = n.shift(), i = parseInt(a, 10), s = parseInt(o, 10), l = [i, s].sort();
    if (isNaN(l[0])) {
      if (a > o)
        return 1;
      if (o > a)
        return -1;
      continue;
    }
    if (isNaN(l[1]))
      return isNaN(i) ? -1 : 1;
    if (i > s)
      return 1;
    if (s > i)
      return -1;
  }
  return t.length - n.length;
}
const bo = {
  alphanumeric: CT,
  alphanumericCaseSensitive: xT,
  text: ST,
  textCaseSensitive: IT,
  datetime: DT,
  basic: _T
}, kT = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: Qt("sorting", e),
    isMultiSortEvent: (r) => r.shiftKey
  }),
  createColumn: (e, r) => {
    e.getAutoSortingFn = () => {
      const t = r.getFilteredRowModel().flatRows.slice(10);
      let n = !1;
      for (const a of t) {
        const o = a == null ? void 0 : a.getValue(e.id);
        if (Object.prototype.toString.call(o) === "[object Date]")
          return bo.datetime;
        if (typeof o == "string" && (n = !0, o.split(Nu).length > 1))
          return bo.alphanumeric;
      }
      return n ? bo.text : bo.basic;
    }, e.getAutoSortDir = () => {
      const t = r.getFilteredRowModel().flatRows[0];
      return typeof (t == null ? void 0 : t.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var t, n;
      if (!e)
        throw new Error();
      return Ks(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (t = (n = r.options.sortingFns) == null ? void 0 : n[e.columnDef.sortingFn]) != null ? t : bo[e.columnDef.sortingFn];
    }, e.toggleSorting = (t, n) => {
      const a = e.getNextSortingOrder(), o = typeof t < "u" && t !== null;
      r.setSorting((i) => {
        const s = i == null ? void 0 : i.find((f) => f.id === e.id), l = i == null ? void 0 : i.findIndex((f) => f.id === e.id);
        let u = [], c, d = o ? t : a === "desc";
        if (i != null && i.length && e.getCanMultiSort() && n ? s ? c = "toggle" : c = "add" : i != null && i.length && l !== i.length - 1 ? c = "replace" : s ? c = "toggle" : c = "replace", c === "toggle" && (o || a || (c = "remove")), c === "add") {
          var p;
          u = [...i, {
            id: e.id,
            desc: d
          }], u.splice(0, u.length - ((p = r.options.maxMultiSortColCount) != null ? p : Number.MAX_SAFE_INTEGER));
        } else c === "toggle" ? u = i.map((f) => f.id === e.id ? {
          ...f,
          desc: d
        } : f) : c === "remove" ? u = i.filter((f) => f.id !== e.id) : u = [{
          id: e.id,
          desc: d
        }];
        return u;
      });
    }, e.getFirstSortDir = () => {
      var t, n;
      return ((t = (n = e.columnDef.sortDescFirst) != null ? n : r.options.sortDescFirst) != null ? t : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (t) => {
      var n, a;
      const o = e.getFirstSortDir(), i = e.getIsSorted();
      return i ? i !== o && ((n = r.options.enableSortingRemoval) == null || n) && // If enableSortRemove, enable in general
      (!(t && (a = r.options.enableMultiRemove) != null) || a) ? !1 : i === "desc" ? "asc" : "desc" : o;
    }, e.getCanSort = () => {
      var t, n;
      return ((t = e.columnDef.enableSorting) != null ? t : !0) && ((n = r.options.enableSorting) != null ? n : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var t, n;
      return (t = (n = e.columnDef.enableMultiSort) != null ? n : r.options.enableMultiSort) != null ? t : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var t;
      const n = (t = r.getState().sorting) == null ? void 0 : t.find((a) => a.id === e.id);
      return n ? n.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var t, n;
      return (t = (n = r.getState().sorting) == null ? void 0 : n.findIndex((a) => a.id === e.id)) != null ? t : -1;
    }, e.clearSorting = () => {
      r.setSorting((t) => t != null && t.length ? t.filter((n) => n.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const t = e.getCanSort();
      return (n) => {
        t && (n.persist == null || n.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? r.options.isMultiSortEvent == null ? void 0 : r.options.isMultiSortEvent(n) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (r) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(r), e.resetSorting = (r) => {
      var t, n;
      e.setSorting(r ? [] : (t = (n = e.initialState) == null ? void 0 : n.sorting) != null ? t : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, ET = [
  U2,
  hT,
  cT,
  dT,
  Q2,
  q2,
  gT,
  //depends on ColumnFaceting
  mT,
  //depends on ColumnFiltering
  kT,
  lT,
  //depends on RowSorting
  vT,
  bT,
  yT,
  wT,
  fT
];
function MT(e) {
  var r, t;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const n = [...ET, ...(r = e._features) != null ? r : []];
  let a = {
    _features: n
  };
  const o = a._features.reduce((p, f) => Object.assign(p, f.getDefaultOptions == null ? void 0 : f.getDefaultOptions(a)), {}), i = (p) => a.options.mergeOptions ? a.options.mergeOptions(o, p) : {
    ...o,
    ...p
  };
  let l = {
    ...{},
    ...(t = e.initialState) != null ? t : {}
  };
  a._features.forEach((p) => {
    var f;
    l = (f = p.getInitialState == null ? void 0 : p.getInitialState(l)) != null ? f : l;
  });
  const u = [];
  let c = !1;
  const d = {
    _features: n,
    options: {
      ...o,
      ...e
    },
    initialState: l,
    _queue: (p) => {
      u.push(p), c || (c = !0, Promise.resolve().then(() => {
        for (; u.length; )
          u.shift()();
        c = !1;
      }).catch((f) => setTimeout(() => {
        throw f;
      })));
    },
    reset: () => {
      a.setState(a.initialState);
    },
    setOptions: (p) => {
      const f = Sn(p, a.options);
      a.options = i(f);
    },
    getState: () => a.options.state,
    setState: (p) => {
      a.options.onStateChange == null || a.options.onStateChange(p);
    },
    _getRowId: (p, f, h) => {
      var g;
      return (g = a.options.getRowId == null ? void 0 : a.options.getRowId(p, f, h)) != null ? g : `${h ? [h.id, f].join(".") : f}`;
    },
    getCoreRowModel: () => (a._getCoreRowModel || (a._getCoreRowModel = a.options.getCoreRowModel(a)), a._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => a.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (p, f) => {
      let h = (f ? a.getPrePaginationRowModel() : a.getRowModel()).rowsById[p];
      if (!h && (h = a.getCoreRowModel().rowsById[p], !h))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${p}`) : new Error();
      return h;
    },
    _getDefaultColumnDef: me(() => [a.options.defaultColumn], (p) => {
      var f;
      return p = (f = p) != null ? f : {}, {
        header: (h) => {
          const g = h.header.column.columnDef;
          return g.accessorKey ? g.accessorKey : g.accessorFn ? g.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (h) => {
          var g, m;
          return (g = (m = h.renderValue()) == null || m.toString == null ? void 0 : m.toString()) != null ? g : null;
        },
        ...a._features.reduce((h, g) => Object.assign(h, g.getDefaultColumnDef == null ? void 0 : g.getDefaultColumnDef()), {}),
        ...p
      };
    }, ve(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => a.options.columns,
    getAllColumns: me(() => [a._getColumnDefs()], (p) => {
      const f = function(h, g, m) {
        return m === void 0 && (m = 0), h.map((v) => {
          const y = Z2(a, v, m, g), w = v;
          return y.columns = w.columns ? f(w.columns, y, m + 1) : [], y;
        });
      };
      return f(p);
    }, ve(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: me(() => [a.getAllColumns()], (p) => p.flatMap((f) => f.getFlatColumns()), ve(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: me(() => [a.getAllFlatColumns()], (p) => p.reduce((f, h) => (f[h.id] = h, f), {}), ve(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: me(() => [a.getAllColumns(), a._getOrderColumnsFn()], (p, f) => {
      let h = p.flatMap((g) => g.getLeafColumns());
      return f(h);
    }, ve(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (p) => {
      const f = a._getAllFlatColumnsById()[p];
      return process.env.NODE_ENV !== "production" && !f && console.error(`[Table] Column with id '${p}' does not exist.`), f;
    }
  };
  Object.assign(a, d);
  for (let p = 0; p < a._features.length; p++) {
    const f = a._features[p];
    f == null || f.createTable == null || f.createTable(a);
  }
  return a;
}
function PT() {
  return (e) => me(() => [e.options.data], (r) => {
    const t = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, n = function(a, o, i) {
      o === void 0 && (o = 0);
      const s = [];
      for (let u = 0; u < a.length; u++) {
        const c = J2(e, e._getRowId(a[u], u, i), a[u], u, o, void 0, i == null ? void 0 : i.id);
        if (t.flatRows.push(c), t.rowsById[c.id] = c, s.push(c), e.options.getSubRows) {
          var l;
          c.originalSubRows = e.options.getSubRows(a[u], u), (l = c.originalSubRows) != null && l.length && (c.subRows = n(c.originalSubRows, o + 1, c));
        }
      }
      return s;
    };
    return t.rows = n(r), t;
  }, ve(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function AT(e) {
  const r = [], t = (n) => {
    var a;
    r.push(n), (a = n.subRows) != null && a.length && n.getIsExpanded() && n.subRows.forEach(t);
  };
  return e.rows.forEach(t), {
    rows: r,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function RT(e) {
  return (r) => me(() => [r.getState().pagination, r.getPrePaginationRowModel(), r.options.paginateExpandedRows ? void 0 : r.getState().expanded], (t, n) => {
    if (!n.rows.length)
      return n;
    const {
      pageSize: a,
      pageIndex: o
    } = t;
    let {
      rows: i,
      flatRows: s,
      rowsById: l
    } = n;
    const u = a * o, c = u + a;
    i = i.slice(u, c);
    let d;
    r.options.paginateExpandedRows ? d = {
      rows: i,
      flatRows: s,
      rowsById: l
    } : d = AT({
      rows: i,
      flatRows: s,
      rowsById: l
    }), d.flatRows = [];
    const p = (f) => {
      d.flatRows.push(f), f.subRows.length && f.subRows.forEach(p);
    };
    return d.rows.forEach(p), d;
  }, ve(r.options, "debugTable", "getPaginationRowModel"));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Cp(e, r) {
  return e ? OT(e) ? /* @__PURE__ */ U.createElement(e, r) : e : null;
}
function OT(e) {
  return TT(e) || typeof e == "function" || FT(e);
}
function TT(e) {
  return typeof e == "function" && (() => {
    const r = Object.getPrototypeOf(e);
    return r.prototype && r.prototype.isReactComponent;
  })();
}
function FT(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function NT(e) {
  const r = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [t] = U.useState(() => ({
    current: MT(r)
  })), [n, a] = U.useState(() => t.current.initialState);
  return t.current.setOptions((o) => ({
    ...o,
    ...e,
    state: {
      ...n,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (i) => {
      a(i), e.onStateChange == null || e.onStateChange(i);
    }
  })), t.current;
}
const Lu = {
  initialConfig: {
    page: 1,
    pageIndex: 0,
    pageSize: 25
  },
  pages: [10, 25, 50, 100]
}, LT = (e, r) => {
  if (r <= 7) {
    const t = [];
    for (let n = 0; n < r; n++)
      t.push(n);
    return t;
  } else
    return e <= 3 ? [0, 1, 2, 3, 4, "...", r - 1] : e <= r - 1 && e >= r - 5 ? [0, "...", r - 6, r - 5, r - 4, r - 3, r - 2, r - 1] : [0, "...", e - 2, e - 1, e, e + 1, e + 2, "...", r - 1];
};
function WT({ table: e, pagination: r, setPagination: t, pageCount: n, isDisabled: a, total: o, page: i, page_size: s, setPage: l, setPageSize: u, showPageNumbers: c }) {
  const [d] = Pb("(min-width: 1024px)"), p = c ?? d, f = i && s ? i - 1 : r.pageIndex, h = We(() => LT(f, n), [f, n]);
  return He(() => {
    i !== void 0 && s !== void 0 && (e.setPageIndex(i - 1), e.setPageSize(s));
  }, [i, s, e]), /* @__PURE__ */ ee(
    Rt,
    {
      width: "fit-content",
      alignSelf: "end",
      justifyContent: "end",
      my: "1rem",
      gap: "0.7rem",
      children: [
        /* @__PURE__ */ x(
          At,
          {
            isDisabled: a || i === 1,
            onClick: () => {
              l && u ? l(1) : e.firstPage();
            },
            disabled: !e.getCanPreviousPage(),
            children: "<<"
          }
        ),
        /* @__PURE__ */ x(
          At,
          {
            isDisabled: a || i === 1,
            onClick: () => {
              l && u && i ? l(i - 1) : e.previousPage();
            },
            disabled: !e.getCanPreviousPage(),
            children: "<"
          }
        ),
        p ? h.map((g, m) => g === "..." ? /* @__PURE__ */ x(
          mt,
          {
            alignSelf: "center",
            mx: "2",
            children: "..."
          },
          `ellipsis-${m}`
        ) : /* @__PURE__ */ x(
          At,
          {
            id: `paginatorPage-${g}`,
            isDisabled: a,
            bg: f === g ? j.tertiary[3] : "initial",
            onClick: () => {
              l && u ? l(g + 1) : e.setPageIndex(g);
            },
            children: g + 1
          },
          `page-${g}`
        )) : null,
        /* @__PURE__ */ x(
          At,
          {
            id: "paginatorNextPage",
            isDisabled: a || n === i,
            onClick: () => {
              l && u && i ? l(i + 1) : e.nextPage();
            },
            disabled: !e.getCanNextPage(),
            children: ">"
          }
        ),
        /* @__PURE__ */ x(
          At,
          {
            isDisabled: a || n === i,
            onClick: () => {
              l && u ? l(Math.ceil(o / r.pageSize)) : e.lastPage();
            },
            disabled: !e.getCanNextPage(),
            children: ">>"
          }
        ),
        /* @__PURE__ */ ee(Pa, { children: [
          /* @__PURE__ */ x(
            Aa,
            {
              isDisabled: a,
              shadow: "base",
              as: At,
              rightIcon: /* @__PURE__ */ x(Vo, {}),
              children: r.pageSize
            }
          ),
          /* @__PURE__ */ x(
            Ra,
            {
              onClick: (g) => {
                const m = g.target;
                m.value && (l && u ? (l(1), u(Number(m.value))) : (e.setPageSize(Number(m.value)), e.firstPage()));
              },
              children: Lu.pages.map((g, m) => /* @__PURE__ */ x(
                Oa,
                {
                  value: g,
                  children: g
                },
                `${g}-${m}`
              ))
            }
          )
        ] })
      ]
    }
  );
}
var BT = /* @__PURE__ */ ((e) => (e.ASC = "ASC", e.DESC = "DESC", e))(BT || {});
const xp = {
  fontSize: {
    badge: { base: "0.55rem", lg: "0.65rem" },
    tag: { base: "0.6rem", lg: "0.75rem" },
    text: { base: "0.65rem", lg: "0.8rem" },
    button: { base: "0.7rem", lg: "0.8rem" },
    icon: { base: "0.8rem", lg: "0.9rem" }
  },
  size: {
    badge: "sm",
    tag: "sm",
    button: "sm",
    spinner: "xs"
  },
  fontWeight: {
    normal: 600,
    bold: 700
  },
  gap: {
    small: ".3rem",
    medium: "1rem"
  },
  padding: {
    button: "0.3rem",
    buttonWithText: "0.3rem 0.5rem",
    iconOnlyButton: "0.3rem 0.6rem"
  }
};
function bF({ id: e, data: r, total: t, page: n, page_size: a, setPage: o, setPageSize: i, columns: s, isLoading: l = !1, isFetching: u = !1, noDataDisclaimer: c, sort_by: d, sort_type: p, setSortBy: f, setSortType: h, enableRowSelection: g, rowSelection: m, onRowSelectionChange: v, getRowId: y, paginationType: w = "API", enableColumnResizing: I = !1, columnResizeMode: b = "onChange" }) {
  const [D, S] = ke({
    pageIndex: Lu.initialConfig.pageIndex,
    pageSize: Lu.initialConfig.pageSize
  }), _ = We(() => Math.ceil((t || r.length) / D.pageSize), [t, r, D]);
  He(() => {
    n && a && w == "API" ? S({
      pageIndex: 0,
      pageSize: a
    }) : n && a && S({
      pageIndex: n - 1,
      pageSize: a
    });
  }, [n, a]);
  const k = NT({
    columns: s,
    data: r,
    pageCount: _,
    getCoreRowModel: PT(),
    getPaginationRowModel: RT(),
    onPaginationChange: S,
    autoResetAll: !1,
    paginateExpandedRows: !1,
    enableRowSelection: g,
    onRowSelectionChange: v,
    getRowId: y,
    enableColumnResizing: I,
    columnResizeMode: b,
    state: {
      pagination: D,
      rowSelection: m || {}
    }
  }), R = ye(null), W = /* @__PURE__ */ x(
    Ab,
    {
      alignContent: "start",
      placeContent: "start",
      justifyContent: "start",
      rowGap: "1rem",
      children: l ? [...Array(D.pageSize).keys()].map((B, V) => /* @__PURE__ */ ee(
        dl,
        {
          maxW: "100vw",
          transition: ".2s ease-in",
          _hover: { backgroundColor: j.neutro[1] },
          children: [
            g && /* @__PURE__ */ x(
              si,
              {
                padding: "1rem 0.4rem",
                width: "40px",
                children: /* @__PURE__ */ x(
                  So,
                  {
                    height: "20px",
                    width: "20px"
                  }
                )
              }
            ),
            [...Array(s.length).keys()].map((F, H) => /* @__PURE__ */ x(
              si,
              {
                fontSize: xp.fontSize.text,
                textAlign: "left",
                paddingY: "1rem",
                paddingX: "0.4rem",
                overflow: "hidden",
                flexWrap: "wrap",
                children: /* @__PURE__ */ x(So, { height: "25px" })
              },
              `${F}-${H}`
            ))
          ]
        },
        `${B}-${V}`
      )) : k.getRowModel().rows.map((B) => /* @__PURE__ */ ee(
        dl,
        {
          maxW: "100vw",
          ref: R,
          transition: ".2s ease-in",
          _hover: { backgroundColor: j.neutro[1] },
          children: [
            g && /* @__PURE__ */ x(
              si,
              {
                padding: "1rem 0.4rem",
                width: "40px",
                children: /* @__PURE__ */ x(
                  td,
                  {
                    isChecked: B.getIsSelected(),
                    isDisabled: !B.getCanSelect(),
                    onChange: B.getToggleSelectedHandler()
                  }
                )
              }
            ),
            B.getVisibleCells().map((V) => {
              const F = V.column.columnDef.meta;
              return /* @__PURE__ */ x(
                si,
                {
                  isNumeric: F == null ? void 0 : F.isNumeric,
                  fontSize: xp.fontSize.text,
                  textAlign: "left",
                  padding: "1rem 0.4rem",
                  overflow: "hidden",
                  flexWrap: "wrap",
                  width: I ? `${V.column.getSize() / k.getCenterTotalSize() * 100}%` : void 0,
                  children: l ? /* @__PURE__ */ x(So, { height: "25px" }) : Cp(V.column.columnDef.cell, V.getContext())
                },
                V.id
              );
            })
          ]
        },
        B.id
      ))
    }
  );
  return /* @__PURE__ */ ee(
    Rt,
    {
      flexDirection: "column",
      justifyContent: "space-between",
      minHeight: !r.length && c ? 0 : {
        base: "",
        md: "500px",
        lg: "600px"
      },
      overflowX: "auto",
      maxW: "100%",
      children: [
        /* @__PURE__ */ ee(
          Rb,
          {
            id: e,
            children: [
              /* @__PURE__ */ x(Ob, { children: k.getHeaderGroups().map((B) => /* @__PURE__ */ ee(dl, { children: [
                g && /* @__PURE__ */ x(rd, { padding: "1rem 0.4rem", children: /* @__PURE__ */ x(
                  td,
                  {
                    isChecked: k.getIsAllRowsSelected(),
                    isIndeterminate: k.getIsSomeRowsSelected(),
                    onChange: k.getToggleAllRowsSelectedHandler()
                  }
                ) }),
                B.headers.map((V) => {
                  const F = V.column.columnDef.meta;
                  return /* @__PURE__ */ ee(
                    rd,
                    {
                      userSelect: "none",
                      fontSize: { base: ".7rem" },
                      textAlign: "left",
                      _hover: { backgroundColor: j.neutro[1] },
                      isNumeric: F == null ? void 0 : F.isNumeric,
                      padding: "1rem 0.4rem",
                      position: I ? "relative" : void 0,
                      width: I ? `${V.getSize() / k.getCenterTotalSize() * 100}%` : void 0,
                      cursor: f && h && V.column.id !== "actions" ? "pointer" : "initial",
                      onClick: () => {
                        V.column.id !== "actions" && f && h && (d === V.column.id ? p === "DESC" ? h(
                          "ASC"
                          /* ASC */
                        ) : (h(null), f("")) : (h(
                          "DESC"
                          /* DESC */
                        ), f(V.column.id)));
                      },
                      children: [
                        Cp(V.column.columnDef.header, V.getContext()),
                        /* @__PURE__ */ x(nd.span, { pl: "4", children: d === V.column.id ? p === "DESC" ? /* @__PURE__ */ x(aD, { "aria-label": "sorted descending" }) : /* @__PURE__ */ x(oD, { "aria-label": "sorted ascending" }) : null }),
                        I && V.column.getCanResize() && /* @__PURE__ */ x(
                          nd.div,
                          {
                            onMouseDown: V.getResizeHandler(),
                            onTouchStart: V.getResizeHandler(),
                            position: "absolute",
                            right: "0",
                            top: "0",
                            height: "100%",
                            width: "4px",
                            cursor: "col-resize",
                            userSelect: "none",
                            bg: V.column.getIsResizing() ? "blue.400" : "transparent",
                            _hover: { bg: "blue.300" },
                            onClick: (H) => H.stopPropagation()
                          }
                        )
                      ]
                    },
                    V.id
                  );
                })
              ] }, B.id)) }),
              W
            ]
          }
        ),
        !u && !l && !r.length && c ? c : null,
        /* @__PURE__ */ x(
          WT,
          {
            total: t,
            page: n,
            page_size: a,
            setPage: o,
            setPageSize: i,
            isDisabled: r.length ? l : !0,
            pageCount: _,
            setPagination: S,
            pagination: D,
            table: k
          }
        )
      ]
    }
  );
}
const VT = Yr(({ children: e, ...r }) => /* @__PURE__ */ x(
  Ze,
  {
    as: "span",
    display: "inline",
    fontWeight: 600,
    color: j.tertiary[1],
    sx: {
      "& a": {
        color: "inherit",
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline"
        }
      }
    },
    ...r,
    children: e
  }
));
VT.displayName = "Link";
const GT = at(({ children: e, label: r, menuProps: t, menuListProps: n, icon: a, hideIcon: o = !1, ...i }, s) => /* @__PURE__ */ ee(Pa, { ...t, children: [
  /* @__PURE__ */ x(
    Aa,
    {
      as: Yi,
      ref: s,
      rightIcon: o ? void 0 : a ?? /* @__PURE__ */ x(nD, {}),
      ...i,
      children: r
    }
  ),
  /* @__PURE__ */ x(
    Ra,
    {
      zIndex: 1500,
      ...n,
      children: e
    }
  )
] }));
GT.displayName = "MenuButton";
const YT = at((e, r) => /* @__PURE__ */ x(
  Oa,
  {
    ref: r,
    ...e
  }
));
YT.displayName = "MenuItem";
const HT = Yr(({ previewType: e, previewUrl: r, button: t }) => {
  const n = Tb();
  return !e || !r ? t(n, !e || !r) : /* @__PURE__ */ ee(Wu, { children: [
    t(n, !e || !r),
    /* @__PURE__ */ ee(
      Ep,
      {
        isOpen: n.isOpen,
        onClose: n.onClose,
        isCentered: !0,
        size: "full",
        closeOnOverlayClick: !0,
        children: [
          /* @__PURE__ */ x(
            Mp,
            {
              bg: "blackAlpha.600",
              backdropFilter: "blur(10px)"
            }
          ),
          /* @__PURE__ */ ee(
            Pp,
            {
              bg: "transparent",
              boxShadow: "none",
              w: e === "image" ? "fit-content" : "85vw",
              h: "95vh",
              m: "auto",
              borderRadius: 0,
              children: [
                /* @__PURE__ */ x(
                  Ap,
                  {
                    color: "white",
                    bg: "blackAlpha.600",
                    _hover: { bg: "blackAlpha.800" },
                    zIndex: 1,
                    size: "lg",
                    top: 4,
                    right: -8
                  }
                ),
                /* @__PURE__ */ x(
                  Rp,
                  {
                    p: 4,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                    children: e === "image" ? /* @__PURE__ */ x(
                      Fb,
                      {
                        src: r,
                        alt: "Vista previa del gasto",
                        maxW: "100%",
                        maxH: "100%",
                        objectFit: "contain"
                      }
                    ) : /* @__PURE__ */ x(
                      "iframe",
                      {
                        src: r,
                        title: "Vista previa del PDF",
                        width: "100%",
                        height: "100%",
                        style: {
                          border: "none",
                          backgroundColor: "white",
                          borderRadius: "8px"
                        }
                      }
                    )
                  }
                )
              ]
            }
          )
        ]
      }
    )
  ] });
});
HT.displayName = "PreviewModalComponent";
const zT = {
  sm: {
    height: "4px"
  },
  md: {
    height: "8px"
  },
  lg: {
    height: "12px"
  }
}, $T = Op`
  0% {
    left: -35%;
    right: 100%;
  }
  60% {
    left: 100%;
    right: -90%;
  }
  100% {
    left: 100%;
    right: -90%;
  }
`, XT = Op`
  0% {
    left: -200%;
    right: 100%;
  }
  60% {
    left: 107%;
    right: -8%;
  }
  100% {
    left: 107%;
    right: -8%;
  }
`, jT = (e) => {
  switch (e) {
    case "success":
      return j.primary[2];
    case "warning":
      return j.orange[1];
    case "danger":
      return j.error[1];
    case "tertiary":
      return j.tertiary[1];
    case "gradient":
      return `linear-gradient(90deg, ${j.primary[2]} 0%, ${j.tertiary[1]} 100%)`;
    case "default":
    default:
      return j.primary[2];
  }
}, ZT = Yr(
  at(({ variant: e = "default", size: r = "sm", isIndeterminate: t = !0, ...n }, a) => {
    const o = jT(e), i = zT[r], s = e === "gradient";
    return /* @__PURE__ */ x(
      Ze,
      {
        ref: a,
        position: "relative",
        width: "100%",
        height: i.height,
        bg: j.neutro[3],
        borderRadius: "full",
        overflow: "hidden",
        ...n,
        children: t && /* @__PURE__ */ ee(Wu, { children: [
          /* @__PURE__ */ x(
            Ze,
            {
              position: "absolute",
              top: 0,
              height: "100%",
              bg: s ? void 0 : o,
              bgGradient: s ? o : void 0,
              borderRadius: "full",
              animation: `${$T} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`,
              willChange: "left, right"
            }
          ),
          /* @__PURE__ */ x(
            Ze,
            {
              position: "absolute",
              top: 0,
              height: "100%",
              bg: s ? void 0 : o,
              bgGradient: s ? o : void 0,
              borderRadius: "full",
              animation: `${XT} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`,
              willChange: "left, right"
            }
          )
        ] })
      }
    );
  })
);
ZT.displayName = "LinearLoader";
const UT = Yr(({ children: e, title: r, isLoading: t }) => /* @__PURE__ */ x(
  Rt,
  {
    display: "flex",
    boxSize: "full",
    bg: "#F9FAFB",
    alignItems: "center",
    justifyContent: "center",
    shadow: "md",
    my: "1rem",
    children: /* @__PURE__ */ x(
      Ze,
      {
        mx: "auto",
        textAlign: {
          base: "left",
          md: "center"
        },
        rounded: "md",
        shadow: "base",
        w: "full",
        children: /* @__PURE__ */ x(Ze, { children: /* @__PURE__ */ x(
          kp,
          {
            gap: "24px",
            rounded: "md",
            textAlign: "left",
            children: /* @__PURE__ */ x(
              Ze,
              {
                bg: "white",
                _dark: {
                  bg: "gray.800"
                },
                pt: 10,
                rounded: "md",
                children: /* @__PURE__ */ ee(Rt, { direction: "column", children: [
                  /* @__PURE__ */ x(
                    Ze,
                    {
                      px: 10,
                      pb: 5,
                      children: /* @__PURE__ */ x(So, { isLoaded: !t, children: /* @__PURE__ */ x(
                        mt,
                        {
                          mb: 2,
                          fontSize: "3xl",
                          fontWeight: ["bold", "extrabold"],
                          color: "gray.900",
                          _dark: {
                            color: "gray.50"
                          },
                          lineHeight: "tight",
                          children: r
                        }
                      ) })
                    }
                  ),
                  /* @__PURE__ */ x(
                    Ze,
                    {
                      px: 10,
                      pt: 5,
                      pb: "1.5rem",
                      bg: "gray.50",
                      _dark: {
                        bg: "gray.900"
                      },
                      children: /* @__PURE__ */ x(So, { isLoaded: !t, children: e })
                    }
                  )
                ] })
              }
            )
          }
        ) })
      }
    )
  }
));
UT.displayName = "ProfileDisplayer";
const JT = Yr(
  at(({ children: e, ...r }, t) => /* @__PURE__ */ x(
    Nb,
    {
      ref: t,
      fontWeight: "semibold",
      fontSize: "0.9rem",
      px: 6,
      py: 2,
      color: "gray.600",
      bg: "transparent",
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      _selected: {
        color: j.secondary[1],
        borderColor: j.secondary[2],
        borderBottom: "2.5px solid",
        borderBottomColor: j.secondary[2],
        borderTop: "none",
        borderLeft: "none",
        borderRight: "none",
        fontWeight: "bold",
        bg: "transparent"
      },
      _hover: {
        color: j.secondary[1],
        bg: "transparent"
      },
      ...r,
      children: e
    }
  ))
);
JT.displayName = "StyledTab";
const QT = Yr(({ children: e, ...r }) => /* @__PURE__ */ x(
  mt,
  {
    as: "h2",
    fontSize: {
      base: "1.5rem",
      md: "1.9rem"
    },
    textAlign: {
      base: "center",
      md: "start"
    },
    fontWeight: 600,
    mb: "0.5rem",
    ...r,
    children: e
  }
));
QT.displayName = "Title";
const yF = ({ children: e, theme: r = Wb, texts: t, ...n }) => /* @__PURE__ */ x(
  Lb,
  {
    theme: r,
    ...n,
    children: /* @__PURE__ */ x(sD, { texts: t, children: e })
  }
);
export {
  cF as AsyncSelectField,
  Yi as Button,
  L2 as Card,
  G2 as CardContent,
  V2 as CardDescription,
  Y2 as CardFooter,
  W2 as CardHeader,
  B2 as CardTitle,
  H2 as ConfirmDialog,
  z2 as CopyToClipboardButton,
  sF as CurrencyField,
  ev as DATE_PICKER_PORTAL_ID,
  bF as DataTable,
  mp as DateField,
  hF as DateRangeField,
  pF as DateRangePicker,
  gF as ExpenseFileInput,
  dF as FileField,
  mF as FileUploadArea,
  Hb as IconButton,
  ZT as LinearLoader,
  VT as Link,
  GT as MenuButton,
  YT as MenuItem,
  vF as MultipleTypeField,
  Lu as PAGINATION_CONFIG,
  WT as Paginator,
  fF as PhoneField,
  HT as PreviewModalComponent,
  UT as ProfileDisplayer,
  uF as SelectField,
  BT as SortType,
  JT as StyledTab,
  xo as Text,
  iF as TextField,
  QT as Title,
  sg as TooltipInfo,
  yF as ZummaProvider,
  sD as ZummaTextsProvider,
  Er as buttonStyles,
  j as colors,
  gt as datePickerHeaderStyles,
  lg as defaultZummaTexts,
  sr as field,
  je as fontSize,
  ia as fontWeight,
  zt as formColors,
  xF as inputContainerHeight,
  ar as inputHeight,
  SF as inputPadding,
  oa as inputWidth,
  IF as padding,
  fn as requiredAsteriskColor,
  Is as rounded,
  DF as specialBoxStyles,
  xp as tableStyles,
  ja as useZummaTexts,
  Wb as zummaTheme
};
